/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var api = __webpack_require__(1);
	var auth = __webpack_require__(238);
	var memo = __webpack_require__(239);
	var broadcast = __webpack_require__(240);
	var config = __webpack_require__(42);
	var formatter = __webpack_require__(242)(api);
	var utils = __webpack_require__(97);
	
	var hive = {
	  api: api,
	  auth: auth,
	  memo: memo,
	  broadcast: broadcast,
	  config: config,
	  formatter: formatter,
	  utils: utils
	};
	
	if (typeof window !== "undefined") {
	  window.hive = hive;
	}
	
	if (typeof global !== "undefined") {
	  global.hive = hive;
	}
	
	exports = module.exports = hive;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(2);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _bluebird = __webpack_require__(3);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _methods = __webpack_require__(83);
	
	var _methods2 = _interopRequireDefault(_methods);
	
	var _transports = __webpack_require__(84);
	
	var _transports2 = _interopRequireDefault(_transports);
	
	var _http = __webpack_require__(85);
	
	var _utils = __webpack_require__(97);
	
	var _ecc = __webpack_require__(103);
	
	var _serializer = __webpack_require__(202);
	
	var _rpcAuth = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hive = function (_EventEmitter) {
	    _inherits(Hive, _EventEmitter);
	
	    function Hive() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Hive);
	
	        var _this = _possibleConstructorReturn(this, (Hive.__proto__ || Object.getPrototypeOf(Hive)).call(this, options));
	
	        _this._setTransport(options);
	        _this._setLogger(options);
	        _this.options = options;
	        _this.seqNo = 0; // used for rpc calls
	        _this.error_count = 0;
	        _this.api_index = 0;
	        _this.error_threshold = 3;
	        _this.alternative_api_endpoints = ['https://api.hive.blog', 'https://anyx.io'];
	        _methods2.default.forEach(function (method) {
	            var methodName = method.method_name || (0, _utils.camelCase)(method.method);
	            var methodParams = method.params || [];
	
	            _this[methodName + 'With'] = function (options, callback) {
	                var params = {};
	                for (var i = 0; i < methodParams.length; i++) {
	                    params[methodParams[i]] = options[methodParams[i]];
	                }
	                return _this.send(method.api, {
	                    method: method.method,
	                    paramsCondenserApi: methodParams.map(function (param) {
	                        return options[param];
	                    }),
	                    params: params
	                }, callback);
	            };
	
	            _this[methodName] = function () {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                if (methodName === 'getAccountHistory' && args.length < 5 && methodParams.length > 4) {
	                    methodParams.pop();
	                    methodParams.pop();
	                }
	                var options = methodParams.reduce(function (memo, param, i) {
	                    memo[param] = args[i]; // eslint-disable-line no-param-reassign
	                    return memo;
	                }, {});
	                var callback = args[methodParams.length];
	                return _this[methodName + 'With'](options, callback);
	            };
	
	            _this[methodName + 'WithAsync'] = _bluebird2.default.promisify(_this[methodName + 'With']);
	            _this[methodName + 'Async'] = _bluebird2.default.promisify(_this[methodName]);
	        });
	        _this.callAsync = _bluebird2.default.promisify(_this.call);
	        _this.signedCallAsync = _bluebird2.default.promisify(_this.signedCall);
	        // console.log("Alternate endpoints: ", this.options.alternative_api_endpoints);
	        // console.log("Failover Threshold (errors): ", this.options.failover_threshold);
	        _this.notifyError = _this.notifyError.bind(_this);
	        return _this;
	    }
	
	    _createClass(Hive, [{
	        key: '_setTransport',
	        value: function _setTransport(options) {
	            if (options.url && options.url.match('^((http|https)?:\/\/)')) {
	                options.uri = options.url;
	                options.transport = 'http';
	                this._transportType = options.transport;
	                this.options = options;
	                this.transport = new _transports2.default.http(options);
	            } else if (options.url && options.url.match('^((ws|wss)?:\/\/)')) {
	                options.websocket = options.url;
	                options.transport = 'ws';
	                this._transportType = options.transport;
	                this.options = options;
	                this.transport = new _transports2.default.ws(options);
	            } else if (options.transport) {
	                if (this.transport && this._transportType !== options.transport) {
	                    this.transport.stop();
	                }
	
	                this._transportType = options.transport;
	
	                if (typeof options.transport === 'string') {
	                    if (!_transports2.default[options.transport]) {
	                        throw new TypeError('Invalid `transport`, valid values are `http`, `ws` or a class');
	                    }
	                    this.transport = new _transports2.default[options.transport](options);
	                } else {
	                    this.transport = new options.transport(options);
	                }
	            } else {
	                this.transport = new _transports2.default.ws(options);
	            }
	        }
	    }, {
	        key: '_setLogger',
	        value: function _setLogger(options) {
	            if (options.hasOwnProperty('logger')) {
	                switch (_typeof(options.logger)) {
	                    case 'function':
	                        this.__logger = {
	                            log: options.logger
	                        };
	                        break;
	                    case 'object':
	                        if (typeof options.logger.log !== 'function') {
	                            throw new Error('setOptions({logger:{}}) must have a property .log of type function');
	                        }
	                        this.__logger = options.logger;
	                        break;
	                    case 'undefined':
	                        if (this.__logger) break;
	                    default:
	                        this.__logger = false;
	                }
	            }
	        }
	    }, {
	        key: 'log',
	        value: function log(logLevel) {
	            if (this.__logger) {
	                if (arguments.length > 1 && typeof this.__logger[logLevel] === 'function') {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    this.__logger[logLevel].apply(this.__logger, args);
	                } else {
	                    this.__logger.log.apply(this.__logger, arguments);
	                }
	            }
	        }
	    }, {
	        key: 'start',
	        value: function start() {
	            return this.transport.start();
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            return this.transport.stop();
	        }
	    }, {
	        key: 'send',
	        value: function send(api, data, callback) {
	            var cb = callback;
	            if (this.__logger) {
	                var id = Math.random();
	                var self = this;
	                this.log('xmit:' + id + ':', data);
	                cb = function cb(e, d) {
	                    if (e) {
	                        self.log('error', 'rsp:' + id + ':\n\n', e, d);
	                    } else {
	                        self.log('rsp:' + id + ':', d);
	                    }
	                    if (callback) {
	                        callback.apply(self, arguments);
	                    }
	                };
	            }
	            return this.transport.send(api, data, cb);
	        }
	    }, {
	        key: 'call',
	        value: function call(method, params, callback) {
	            var _this2 = this;
	
	            if (this._transportType !== 'http') {
	                callback(new Error('RPC methods can only be called when using http transport'));
	                return;
	            }
	            var id = ++this.seqNo;
	            (0, _http.jsonRpc)(this.options.uri, { method: method, params: params, id: id }).then(function (res) {
	                callback(null, res);
	            }, function (err) {
	                _this2.notifyError(err, err instanceof _http.RPCError);callback(err);
	            });
	        }
	    }, {
	        key: 'signedCall',
	        value: function signedCall(method, params, account, key, callback) {
	            var _this3 = this;
	
	            if (this._transportType !== 'http') {
	                callback(new Error('RPC methods can only be called when using http transport'));
	                return;
	            }
	            var id = ++this.seqNo;
	            var request = void 0;
	            try {
	                request = (0, _rpcAuth.sign)({ method: method, params: params, id: id }, account, [key]);
	            } catch (error) {
	                callback(error);
	                return;
	            }
	            (0, _http.jsonRpc)(this.options.uri, request).then(function (res) {
	                callback(null, res);
	            }, function (err) {
	                callback(err);_this3.notifyError(err);
	            });
	        }
	    }, {
	        key: 'setOptions',
	        value: function setOptions(options) {
	            Object.assign(this.options, options);
	
	            if (options.hasOwnProperty('useAppbaseApi')) _config2.default.set('useAppbaseApi', options.useAppbaseApi);
	            if (options.hasOwnProperty('failover_threshold')) this.failover_threshold = options.failover_threshold;
	            if (options.hasOwnProperty('alternative_api_endpoints')) this.alternative_api_endpoints = options.alternative_api_endpoints;
	
	            this._setLogger(options);
	            this._setTransport(options);
	            this.transport.setOptions(options);
	            if (options.hasOwnProperty('useTestNet')) {
	                _config2.default.set('address_prefix', options.useTestNet ? 'TST' : 'STM');
	            }
	
	            if (options.hasOwnProperty('url')) {
	                var new_index = 0;
	                for (var i = 0; i < this.alternative_api_endpoints.length; i++) {
	                    var temp_endpoint = this.alternative_api_endpoints[i];
	                    if (temp_endpoint === options.url) {
	                        new_index = i;
	                        break;
	                    }
	                }
	                this.api_index = new_index;
	                var new_endpoint = this.alternative_api_endpoints[this.api_index];
	            }
	        }
	    }, {
	        key: 'setWebSocket',
	        value: function setWebSocket(url) {
	            this.setOptions({
	                websocket: url
	            });
	        }
	    }, {
	        key: 'setUri',
	        value: function setUri(url) {
	            this.setOptions({
	                uri: url
	            });
	        }
	    }, {
	        key: 'streamBlockNumber',
	        value: function streamBlockNumber() {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'head';
	
	            var _this4 = this;
	
	            var callback = arguments[1];
	            var ts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	
	            if (typeof mode === 'function') {
	                callback = mode;
	                mode = 'head';
	            }
	            var current = '';
	            var running = true;
	
	            var update = function update() {
	                if (!running) return;
	
	                _this4.getDynamicGlobalPropertiesAsync().then(function (result) {
	                    var blockId = mode === 'irreversible' ? result.last_irreversible_block_num : result.head_block_number;
	
	                    if (blockId !== current) {
	                        if (current) {
	                            for (var i = current; i < blockId; i++) {
	                                if (i !== current) {
	                                    callback(null, i);
	                                }
	                                current = i;
	                            }
	                        } else {
	                            current = blockId;
	                            callback(null, blockId);
	                        }
	                    }
	
	                    _bluebird2.default.delay(ts).then(function () {
	                        update();
	                    });
	                }, function (err) {
	                    callback(err);
	                });
	            };
	
	            update();
	
	            return function () {
	                running = false;
	            };
	        }
	    }, {
	        key: 'streamBlock',
	        value: function streamBlock() {
	            var _this5 = this;
	
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'head';
	            var callback = arguments[1];
	
	            if (typeof mode === 'function') {
	                callback = mode;
	                mode = 'head';
	            }
	
	            var current = '';
	            var last = '';
	
	            var release = this.streamBlockNumber(mode, function (err, id) {
	                if (err) {
	                    release();
	                    callback(err);
	                    return;
	                }
	
	                current = id;
	                if (current !== last) {
	                    last = current;
	                    _this5.getBlock(current, callback);
	                }
	            });
	
	            return release;
	        }
	    }, {
	        key: 'streamTransactions',
	        value: function streamTransactions() {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'head';
	            var callback = arguments[1];
	
	            if (typeof mode === 'function') {
	                callback = mode;
	                mode = 'head';
	            }
	
	            var release = this.streamBlock(mode, function (err, result) {
	                if (err) {
	                    release();
	                    callback(err);
	                    return;
	                }
	
	                if (result && result.transactions) {
	                    result.transactions.forEach(function (transaction) {
	                        callback(null, transaction);
	                    });
	                }
	            });
	
	            return release;
	        }
	    }, {
	        key: 'streamOperations',
	        value: function streamOperations() {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'head';
	            var callback = arguments[1];
	
	            if (typeof mode === 'function') {
	                callback = mode;
	                mode = 'head';
	            }
	
	            var release = this.streamTransactions(mode, function (err, transaction) {
	                if (err) {
	                    release();
	                    callback(err);
	                    return;
	                }
	
	                transaction.operations.forEach(function (operation) {
	                    callback(null, operation);
	                });
	            });
	
	            return release;
	        }
	    }, {
	        key: 'broadcastTransactionSynchronousWith',
	        value: function broadcastTransactionSynchronousWith(options, callback) {
	            var trx = options.trx;
	            return this.send('network_broadcast_api', {
	                method: 'broadcast_transaction_synchronous',
	                params: [trx]
	            }, function (err, result) {
	                if (err) {
	                    var signed_transaction = _serializer.ops.signed_transaction;
	                    // console.log('-- broadcastTransactionSynchronous -->', JSON.stringify(signed_transaction.toObject(trx), null, 2));
	                    // toObject converts objects into serializable types
	
	                    var trObject = signed_transaction.toObject(trx);
	                    var buf = signed_transaction.toBuffer(trx);
	                    err.digest = _ecc.hash.sha256(buf).toString('hex');
	                    err.transaction_id = buf.toString('hex');
	                    err.transaction = JSON.stringify(trObject);
	                    callback(err, '');
	                } else {
	                    callback('', result);
	                }
	            });
	        }
	    }, {
	        key: 'notifyError',
	        value: function notifyError(err) {
	            var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            if (ignore) {
	                return;
	            }
	            if (this.failover_threshold === undefined || this.alternative_api_endpoints === undefined) {
	                return;
	            }
	            if (err && err.toString().includes("overseer")) {
	                //overseer was a steem thing, it doesn't exist in hive so don't count this error towards failover
	                return;
	            }
	            this.error_count++;
	            if (this.error_count >= this.failover_threshold) {
	                var current_url = this.options.url;
	                this.error_count = 0;
	                this.api_index++;
	                if (this.api_index >= this.alternative_api_endpoints.length) {
	                    this.api_index = 0;
	                }
	                var nextEndpoint = this.alternative_api_endpoints[this.api_index];
	                // console.log("failing over. old endpoint was: ", current_url, " new one is: ", nextEndpoint);
	                this.setOptions({ url: nextEndpoint });
	            }
	        }
	    }]);
	
	    return Hive;
	}(_events2.default);
	
	// Export singleton instance
	
	
	var hive = new Hive(_config2.default);
	exports = module.exports = hive;
	exports.Hive = Hive;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function (n) {
	  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function (type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events) this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler)) return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++) {
	      listeners[i].apply(this, args);
	    }
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function (type, listener) {
	  var m;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events) this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function (type, listener) {
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function (type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type]) return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener || isFunction(list.listener) && list.listener === listener) {
	    delete this._events[type];
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0) return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function (type) {
	  var key, listeners;
	
	  if (!this._events) return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length) {
	      this.removeListener(type, listeners[listeners.length - 1]);
	    }
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function (type) {
	  var ret;
	  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function (type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function (emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try {
	        if (Promise === bluebird) Promise = old;
	    } catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(4)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	module.exports = function () {
	    var makeSelfResolutionError = function makeSelfResolutionError() {
	        return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
	    };
	    var reflectHandler = function reflectHandler() {
	        return new Promise.PromiseInspection(this._target());
	    };
	    var apiRejection = function apiRejection(msg) {
	        return Promise.reject(new TypeError(msg));
	    };
	    function Proxyable() {}
	    var UNDEFINED_BINDING = {};
	    var util = __webpack_require__(6);
	
	    var getDomain;
	    if (util.isNode) {
	        getDomain = function getDomain() {
	            var ret = process.domain;
	            if (ret === undefined) ret = null;
	            return ret;
	        };
	    } else {
	        getDomain = function getDomain() {
	            return null;
	        };
	    }
	    util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	    var es5 = __webpack_require__(7);
	    var Async = __webpack_require__(8);
	    var async = new Async();
	    es5.defineProperty(Promise, "_async", { value: async });
	    var errors = __webpack_require__(13);
	    var TypeError = Promise.TypeError = errors.TypeError;
	    Promise.RangeError = errors.RangeError;
	    var CancellationError = Promise.CancellationError = errors.CancellationError;
	    Promise.TimeoutError = errors.TimeoutError;
	    Promise.OperationalError = errors.OperationalError;
	    Promise.RejectionError = errors.OperationalError;
	    Promise.AggregateError = errors.AggregateError;
	    var INTERNAL = function INTERNAL() {};
	    var APPLY = {};
	    var NEXT_FILTER = {};
	    var tryConvertToPromise = __webpack_require__(14)(Promise, INTERNAL);
	    var PromiseArray = __webpack_require__(15)(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
	    var Context = __webpack_require__(16)(Promise);
	    /*jshint unused:false*/
	    var createContext = Context.create;
	    var debug = __webpack_require__(17)(Promise, Context);
	    var CapturedTrace = debug.CapturedTrace;
	    var PassThroughHandlerContext = __webpack_require__(18)(Promise, tryConvertToPromise, NEXT_FILTER);
	    var catchFilter = __webpack_require__(19)(NEXT_FILTER);
	    var nodebackForPromise = __webpack_require__(20);
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    function check(self, executor) {
	        if (self == null || self.constructor !== Promise) {
	            throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        if (typeof executor !== "function") {
	            throw new TypeError("expecting a function but got " + util.classString(executor));
	        }
	    }
	
	    function Promise(executor) {
	        if (executor !== INTERNAL) {
	            check(this, executor);
	        }
	        this._bitField = 0;
	        this._fulfillmentHandler0 = undefined;
	        this._rejectionHandler0 = undefined;
	        this._promise0 = undefined;
	        this._receiver0 = undefined;
	        this._resolveFromExecutor(executor);
	        this._promiseCreated();
	        this._fireEvent("promiseCreated", this);
	    }
	
	    Promise.prototype.toString = function () {
	        return "[object Promise]";
	    };
	
	    Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	        var len = arguments.length;
	        if (len > 1) {
	            var catchInstances = new Array(len - 1),
	                j = 0,
	                i;
	            for (i = 0; i < len - 1; ++i) {
	                var item = arguments[i];
	                if (util.isObject(item)) {
	                    catchInstances[j++] = item;
	                } else {
	                    return apiRejection("Catch statement predicate: " + "expecting an object but got " + util.classString(item));
	                }
	            }
	            catchInstances.length = j;
	            fn = arguments[i];
	            return this.then(undefined, catchFilter(catchInstances, fn, this));
	        }
	        return this.then(undefined, fn);
	    };
	
	    Promise.prototype.reflect = function () {
	        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
	    };
	
	    Promise.prototype.then = function (didFulfill, didReject) {
	        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
	            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
	            if (arguments.length > 1) {
	                msg += ", " + util.classString(didReject);
	            }
	            this._warn(msg);
	        }
	        return this._then(didFulfill, didReject, undefined, undefined, undefined);
	    };
	
	    Promise.prototype.done = function (didFulfill, didReject) {
	        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
	        promise._setIsFinal();
	    };
	
	    Promise.prototype.spread = function (fn) {
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	    };
	
	    Promise.prototype.toJSON = function () {
	        var ret = {
	            isFulfilled: false,
	            isRejected: false,
	            fulfillmentValue: undefined,
	            rejectionReason: undefined
	        };
	        if (this.isFulfilled()) {
	            ret.fulfillmentValue = this.value();
	            ret.isFulfilled = true;
	        } else if (this.isRejected()) {
	            ret.rejectionReason = this.reason();
	            ret.isRejected = true;
	        }
	        return ret;
	    };
	
	    Promise.prototype.all = function () {
	        if (arguments.length > 0) {
	            this._warn(".all() was passed arguments but it does not take any");
	        }
	        return new PromiseArray(this).promise();
	    };
	
	    Promise.prototype.error = function (fn) {
	        return this.caught(util.originatesFromRejection, fn);
	    };
	
	    Promise.getNewLibraryCopy = module.exports;
	
	    Promise.is = function (val) {
	        return val instanceof Promise;
	    };
	
	    Promise.fromNode = Promise.fromCallback = function (fn) {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
	        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	        if (result === errorObj) {
	            ret._rejectCallback(result.e, true);
	        }
	        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	        return ret;
	    };
	
	    Promise.all = function (promises) {
	        return new PromiseArray(promises).promise();
	    };
	
	    Promise.cast = function (obj) {
	        var ret = tryConvertToPromise(obj);
	        if (!(ret instanceof Promise)) {
	            ret = new Promise(INTERNAL);
	            ret._captureStackTrace();
	            ret._setFulfilled();
	            ret._rejectionHandler0 = obj;
	        }
	        return ret;
	    };
	
	    Promise.resolve = Promise.fulfilled = Promise.cast;
	
	    Promise.reject = Promise.rejected = function (reason) {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._rejectCallback(reason, true);
	        return ret;
	    };
	
	    Promise.setScheduler = function (fn) {
	        if (typeof fn !== "function") {
	            throw new TypeError("expecting a function but got " + util.classString(fn));
	        }
	        return async.setScheduler(fn);
	    };
	
	    Promise.prototype._then = function (didFulfill, didReject, _, receiver, internalData) {
	        var haveInternalData = internalData !== undefined;
	        var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	        var target = this._target();
	        var bitField = target._bitField;
	
	        if (!haveInternalData) {
	            promise._propagateFrom(this, 3);
	            promise._captureStackTrace();
	            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
	                if (!((bitField & 50397184) === 0)) {
	                    receiver = this._boundValue();
	                } else {
	                    receiver = target === this ? undefined : this._boundTo;
	                }
	            }
	            this._fireEvent("promiseChained", this, promise);
	        }
	
	        var domain = getDomain();
	        if (!((bitField & 50397184) === 0)) {
	            var handler,
	                value,
	                settler = target._settlePromiseCtx;
	            if ((bitField & 33554432) !== 0) {
	                value = target._rejectionHandler0;
	                handler = didFulfill;
	            } else if ((bitField & 16777216) !== 0) {
	                value = target._fulfillmentHandler0;
	                handler = didReject;
	                target._unsetRejectionIsUnhandled();
	            } else {
	                settler = target._settlePromiseLateCancellationObserver;
	                value = new CancellationError("late cancellation observer");
	                target._attachExtraTrace(value);
	                handler = didReject;
	            }
	
	            async.invoke(settler, target, {
	                handler: domain === null ? handler : typeof handler === "function" && util.domainBind(domain, handler),
	                promise: promise,
	                receiver: receiver,
	                value: value
	            });
	        } else {
	            target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	        }
	
	        return promise;
	    };
	
	    Promise.prototype._length = function () {
	        return this._bitField & 65535;
	    };
	
	    Promise.prototype._isFateSealed = function () {
	        return (this._bitField & 117506048) !== 0;
	    };
	
	    Promise.prototype._isFollowing = function () {
	        return (this._bitField & 67108864) === 67108864;
	    };
	
	    Promise.prototype._setLength = function (len) {
	        this._bitField = this._bitField & -65536 | len & 65535;
	    };
	
	    Promise.prototype._setFulfilled = function () {
	        this._bitField = this._bitField | 33554432;
	        this._fireEvent("promiseFulfilled", this);
	    };
	
	    Promise.prototype._setRejected = function () {
	        this._bitField = this._bitField | 16777216;
	        this._fireEvent("promiseRejected", this);
	    };
	
	    Promise.prototype._setFollowing = function () {
	        this._bitField = this._bitField | 67108864;
	        this._fireEvent("promiseResolved", this);
	    };
	
	    Promise.prototype._setIsFinal = function () {
	        this._bitField = this._bitField | 4194304;
	    };
	
	    Promise.prototype._isFinal = function () {
	        return (this._bitField & 4194304) > 0;
	    };
	
	    Promise.prototype._unsetCancelled = function () {
	        this._bitField = this._bitField & ~65536;
	    };
	
	    Promise.prototype._setCancelled = function () {
	        this._bitField = this._bitField | 65536;
	        this._fireEvent("promiseCancelled", this);
	    };
	
	    Promise.prototype._setWillBeCancelled = function () {
	        this._bitField = this._bitField | 8388608;
	    };
	
	    Promise.prototype._setAsyncGuaranteed = function () {
	        if (async.hasCustomScheduler()) return;
	        this._bitField = this._bitField | 134217728;
	    };
	
	    Promise.prototype._receiverAt = function (index) {
	        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
	        if (ret === UNDEFINED_BINDING) {
	            return undefined;
	        } else if (ret === undefined && this._isBound()) {
	            return this._boundValue();
	        }
	        return ret;
	    };
	
	    Promise.prototype._promiseAt = function (index) {
	        return this[index * 4 - 4 + 2];
	    };
	
	    Promise.prototype._fulfillmentHandlerAt = function (index) {
	        return this[index * 4 - 4 + 0];
	    };
	
	    Promise.prototype._rejectionHandlerAt = function (index) {
	        return this[index * 4 - 4 + 1];
	    };
	
	    Promise.prototype._boundValue = function () {};
	
	    Promise.prototype._migrateCallback0 = function (follower) {
	        var bitField = follower._bitField;
	        var fulfill = follower._fulfillmentHandler0;
	        var reject = follower._rejectionHandler0;
	        var promise = follower._promise0;
	        var receiver = follower._receiverAt(0);
	        if (receiver === undefined) receiver = UNDEFINED_BINDING;
	        this._addCallbacks(fulfill, reject, promise, receiver, null);
	    };
	
	    Promise.prototype._migrateCallbackAt = function (follower, index) {
	        var fulfill = follower._fulfillmentHandlerAt(index);
	        var reject = follower._rejectionHandlerAt(index);
	        var promise = follower._promiseAt(index);
	        var receiver = follower._receiverAt(index);
	        if (receiver === undefined) receiver = UNDEFINED_BINDING;
	        this._addCallbacks(fulfill, reject, promise, receiver, null);
	    };
	
	    Promise.prototype._addCallbacks = function (fulfill, reject, promise, receiver, domain) {
	        var index = this._length();
	
	        if (index >= 65535 - 4) {
	            index = 0;
	            this._setLength(0);
	        }
	
	        if (index === 0) {
	            this._promise0 = promise;
	            this._receiver0 = receiver;
	            if (typeof fulfill === "function") {
	                this._fulfillmentHandler0 = domain === null ? fulfill : util.domainBind(domain, fulfill);
	            }
	            if (typeof reject === "function") {
	                this._rejectionHandler0 = domain === null ? reject : util.domainBind(domain, reject);
	            }
	        } else {
	            var base = index * 4 - 4;
	            this[base + 2] = promise;
	            this[base + 3] = receiver;
	            if (typeof fulfill === "function") {
	                this[base + 0] = domain === null ? fulfill : util.domainBind(domain, fulfill);
	            }
	            if (typeof reject === "function") {
	                this[base + 1] = domain === null ? reject : util.domainBind(domain, reject);
	            }
	        }
	        this._setLength(index + 1);
	        return index;
	    };
	
	    Promise.prototype._proxy = function (proxyable, arg) {
	        this._addCallbacks(undefined, undefined, arg, proxyable, null);
	    };
	
	    Promise.prototype._resolveCallback = function (value, shouldBind) {
	        if ((this._bitField & 117506048) !== 0) return;
	        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
	        var maybePromise = tryConvertToPromise(value, this);
	        if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	        if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	        var promise = maybePromise._target();
	
	        if (promise === this) {
	            this._reject(makeSelfResolutionError());
	            return;
	        }
	
	        var bitField = promise._bitField;
	        if ((bitField & 50397184) === 0) {
	            var len = this._length();
	            if (len > 0) promise._migrateCallback0(this);
	            for (var i = 1; i < len; ++i) {
	                promise._migrateCallbackAt(this, i);
	            }
	            this._setFollowing();
	            this._setLength(0);
	            this._setFollowee(promise);
	        } else if ((bitField & 33554432) !== 0) {
	            this._fulfill(promise._value());
	        } else if ((bitField & 16777216) !== 0) {
	            this._reject(promise._reason());
	        } else {
	            var reason = new CancellationError("late cancellation observer");
	            promise._attachExtraTrace(reason);
	            this._reject(reason);
	        }
	    };
	
	    Promise.prototype._rejectCallback = function (reason, synchronous, ignoreNonErrorWarnings) {
	        var trace = util.ensureErrorObject(reason);
	        var hasStack = trace === reason;
	        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	            var message = "a promise was rejected with a non-error: " + util.classString(reason);
	            this._warn(message, true);
	        }
	        this._attachExtraTrace(trace, synchronous ? hasStack : false);
	        this._reject(reason);
	    };
	
	    Promise.prototype._resolveFromExecutor = function (executor) {
	        if (executor === INTERNAL) return;
	        var promise = this;
	        this._captureStackTrace();
	        this._pushContext();
	        var synchronous = true;
	        var r = this._execute(executor, function (value) {
	            promise._resolveCallback(value);
	        }, function (reason) {
	            promise._rejectCallback(reason, synchronous);
	        });
	        synchronous = false;
	        this._popContext();
	
	        if (r !== undefined) {
	            promise._rejectCallback(r, true);
	        }
	    };
	
	    Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
	        var bitField = promise._bitField;
	        if ((bitField & 65536) !== 0) return;
	        promise._pushContext();
	        var x;
	        if (receiver === APPLY) {
	            if (!value || typeof value.length !== "number") {
	                x = errorObj;
	                x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
	            } else {
	                x = tryCatch(handler).apply(this._boundValue(), value);
	            }
	        } else {
	            x = tryCatch(handler).call(receiver, value);
	        }
	        var promiseCreated = promise._popContext();
	        bitField = promise._bitField;
	        if ((bitField & 65536) !== 0) return;
	
	        if (x === NEXT_FILTER) {
	            promise._reject(value);
	        } else if (x === errorObj) {
	            promise._rejectCallback(x.e, false);
	        } else {
	            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
	            promise._resolveCallback(x);
	        }
	    };
	
	    Promise.prototype._target = function () {
	        var ret = this;
	        while (ret._isFollowing()) {
	            ret = ret._followee();
	        }return ret;
	    };
	
	    Promise.prototype._followee = function () {
	        return this._rejectionHandler0;
	    };
	
	    Promise.prototype._setFollowee = function (promise) {
	        this._rejectionHandler0 = promise;
	    };
	
	    Promise.prototype._settlePromise = function (promise, handler, receiver, value) {
	        var isPromise = promise instanceof Promise;
	        var bitField = this._bitField;
	        var asyncGuaranteed = (bitField & 134217728) !== 0;
	        if ((bitField & 65536) !== 0) {
	            if (isPromise) promise._invokeInternalOnCancel();
	
	            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
	                receiver.cancelPromise = promise;
	                if (tryCatch(handler).call(receiver, value) === errorObj) {
	                    promise._reject(errorObj.e);
	                }
	            } else if (handler === reflectHandler) {
	                promise._fulfill(reflectHandler.call(receiver));
	            } else if (receiver instanceof Proxyable) {
	                receiver._promiseCancelled(promise);
	            } else if (isPromise || promise instanceof PromiseArray) {
	                promise._cancel();
	            } else {
	                receiver.cancel();
	            }
	        } else if (typeof handler === "function") {
	            if (!isPromise) {
	                handler.call(receiver, value, promise);
	            } else {
	                if (asyncGuaranteed) promise._setAsyncGuaranteed();
	                this._settlePromiseFromHandler(handler, receiver, value, promise);
	            }
	        } else if (receiver instanceof Proxyable) {
	            if (!receiver._isResolved()) {
	                if ((bitField & 33554432) !== 0) {
	                    receiver._promiseFulfilled(value, promise);
	                } else {
	                    receiver._promiseRejected(value, promise);
	                }
	            }
	        } else if (isPromise) {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            if ((bitField & 33554432) !== 0) {
	                promise._fulfill(value);
	            } else {
	                promise._reject(value);
	            }
	        }
	    };
	
	    Promise.prototype._settlePromiseLateCancellationObserver = function (ctx) {
	        var handler = ctx.handler;
	        var promise = ctx.promise;
	        var receiver = ctx.receiver;
	        var value = ctx.value;
	        if (typeof handler === "function") {
	            if (!(promise instanceof Promise)) {
	                handler.call(receiver, value, promise);
	            } else {
	                this._settlePromiseFromHandler(handler, receiver, value, promise);
	            }
	        } else if (promise instanceof Promise) {
	            promise._reject(value);
	        }
	    };
	
	    Promise.prototype._settlePromiseCtx = function (ctx) {
	        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	    };
	
	    Promise.prototype._settlePromise0 = function (handler, value, bitField) {
	        var promise = this._promise0;
	        var receiver = this._receiverAt(0);
	        this._promise0 = undefined;
	        this._receiver0 = undefined;
	        this._settlePromise(promise, handler, receiver, value);
	    };
	
	    Promise.prototype._clearCallbackDataAtIndex = function (index) {
	        var base = index * 4 - 4;
	        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
	    };
	
	    Promise.prototype._fulfill = function (value) {
	        var bitField = this._bitField;
	        if ((bitField & 117506048) >>> 16) return;
	        if (value === this) {
	            var err = makeSelfResolutionError();
	            this._attachExtraTrace(err);
	            return this._reject(err);
	        }
	        this._setFulfilled();
	        this._rejectionHandler0 = value;
	
	        if ((bitField & 65535) > 0) {
	            if ((bitField & 134217728) !== 0) {
	                this._settlePromises();
	            } else {
	                async.settlePromises(this);
	            }
	        }
	    };
	
	    Promise.prototype._reject = function (reason) {
	        var bitField = this._bitField;
	        if ((bitField & 117506048) >>> 16) return;
	        this._setRejected();
	        this._fulfillmentHandler0 = reason;
	
	        if (this._isFinal()) {
	            return async.fatalError(reason, util.isNode);
	        }
	
	        if ((bitField & 65535) > 0) {
	            async.settlePromises(this);
	        } else {
	            this._ensurePossibleRejectionHandled();
	        }
	    };
	
	    Promise.prototype._fulfillPromises = function (len, value) {
	        for (var i = 1; i < len; i++) {
	            var handler = this._fulfillmentHandlerAt(i);
	            var promise = this._promiseAt(i);
	            var receiver = this._receiverAt(i);
	            this._clearCallbackDataAtIndex(i);
	            this._settlePromise(promise, handler, receiver, value);
	        }
	    };
	
	    Promise.prototype._rejectPromises = function (len, reason) {
	        for (var i = 1; i < len; i++) {
	            var handler = this._rejectionHandlerAt(i);
	            var promise = this._promiseAt(i);
	            var receiver = this._receiverAt(i);
	            this._clearCallbackDataAtIndex(i);
	            this._settlePromise(promise, handler, receiver, reason);
	        }
	    };
	
	    Promise.prototype._settlePromises = function () {
	        var bitField = this._bitField;
	        var len = bitField & 65535;
	
	        if (len > 0) {
	            if ((bitField & 16842752) !== 0) {
	                var reason = this._fulfillmentHandler0;
	                this._settlePromise0(this._rejectionHandler0, reason, bitField);
	                this._rejectPromises(len, reason);
	            } else {
	                var value = this._rejectionHandler0;
	                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	                this._fulfillPromises(len, value);
	            }
	            this._setLength(0);
	        }
	        this._clearCancellationData();
	    };
	
	    Promise.prototype._settledValue = function () {
	        var bitField = this._bitField;
	        if ((bitField & 33554432) !== 0) {
	            return this._rejectionHandler0;
	        } else if ((bitField & 16777216) !== 0) {
	            return this._fulfillmentHandler0;
	        }
	    };
	
	    function deferResolve(v) {
	        this.promise._resolveCallback(v);
	    }
	    function deferReject(v) {
	        this.promise._rejectCallback(v, false);
	    }
	
	    Promise.defer = Promise.pending = function () {
	        debug.deprecated("Promise.defer", "new Promise");
	        var promise = new Promise(INTERNAL);
	        return {
	            promise: promise,
	            resolve: deferResolve,
	            reject: deferReject
	        };
	    };
	
	    util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
	
	    __webpack_require__(21)(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
	    __webpack_require__(22)(Promise, INTERNAL, tryConvertToPromise, debug);
	    __webpack_require__(23)(Promise, PromiseArray, apiRejection, debug);
	    __webpack_require__(24)(Promise);
	    __webpack_require__(25)(Promise);
	    __webpack_require__(26)(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	    Promise.Promise = Promise;
	    Promise.version = "3.5.1";
	    __webpack_require__(27)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	    __webpack_require__(28)(Promise);
	    __webpack_require__(29)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	    __webpack_require__(30)(Promise, INTERNAL, debug);
	    __webpack_require__(31)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	    __webpack_require__(32)(Promise);
	    __webpack_require__(33)(Promise, INTERNAL);
	    __webpack_require__(34)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	    __webpack_require__(35)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	    __webpack_require__(36)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	    __webpack_require__(37)(Promise, PromiseArray, debug);
	    __webpack_require__(38)(Promise, PromiseArray, apiRejection);
	    __webpack_require__(39)(Promise, INTERNAL);
	    __webpack_require__(40)(Promise, INTERNAL);
	    __webpack_require__(41)(Promise);
	
	    util.toFastProperties(Promise);
	    util.toFastProperties(Promise.prototype);
	    function fillTypes(value) {
	        var p = new Promise(INTERNAL);
	        p._fulfillmentHandler0 = value;
	        p._rejectionHandler0 = value;
	        p._promise0 = value;
	        p._receiver0 = value;
	    }
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({ a: 1 });
	    fillTypes({ b: 2 });
	    fillTypes({ c: 3 });
	    fillTypes(1);
	    fillTypes(function () {});
	    fillTypes(undefined);
	    fillTypes(false);
	    fillTypes(new Promise(INTERNAL));
	    debug.setBounds(Async.firstLineError, util.lastLineError);
	    return Promise;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var es5 = __webpack_require__(7);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = { e: {} };
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : undefined !== undefined ? undefined : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function inherits(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
	}
	
	function isObject(value) {
	    return typeof value === "function" || (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null ? desc.value : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = function () {
	    var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];
	
	    var isExcludedProto = function isExcludedProto(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function (obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function (obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	}();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) {
	        new FakeConstructor();
	    }return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for (var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error || obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && typeof obj.message === "string" && typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    } catch (ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = function () {
	    if (!("stack" in new Error())) {
	        return function (value) {
	            if (canAttachTrace(value)) return value;
	            try {
	                throw new Error(safeToString(value));
	            } catch (err) {
	                return err;
	            }
	        };
	    } else {
	        return function (value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	}();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function asArray(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function (v) {
	        return Array.from(v);
	    } : function (v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!(itResult = it.next()).done) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function asArray(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function () {});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && function () {
	    var version = process.versions.node.split(".").map(Number);
	    return version[0] === 0 && version[1] > 10 || version[0] > 0;
	}();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {
	    throw new Error();
	} catch (e) {
	    ret.lastLineError = e;
	}
	module.exports = ret;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	var isES5 = function () {
	    "use strict";
	
	    return this === undefined;
	}();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function propertyIsWritable(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function ObjectKeys(o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
	        return { value: o[key] };
	    };
	
	    var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function ObjectFreeze(obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        } catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function ArrayIsArray(obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        } catch (e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function propertyIsWritable() {
	            return true;
	        }
	    };
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var firstLineError;
	try {
	    throw new Error();
	} catch (e) {
	    firstLineError = e;
	}
	var schedule = __webpack_require__(9);
	var Queue = __webpack_require__(12);
	var util = __webpack_require__(6);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function (fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function () {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function () {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function () {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	Async.prototype.fatalError = function (e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function (fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function fn() {
	            throw arg;
	        };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function () {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function () {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function () {
	                setTimeout(function () {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function () {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function (promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function () {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function (queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	
	var util = __webpack_require__(6);
	var schedule;
	var noAsyncScheduler = function noAsyncScheduler() {
	    throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode ? function (fn) {
	        GlobalSetImmediate.call(global, fn);
	    } : function (fn) {
	        ProcessNextTick.call(process, fn);
	    };
	} else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function schedule(fn) {
	        nativePromise.then(fn);
	    };
	} else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova))) {
	    schedule = function () {
	        var div = document.createElement("div");
	        var opts = { attributes: true };
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function () {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function scheduleToggle() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function () {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    }();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function schedule(fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function schedule(fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5), __webpack_require__(10).setImmediate))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(11);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	
	(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	        // Callback can either be a function or a string
	        if (typeof callback !== "function") {
	            callback = new Function("" + callback);
	        }
	        // Copy function arguments
	        var args = new Array(arguments.length - 1);
	        for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i + 1];
	        }
	        // Store and register the task
	        var task = { callback: callback, args: args };
	        tasksByHandle[nextHandle] = task;
	        registerImmediate(nextHandle);
	        return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	            case 0:
	                callback();
	                break;
	            case 1:
	                callback(args[0]);
	                break;
	            case 2:
	                callback(args[0], args[1]);
	                break;
	            case 3:
	                callback(args[0], args[1], args[2]);
	                break;
	            default:
	                callback.apply(undefined, args);
	                break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            process.nextTick(function () {
	                runIfPresent(handle);
	            });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function registerImmediate(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function registerImmediate(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function registerImmediate(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = this._front + length & this._capacity - 1;
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[j + 0 & wrapMask] = fn;
	    this[j + 1 & wrapMask] = receiver;
	    this[j + 2 & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = front + 1 & this._capacity - 1;
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = front + length & oldCapacity - 1;
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var es5 = __webpack_require__(7);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(6);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch (e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function () {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError)) return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL) {
	    var util = __webpack_require__(6);
	    var errorObj = util.errorObj;
	    var isObject = util.isObject;
	
	    function tryConvertToPromise(obj, context) {
	        if (isObject(obj)) {
	            if (obj instanceof Promise) return obj;
	            var then = getThen(obj);
	            if (then === errorObj) {
	                if (context) context._pushContext();
	                var ret = Promise.reject(then.e);
	                if (context) context._popContext();
	                return ret;
	            } else if (typeof then === "function") {
	                if (isAnyBluebirdPromise(obj)) {
	                    var ret = new Promise(INTERNAL);
	                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
	                    return ret;
	                }
	                return doThenable(obj, then, context);
	            }
	        }
	        return obj;
	    }
	
	    function doGetThen(obj) {
	        return obj.then;
	    }
	
	    function getThen(obj) {
	        try {
	            return doGetThen(obj);
	        } catch (e) {
	            errorObj.e = e;
	            return errorObj;
	        }
	    }
	
	    var hasProp = {}.hasOwnProperty;
	    function isAnyBluebirdPromise(obj) {
	        try {
	            return hasProp.call(obj, "_promise0");
	        } catch (e) {
	            return false;
	        }
	    }
	
	    function doThenable(x, then, context) {
	        var promise = new Promise(INTERNAL);
	        var ret = promise;
	        if (context) context._pushContext();
	        promise._captureStackTrace();
	        if (context) context._popContext();
	        var synchronous = true;
	        var result = util.tryCatch(then).call(x, resolve, reject);
	        synchronous = false;
	
	        if (promise && result === errorObj) {
	            promise._rejectCallback(result.e, true, true);
	            promise = null;
	        }
	
	        function resolve(value) {
	            if (!promise) return;
	            promise._resolveCallback(value);
	            promise = null;
	        }
	
	        function reject(reason) {
	            if (!promise) return;
	            promise._rejectCallback(reason, synchronous, true);
	            promise = null;
	        }
	        return ret;
	    }
	
	    return tryConvertToPromise;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
	    var util = __webpack_require__(6);
	    var isArray = util.isArray;
	
	    function toResolutionValue(val) {
	        switch (val) {
	            case -2:
	                return [];
	            case -3:
	                return {};
	            case -6:
	                return new Map();
	        }
	    }
	
	    function PromiseArray(values) {
	        var promise = this._promise = new Promise(INTERNAL);
	        if (values instanceof Promise) {
	            promise._propagateFrom(values, 3);
	        }
	        promise._setOnCancel(this);
	        this._values = values;
	        this._length = 0;
	        this._totalResolved = 0;
	        this._init(undefined, -2);
	    }
	    util.inherits(PromiseArray, Proxyable);
	
	    PromiseArray.prototype.length = function () {
	        return this._length;
	    };
	
	    PromiseArray.prototype.promise = function () {
	        return this._promise;
	    };
	
	    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	        var values = tryConvertToPromise(this._values, this._promise);
	        if (values instanceof Promise) {
	            values = values._target();
	            var bitField = values._bitField;
	            ;
	            this._values = values;
	
	            if ((bitField & 50397184) === 0) {
	                this._promise._setAsyncGuaranteed();
	                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
	            } else if ((bitField & 33554432) !== 0) {
	                values = values._value();
	            } else if ((bitField & 16777216) !== 0) {
	                return this._reject(values._reason());
	            } else {
	                return this._cancel();
	            }
	        }
	        values = util.asArray(values);
	        if (values === null) {
	            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
	            this._promise._rejectCallback(err, false);
	            return;
	        }
	
	        if (values.length === 0) {
	            if (resolveValueIfEmpty === -5) {
	                this._resolveEmptyArray();
	            } else {
	                this._resolve(toResolutionValue(resolveValueIfEmpty));
	            }
	            return;
	        }
	        this._iterate(values);
	    };
	
	    PromiseArray.prototype._iterate = function (values) {
	        var len = this.getActualLength(values.length);
	        this._length = len;
	        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	        var result = this._promise;
	        var isResolved = false;
	        var bitField = null;
	        for (var i = 0; i < len; ++i) {
	            var maybePromise = tryConvertToPromise(values[i], result);
	
	            if (maybePromise instanceof Promise) {
	                maybePromise = maybePromise._target();
	                bitField = maybePromise._bitField;
	            } else {
	                bitField = null;
	            }
	
	            if (isResolved) {
	                if (bitField !== null) {
	                    maybePromise.suppressUnhandledRejections();
	                }
	            } else if (bitField !== null) {
	                if ((bitField & 50397184) === 0) {
	                    maybePromise._proxy(this, i);
	                    this._values[i] = maybePromise;
	                } else if ((bitField & 33554432) !== 0) {
	                    isResolved = this._promiseFulfilled(maybePromise._value(), i);
	                } else if ((bitField & 16777216) !== 0) {
	                    isResolved = this._promiseRejected(maybePromise._reason(), i);
	                } else {
	                    isResolved = this._promiseCancelled(i);
	                }
	            } else {
	                isResolved = this._promiseFulfilled(maybePromise, i);
	            }
	        }
	        if (!isResolved) result._setAsyncGuaranteed();
	    };
	
	    PromiseArray.prototype._isResolved = function () {
	        return this._values === null;
	    };
	
	    PromiseArray.prototype._resolve = function (value) {
	        this._values = null;
	        this._promise._fulfill(value);
	    };
	
	    PromiseArray.prototype._cancel = function () {
	        if (this._isResolved() || !this._promise._isCancellable()) return;
	        this._values = null;
	        this._promise._cancel();
	    };
	
	    PromiseArray.prototype._reject = function (reason) {
	        this._values = null;
	        this._promise._rejectCallback(reason, false);
	    };
	
	    PromiseArray.prototype._promiseFulfilled = function (value, index) {
	        this._values[index] = value;
	        var totalResolved = ++this._totalResolved;
	        if (totalResolved >= this._length) {
	            this._resolve(this._values);
	            return true;
	        }
	        return false;
	    };
	
	    PromiseArray.prototype._promiseCancelled = function () {
	        this._cancel();
	        return true;
	    };
	
	    PromiseArray.prototype._promiseRejected = function (reason) {
	        this._totalResolved++;
	        this._reject(reason);
	        return true;
	    };
	
	    PromiseArray.prototype._resultCancelled = function () {
	        if (this._isResolved()) return;
	        var values = this._values;
	        this._cancel();
	        if (values instanceof Promise) {
	            values.cancel();
	        } else {
	            for (var i = 0; i < values.length; ++i) {
	                if (values[i] instanceof Promise) {
	                    values[i].cancel();
	                }
	            }
	        }
	    };
	
	    PromiseArray.prototype.shouldCopyValues = function () {
	        return true;
	    };
	
	    PromiseArray.prototype.getActualLength = function (len) {
	        return len;
	    };
	
	    return PromiseArray;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise) {
	    var longStackTraces = false;
	    var contextStack = [];
	
	    Promise.prototype._promiseCreated = function () {};
	    Promise.prototype._pushContext = function () {};
	    Promise.prototype._popContext = function () {
	        return null;
	    };
	    Promise._peekContext = Promise.prototype._peekContext = function () {};
	
	    function Context() {
	        this._trace = new Context.CapturedTrace(peekContext());
	    }
	    Context.prototype._pushContext = function () {
	        if (this._trace !== undefined) {
	            this._trace._promiseCreated = null;
	            contextStack.push(this._trace);
	        }
	    };
	
	    Context.prototype._popContext = function () {
	        if (this._trace !== undefined) {
	            var trace = contextStack.pop();
	            var ret = trace._promiseCreated;
	            trace._promiseCreated = null;
	            return ret;
	        }
	        return null;
	    };
	
	    function createContext() {
	        if (longStackTraces) return new Context();
	    }
	
	    function peekContext() {
	        var lastIndex = contextStack.length - 1;
	        if (lastIndex >= 0) {
	            return contextStack[lastIndex];
	        }
	        return undefined;
	    }
	    Context.CapturedTrace = null;
	    Context.create = createContext;
	    Context.deactivateLongStackTraces = function () {};
	    Context.activateLongStackTraces = function () {
	        var Promise_pushContext = Promise.prototype._pushContext;
	        var Promise_popContext = Promise.prototype._popContext;
	        var Promise_PeekContext = Promise._peekContext;
	        var Promise_peekContext = Promise.prototype._peekContext;
	        var Promise_promiseCreated = Promise.prototype._promiseCreated;
	        Context.deactivateLongStackTraces = function () {
	            Promise.prototype._pushContext = Promise_pushContext;
	            Promise.prototype._popContext = Promise_popContext;
	            Promise._peekContext = Promise_PeekContext;
	            Promise.prototype._peekContext = Promise_peekContext;
	            Promise.prototype._promiseCreated = Promise_promiseCreated;
	            longStackTraces = false;
	        };
	        longStackTraces = true;
	        Promise.prototype._pushContext = Context.prototype._pushContext;
	        Promise.prototype._popContext = Context.prototype._popContext;
	        Promise._peekContext = Promise.prototype._peekContext = peekContext;
	        Promise.prototype._promiseCreated = function () {
	            var ctx = this._peekContext();
	            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	        };
	    };
	    return Context;
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (Promise, Context) {
	    var getDomain = Promise._getDomain;
	    var async = Promise._async;
	    var Warning = __webpack_require__(13).Warning;
	    var util = __webpack_require__(6);
	    var canAttachTrace = util.canAttachTrace;
	    var unhandledRejectionHandled;
	    var possiblyUnhandledRejection;
	    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	    var stackFramePattern = null;
	    var formatStack = null;
	    var indentStackFrames = false;
	    var printWarning;
	    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (false || util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
	
	    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	    Promise.prototype.suppressUnhandledRejections = function () {
	        var target = this._target();
	        target._bitField = target._bitField & ~1048576 | 524288;
	    };
	
	    Promise.prototype._ensurePossibleRejectionHandled = function () {
	        if ((this._bitField & 524288) !== 0) return;
	        this._setRejectionIsUnhandled();
	        var self = this;
	        setTimeout(function () {
	            self._notifyUnhandledRejection();
	        }, 1);
	    };
	
	    Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
	    };
	
	    Promise.prototype._setReturnedNonUndefined = function () {
	        this._bitField = this._bitField | 268435456;
	    };
	
	    Promise.prototype._returnedNonUndefined = function () {
	        return (this._bitField & 268435456) !== 0;
	    };
	
	    Promise.prototype._notifyUnhandledRejection = function () {
	        if (this._isRejectionUnhandled()) {
	            var reason = this._settledValue();
	            this._setUnhandledRejectionIsNotified();
	            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
	        }
	    };
	
	    Promise.prototype._setUnhandledRejectionIsNotified = function () {
	        this._bitField = this._bitField | 262144;
	    };
	
	    Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	        this._bitField = this._bitField & ~262144;
	    };
	
	    Promise.prototype._isUnhandledRejectionNotified = function () {
	        return (this._bitField & 262144) > 0;
	    };
	
	    Promise.prototype._setRejectionIsUnhandled = function () {
	        this._bitField = this._bitField | 1048576;
	    };
	
	    Promise.prototype._unsetRejectionIsUnhandled = function () {
	        this._bitField = this._bitField & ~1048576;
	        if (this._isUnhandledRejectionNotified()) {
	            this._unsetUnhandledRejectionIsNotified();
	            this._notifyUnhandledRejectionIsHandled();
	        }
	    };
	
	    Promise.prototype._isRejectionUnhandled = function () {
	        return (this._bitField & 1048576) > 0;
	    };
	
	    Promise.prototype._warn = function (message, shouldUseOwnTrace, promise) {
	        return warn(message, shouldUseOwnTrace, promise || this);
	    };
	
	    Promise.onPossiblyUnhandledRejection = function (fn) {
	        var domain = getDomain();
	        possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
	    };
	
	    Promise.onUnhandledRejectionHandled = function (fn) {
	        var domain = getDomain();
	        unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
	    };
	
	    var disableLongStackTraces = function disableLongStackTraces() {};
	    Promise.longStackTraces = function () {
	        if (async.haveItemsQueued() && !config.longStackTraces) {
	            throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        if (!config.longStackTraces && longStackTracesIsSupported()) {
	            var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	            var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	            config.longStackTraces = true;
	            disableLongStackTraces = function disableLongStackTraces() {
	                if (async.haveItemsQueued() && !config.longStackTraces) {
	                    throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
	                }
	                Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	                Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	                Context.deactivateLongStackTraces();
	                async.enableTrampoline();
	                config.longStackTraces = false;
	            };
	            Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	            Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	            Context.activateLongStackTraces();
	            async.disableTrampolineIfNecessary();
	        }
	    };
	
	    Promise.hasLongStackTraces = function () {
	        return config.longStackTraces && longStackTracesIsSupported();
	    };
	
	    var fireDomEvent = function () {
	        try {
	            if (typeof CustomEvent === "function") {
	                var event = new CustomEvent("CustomEvent");
	                util.global.dispatchEvent(event);
	                return function (name, event) {
	                    var domEvent = new CustomEvent(name.toLowerCase(), {
	                        detail: event,
	                        cancelable: true
	                    });
	                    return !util.global.dispatchEvent(domEvent);
	                };
	            } else if (typeof Event === "function") {
	                var event = new Event("CustomEvent");
	                util.global.dispatchEvent(event);
	                return function (name, event) {
	                    var domEvent = new Event(name.toLowerCase(), {
	                        cancelable: true
	                    });
	                    domEvent.detail = event;
	                    return !util.global.dispatchEvent(domEvent);
	                };
	            } else {
	                var event = document.createEvent("CustomEvent");
	                event.initCustomEvent("testingtheevent", false, true, {});
	                util.global.dispatchEvent(event);
	                return function (name, event) {
	                    var domEvent = document.createEvent("CustomEvent");
	                    domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
	                    return !util.global.dispatchEvent(domEvent);
	                };
	            }
	        } catch (e) {}
	        return function () {
	            return false;
	        };
	    }();
	
	    var fireGlobalEvent = function () {
	        if (util.isNode) {
	            return function () {
	                return process.emit.apply(process, arguments);
	            };
	        } else {
	            if (!util.global) {
	                return function () {
	                    return false;
	                };
	            }
	            return function (name) {
	                var methodName = "on" + name.toLowerCase();
	                var method = util.global[methodName];
	                if (!method) return false;
	                method.apply(util.global, [].slice.call(arguments, 1));
	                return true;
	            };
	        }
	    }();
	
	    function generatePromiseLifecycleEventObject(name, promise) {
	        return { promise: promise };
	    }
	
	    var eventToObjectGenerator = {
	        promiseCreated: generatePromiseLifecycleEventObject,
	        promiseFulfilled: generatePromiseLifecycleEventObject,
	        promiseRejected: generatePromiseLifecycleEventObject,
	        promiseResolved: generatePromiseLifecycleEventObject,
	        promiseCancelled: generatePromiseLifecycleEventObject,
	        promiseChained: function promiseChained(name, promise, child) {
	            return { promise: promise, child: child };
	        },
	        warning: function warning(name, _warning) {
	            return { warning: _warning };
	        },
	        unhandledRejection: function unhandledRejection(name, reason, promise) {
	            return { reason: reason, promise: promise };
	        },
	        rejectionHandled: generatePromiseLifecycleEventObject
	    };
	
	    var activeFireEvent = function activeFireEvent(name) {
	        var globalEventFired = false;
	        try {
	            globalEventFired = fireGlobalEvent.apply(null, arguments);
	        } catch (e) {
	            async.throwLater(e);
	            globalEventFired = true;
	        }
	
	        var domEventFired = false;
	        try {
	            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
	        } catch (e) {
	            async.throwLater(e);
	            domEventFired = true;
	        }
	
	        return domEventFired || globalEventFired;
	    };
	
	    Promise.config = function (opts) {
	        opts = Object(opts);
	        if ("longStackTraces" in opts) {
	            if (opts.longStackTraces) {
	                Promise.longStackTraces();
	            } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	                disableLongStackTraces();
	            }
	        }
	        if ("warnings" in opts) {
	            var warningsOption = opts.warnings;
	            config.warnings = !!warningsOption;
	            wForgottenReturn = config.warnings;
	
	            if (util.isObject(warningsOption)) {
	                if ("wForgottenReturn" in warningsOption) {
	                    wForgottenReturn = !!warningsOption.wForgottenReturn;
	                }
	            }
	        }
	        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	            if (async.haveItemsQueued()) {
	                throw new Error("cannot enable cancellation after promises are in use");
	            }
	            Promise.prototype._clearCancellationData = cancellationClearCancellationData;
	            Promise.prototype._propagateFrom = cancellationPropagateFrom;
	            Promise.prototype._onCancel = cancellationOnCancel;
	            Promise.prototype._setOnCancel = cancellationSetOnCancel;
	            Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
	            Promise.prototype._execute = cancellationExecute;
	            _propagateFromFunction = cancellationPropagateFrom;
	            config.cancellation = true;
	        }
	        if ("monitoring" in opts) {
	            if (opts.monitoring && !config.monitoring) {
	                config.monitoring = true;
	                Promise.prototype._fireEvent = activeFireEvent;
	            } else if (!opts.monitoring && config.monitoring) {
	                config.monitoring = false;
	                Promise.prototype._fireEvent = defaultFireEvent;
	            }
	        }
	        return Promise;
	    };
	
	    function defaultFireEvent() {
	        return false;
	    }
	
	    Promise.prototype._fireEvent = defaultFireEvent;
	    Promise.prototype._execute = function (executor, resolve, reject) {
	        try {
	            executor(resolve, reject);
	        } catch (e) {
	            return e;
	        }
	    };
	    Promise.prototype._onCancel = function () {};
	    Promise.prototype._setOnCancel = function (handler) {
	        ;
	    };
	    Promise.prototype._attachCancellationCallback = function (onCancel) {
	        ;
	    };
	    Promise.prototype._captureStackTrace = function () {};
	    Promise.prototype._attachExtraTrace = function () {};
	    Promise.prototype._clearCancellationData = function () {};
	    Promise.prototype._propagateFrom = function (parent, flags) {
	        ;
	        ;
	    };
	
	    function cancellationExecute(executor, resolve, reject) {
	        var promise = this;
	        try {
	            executor(resolve, reject, function (onCancel) {
	                if (typeof onCancel !== "function") {
	                    throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
	                }
	                promise._attachCancellationCallback(onCancel);
	            });
	        } catch (e) {
	            return e;
	        }
	    }
	
	    function cancellationAttachCancellationCallback(onCancel) {
	        if (!this._isCancellable()) return this;
	
	        var previousOnCancel = this._onCancel();
	        if (previousOnCancel !== undefined) {
	            if (util.isArray(previousOnCancel)) {
	                previousOnCancel.push(onCancel);
	            } else {
	                this._setOnCancel([previousOnCancel, onCancel]);
	            }
	        } else {
	            this._setOnCancel(onCancel);
	        }
	    }
	
	    function cancellationOnCancel() {
	        return this._onCancelField;
	    }
	
	    function cancellationSetOnCancel(onCancel) {
	        this._onCancelField = onCancel;
	    }
	
	    function cancellationClearCancellationData() {
	        this._cancellationParent = undefined;
	        this._onCancelField = undefined;
	    }
	
	    function cancellationPropagateFrom(parent, flags) {
	        if ((flags & 1) !== 0) {
	            this._cancellationParent = parent;
	            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	            if (branchesRemainingToCancel === undefined) {
	                branchesRemainingToCancel = 0;
	            }
	            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	        }
	        if ((flags & 2) !== 0 && parent._isBound()) {
	            this._setBoundTo(parent._boundTo);
	        }
	    }
	
	    function bindingPropagateFrom(parent, flags) {
	        if ((flags & 2) !== 0 && parent._isBound()) {
	            this._setBoundTo(parent._boundTo);
	        }
	    }
	    var _propagateFromFunction = bindingPropagateFrom;
	
	    function _boundValueFunction() {
	        var ret = this._boundTo;
	        if (ret !== undefined) {
	            if (ret instanceof Promise) {
	                if (ret.isFulfilled()) {
	                    return ret.value();
	                } else {
	                    return undefined;
	                }
	            }
	        }
	        return ret;
	    }
	
	    function longStackTracesCaptureStackTrace() {
	        this._trace = new CapturedTrace(this._peekContext());
	    }
	
	    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	        if (canAttachTrace(error)) {
	            var trace = this._trace;
	            if (trace !== undefined) {
	                if (ignoreSelf) trace = trace._parent;
	            }
	            if (trace !== undefined) {
	                trace.attachExtraTrace(error);
	            } else if (!error.__stackCleaned__) {
	                var parsed = parseStackAndMessage(error);
	                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
	                util.notEnumerableProp(error, "__stackCleaned__", true);
	            }
	        }
	    }
	
	    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
	        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
	            if (parent !== undefined && parent._returnedNonUndefined()) return;
	            if ((promise._bitField & 65535) === 0) return;
	
	            if (name) name = name + " ";
	            var handlerLine = "";
	            var creatorLine = "";
	            if (promiseCreated._trace) {
	                var traceLines = promiseCreated._trace.stack.split("\n");
	                var stack = cleanStack(traceLines);
	                for (var i = stack.length - 1; i >= 0; --i) {
	                    var line = stack[i];
	                    if (!nodeFramePattern.test(line)) {
	                        var lineMatches = line.match(parseLinePattern);
	                        if (lineMatches) {
	                            handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                        }
	                        break;
	                    }
	                }
	
	                if (stack.length > 0) {
	                    var firstUserLine = stack[0];
	                    for (var i = 0; i < traceLines.length; ++i) {
	
	                        if (traceLines[i] === firstUserLine) {
	                            if (i > 0) {
	                                creatorLine = "\n" + traceLines[i - 1];
	                            }
	                            break;
	                        }
	                    }
	                }
	            }
	            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
	            promise._warn(msg, true, promiseCreated);
	        }
	    }
	
	    function deprecated(name, replacement) {
	        var message = name + " is deprecated and will be removed in a future version.";
	        if (replacement) message += " Use " + replacement + " instead.";
	        return warn(message);
	    }
	
	    function warn(message, shouldUseOwnTrace, promise) {
	        if (!config.warnings) return;
	        var warning = new Warning(message);
	        var ctx;
	        if (shouldUseOwnTrace) {
	            promise._attachExtraTrace(warning);
	        } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	            ctx.attachExtraTrace(warning);
	        } else {
	            var parsed = parseStackAndMessage(warning);
	            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	        }
	
	        if (!activeFireEvent("warning", warning)) {
	            formatAndLogError(warning, "", true);
	        }
	    }
	
	    function reconstructStack(message, stacks) {
	        for (var i = 0; i < stacks.length - 1; ++i) {
	            stacks[i].push("From previous event:");
	            stacks[i] = stacks[i].join("\n");
	        }
	        if (i < stacks.length) {
	            stacks[i] = stacks[i].join("\n");
	        }
	        return message + "\n" + stacks.join("\n");
	    }
	
	    function removeDuplicateOrEmptyJumps(stacks) {
	        for (var i = 0; i < stacks.length; ++i) {
	            if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
	                stacks.splice(i, 1);
	                i--;
	            }
	        }
	    }
	
	    function removeCommonRoots(stacks) {
	        var current = stacks[0];
	        for (var i = 1; i < stacks.length; ++i) {
	            var prev = stacks[i];
	            var currentLastIndex = current.length - 1;
	            var currentLastLine = current[currentLastIndex];
	            var commonRootMeetPoint = -1;
	
	            for (var j = prev.length - 1; j >= 0; --j) {
	                if (prev[j] === currentLastLine) {
	                    commonRootMeetPoint = j;
	                    break;
	                }
	            }
	
	            for (var j = commonRootMeetPoint; j >= 0; --j) {
	                var line = prev[j];
	                if (current[currentLastIndex] === line) {
	                    current.pop();
	                    currentLastIndex--;
	                } else {
	                    break;
	                }
	            }
	            current = prev;
	        }
	    }
	
	    function cleanStack(stack) {
	        var ret = [];
	        for (var i = 0; i < stack.length; ++i) {
	            var line = stack[i];
	            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
	            var isInternalFrame = isTraceLine && shouldIgnore(line);
	            if (isTraceLine && !isInternalFrame) {
	                if (indentStackFrames && line.charAt(0) !== " ") {
	                    line = "    " + line;
	                }
	                ret.push(line);
	            }
	        }
	        return ret;
	    }
	
	    function stackFramesAsArray(error) {
	        var stack = error.stack.replace(/\s+$/g, "").split("\n");
	        for (var i = 0; i < stack.length; ++i) {
	            var line = stack[i];
	            if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	                break;
	            }
	        }
	        if (i > 0 && error.name != "SyntaxError") {
	            stack = stack.slice(i);
	        }
	        return stack;
	    }
	
	    function parseStackAndMessage(error) {
	        var stack = error.stack;
	        var message = error.toString();
	        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
	        return {
	            message: message,
	            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	        };
	    }
	
	    function formatAndLogError(error, title, isSoft) {
	        if (typeof console !== "undefined") {
	            var message;
	            if (util.isObject(error)) {
	                var stack = error.stack;
	                message = title + formatStack(stack, error);
	            } else {
	                message = title + String(error);
	            }
	            if (typeof printWarning === "function") {
	                printWarning(message, isSoft);
	            } else if (typeof console.log === "function" || _typeof(console.log) === "object") {
	                console.log(message);
	            }
	        }
	    }
	
	    function fireRejectionEvent(name, localHandler, reason, promise) {
	        var localEventFired = false;
	        try {
	            if (typeof localHandler === "function") {
	                localEventFired = true;
	                if (name === "rejectionHandled") {
	                    localHandler(promise);
	                } else {
	                    localHandler(reason, promise);
	                }
	            }
	        } catch (e) {
	            async.throwLater(e);
	        }
	
	        if (name === "unhandledRejection") {
	            if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	                formatAndLogError(reason, "Unhandled rejection ");
	            }
	        } else {
	            activeFireEvent(name, promise);
	        }
	    }
	
	    function formatNonError(obj) {
	        var str;
	        if (typeof obj === "function") {
	            str = "[function " + (obj.name || "anonymous") + "]";
	        } else {
	            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
	            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	            if (ruselessToString.test(str)) {
	                try {
	                    var newStr = JSON.stringify(obj);
	                    str = newStr;
	                } catch (e) {}
	            }
	            if (str.length === 0) {
	                str = "(empty array)";
	            }
	        }
	        return "(<" + snip(str) + ">, no stack trace)";
	    }
	
	    function snip(str) {
	        var maxChars = 41;
	        if (str.length < maxChars) {
	            return str;
	        }
	        return str.substr(0, maxChars - 3) + "...";
	    }
	
	    function longStackTracesIsSupported() {
	        return typeof captureStackTrace === "function";
	    }
	
	    var shouldIgnore = function shouldIgnore() {
	        return false;
	    };
	    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	    function parseLineInfo(line) {
	        var matches = line.match(parseLineInfoRegex);
	        if (matches) {
	            return {
	                fileName: matches[1],
	                line: parseInt(matches[2], 10)
	            };
	        }
	    }
	
	    function setBounds(firstLineError, lastLineError) {
	        if (!longStackTracesIsSupported()) return;
	        var firstStackLines = firstLineError.stack.split("\n");
	        var lastStackLines = lastLineError.stack.split("\n");
	        var firstIndex = -1;
	        var lastIndex = -1;
	        var firstFileName;
	        var lastFileName;
	        for (var i = 0; i < firstStackLines.length; ++i) {
	            var result = parseLineInfo(firstStackLines[i]);
	            if (result) {
	                firstFileName = result.fileName;
	                firstIndex = result.line;
	                break;
	            }
	        }
	        for (var i = 0; i < lastStackLines.length; ++i) {
	            var result = parseLineInfo(lastStackLines[i]);
	            if (result) {
	                lastFileName = result.fileName;
	                lastIndex = result.line;
	                break;
	            }
	        }
	        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
	            return;
	        }
	
	        shouldIgnore = function shouldIgnore(line) {
	            if (bluebirdFramePattern.test(line)) return true;
	            var info = parseLineInfo(line);
	            if (info) {
	                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
	                    return true;
	                }
	            }
	            return false;
	        };
	    }
	
	    function CapturedTrace(parent) {
	        this._parent = parent;
	        this._promisesCreated = 0;
	        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	        captureStackTrace(this, CapturedTrace);
	        if (length > 32) this.uncycle();
	    }
	    util.inherits(CapturedTrace, Error);
	    Context.CapturedTrace = CapturedTrace;
	
	    CapturedTrace.prototype.uncycle = function () {
	        var length = this._length;
	        if (length < 2) return;
	        var nodes = [];
	        var stackToIndex = {};
	
	        for (var i = 0, node = this; node !== undefined; ++i) {
	            nodes.push(node);
	            node = node._parent;
	        }
	        length = this._length = i;
	        for (var i = length - 1; i >= 0; --i) {
	            var stack = nodes[i].stack;
	            if (stackToIndex[stack] === undefined) {
	                stackToIndex[stack] = i;
	            }
	        }
	        for (var i = 0; i < length; ++i) {
	            var currentStack = nodes[i].stack;
	            var index = stackToIndex[currentStack];
	            if (index !== undefined && index !== i) {
	                if (index > 0) {
	                    nodes[index - 1]._parent = undefined;
	                    nodes[index - 1]._length = 1;
	                }
	                nodes[i]._parent = undefined;
	                nodes[i]._length = 1;
	                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	                if (index < length - 1) {
	                    cycleEdgeNode._parent = nodes[index + 1];
	                    cycleEdgeNode._parent.uncycle();
	                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
	                } else {
	                    cycleEdgeNode._parent = undefined;
	                    cycleEdgeNode._length = 1;
	                }
	                var currentChildLength = cycleEdgeNode._length + 1;
	                for (var j = i - 2; j >= 0; --j) {
	                    nodes[j]._length = currentChildLength;
	                    currentChildLength++;
	                }
	                return;
	            }
	        }
	    };
	
	    CapturedTrace.prototype.attachExtraTrace = function (error) {
	        if (error.__stackCleaned__) return;
	        this.uncycle();
	        var parsed = parseStackAndMessage(error);
	        var message = parsed.message;
	        var stacks = [parsed.stack];
	
	        var trace = this;
	        while (trace !== undefined) {
	            stacks.push(cleanStack(trace.stack.split("\n")));
	            trace = trace._parent;
	        }
	        removeCommonRoots(stacks);
	        removeDuplicateOrEmptyJumps(stacks);
	        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	        util.notEnumerableProp(error, "__stackCleaned__", true);
	    };
	
	    var captureStackTrace = function stackDetection() {
	        var v8stackFramePattern = /^\s*at\s*/;
	        var v8stackFormatter = function v8stackFormatter(stack, error) {
	            if (typeof stack === "string") return stack;
	
	            if (error.name !== undefined && error.message !== undefined) {
	                return error.toString();
	            }
	            return formatNonError(error);
	        };
	
	        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
	            Error.stackTraceLimit += 6;
	            stackFramePattern = v8stackFramePattern;
	            formatStack = v8stackFormatter;
	            var captureStackTrace = Error.captureStackTrace;
	
	            shouldIgnore = function shouldIgnore(line) {
	                return bluebirdFramePattern.test(line);
	            };
	            return function (receiver, ignoreUntil) {
	                Error.stackTraceLimit += 6;
	                captureStackTrace(receiver, ignoreUntil);
	                Error.stackTraceLimit -= 6;
	            };
	        }
	        var err = new Error();
	
	        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	            stackFramePattern = /@/;
	            formatStack = v8stackFormatter;
	            indentStackFrames = true;
	            return function captureStackTrace(o) {
	                o.stack = new Error().stack;
	            };
	        }
	
	        var hasStackAfterThrow;
	        try {
	            throw new Error();
	        } catch (e) {
	            hasStackAfterThrow = "stack" in e;
	        }
	        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
	            stackFramePattern = v8stackFramePattern;
	            formatStack = v8stackFormatter;
	            return function captureStackTrace(o) {
	                Error.stackTraceLimit += 6;
	                try {
	                    throw new Error();
	                } catch (e) {
	                    o.stack = e.stack;
	                }
	                Error.stackTraceLimit -= 6;
	            };
	        }
	
	        formatStack = function formatStack(stack, error) {
	            if (typeof stack === "string") return stack;
	
	            if (((typeof error === "undefined" ? "undefined" : _typeof(error)) === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
	                return error.toString();
	            }
	            return formatNonError(error);
	        };
	
	        return null;
	    }([]);
	
	    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	        printWarning = function printWarning(message) {
	            console.warn(message);
	        };
	        if (util.isNode && process.stderr.isTTY) {
	            printWarning = function printWarning(message, isSoft) {
	                var color = isSoft ? "\x1B[33m" : "\x1B[31m";
	                console.warn(color + message + "\x1B[0m\n");
	            };
	        } else if (!util.isNode && typeof new Error().stack === "string") {
	            printWarning = function printWarning(message, isSoft) {
	                console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
	            };
	        }
	    }
	
	    var config = {
	        warnings: warnings,
	        longStackTraces: false,
	        cancellation: false,
	        monitoring: false
	    };
	
	    if (longStackTraces) Promise.longStackTraces();
	
	    return {
	        longStackTraces: function longStackTraces() {
	            return config.longStackTraces;
	        },
	        warnings: function warnings() {
	            return config.warnings;
	        },
	        cancellation: function cancellation() {
	            return config.cancellation;
	        },
	        monitoring: function monitoring() {
	            return config.monitoring;
	        },
	        propagateFromFunction: function propagateFromFunction() {
	            return _propagateFromFunction;
	        },
	        boundValueFunction: function boundValueFunction() {
	            return _boundValueFunction;
	        },
	        checkForgottenReturns: checkForgottenReturns,
	        setBounds: setBounds,
	        warn: warn,
	        deprecated: deprecated,
	        CapturedTrace: CapturedTrace,
	        fireDomEvent: fireDomEvent,
	        fireGlobalEvent: fireGlobalEvent
	    };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, tryConvertToPromise, NEXT_FILTER) {
	    var util = __webpack_require__(6);
	    var CancellationError = Promise.CancellationError;
	    var errorObj = util.errorObj;
	    var catchFilter = __webpack_require__(19)(NEXT_FILTER);
	
	    function PassThroughHandlerContext(promise, type, handler) {
	        this.promise = promise;
	        this.type = type;
	        this.handler = handler;
	        this.called = false;
	        this.cancelPromise = null;
	    }
	
	    PassThroughHandlerContext.prototype.isFinallyHandler = function () {
	        return this.type === 0;
	    };
	
	    function FinallyHandlerCancelReaction(finallyHandler) {
	        this.finallyHandler = finallyHandler;
	    }
	
	    FinallyHandlerCancelReaction.prototype._resultCancelled = function () {
	        checkCancel(this.finallyHandler);
	    };
	
	    function checkCancel(ctx, reason) {
	        if (ctx.cancelPromise != null) {
	            if (arguments.length > 1) {
	                ctx.cancelPromise._reject(reason);
	            } else {
	                ctx.cancelPromise._cancel();
	            }
	            ctx.cancelPromise = null;
	            return true;
	        }
	        return false;
	    }
	
	    function succeed() {
	        return finallyHandler.call(this, this.promise._target()._settledValue());
	    }
	    function fail(reason) {
	        if (checkCancel(this, reason)) return;
	        errorObj.e = reason;
	        return errorObj;
	    }
	    function finallyHandler(reasonOrValue) {
	        var promise = this.promise;
	        var handler = this.handler;
	
	        if (!this.called) {
	            this.called = true;
	            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
	            if (ret === NEXT_FILTER) {
	                return ret;
	            } else if (ret !== undefined) {
	                promise._setReturnedNonUndefined();
	                var maybePromise = tryConvertToPromise(ret, promise);
	                if (maybePromise instanceof Promise) {
	                    if (this.cancelPromise != null) {
	                        if (maybePromise._isCancelled()) {
	                            var reason = new CancellationError("late cancellation observer");
	                            promise._attachExtraTrace(reason);
	                            errorObj.e = reason;
	                            return errorObj;
	                        } else if (maybePromise.isPending()) {
	                            maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
	                        }
	                    }
	                    return maybePromise._then(succeed, fail, undefined, this, undefined);
	                }
	            }
	        }
	
	        if (promise.isRejected()) {
	            checkCancel(this);
	            errorObj.e = reasonOrValue;
	            return errorObj;
	        } else {
	            checkCancel(this);
	            return reasonOrValue;
	        }
	    }
	
	    Promise.prototype._passThrough = function (handler, type, success, fail) {
	        if (typeof handler !== "function") return this.then();
	        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
	    };
	
	    Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
	        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
	    };
	
	    Promise.prototype.tap = function (handler) {
	        return this._passThrough(handler, 1, finallyHandler);
	    };
	
	    Promise.prototype.tapCatch = function (handlerOrPredicate) {
	        var len = arguments.length;
	        if (len === 1) {
	            return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
	        } else {
	            var catchInstances = new Array(len - 1),
	                j = 0,
	                i;
	            for (i = 0; i < len - 1; ++i) {
	                var item = arguments[i];
	                if (util.isObject(item)) {
	                    catchInstances[j++] = item;
	                } else {
	                    return Promise.reject(new TypeError("tapCatch statement predicate: " + "expecting an object but got " + util.classString(item)));
	                }
	            }
	            catchInstances.length = j;
	            var handler = arguments[i];
	            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
	        }
	    };
	
	    return PassThroughHandlerContext;
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (NEXT_FILTER) {
	    var util = __webpack_require__(6);
	    var getKeys = __webpack_require__(7).keys;
	    var tryCatch = util.tryCatch;
	    var errorObj = util.errorObj;
	
	    function catchFilter(instances, cb, promise) {
	        return function (e) {
	            var boundTo = promise._boundValue();
	            predicateLoop: for (var i = 0; i < instances.length; ++i) {
	                var item = instances[i];
	
	                if (item === Error || item != null && item.prototype instanceof Error) {
	                    if (e instanceof item) {
	                        return tryCatch(cb).call(boundTo, e);
	                    }
	                } else if (typeof item === "function") {
	                    var matchesPredicate = tryCatch(item).call(boundTo, e);
	                    if (matchesPredicate === errorObj) {
	                        return matchesPredicate;
	                    } else if (matchesPredicate) {
	                        return tryCatch(cb).call(boundTo, e);
	                    }
	                } else if (util.isObject(e)) {
	                    var keys = getKeys(item);
	                    for (var j = 0; j < keys.length; ++j) {
	                        var key = keys[j];
	                        if (item[key] != e[key]) {
	                            continue predicateLoop;
	                        }
	                    }
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            }
	            return NEXT_FILTER;
	        };
	    }
	
	    return catchFilter;
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var util = __webpack_require__(6);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(13);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(7);
	
	function isUntypedError(obj) {
	    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function (err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0));for (var $_i = 1; $_i < $_len; ++$_i) {
	                args[$_i - 1] = arguments[$_i];
	            };
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	    var util = __webpack_require__(6);
	    var tryCatch = util.tryCatch;
	
	    Promise.method = function (fn) {
	        if (typeof fn !== "function") {
	            throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	        }
	        return function () {
	            var ret = new Promise(INTERNAL);
	            ret._captureStackTrace();
	            ret._pushContext();
	            var value = tryCatch(fn).apply(this, arguments);
	            var promiseCreated = ret._popContext();
	            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
	            ret._resolveFromSyncValue(value);
	            return ret;
	        };
	    };
	
	    Promise.attempt = Promise["try"] = function (fn) {
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value;
	        if (arguments.length > 1) {
	            debug.deprecated("calling Promise.try with more than 1 argument");
	            var arg = arguments[1];
	            var ctx = arguments[2];
	            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
	        } else {
	            value = tryCatch(fn)();
	        }
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	
	    Promise.prototype._resolveFromSyncValue = function (value) {
	        if (value === util.errorObj) {
	            this._rejectCallback(value.e, false);
	        } else {
	            this._resolveCallback(value, true);
	        }
	    };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL, tryConvertToPromise, debug) {
	    var calledBind = false;
	    var rejectThis = function rejectThis(_, e) {
	        this._reject(e);
	    };
	
	    var targetRejected = function targetRejected(e, context) {
	        context.promiseRejectionQueued = true;
	        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	    };
	
	    var bindingResolved = function bindingResolved(thisArg, context) {
	        if ((this._bitField & 50397184) === 0) {
	            this._resolveCallback(context.target);
	        }
	    };
	
	    var bindingRejected = function bindingRejected(e, context) {
	        if (!context.promiseRejectionQueued) this._reject(e);
	    };
	
	    Promise.prototype.bind = function (thisArg) {
	        if (!calledBind) {
	            calledBind = true;
	            Promise.prototype._propagateFrom = debug.propagateFromFunction();
	            Promise.prototype._boundValue = debug.boundValueFunction();
	        }
	        var maybePromise = tryConvertToPromise(thisArg);
	        var ret = new Promise(INTERNAL);
	        ret._propagateFrom(this, 1);
	        var target = this._target();
	        ret._setBoundTo(maybePromise);
	        if (maybePromise instanceof Promise) {
	            var context = {
	                promiseRejectionQueued: false,
	                promise: ret,
	                target: target,
	                bindingPromise: maybePromise
	            };
	            target._then(INTERNAL, targetRejected, undefined, ret, context);
	            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
	            ret._setOnCancel(maybePromise);
	        } else {
	            ret._resolveCallback(target);
	        }
	        return ret;
	    };
	
	    Promise.prototype._setBoundTo = function (obj) {
	        if (obj !== undefined) {
	            this._bitField = this._bitField | 2097152;
	            this._boundTo = obj;
	        } else {
	            this._bitField = this._bitField & ~2097152;
	        }
	    };
	
	    Promise.prototype._isBound = function () {
	        return (this._bitField & 2097152) === 2097152;
	    };
	
	    Promise.bind = function (thisArg, value) {
	        return Promise.resolve(value).bind(thisArg);
	    };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, apiRejection, debug) {
	    var util = __webpack_require__(6);
	    var tryCatch = util.tryCatch;
	    var errorObj = util.errorObj;
	    var async = Promise._async;
	
	    Promise.prototype["break"] = Promise.prototype.cancel = function () {
	        if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	        var promise = this;
	        var child = promise;
	        while (promise._isCancellable()) {
	            if (!promise._cancelBy(child)) {
	                if (child._isFollowing()) {
	                    child._followee().cancel();
	                } else {
	                    child._cancelBranched();
	                }
	                break;
	            }
	
	            var parent = promise._cancellationParent;
	            if (parent == null || !parent._isCancellable()) {
	                if (promise._isFollowing()) {
	                    promise._followee().cancel();
	                } else {
	                    promise._cancelBranched();
	                }
	                break;
	            } else {
	                if (promise._isFollowing()) promise._followee().cancel();
	                promise._setWillBeCancelled();
	                child = promise;
	                promise = parent;
	            }
	        }
	    };
	
	    Promise.prototype._branchHasCancelled = function () {
	        this._branchesRemainingToCancel--;
	    };
	
	    Promise.prototype._enoughBranchesHaveCancelled = function () {
	        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
	    };
	
	    Promise.prototype._cancelBy = function (canceller) {
	        if (canceller === this) {
	            this._branchesRemainingToCancel = 0;
	            this._invokeOnCancel();
	            return true;
	        } else {
	            this._branchHasCancelled();
	            if (this._enoughBranchesHaveCancelled()) {
	                this._invokeOnCancel();
	                return true;
	            }
	        }
	        return false;
	    };
	
	    Promise.prototype._cancelBranched = function () {
	        if (this._enoughBranchesHaveCancelled()) {
	            this._cancel();
	        }
	    };
	
	    Promise.prototype._cancel = function () {
	        if (!this._isCancellable()) return;
	        this._setCancelled();
	        async.invoke(this._cancelPromises, this, undefined);
	    };
	
	    Promise.prototype._cancelPromises = function () {
	        if (this._length() > 0) this._settlePromises();
	    };
	
	    Promise.prototype._unsetOnCancel = function () {
	        this._onCancelField = undefined;
	    };
	
	    Promise.prototype._isCancellable = function () {
	        return this.isPending() && !this._isCancelled();
	    };
	
	    Promise.prototype.isCancellable = function () {
	        return this.isPending() && !this.isCancelled();
	    };
	
	    Promise.prototype._doInvokeOnCancel = function (onCancelCallback, internalOnly) {
	        if (util.isArray(onCancelCallback)) {
	            for (var i = 0; i < onCancelCallback.length; ++i) {
	                this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	            }
	        } else if (onCancelCallback !== undefined) {
	            if (typeof onCancelCallback === "function") {
	                if (!internalOnly) {
	                    var e = tryCatch(onCancelCallback).call(this._boundValue());
	                    if (e === errorObj) {
	                        this._attachExtraTrace(e.e);
	                        async.throwLater(e.e);
	                    }
	                }
	            } else {
	                onCancelCallback._resultCancelled(this);
	            }
	        }
	    };
	
	    Promise.prototype._invokeOnCancel = function () {
	        var onCancelCallback = this._onCancel();
	        this._unsetOnCancel();
	        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	    };
	
	    Promise.prototype._invokeInternalOnCancel = function () {
	        if (this._isCancellable()) {
	            this._doInvokeOnCancel(this._onCancel(), true);
	            this._unsetOnCancel();
	        }
	    };
	
	    Promise.prototype._resultCancelled = function () {
	        this.cancel();
	    };
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise) {
	    function returner() {
	        return this.value;
	    }
	    function thrower() {
	        throw this.reason;
	    }
	
	    Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(returner, undefined, undefined, { value: value }, undefined);
	    };
	
	    Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
	        return this._then(thrower, undefined, undefined, { reason: reason }, undefined);
	    };
	
	    Promise.prototype.catchThrow = function (reason) {
	        if (arguments.length <= 1) {
	            return this._then(undefined, thrower, undefined, { reason: reason }, undefined);
	        } else {
	            var _reason = arguments[1];
	            var handler = function handler() {
	                throw _reason;
	            };
	            return this.caught(reason, handler);
	        }
	    };
	
	    Promise.prototype.catchReturn = function (value) {
	        if (arguments.length <= 1) {
	            if (value instanceof Promise) value.suppressUnhandledRejections();
	            return this._then(undefined, returner, undefined, { value: value }, undefined);
	        } else {
	            var _value = arguments[1];
	            if (_value instanceof Promise) _value.suppressUnhandledRejections();
	            var handler = function handler() {
	                return _value;
	            };
	            return this.caught(value, handler);
	        }
	    };
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise) {
	    function PromiseInspection(promise) {
	        if (promise !== undefined) {
	            promise = promise._target();
	            this._bitField = promise._bitField;
	            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
	        } else {
	            this._bitField = 0;
	            this._settledValueField = undefined;
	        }
	    }
	
	    PromiseInspection.prototype._settledValue = function () {
	        return this._settledValueField;
	    };
	
	    var value = PromiseInspection.prototype.value = function () {
	        if (!this.isFulfilled()) {
	            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        return this._settledValue();
	    };
	
	    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
	        if (!this.isRejected()) {
	            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        return this._settledValue();
	    };
	
	    var isFulfilled = PromiseInspection.prototype.isFulfilled = function () {
	        return (this._bitField & 33554432) !== 0;
	    };
	
	    var isRejected = PromiseInspection.prototype.isRejected = function () {
	        return (this._bitField & 16777216) !== 0;
	    };
	
	    var isPending = PromiseInspection.prototype.isPending = function () {
	        return (this._bitField & 50397184) === 0;
	    };
	
	    var isResolved = PromiseInspection.prototype.isResolved = function () {
	        return (this._bitField & 50331648) !== 0;
	    };
	
	    PromiseInspection.prototype.isCancelled = function () {
	        return (this._bitField & 8454144) !== 0;
	    };
	
	    Promise.prototype.__isCancelled = function () {
	        return (this._bitField & 65536) === 65536;
	    };
	
	    Promise.prototype._isCancelled = function () {
	        return this._target().__isCancelled();
	    };
	
	    Promise.prototype.isCancelled = function () {
	        return (this._target()._bitField & 8454144) !== 0;
	    };
	
	    Promise.prototype.isPending = function () {
	        return isPending.call(this._target());
	    };
	
	    Promise.prototype.isRejected = function () {
	        return isRejected.call(this._target());
	    };
	
	    Promise.prototype.isFulfilled = function () {
	        return isFulfilled.call(this._target());
	    };
	
	    Promise.prototype.isResolved = function () {
	        return isResolved.call(this._target());
	    };
	
	    Promise.prototype.value = function () {
	        return value.call(this._target());
	    };
	
	    Promise.prototype.reason = function () {
	        var target = this._target();
	        target._unsetRejectionIsUnhandled();
	        return reason.call(target);
	    };
	
	    Promise.prototype._value = function () {
	        return this._settledValue();
	    };
	
	    Promise.prototype._reason = function () {
	        this._unsetRejectionIsUnhandled();
	        return this._settledValue();
	    };
	
	    Promise.PromiseInspection = PromiseInspection;
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain) {
	    var util = __webpack_require__(6);
	    var canEvaluate = util.canEvaluate;
	    var tryCatch = util.tryCatch;
	    var errorObj = util.errorObj;
	    var reject;
	
	    if (true) {
	        if (canEvaluate) {
	            var thenCallback = function thenCallback(i) {
	                return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	            };
	
	            var promiseSetter = function promiseSetter(i) {
	                return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	            };
	
	            var generateHolderClass = function generateHolderClass(total) {
	                var props = new Array(total);
	                for (var i = 0; i < props.length; ++i) {
	                    props[i] = "this.p" + (i + 1);
	                }
	                var assignment = props.join(" = ") + " = null;";
	                var cancellationCode = "var promise;\n" + props.map(function (prop) {
	                    return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	                }).join("\n");
	                var passedArguments = props.join(", ");
	                var name = "Holder$" + total;
	
	                var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	                code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
	
	                return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
	            };
	
	            var holderClasses = [];
	            var thenCallbacks = [];
	            var promiseSetters = [];
	
	            for (var i = 0; i < 8; ++i) {
	                holderClasses.push(generateHolderClass(i + 1));
	                thenCallbacks.push(thenCallback(i + 1));
	                promiseSetters.push(promiseSetter(i + 1));
	            }
	
	            reject = function reject(reason) {
	                this._reject(reason);
	            };
	        }
	    }
	
	    Promise.join = function () {
	        var last = arguments.length - 1;
	        var fn;
	        if (last > 0 && typeof arguments[last] === "function") {
	            fn = arguments[last];
	            if (true) {
	                if (last <= 8 && canEvaluate) {
	                    var ret = new Promise(INTERNAL);
	                    ret._captureStackTrace();
	                    var HolderClass = holderClasses[last - 1];
	                    var holder = new HolderClass(fn);
	                    var callbacks = thenCallbacks;
	
	                    for (var i = 0; i < last; ++i) {
	                        var maybePromise = tryConvertToPromise(arguments[i], ret);
	                        if (maybePromise instanceof Promise) {
	                            maybePromise = maybePromise._target();
	                            var bitField = maybePromise._bitField;
	                            ;
	                            if ((bitField & 50397184) === 0) {
	                                maybePromise._then(callbacks[i], reject, undefined, ret, holder);
	                                promiseSetters[i](maybePromise, holder);
	                                holder.asyncNeeded = false;
	                            } else if ((bitField & 33554432) !== 0) {
	                                callbacks[i].call(ret, maybePromise._value(), holder);
	                            } else if ((bitField & 16777216) !== 0) {
	                                ret._reject(maybePromise._reason());
	                            } else {
	                                ret._cancel();
	                            }
	                        } else {
	                            callbacks[i].call(ret, maybePromise, holder);
	                        }
	                    }
	
	                    if (!ret._isFateSealed()) {
	                        if (holder.asyncNeeded) {
	                            var domain = getDomain();
	                            if (domain !== null) {
	                                holder.fn = util.domainBind(domain, holder.fn);
	                            }
	                        }
	                        ret._setAsyncGuaranteed();
	                        ret._setOnCancel(holder);
	                    }
	                    return ret;
	                }
	            }
	        }
	        var $_len = arguments.length;var args = new Array($_len);for (var $_i = 0; $_i < $_len; ++$_i) {
	            args[$_i] = arguments[$_i];
	        };
	        if (fn) args.pop();
	        var ret = new PromiseArray(args).promise();
	        return fn !== undefined ? ret.spread(fn) : ret;
	    };
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
	    var getDomain = Promise._getDomain;
	    var util = __webpack_require__(6);
	    var tryCatch = util.tryCatch;
	    var errorObj = util.errorObj;
	    var async = Promise._async;
	
	    function MappingPromiseArray(promises, fn, limit, _filter) {
	        this.constructor$(promises);
	        this._promise._captureStackTrace();
	        var domain = getDomain();
	        this._callback = domain === null ? fn : util.domainBind(domain, fn);
	        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
	        this._limit = limit;
	        this._inFlight = 0;
	        this._queue = [];
	        async.invoke(this._asyncInit, this, undefined);
	    }
	    util.inherits(MappingPromiseArray, PromiseArray);
	
	    MappingPromiseArray.prototype._asyncInit = function () {
	        this._init$(undefined, -2);
	    };
	
	    MappingPromiseArray.prototype._init = function () {};
	
	    MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	        var values = this._values;
	        var length = this.length();
	        var preservedValues = this._preservedValues;
	        var limit = this._limit;
	
	        if (index < 0) {
	            index = index * -1 - 1;
	            values[index] = value;
	            if (limit >= 1) {
	                this._inFlight--;
	                this._drainQueue();
	                if (this._isResolved()) return true;
	            }
	        } else {
	            if (limit >= 1 && this._inFlight >= limit) {
	                values[index] = value;
	                this._queue.push(index);
	                return false;
	            }
	            if (preservedValues !== null) preservedValues[index] = value;
	
	            var promise = this._promise;
	            var callback = this._callback;
	            var receiver = promise._boundValue();
	            promise._pushContext();
	            var ret = tryCatch(callback).call(receiver, value, index, length);
	            var promiseCreated = promise._popContext();
	            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
	            if (ret === errorObj) {
	                this._reject(ret.e);
	                return true;
	            }
	
	            var maybePromise = tryConvertToPromise(ret, this._promise);
	            if (maybePromise instanceof Promise) {
	                maybePromise = maybePromise._target();
	                var bitField = maybePromise._bitField;
	                ;
	                if ((bitField & 50397184) === 0) {
	                    if (limit >= 1) this._inFlight++;
	                    values[index] = maybePromise;
	                    maybePromise._proxy(this, (index + 1) * -1);
	                    return false;
	                } else if ((bitField & 33554432) !== 0) {
	                    ret = maybePromise._value();
	                } else if ((bitField & 16777216) !== 0) {
	                    this._reject(maybePromise._reason());
	                    return true;
	                } else {
	                    this._cancel();
	                    return true;
	                }
	            }
	            values[index] = ret;
	        }
	        var totalResolved = ++this._totalResolved;
	        if (totalResolved >= length) {
	            if (preservedValues !== null) {
	                this._filter(values, preservedValues);
	            } else {
	                this._resolve(values);
	            }
	            return true;
	        }
	        return false;
	    };
	
	    MappingPromiseArray.prototype._drainQueue = function () {
	        var queue = this._queue;
	        var limit = this._limit;
	        var values = this._values;
	        while (queue.length > 0 && this._inFlight < limit) {
	            if (this._isResolved()) return;
	            var index = queue.pop();
	            this._promiseFulfilled(values[index], index);
	        }
	    };
	
	    MappingPromiseArray.prototype._filter = function (booleans, values) {
	        var len = values.length;
	        var ret = new Array(len);
	        var j = 0;
	        for (var i = 0; i < len; ++i) {
	            if (booleans[i]) ret[j++] = values[i];
	        }
	        ret.length = j;
	        this._resolve(ret);
	    };
	
	    MappingPromiseArray.prototype.preservedValues = function () {
	        return this._preservedValues;
	    };
	
	    function map(promises, fn, options, _filter) {
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	
	        var limit = 0;
	        if (options !== undefined) {
	            if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object" && options !== null) {
	                if (typeof options.concurrency !== "number") {
	                    return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
	                }
	                limit = options.concurrency;
	            } else {
	                return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
	            }
	        }
	        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
	        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	    }
	
	    Promise.prototype.map = function (fn, options) {
	        return map(this, fn, options, null);
	    };
	
	    Promise.map = function (promises, fn, options, _filter) {
	        return map(promises, fn, options, _filter);
	    };
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function (Promise) {
	    var util = __webpack_require__(6);
	    var canEvaluate = util.canEvaluate;
	    var isIdentifier = util.isIdentifier;
	
	    var getMethodCaller;
	    var getGetter;
	    if (true) {
	        var makeMethodCaller = function makeMethodCaller(methodName) {
	            return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	        };
	
	        var makeGetter = function makeGetter(propertyName) {
	            return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	        };
	
	        var getCompiled = function getCompiled(name, compiler, cache) {
	            var ret = cache[name];
	            if (typeof ret !== "function") {
	                if (!isIdentifier(name)) {
	                    return null;
	                }
	                ret = compiler(name);
	                cache[name] = ret;
	                cache[" size"]++;
	                if (cache[" size"] > 512) {
	                    var keys = Object.keys(cache);
	                    for (var i = 0; i < 256; ++i) {
	                        delete cache[keys[i]];
	                    }cache[" size"] = keys.length - 256;
	                }
	            }
	            return ret;
	        };
	
	        getMethodCaller = function getMethodCaller(name) {
	            return getCompiled(name, makeMethodCaller, callerCache);
	        };
	
	        getGetter = function getGetter(name) {
	            return getCompiled(name, makeGetter, getterCache);
	        };
	    }
	
	    function ensureMethod(obj, methodName) {
	        var fn;
	        if (obj != null) fn = obj[methodName];
	        if (typeof fn !== "function") {
	            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
	            throw new Promise.TypeError(message);
	        }
	        return fn;
	    }
	
	    function caller(obj) {
	        var methodName = this.pop();
	        var fn = ensureMethod(obj, methodName);
	        return fn.apply(obj, this);
	    }
	    Promise.prototype.call = function (methodName) {
	        var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0));for (var $_i = 1; $_i < $_len; ++$_i) {
	            args[$_i - 1] = arguments[$_i];
	        };
	        if (true) {
	            if (canEvaluate) {
	                var maybeCaller = getMethodCaller(methodName);
	                if (maybeCaller !== null) {
	                    return this._then(maybeCaller, undefined, undefined, args, undefined);
	                }
	            }
	        }
	        args.push(methodName);
	        return this._then(caller, undefined, undefined, args, undefined);
	    };
	
	    function namedGetter(obj) {
	        return obj[this];
	    }
	    function indexedGetter(obj) {
	        var index = +this;
	        if (index < 0) index = Math.max(0, index + obj.length);
	        return obj[index];
	    }
	    Promise.prototype.get = function (propertyName) {
	        var isIndex = typeof propertyName === "number";
	        var getter;
	        if (!isIndex) {
	            if (canEvaluate) {
	                var maybeGetter = getGetter(propertyName);
	                getter = maybeGetter !== null ? maybeGetter : namedGetter;
	            } else {
	                getter = namedGetter;
	            }
	        } else {
	            getter = indexedGetter;
	        }
	        return this._then(getter, undefined, undefined, propertyName, undefined);
	    };
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
	    var util = __webpack_require__(6);
	    var TypeError = __webpack_require__(13).TypeError;
	    var inherits = __webpack_require__(6).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function () {
	            throw e;
	        }, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower, null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function (inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length - 1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function () {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
	                        resources: resources,
	                        index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources).then(function (inspections) {
	            for (var i = 0; i < inspections.length; ++i) {
	                var inspection = inspections[i];
	                if (inspection.isRejected()) {
	                    errorObj.e = inspection.error();
	                    return errorObj;
	                } else if (!inspection.isFulfilled()) {
	                    resultPromise.cancel();
	                    return;
	                }
	                inspections[i] = inspection.value();
	            }
	            promise._pushContext();
	
	            fn = tryCatch(fn);
	            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
	            var promiseCreated = promise._popContext();
	            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
	            return ret;
	        });
	
	        var promise = resultPromise.lastly(function () {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & ~131072;
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL, debug) {
	    var util = __webpack_require__(6);
	    var TimeoutError = Promise.TimeoutError;
	
	    function HandleWrapper(handle) {
	        this.handle = handle;
	    }
	
	    HandleWrapper.prototype._resultCancelled = function () {
	        clearTimeout(this.handle);
	    };
	
	    var afterValue = function afterValue(value) {
	        return delay(+this).thenReturn(value);
	    };
	    var delay = Promise.delay = function (ms, value) {
	        var ret;
	        var handle;
	        if (value !== undefined) {
	            ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
	            if (debug.cancellation() && value instanceof Promise) {
	                ret._setOnCancel(value);
	            }
	        } else {
	            ret = new Promise(INTERNAL);
	            handle = setTimeout(function () {
	                ret._fulfill();
	            }, +ms);
	            if (debug.cancellation()) {
	                ret._setOnCancel(new HandleWrapper(handle));
	            }
	            ret._captureStackTrace();
	        }
	        ret._setAsyncGuaranteed();
	        return ret;
	    };
	
	    Promise.prototype.delay = function (ms) {
	        return delay(ms, this);
	    };
	
	    var afterTimeout = function afterTimeout(promise, message, parent) {
	        var err;
	        if (typeof message !== "string") {
	            if (message instanceof Error) {
	                err = message;
	            } else {
	                err = new TimeoutError("operation timed out");
	            }
	        } else {
	            err = new TimeoutError(message);
	        }
	        util.markAsOriginatingFromRejection(err);
	        promise._attachExtraTrace(err);
	        promise._reject(err);
	
	        if (parent != null) {
	            parent.cancel();
	        }
	    };
	
	    function successClear(value) {
	        clearTimeout(this.handle);
	        return value;
	    }
	
	    function failureClear(reason) {
	        clearTimeout(this.handle);
	        throw reason;
	    }
	
	    Promise.prototype.timeout = function (ms, message) {
	        ms = +ms;
	        var ret, parent;
	
	        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	            if (ret.isPending()) {
	                afterTimeout(ret, message, parent);
	            }
	        }, ms));
	
	        if (debug.cancellation()) {
	            parent = this.then();
	            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
	            ret._setOnCancel(handleWrapper);
	        } else {
	            ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
	        }
	
	        return ret;
	    };
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
	    var errors = __webpack_require__(13);
	    var TypeError = errors.TypeError;
	    var util = __webpack_require__(6);
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var yieldHandlers = [];
	
	    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	        for (var i = 0; i < yieldHandlers.length; ++i) {
	            traceParent._pushContext();
	            var result = tryCatch(yieldHandlers[i])(value);
	            traceParent._popContext();
	            if (result === errorObj) {
	                traceParent._pushContext();
	                var ret = Promise.reject(errorObj.e);
	                traceParent._popContext();
	                return ret;
	            }
	            var maybePromise = tryConvertToPromise(result, traceParent);
	            if (maybePromise instanceof Promise) return maybePromise;
	        }
	        return null;
	    }
	
	    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	        if (debug.cancellation()) {
	            var internal = new Promise(INTERNAL);
	            var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	            this._promise = internal.lastly(function () {
	                return _finallyPromise;
	            });
	            internal._captureStackTrace();
	            internal._setOnCancel(this);
	        } else {
	            var promise = this._promise = new Promise(INTERNAL);
	            promise._captureStackTrace();
	        }
	        this._stack = stack;
	        this._generatorFunction = generatorFunction;
	        this._receiver = receiver;
	        this._generator = undefined;
	        this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
	        this._yieldedPromise = null;
	        this._cancellationPhase = false;
	    }
	    util.inherits(PromiseSpawn, Proxyable);
	
	    PromiseSpawn.prototype._isResolved = function () {
	        return this._promise === null;
	    };
	
	    PromiseSpawn.prototype._cleanup = function () {
	        this._promise = this._generator = null;
	        if (debug.cancellation() && this._finallyPromise !== null) {
	            this._finallyPromise._fulfill();
	            this._finallyPromise = null;
	        }
	    };
	
	    PromiseSpawn.prototype._promiseCancelled = function () {
	        if (this._isResolved()) return;
	        var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	        var result;
	        if (!implementsReturn) {
	            var reason = new Promise.CancellationError("generator .return() sentinel");
	            Promise.coroutine.returnSentinel = reason;
	            this._promise._attachExtraTrace(reason);
	            this._promise._pushContext();
	            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
	            this._promise._popContext();
	        } else {
	            this._promise._pushContext();
	            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
	            this._promise._popContext();
	        }
	        this._cancellationPhase = true;
	        this._yieldedPromise = null;
	        this._continue(result);
	    };
	
	    PromiseSpawn.prototype._promiseFulfilled = function (value) {
	        this._yieldedPromise = null;
	        this._promise._pushContext();
	        var result = tryCatch(this._generator.next).call(this._generator, value);
	        this._promise._popContext();
	        this._continue(result);
	    };
	
	    PromiseSpawn.prototype._promiseRejected = function (reason) {
	        this._yieldedPromise = null;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
	        this._promise._popContext();
	        this._continue(result);
	    };
	
	    PromiseSpawn.prototype._resultCancelled = function () {
	        if (this._yieldedPromise instanceof Promise) {
	            var promise = this._yieldedPromise;
	            this._yieldedPromise = null;
	            promise.cancel();
	        }
	    };
	
	    PromiseSpawn.prototype.promise = function () {
	        return this._promise;
	    };
	
	    PromiseSpawn.prototype._run = function () {
	        this._generator = this._generatorFunction.call(this._receiver);
	        this._receiver = this._generatorFunction = undefined;
	        this._promiseFulfilled(undefined);
	    };
	
	    PromiseSpawn.prototype._continue = function (result) {
	        var promise = this._promise;
	        if (result === errorObj) {
	            this._cleanup();
	            if (this._cancellationPhase) {
	                return promise.cancel();
	            } else {
	                return promise._rejectCallback(result.e, false);
	            }
	        }
	
	        var value = result.value;
	        if (result.done === true) {
	            this._cleanup();
	            if (this._cancellationPhase) {
	                return promise.cancel();
	            } else {
	                return promise._resolveCallback(value);
	            }
	        } else {
	            var maybePromise = tryConvertToPromise(value, this._promise);
	            if (!(maybePromise instanceof Promise)) {
	                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
	                if (maybePromise === null) {
	                    this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
	                    return;
	                }
	            }
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if ((bitField & 50397184) === 0) {
	                this._yieldedPromise = maybePromise;
	                maybePromise._proxy(this, null);
	            } else if ((bitField & 33554432) !== 0) {
	                Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
	            } else if ((bitField & 16777216) !== 0) {
	                Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
	            } else {
	                this._promiseCancelled();
	            }
	        }
	    };
	
	    Promise.coroutine = function (generatorFunction, options) {
	        if (typeof generatorFunction !== "function") {
	            throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        var yieldHandler = Object(options).yieldHandler;
	        var PromiseSpawn$ = PromiseSpawn;
	        var stack = new Error().stack;
	        return function () {
	            var generator = generatorFunction.apply(this, arguments);
	            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
	            var ret = spawn.promise();
	            spawn._generator = generator;
	            spawn._promiseFulfilled(undefined);
	            return ret;
	        };
	    };
	
	    Promise.coroutine.addYieldHandler = function (fn) {
	        if (typeof fn !== "function") {
	            throw new TypeError("expecting a function but got " + util.classString(fn));
	        }
	        yieldHandlers.push(fn);
	    };
	
	    Promise.spawn = function (generatorFunction) {
	        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	        if (typeof generatorFunction !== "function") {
	            return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        var spawn = new PromiseSpawn(generatorFunction, this);
	        var ret = spawn.promise();
	        spawn._run(Promise.spawn);
	        return ret;
	    };
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise) {
	    var util = __webpack_require__(6);
	    var async = Promise._async;
	    var tryCatch = util.tryCatch;
	    var errorObj = util.errorObj;
	
	    function spreadAdapter(val, nodeback) {
	        var promise = this;
	        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	        var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	        if (ret === errorObj) {
	            async.throwLater(ret.e);
	        }
	    }
	
	    function successAdapter(val, nodeback) {
	        var promise = this;
	        var receiver = promise._boundValue();
	        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
	        if (ret === errorObj) {
	            async.throwLater(ret.e);
	        }
	    }
	    function errorAdapter(reason, nodeback) {
	        var promise = this;
	        if (!reason) {
	            var newReason = new Error(reason + "");
	            newReason.cause = reason;
	            reason = newReason;
	        }
	        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	        if (ret === errorObj) {
	            async.throwLater(ret.e);
	        }
	    }
	
	    Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
	        if (typeof nodeback == "function") {
	            var adapter = successAdapter;
	            if (options !== undefined && Object(options).spread) {
	                adapter = spreadAdapter;
	            }
	            this._then(adapter, errorAdapter, undefined, this, nodeback);
	        }
	        return this;
	    };
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (Promise, INTERNAL) {
	    var THIS = {};
	    var util = __webpack_require__(6);
	    var nodebackForPromise = __webpack_require__(20);
	    var withAppended = util.withAppended;
	    var maybeWrapAsError = util.maybeWrapAsError;
	    var canEvaluate = util.canEvaluate;
	    var TypeError = __webpack_require__(13).TypeError;
	    var defaultSuffix = "Async";
	    var defaultPromisified = { __isPromisified__: true };
	    var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
	    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	    var defaultFilter = function defaultFilter(name) {
	        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
	    };
	
	    function propsFilter(key) {
	        return !noCopyPropsPattern.test(key);
	    }
	
	    function isPromisified(fn) {
	        try {
	            return fn.__isPromisified__ === true;
	        } catch (e) {
	            return false;
	        }
	    }
	
	    function hasPromisified(obj, key, suffix) {
	        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
	        return val ? isPromisified(val) : false;
	    }
	    function checkValid(ret, suffix, suffixRegexp) {
	        for (var i = 0; i < ret.length; i += 2) {
	            var key = ret[i];
	            if (suffixRegexp.test(key)) {
	                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	                for (var j = 0; j < ret.length; j += 2) {
	                    if (ret[j] === keyWithoutAsyncSuffix) {
	                        throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
	                    }
	                }
	            }
	        }
	    }
	
	    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	        var keys = util.inheritedDataKeys(obj);
	        var ret = [];
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            var value = obj[key];
	            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
	            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
	                ret.push(key, value);
	            }
	        }
	        checkValid(ret, suffix, suffixRegexp);
	        return ret;
	    }
	
	    var escapeIdentRegex = function escapeIdentRegex(str) {
	        return str.replace(/([$])/, "\\$");
	    };
	
	    var makeNodePromisifiedEval;
	    if (true) {
	        var switchCaseArgumentOrder = function switchCaseArgumentOrder(likelyArgumentCount) {
	            var ret = [likelyArgumentCount];
	            var min = Math.max(0, likelyArgumentCount - 1 - 3);
	            for (var i = likelyArgumentCount - 1; i >= min; --i) {
	                ret.push(i);
	            }
	            for (var i = likelyArgumentCount + 1; i <= 3; ++i) {
	                ret.push(i);
	            }
	            return ret;
	        };
	
	        var argumentSequence = function argumentSequence(argumentCount) {
	            return util.filledRange(argumentCount, "_arg", "");
	        };
	
	        var parameterDeclaration = function parameterDeclaration(parameterCount) {
	            return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
	        };
	
	        var parameterCount = function parameterCount(fn) {
	            if (typeof fn.length === "number") {
	                return Math.max(Math.min(fn.length, 1023 + 1), 0);
	            }
	            return 0;
	        };
	
	        makeNodePromisifiedEval = function makeNodePromisifiedEval(callback, receiver, originalName, fn, _, multiArgs) {
	            var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	            var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	            var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	            function generateCallForArgumentCount(count) {
	                var args = argumentSequence(count).join(", ");
	                var comma = count > 0 ? ", " : "";
	                var ret;
	                if (shouldProxyThis) {
	                    ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	                } else {
	                    ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	                }
	                return ret.replace("{{args}}", args).replace(", ", comma);
	            }
	
	            function generateArgumentSwitchCase() {
	                var ret = "";
	                for (var i = 0; i < argumentOrder.length; ++i) {
	                    ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
	                }
	
	                ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
	                return ret;
	            }
	
	            var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
	            var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
	            body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	            return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
	        };
	    }
	
	    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	        var defaultThis = function () {
	            return this;
	        }();
	        var method = callback;
	        if (typeof method === "string") {
	            callback = fn;
	        }
	        function promisified() {
	            var _receiver = receiver;
	            if (receiver === THIS) _receiver = this;
	            var promise = new Promise(INTERNAL);
	            promise._captureStackTrace();
	            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
	            var fn = nodebackForPromise(promise, multiArgs);
	            try {
	                cb.apply(_receiver, withAppended(arguments, fn));
	            } catch (e) {
	                promise._rejectCallback(maybeWrapAsError(e), true, true);
	            }
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	            return promise;
	        }
	        util.notEnumerableProp(promisified, "__isPromisified__", true);
	        return promisified;
	    }
	
	    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
	
	    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	        for (var i = 0, len = methods.length; i < len; i += 2) {
	            var key = methods[i];
	            var fn = methods[i + 1];
	            var promisifiedKey = key + suffix;
	            if (promisifier === makeNodePromisified) {
	                obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	            } else {
	                var promisified = promisifier(fn, function () {
	                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	                });
	                util.notEnumerableProp(promisified, "__isPromisified__", true);
	                obj[promisifiedKey] = promisified;
	            }
	        }
	        util.toFastProperties(obj);
	        return obj;
	    }
	
	    function promisify(callback, receiver, multiArgs) {
	        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
	    }
	
	    Promise.promisify = function (fn, options) {
	        if (typeof fn !== "function") {
	            throw new TypeError("expecting a function but got " + util.classString(fn));
	        }
	        if (isPromisified(fn)) {
	            return fn;
	        }
	        options = Object(options);
	        var receiver = options.context === undefined ? THIS : options.context;
	        var multiArgs = !!options.multiArgs;
	        var ret = promisify(fn, receiver, multiArgs);
	        util.copyDescriptors(fn, ret, propsFilter);
	        return ret;
	    };
	
	    Promise.promisifyAll = function (target, options) {
	        if (typeof target !== "function" && (typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object") {
	            throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        options = Object(options);
	        var multiArgs = !!options.multiArgs;
	        var suffix = options.suffix;
	        if (typeof suffix !== "string") suffix = defaultSuffix;
	        var filter = options.filter;
	        if (typeof filter !== "function") filter = defaultFilter;
	        var promisifier = options.promisifier;
	        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	        if (!util.isIdentifier(suffix)) {
	            throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
	        }
	
	        var keys = util.inheritedDataKeys(target);
	        for (var i = 0; i < keys.length; ++i) {
	            var value = target[keys[i]];
	            if (keys[i] !== "constructor" && util.isClass(value)) {
	                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
	                promisifyAll(value, suffix, filter, promisifier, multiArgs);
	            }
	        }
	
	        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	    };
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	    var util = __webpack_require__(6);
	    var isObject = util.isObject;
	    var es5 = __webpack_require__(7);
	    var Es6Map;
	    if (typeof Map === "function") Es6Map = Map;
	
	    var mapToEntries = function () {
	        var index = 0;
	        var size = 0;
	
	        function extractEntry(value, key) {
	            this[index] = value;
	            this[index + size] = key;
	            index++;
	        }
	
	        return function mapToEntries(map) {
	            size = map.size;
	            index = 0;
	            var ret = new Array(map.size * 2);
	            map.forEach(extractEntry, ret);
	            return ret;
	        };
	    }();
	
	    var entriesToMap = function entriesToMap(entries) {
	        var ret = new Es6Map();
	        var length = entries.length / 2 | 0;
	        for (var i = 0; i < length; ++i) {
	            var key = entries[length + i];
	            var value = entries[i];
	            ret.set(key, value);
	        }
	        return ret;
	    };
	
	    function PropertiesPromiseArray(obj) {
	        var isMap = false;
	        var entries;
	        if (Es6Map !== undefined && obj instanceof Es6Map) {
	            entries = mapToEntries(obj);
	            isMap = true;
	        } else {
	            var keys = es5.keys(obj);
	            var len = keys.length;
	            entries = new Array(len * 2);
	            for (var i = 0; i < len; ++i) {
	                var key = keys[i];
	                entries[i] = obj[key];
	                entries[i + len] = key;
	            }
	        }
	        this.constructor$(entries);
	        this._isMap = isMap;
	        this._init$(undefined, isMap ? -6 : -3);
	    }
	    util.inherits(PropertiesPromiseArray, PromiseArray);
	
	    PropertiesPromiseArray.prototype._init = function () {};
	
	    PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	        this._values[index] = value;
	        var totalResolved = ++this._totalResolved;
	        if (totalResolved >= this._length) {
	            var val;
	            if (this._isMap) {
	                val = entriesToMap(this._values);
	            } else {
	                val = {};
	                var keyOffset = this.length();
	                for (var i = 0, len = this.length(); i < len; ++i) {
	                    val[this._values[i + keyOffset]] = this._values[i];
	                }
	            }
	            this._resolve(val);
	            return true;
	        }
	        return false;
	    };
	
	    PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	        return false;
	    };
	
	    PropertiesPromiseArray.prototype.getActualLength = function (len) {
	        return len >> 1;
	    };
	
	    function props(promises) {
	        var ret;
	        var castValue = tryConvertToPromise(promises);
	
	        if (!isObject(castValue)) {
	            return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
	        } else if (castValue instanceof Promise) {
	            ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
	        } else {
	            ret = new PropertiesPromiseArray(castValue).promise();
	        }
	
	        if (castValue instanceof Promise) {
	            ret._propagateFrom(castValue, 2);
	        }
	        return ret;
	    }
	
	    Promise.prototype.props = function () {
	        return props(this);
	    };
	
	    Promise.props = function (promises) {
	        return props(promises);
	    };
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	    var util = __webpack_require__(6);
	
	    var raceLater = function raceLater(promise) {
	        return promise.then(function (array) {
	            return race(array, promise);
	        });
	    };
	
	    function race(promises, parent) {
	        var maybePromise = tryConvertToPromise(promises);
	
	        if (maybePromise instanceof Promise) {
	            return raceLater(maybePromise);
	        } else {
	            promises = util.asArray(promises);
	            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	        }
	
	        var ret = new Promise(INTERNAL);
	        if (parent !== undefined) {
	            ret._propagateFrom(parent, 3);
	        }
	        var fulfill = ret._fulfill;
	        var reject = ret._reject;
	        for (var i = 0, len = promises.length; i < len; ++i) {
	            var val = promises[i];
	
	            if (val === undefined && !(i in promises)) {
	                continue;
	            }
	
	            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	        }
	        return ret;
	    }
	
	    Promise.race = function (promises) {
	        return race(promises, undefined);
	    };
	
	    Promise.prototype.race = function () {
	        return race(this, undefined);
	    };
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
	    var getDomain = Promise._getDomain;
	    var util = __webpack_require__(6);
	    var tryCatch = util.tryCatch;
	
	    function ReductionPromiseArray(promises, fn, initialValue, _each) {
	        this.constructor$(promises);
	        var domain = getDomain();
	        this._fn = domain === null ? fn : util.domainBind(domain, fn);
	        if (initialValue !== undefined) {
	            initialValue = Promise.resolve(initialValue);
	            initialValue._attachCancellationCallback(this);
	        }
	        this._initialValue = initialValue;
	        this._currentCancellable = null;
	        if (_each === INTERNAL) {
	            this._eachValues = Array(this._length);
	        } else if (_each === 0) {
	            this._eachValues = null;
	        } else {
	            this._eachValues = undefined;
	        }
	        this._promise._captureStackTrace();
	        this._init$(undefined, -5);
	    }
	    util.inherits(ReductionPromiseArray, PromiseArray);
	
	    ReductionPromiseArray.prototype._gotAccum = function (accum) {
	        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) {
	            this._eachValues.push(accum);
	        }
	    };
	
	    ReductionPromiseArray.prototype._eachComplete = function (value) {
	        if (this._eachValues !== null) {
	            this._eachValues.push(value);
	        }
	        return this._eachValues;
	    };
	
	    ReductionPromiseArray.prototype._init = function () {};
	
	    ReductionPromiseArray.prototype._resolveEmptyArray = function () {
	        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
	    };
	
	    ReductionPromiseArray.prototype.shouldCopyValues = function () {
	        return false;
	    };
	
	    ReductionPromiseArray.prototype._resolve = function (value) {
	        this._promise._resolveCallback(value);
	        this._values = null;
	    };
	
	    ReductionPromiseArray.prototype._resultCancelled = function (sender) {
	        if (sender === this._initialValue) return this._cancel();
	        if (this._isResolved()) return;
	        this._resultCancelled$();
	        if (this._currentCancellable instanceof Promise) {
	            this._currentCancellable.cancel();
	        }
	        if (this._initialValue instanceof Promise) {
	            this._initialValue.cancel();
	        }
	    };
	
	    ReductionPromiseArray.prototype._iterate = function (values) {
	        this._values = values;
	        var value;
	        var i;
	        var length = values.length;
	        if (this._initialValue !== undefined) {
	            value = this._initialValue;
	            i = 0;
	        } else {
	            value = Promise.resolve(values[0]);
	            i = 1;
	        }
	
	        this._currentCancellable = value;
	
	        if (!value.isRejected()) {
	            for (; i < length; ++i) {
	                var ctx = {
	                    accum: null,
	                    value: values[i],
	                    index: i,
	                    length: length,
	                    array: this
	                };
	                value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	            }
	        }
	
	        if (this._eachValues !== undefined) {
	            value = value._then(this._eachComplete, undefined, undefined, this, undefined);
	        }
	        value._then(completed, completed, undefined, value, this);
	    };
	
	    Promise.prototype.reduce = function (fn, initialValue) {
	        return reduce(this, fn, initialValue, null);
	    };
	
	    Promise.reduce = function (promises, fn, initialValue, _each) {
	        return reduce(promises, fn, initialValue, _each);
	    };
	
	    function completed(valueOrReason, array) {
	        if (this.isFulfilled()) {
	            array._resolve(valueOrReason);
	        } else {
	            array._reject(valueOrReason);
	        }
	    }
	
	    function reduce(promises, fn, initialValue, _each) {
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	        return array.promise();
	    }
	
	    function gotAccum(accum) {
	        this.accum = accum;
	        this.array._gotAccum(accum);
	        var value = tryConvertToPromise(this.value, this.array._promise);
	        if (value instanceof Promise) {
	            this.array._currentCancellable = value;
	            return value._then(gotValue, undefined, undefined, this, undefined);
	        } else {
	            return gotValue.call(this, value);
	        }
	    }
	
	    function gotValue(value) {
	        var array = this.array;
	        var promise = array._promise;
	        var fn = tryCatch(array._fn);
	        promise._pushContext();
	        var ret;
	        if (array._eachValues !== undefined) {
	            ret = fn.call(promise._boundValue(), value, this.index, this.length);
	        } else {
	            ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
	        }
	        if (ret instanceof Promise) {
	            array._currentCancellable = ret;
	        }
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
	        return ret;
	    }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, debug) {
	    var PromiseInspection = Promise.PromiseInspection;
	    var util = __webpack_require__(6);
	
	    function SettledPromiseArray(values) {
	        this.constructor$(values);
	    }
	    util.inherits(SettledPromiseArray, PromiseArray);
	
	    SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	        this._values[index] = inspection;
	        var totalResolved = ++this._totalResolved;
	        if (totalResolved >= this._length) {
	            this._resolve(this._values);
	            return true;
	        }
	        return false;
	    };
	
	    SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	        var ret = new PromiseInspection();
	        ret._bitField = 33554432;
	        ret._settledValueField = value;
	        return this._promiseResolved(index, ret);
	    };
	    SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	        var ret = new PromiseInspection();
	        ret._bitField = 16777216;
	        ret._settledValueField = reason;
	        return this._promiseResolved(index, ret);
	    };
	
	    Promise.settle = function (promises) {
	        debug.deprecated(".settle()", ".reflect()");
	        return new SettledPromiseArray(promises).promise();
	    };
	
	    Promise.prototype.settle = function () {
	        return Promise.settle(this);
	    };
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (Promise, PromiseArray, apiRejection) {
	    var util = __webpack_require__(6);
	    var RangeError = __webpack_require__(13).RangeError;
	    var AggregateError = __webpack_require__(13).AggregateError;
	    var isArray = util.isArray;
	    var CANCELLATION = {};
	
	    function SomePromiseArray(values) {
	        this.constructor$(values);
	        this._howMany = 0;
	        this._unwrap = false;
	        this._initialized = false;
	    }
	    util.inherits(SomePromiseArray, PromiseArray);
	
	    SomePromiseArray.prototype._init = function () {
	        if (!this._initialized) {
	            return;
	        }
	        if (this._howMany === 0) {
	            this._resolve([]);
	            return;
	        }
	        this._init$(undefined, -5);
	        var isArrayResolved = isArray(this._values);
	        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
	            this._reject(this._getRangeError(this.length()));
	        }
	    };
	
	    SomePromiseArray.prototype.init = function () {
	        this._initialized = true;
	        this._init();
	    };
	
	    SomePromiseArray.prototype.setUnwrap = function () {
	        this._unwrap = true;
	    };
	
	    SomePromiseArray.prototype.howMany = function () {
	        return this._howMany;
	    };
	
	    SomePromiseArray.prototype.setHowMany = function (count) {
	        this._howMany = count;
	    };
	
	    SomePromiseArray.prototype._promiseFulfilled = function (value) {
	        this._addFulfilled(value);
	        if (this._fulfilled() === this.howMany()) {
	            this._values.length = this.howMany();
	            if (this.howMany() === 1 && this._unwrap) {
	                this._resolve(this._values[0]);
	            } else {
	                this._resolve(this._values);
	            }
	            return true;
	        }
	        return false;
	    };
	    SomePromiseArray.prototype._promiseRejected = function (reason) {
	        this._addRejected(reason);
	        return this._checkOutcome();
	    };
	
	    SomePromiseArray.prototype._promiseCancelled = function () {
	        if (this._values instanceof Promise || this._values == null) {
	            return this._cancel();
	        }
	        this._addRejected(CANCELLATION);
	        return this._checkOutcome();
	    };
	
	    SomePromiseArray.prototype._checkOutcome = function () {
	        if (this.howMany() > this._canPossiblyFulfill()) {
	            var e = new AggregateError();
	            for (var i = this.length(); i < this._values.length; ++i) {
	                if (this._values[i] !== CANCELLATION) {
	                    e.push(this._values[i]);
	                }
	            }
	            if (e.length > 0) {
	                this._reject(e);
	            } else {
	                this._cancel();
	            }
	            return true;
	        }
	        return false;
	    };
	
	    SomePromiseArray.prototype._fulfilled = function () {
	        return this._totalResolved;
	    };
	
	    SomePromiseArray.prototype._rejected = function () {
	        return this._values.length - this.length();
	    };
	
	    SomePromiseArray.prototype._addRejected = function (reason) {
	        this._values.push(reason);
	    };
	
	    SomePromiseArray.prototype._addFulfilled = function (value) {
	        this._values[this._totalResolved++] = value;
	    };
	
	    SomePromiseArray.prototype._canPossiblyFulfill = function () {
	        return this.length() - this._rejected();
	    };
	
	    SomePromiseArray.prototype._getRangeError = function (count) {
	        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
	        return new RangeError(message);
	    };
	
	    SomePromiseArray.prototype._resolveEmptyArray = function () {
	        this._reject(this._getRangeError(0));
	    };
	
	    function some(promises, howMany) {
	        if ((howMany | 0) !== howMany || howMany < 0) {
	            return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
	        }
	        var ret = new SomePromiseArray(promises);
	        var promise = ret.promise();
	        ret.setHowMany(howMany);
	        ret.init();
	        return promise;
	    }
	
	    Promise.some = function (promises, howMany) {
	        return some(promises, howMany);
	    };
	
	    Promise.prototype.some = function (howMany) {
	        return some(this, howMany);
	    };
	
	    Promise._SomePromiseArray = SomePromiseArray;
	};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL) {
	    var PromiseMap = Promise.map;
	
	    Promise.prototype.filter = function (fn, options) {
	        return PromiseMap(this, fn, options, INTERNAL);
	    };
	
	    Promise.filter = function (promises, fn, options) {
	        return PromiseMap(promises, fn, options, INTERNAL);
	    };
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise, INTERNAL) {
	    var PromiseReduce = Promise.reduce;
	    var PromiseAll = Promise.all;
	
	    function promiseAllThis() {
	        return PromiseAll(this);
	    }
	
	    function PromiseMapSeries(promises, fn) {
	        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	    }
	
	    Promise.prototype.each = function (fn) {
	        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
	    };
	
	    Promise.prototype.mapSeries = function (fn) {
	        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	    };
	
	    Promise.each = function (promises, fn) {
	        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
	    };
	
	    Promise.mapSeries = PromiseMapSeries;
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Promise) {
	    var SomePromiseArray = Promise._SomePromiseArray;
	    function any(promises) {
	        var ret = new SomePromiseArray(promises);
	        var promise = ret.promise();
	        ret.setHowMany(1);
	        ret.setUnwrap();
	        ret.init();
	        return promise;
	    }
	
	    Promise.any = function (promises) {
	        return any(promises);
	    };
	
	    Promise.prototype.any = function () {
	        return any(this);
	    };
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _each = __webpack_require__(43);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultConfig = __webpack_require__(82);
	
	var Config = function () {
	  function Config(c) {
	    var _this = this;
	
	    _classCallCheck(this, Config);
	
	    (0, _each2.default)(c, function (value, key) {
	      _this[key] = value;
	    });
	  }
	
	  _createClass(Config, [{
	    key: 'get',
	    value: function get(k) {
	      return this[k];
	    }
	  }, {
	    key: 'set',
	    value: function set(k, v) {
	      this[k] = v;
	    }
	  }]);
	
	  return Config;
	}();
	
	module.exports = new Config(defaultConfig);
	if (typeof module.exports.Config !== 'undefined') {
	  throw new Error("default config.json file may not contain a property 'Config'");
	}
	module.exports.Config = Config;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(44);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var arrayEach = __webpack_require__(45),
	    baseEach = __webpack_require__(46),
	    castFunction = __webpack_require__(80),
	    isArray = __webpack_require__(62);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseForOwn = __webpack_require__(47),
	    createBaseEach = __webpack_require__(79);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseFor = __webpack_require__(48),
	    keys = __webpack_require__(50);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createBaseFor = __webpack_require__(49);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function (object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var arrayLikeKeys = __webpack_require__(51),
	    baseKeys = __webpack_require__(72),
	    isArrayLike = __webpack_require__(76);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseTimes = __webpack_require__(52),
	    isArguments = __webpack_require__(53),
	    isArray = __webpack_require__(62),
	    isBuffer = __webpack_require__(63),
	    isIndex = __webpack_require__(66),
	    isTypedArray = __webpack_require__(67);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
	    // Safari 9 has enumerable `arguments.length` in strict mode.
	    key == 'length' ||
	    // Node.js 0.10 has enumerable non-index properties on buffers.
	    isBuff && (key == 'offset' || key == 'parent') ||
	    // PhantomJS 2 has enumerable non-index properties on typed arrays.
	    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
	    // Skip index properties.
	    isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseIsArguments = __webpack_require__(54),
	    isObjectLike = __webpack_require__(61);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function () {
	    return arguments;
	}()) ? baseIsArguments : function (value) {
	    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseGetTag = __webpack_require__(55),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Symbol = __webpack_require__(56),
	    getRawTag = __webpack_require__(59),
	    objectToString = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	    if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	    }
	    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
	}
	
	module.exports = baseGetTag;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var root = __webpack_require__(57);
	
	/** Built-in value references. */
	var _Symbol = root.Symbol;
	
	module.exports = _Symbol;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var freeGlobal = __webpack_require__(58);
	
	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Symbol = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	module.exports = isObjectLike;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var root = __webpack_require__(57),
	    stubFalse = __webpack_require__(65);
	
	/** Detect free variable `exports`. */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseIsTypedArray = __webpack_require__(68),
	    baseUnary = __webpack_require__(70),
	    nodeUtil = __webpack_require__(71);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseGetTag = __webpack_require__(55),
	    isLength = __webpack_require__(69),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function (value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var freeGlobal = __webpack_require__(58);
	
	/** Detect free variable `exports`. */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = function () {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}();
	
	module.exports = nodeUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isPrototype = __webpack_require__(73),
	    nativeKeys = __webpack_require__(74);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var overArg = __webpack_require__(75);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function (arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isFunction = __webpack_require__(77),
	    isLength = __webpack_require__(69);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseGetTag = __webpack_require__(55),
	    isObject = __webpack_require__(78);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	    if (!isObject(value)) {
	        return false;
	    }
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in Safari 9 which returns 'object' for typed arrays and other constructors.
	    var tag = baseGetTag(value);
	    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayLike = __webpack_require__(76);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function (collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while (fromRight ? index-- : ++index < length) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var identity = __webpack_require__(81);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = {"transport":"http","websocket":"wss://api.hive.blog:8090","uri":"https://api.hive.blog","url":"https://api.hive.blog","dev_uri":"","stage_uri":"","address_prefix":"STM","chain_id":"beeab0de00000000000000000000000000000000000000000000000000000000","alternative_api_endpoints":["https://api.hive.blog","https://api.ha.deathwing.me"],"failover_threshold":3,"useAppbaseApi":true}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  "api": "condenser_api",
	  "method": "get_trending_tags",
	  "params": ["tag", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_tags_used_by_author",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_post_discussions_by_payout",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_comment_discussions_by_payout",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_trending",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_created",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_active",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_cashout",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_votes",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_children",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_hot",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_feed",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_blog",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_comments",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_promoted",
	  "params": ["query"]
	}, {
	  "api": "condenser_api",
	  "method": "get_block_header",
	  "params": ["block_num"]
	}, {
	  "api": "block_api",
	  "method": "get_block",
	  "params": ["block_num"]
	}, {
	  "api": "account_history_api",
	  "method": "get_ops_in_block",
	  "params": ["block_num", "only_virtual"]
	}, {
	  "api": "condenser_api",
	  "method": "get_state",
	  "params": ["path"]
	}, {
	  "api": "database_api",
	  "method": "get_config"
	}, {
	  "api": "database_api",
	  "method": "get_dynamic_global_properties"
	}, {
	  "api": "condenser_api",
	  "method": "get_chain_properties"
	}, {
	  "api": "database_api",
	  "method": "get_feed_history"
	}, {
	  "api": "condenser_api",
	  "method": "get_current_median_history_price"
	}, {
	  "api": "database_api",
	  "method": "get_witness_schedule"
	}, {
	  "api": "condenser_api",
	  "method": "get_hardfork_version"
	}, {
	  "api": "condenser_api",
	  "method": "get_next_scheduled_hardfork"
	}, {
	  "api": "account_by_key_api",
	  "method": "get_key_references",
	  "params": ["keys"]
	}, {
	  "api": "condenser_api",
	  "method": "get_accounts",
	  "params": ["names"]
	}, {
	  "api": "condenser_api",
	  "method": "get_account_references",
	  "params": ["accountId"]
	}, {
	  "api": "condenser_api",
	  "method": "lookup_account_names",
	  "params": ["accounts"]
	}, {
	  "api": "condenser_api",
	  "method": "lookup_accounts",
	  "params": ["lower_bound_name", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_account_count"
	}, {
	  "api": "condenser_api",
	  "method": "get_conversion_requests",
	  "params": ["accountName"]
	}, {
	  "api": "account_history_api",
	  "method": "get_account_history",
	  "params": ["account", "from", "limit", "operation_filter_low", "operation_filter_high"]
	}, {
	  "api": "condenser_api",
	  "method": "get_owner_history",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_recovery_request",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_escrow",
	  "params": ["from", "escrow_id"]
	}, {
	  "api": "condenser_api",
	  "method": "get_withdraw_routes",
	  "params": ["account", "withdraw_route_type"]
	}, {
	  "api": "condenser_api",
	  "method": "get_savings_withdraw_from",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_savings_withdraw_to",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_order_book",
	  "params": ["limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_open_orders",
	  "params": ["owner"]
	}, {
	  "api": "database_api",
	  "method": "get_transaction_hex",
	  "params": ["trx"]
	}, {
	  "api": "condenser_api",
	  "method": "get_transaction",
	  "params": ["trx_id"]
	}, {
	  "api": "database_api",
	  "method": "get_required_signatures",
	  "params": ["trx", "available_keys"]
	}, {
	  "api": "database_api",
	  "method": "get_potential_signatures",
	  "params": ["trx"]
	}, {
	  "api": "database_api",
	  "method": "verify_authority",
	  "params": ["trx"]
	}, {
	  "api": "database_api",
	  "method": "verify_account_authority",
	  "params": ["account", "signers"]
	}, {
	  "api": "condenser_api",
	  "method": "get_active_votes",
	  "params": ["author", "permlink"]
	}, {
	  "api": "database_api",
	  "method": "list_votes",
	  "params": ["voter"]
	}, {
	  "api": "condenser_api",
	  "method": "get_content",
	  "params": ["author", "permlink"]
	}, {
	  "api": "condenser_api",
	  "method": "get_content_replies",
	  "params": ["author", "permlink"]
	}, {
	  "api": "condenser_api",
	  "method": "get_discussions_by_author_before_date",
	  "params": ["author", "start_permlink", "before_date", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_replies_by_last_update",
	  "params": ["start_author", "start_permlink", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_witnesses",
	  "params": ["witnessIds"]
	}, {
	  "api": "condenser_api",
	  "method": "get_witness_by_account",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_witnesses_by_vote",
	  "params": ["from", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "lookup_witness_accounts",
	  "params": ["lower_bound_name", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_witness_count"
	}, {
	  "api": "database_api",
	  "method": "get_active_witnesses"
	}, {
	  "api": "condenser_api",
	  "method": "get_reward_fund",
	  "params": ["name"]
	}, {
	  "api": "database_api",
	  "method": "get_reward_funds"
	}, {
	  "api": "condenser_api",
	  "method": "get_vesting_delegations",
	  "params": ["account", "from", "limit"]
	}, {
	  "api": "database_api",
	  "method": "get_version"
	}, {
	  "api": "condenser_api",
	  "method": "get_followers",
	  "params": ["account", "start", "type", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_following",
	  "params": ["account", "start", "type", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_follow_count",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "get_feed_entries",
	  "params": ["account", "start_entry_id", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_feed",
	  "params": ["account", "start_entry_id", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_blog_entries",
	  "params": ["account", "start_entry_id", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_blog",
	  "params": ["account", "start_entry_id", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_account_reputations",
	  "params": ["lower_bound_name", "limit"]
	}, {
	  "api": "condenser_api",
	  "method": "get_reblogged_by",
	  "params": ["author", "permlink"]
	}, {
	  "api": "condenser_api",
	  "method": "get_blog_authors",
	  "params": ["account"]
	}, {
	  "api": "condenser_api",
	  "method": "broadcast_transaction",
	  "params": ["trx"]
	}, {
	  "api": "condenser_api",
	  "method": "broadcast_transaction_synchronous",
	  "params": ["trx"]
	}, {
	  "api": "network_broadcast_api",
	  "method": "broadcast_block",
	  "params": ["block"]
	}, {
	  "api": "transaction_status_api",
	  "method": "find_transaction",
	  "params": ["transaction_id", "expiration"]
	}, {
	  "api": "market_history_api",
	  "method": "get_ticker",
	  "params": []
	}, {
	  "api": "market_history_api",
	  "method": "get_volume",
	  "params": []
	}, {
	  "api": "market_history_api",
	  "method": "get_order_book",
	  "method_name": "getMarketOrderBook",
	  "params": ["limit"]
	}, {
	  "api": "market_history_api",
	  "method": "get_trade_history",
	  "params": ["start", "end", "limit"]
	}, {
	  "api": "market_history_api",
	  "method": "get_recent_trades",
	  "params": ["limit"]
	}, {
	  "api": "market_history_api",
	  "method": "get_market_history",
	  "params": ["bucket_seconds", "start", "end"]
	}, {
	  "api": "market_history_api",
	  "method": "get_market_history_buckets"
	}, {
	  "api": "database_api",
	  "method": "find_proposals",
	  "params": ["proposal_ids"]
	}, {
	  "api": "database_api",
	  "method": "list_proposals",
	  "params": ["start", "limit", "order", "order_direction", "status"]
	}, {
	  "api": "database_api",
	  "method": "list_proposal_votes",
	  "params": ["start", "limit", "order", "order_direction", "status"]
	}, {
	  "api": "database_api",
	  "method": "get_nai_pool"
	}];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(85);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _ws = __webpack_require__(94);
	
	var _ws2 = _interopRequireDefault(_ws);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  http: _http2.default,
	  ws: _ws2.default
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RPCError = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.jsonRpc = jsonRpc;
	
	var _crossFetch = __webpack_require__(86);
	
	var _crossFetch2 = _interopRequireDefault(_crossFetch);
	
	var _debug = __webpack_require__(87);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _retry = __webpack_require__(90);
	
	var _retry2 = _interopRequireDefault(_retry);
	
	var _base = __webpack_require__(93);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _debug2.default)('steem:http');
	
	var RPCError = exports.RPCError = function (_Error) {
	  _inherits(RPCError, _Error);
	
	  function RPCError(rpcError) {
	    _classCallCheck(this, RPCError);
	
	    var _this = _possibleConstructorReturn(this, (RPCError.__proto__ || Object.getPrototypeOf(RPCError)).call(this, rpcError.message));
	
	    _this.name = 'RPCError';
	    _this.code = rpcError.code;
	    _this.data = rpcError.data;
	    return _this;
	  }
	
	  return RPCError;
	}(Error);
	
	/**
	 * Makes a JSON-RPC request using `fetch` or a user-provided `fetchMethod`.
	 *
	 * @param {string} uri - The URI to the JSON-RPC endpoint.
	 * @param {string} options.method - The remote JSON-RPC method to call.
	 * @param {string} options.id - ID for the request, for matching to a response.
	 * @param {*} options.params  - The params for the remote method.
	 * @param {function} [options.fetchMethod=fetch] - A function with the same
	 * signature as `fetch`, which can be used to make the network request, or for
	 * stubbing in tests.
	 */
	
	
	function jsonRpc(uri, _ref) {
	  var method = _ref.method,
	      id = _ref.id,
	      params = _ref.params,
	      _ref$fetchMethod = _ref.fetchMethod,
	      fetchMethod = _ref$fetchMethod === undefined ? _crossFetch2.default : _ref$fetchMethod;
	
	  var payload = { id: id, jsonrpc: '2.0', method: method, params: params };
	  return fetchMethod(uri, {
	    body: JSON.stringify(payload),
	    method: 'post',
	    mode: 'cors',
	    headers: {
	      Accept: 'application/json, text/plain, */*',
	      'Content-Type': 'application/json'
	    }
	  }).then(function (res) {
	    if (!res.ok) {
	      throw new Error('HTTP ' + res.status + ': ' + res.statusText);
	    }
	    return res.json();
	  }).then(function (rpcRes) {
	    if (rpcRes.id !== id) {
	      throw new Error('Invalid response id: ' + rpcRes.id);
	    }
	    if (rpcRes.error) {
	      throw new RPCError(rpcRes.error);
	    }
	    return rpcRes.result;
	  });
	}
	
	var HttpTransport = function (_Transport) {
	  _inherits(HttpTransport, _Transport);
	
	  function HttpTransport() {
	    _classCallCheck(this, HttpTransport);
	
	    return _possibleConstructorReturn(this, (HttpTransport.__proto__ || Object.getPrototypeOf(HttpTransport)).apply(this, arguments));
	  }
	
	  _createClass(HttpTransport, [{
	    key: 'send',
	    value: function send(api, data, callback) {
	      var _this3 = this;
	
	      var params = data.params;
	      if ((_config2.default.get('useAppbaseApi') || this.options.useAppbaseApi) && api !== 'transaction_status_api') {
	        api = 'condenser_api';
	      }
	      if (api === 'condenser_api') {
	        params = data.paramsCondenserApi;
	      }
	      debug('Steem::send', api, data);
	      var id = data.id || this.id++;
	      var method = api + '.' + data.method;
	
	      var retriable = this.retriable(api, data);
	      var fetchMethod = this.options.fetchMethod;
	      if (retriable) {
	        retriable.attempt(function (currentAttempt) {
	          jsonRpc(_this3.options.uri, { method: method, id: id, params: params, fetchMethod: fetchMethod }).then(function (res) {
	            callback(null, res);
	          }, function (err) {
	            if (retriable.retry(err)) {
	              return;
	            }
	            callback(retriable.mainError());
	          });
	        });
	      } else {
	        jsonRpc(this.options.uri, { method: method, id: id, params: params, fetchMethod: fetchMethod }).then(function (res) {
	          callback(null, res);
	        }, function (err) {
	          callback(err);
	        });
	      }
	    }
	  }, {
	    key: 'retriable',
	
	
	    // An object which can be used to track retries.
	    value: function retriable(api, data) {
	      if (this.nonRetriableOperations.some(function (o) {
	        return o === data.method;
	      })) {
	        // Do not retry if the operation is non-retriable.
	        return null;
	      } else if (Object(this.options.retry) === this.options.retry) {
	        // If `this.options.retry` is a map of options, pass those to operation.
	        return _retry2.default.operation(this.options.retry);
	      } else if (this.options.retry) {
	        // If `this.options.retry` is `true`, use default options.
	        return _retry2.default.operation();
	      } else {
	        // Otherwise, don't retry.
	        return null;
	      }
	    }
	  }, {
	    key: 'nonRetriableOperations',
	    get: function get() {
	      return this.options.nonRetriableOperations || ['broadcast_transaction', 'broadcast_transaction_with_callback', 'broadcast_transaction_synchronous', 'broadcast_block', 'get_account_history'];
	    }
	  }]);
	
	  return HttpTransport;
	}(_base2.default);
	
	exports.default = HttpTransport;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	var self = {};
	(function (self) {
	  'use strict';
	
	  if (self.fetch) {
	    return;
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && function () {
	      try {
	        new Blob();
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  if (support.arrayBuffer) {
	    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];
	
	    var isDataView = function isDataView(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj);
	    };
	
	    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
	    };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name');
	    }
	    return name.toLowerCase();
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value;
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function next() {
	        var value = items.shift();
	        return { done: value === undefined, value: value };
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function () {
	        return iterator;
	      };
	    }
	
	    return iterator;
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function (value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function (header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function (name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function (name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ',' + value : value;
	  };
	
	  Headers.prototype['delete'] = function (name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function (name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null;
	  };
	
	  Headers.prototype.has = function (name) {
	    return this.map.hasOwnProperty(normalizeName(name));
	  };
	
	  Headers.prototype.set = function (name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function (callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.values = function () {
	    var items = [];
	    this.forEach(function (value) {
	      items.push(value);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.entries = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items);
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'));
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function (resolve, reject) {
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	      reader.onerror = function () {
	        reject(reader.error);
	      };
	    });
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise;
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise;
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('');
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0);
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer;
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function (body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        throw new Error('unsupported BodyInit type');
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob);
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob');
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]));
	        }
	      };
	
	      this.arrayBuffer = function () {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer);
	        }
	      };
	    }
	
	    this.text = function () {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected;
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob);
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text');
	      } else {
	        return Promise.resolve(this._bodyText);
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function () {
	        return this.text().then(decode);
	      };
	    }
	
	    this.json = function () {
	      return this.text().then(JSON.parse);
	    };
	
	    return this;
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method;
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read');
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests');
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function () {
	    return new Request(this, { body: this._bodyInit });
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function (bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form;
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    rawHeaders.split(/\r?\n/).forEach(function (line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers;
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = 'status' in options ? options.status : 200;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function () {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    });
	  };
	
	  Response.error = function () {
	    var response = new Response(null, { status: 0, statusText: '' });
	    response.type = 'error';
	    return response;
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function (url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code');
	    }
	
	    return new Response(null, { status: status, headers: { location: url } });
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function (input, init) {
	    return new Promise(function (resolve, reject) {
	      var request = new Request(input, init);
	      var xhr = new XMLHttpRequest();
	
	      xhr.onload = function () {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function (value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    });
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : undefined);
	
	/*
	 * Rollup wraps up the whatwg-fetch code on ponyfill mode in
	 * order to prevent it from adding fetch to the global object.
	 */
	
	var fetch = self.fetch;
	
	fetch.fetch = fetch;
	fetch.Response = self.Response;
	fetch.Headers = self.Headers;
	fetch.Request = self.Request;
	
	// fetch now can be imported as the default object
	module.exports = fetch;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(88);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
	  // is firebug? http://stackoverflow.com/a/398120/376773
	  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
	  // is firefox >= v31?
	  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
	  // double check webkit in userAgent just in case we are in a worker
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function (v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit');
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function (match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch (e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch (e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(89);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0,
	      i;
	
	  for (i in namespace) {
	    hash = (hash << 5) - hash + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {};
	  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(91);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var RetryOperation = __webpack_require__(92);
	
	exports.operation = function (options) {
	  var timeouts = exports.timeouts(options);
	  return new RetryOperation(timeouts, {
	    forever: options && options.forever,
	    unref: options && options.unref,
	    maxRetryTime: options && options.maxRetryTime
	  });
	};
	
	exports.timeouts = function (options) {
	  if (options instanceof Array) {
	    return [].concat(options);
	  }
	
	  var opts = {
	    retries: 10,
	    factor: 2,
	    minTimeout: 1 * 1000,
	    maxTimeout: Infinity,
	    randomize: false
	  };
	  for (var key in options) {
	    opts[key] = options[key];
	  }
	
	  if (opts.minTimeout > opts.maxTimeout) {
	    throw new Error('minTimeout is greater than maxTimeout');
	  }
	
	  var timeouts = [];
	  for (var i = 0; i < opts.retries; i++) {
	    timeouts.push(this.createTimeout(i, opts));
	  }
	
	  if (options && options.forever && !timeouts.length) {
	    timeouts.push(this.createTimeout(i, opts));
	  }
	
	  // sort the array numerically ascending
	  timeouts.sort(function (a, b) {
	    return a - b;
	  });
	
	  return timeouts;
	};
	
	exports.createTimeout = function (attempt, opts) {
	  var random = opts.randomize ? Math.random() + 1 : 1;
	
	  var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
	  timeout = Math.min(timeout, opts.maxTimeout);
	
	  return timeout;
	};
	
	exports.wrap = function (obj, options, methods) {
	  if (options instanceof Array) {
	    methods = options;
	    options = null;
	  }
	
	  if (!methods) {
	    methods = [];
	    for (var key in obj) {
	      if (typeof obj[key] === 'function') {
	        methods.push(key);
	      }
	    }
	  }
	
	  for (var i = 0; i < methods.length; i++) {
	    var method = methods[i];
	    var original = obj[method];
	
	    obj[method] = function retryWrapper(original) {
	      var op = exports.operation(options);
	      var args = Array.prototype.slice.call(arguments, 1);
	      var callback = args.pop();
	
	      args.push(function (err) {
	        if (op.retry(err)) {
	          return;
	        }
	        if (err) {
	          arguments[0] = op.mainError();
	        }
	        callback.apply(this, arguments);
	      });
	
	      op.attempt(function () {
	        original.apply(obj, args);
	      });
	    }.bind(obj, original);
	    obj[method].options = options;
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	function RetryOperation(timeouts, options) {
	  // Compatibility for the old (timeouts, retryForever) signature
	  if (typeof options === 'boolean') {
	    options = { forever: options };
	  }
	
	  this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
	  this._timeouts = timeouts;
	  this._options = options || {};
	  this._maxRetryTime = options && options.maxRetryTime || Infinity;
	  this._fn = null;
	  this._errors = [];
	  this._attempts = 1;
	  this._operationTimeout = null;
	  this._operationTimeoutCb = null;
	  this._timeout = null;
	  this._operationStart = null;
	
	  if (this._options.forever) {
	    this._cachedTimeouts = this._timeouts.slice(0);
	  }
	}
	module.exports = RetryOperation;
	
	RetryOperation.prototype.reset = function () {
	  this._attempts = 1;
	  this._timeouts = this._originalTimeouts;
	};
	
	RetryOperation.prototype.stop = function () {
	  if (this._timeout) {
	    clearTimeout(this._timeout);
	  }
	
	  this._timeouts = [];
	  this._cachedTimeouts = null;
	};
	
	RetryOperation.prototype.retry = function (err) {
	  if (this._timeout) {
	    clearTimeout(this._timeout);
	  }
	
	  if (!err) {
	    return false;
	  }
	  var currentTime = new Date().getTime();
	  if (err && currentTime - this._operationStart >= this._maxRetryTime) {
	    this._errors.unshift(new Error('RetryOperation timeout occurred'));
	    return false;
	  }
	
	  this._errors.push(err);
	
	  var timeout = this._timeouts.shift();
	  if (timeout === undefined) {
	    if (this._cachedTimeouts) {
	      // retry forever, only keep last error
	      this._errors.splice(this._errors.length - 1, this._errors.length);
	      this._timeouts = this._cachedTimeouts.slice(0);
	      timeout = this._timeouts.shift();
	    } else {
	      return false;
	    }
	  }
	
	  var self = this;
	  var timer = setTimeout(function () {
	    self._attempts++;
	
	    if (self._operationTimeoutCb) {
	      self._timeout = setTimeout(function () {
	        self._operationTimeoutCb(self._attempts);
	      }, self._operationTimeout);
	
	      if (self._options.unref) {
	        self._timeout.unref();
	      }
	    }
	
	    self._fn(self._attempts);
	  }, timeout);
	
	  if (this._options.unref) {
	    timer.unref();
	  }
	
	  return true;
	};
	
	RetryOperation.prototype.attempt = function (fn, timeoutOps) {
	  this._fn = fn;
	
	  if (timeoutOps) {
	    if (timeoutOps.timeout) {
	      this._operationTimeout = timeoutOps.timeout;
	    }
	    if (timeoutOps.cb) {
	      this._operationTimeoutCb = timeoutOps.cb;
	    }
	  }
	
	  var self = this;
	  if (this._operationTimeoutCb) {
	    this._timeout = setTimeout(function () {
	      self._operationTimeoutCb();
	    }, self._operationTimeout);
	  }
	
	  this._operationStart = new Date().getTime();
	
	  this._fn(this._attempts);
	};
	
	RetryOperation.prototype.try = function (fn) {
	  console.log('Using RetryOperation.try() is deprecated');
	  this.attempt(fn);
	};
	
	RetryOperation.prototype.start = function (fn) {
	  console.log('Using RetryOperation.start() is deprecated');
	  this.attempt(fn);
	};
	
	RetryOperation.prototype.start = RetryOperation.prototype.try;
	
	RetryOperation.prototype.errors = function () {
	  return this._errors;
	};
	
	RetryOperation.prototype.attempts = function () {
	  return this._attempts;
	};
	
	RetryOperation.prototype.mainError = function () {
	  if (this._errors.length === 0) {
	    return null;
	  }
	
	  var counts = {};
	  var mainError = null;
	  var mainErrorCount = 0;
	
	  for (var i = 0; i < this._errors.length; i++) {
	    var error = this._errors[i];
	    var message = error.message;
	    var count = (counts[message] || 0) + 1;
	
	    counts[message] = count;
	
	    if (count >= mainErrorCount) {
	      mainError = error;
	      mainErrorCount = count;
	    }
	  }
	
	  return mainError;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bluebird = __webpack_require__(3);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _events = __webpack_require__(2);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transport = function (_EventEmitter) {
	  _inherits(Transport, _EventEmitter);
	
	  function Transport() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Transport);
	
	    var _this = _possibleConstructorReturn(this, (Transport.__proto__ || Object.getPrototypeOf(Transport)).call(this, options));
	
	    _this.options = options;
	    _this.id = 0;
	    return _this;
	  }
	
	  _createClass(Transport, [{
	    key: 'setOptions',
	    value: function setOptions(options) {
	      Object.assign(this.options, options);
	      this.stop();
	    }
	  }, {
	    key: 'listenTo',
	    value: function listenTo(target, eventName, callback) {
	      if (target.addEventListener) target.addEventListener(eventName, callback);else target.on(eventName, callback);
	
	      return function () {
	        if (target.removeEventListener) target.removeEventListener(eventName, callback);else target.removeListener(eventName, callback);
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {}
	  }, {
	    key: 'start',
	    value: function start() {}
	  }, {
	    key: 'stop',
	    value: function stop() {}
	  }]);
	
	  return Transport;
	}(_events2.default);
	
	exports.default = Transport;
	
	
	_bluebird2.default.promisifyAll(Transport.prototype);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bluebird = __webpack_require__(3);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _detectNode = __webpack_require__(95);
	
	var _detectNode2 = _interopRequireDefault(_detectNode);
	
	var _debug = __webpack_require__(87);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _base = __webpack_require__(93);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebSocket = void 0;
	if (_detectNode2.default) {
	  WebSocket = __webpack_require__(96); // eslint-disable-line global-require
	} else if (typeof window !== 'undefined') {
	  WebSocket = window.WebSocket;
	} else {
	  throw new Error("Couldn't decide on a `WebSocket` class");
	}
	
	var debug = (0, _debug2.default)('steem:ws');
	
	var WsTransport = function (_Transport) {
	  _inherits(WsTransport, _Transport);
	
	  function WsTransport() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, WsTransport);
	
	    var _this = _possibleConstructorReturn(this, (WsTransport.__proto__ || Object.getPrototypeOf(WsTransport)).call(this, Object.assign({ id: 0 }, options)));
	
	    _this._requests = new Map();
	    _this.inFlight = 0;
	    _this.isOpen = false;
	    return _this;
	  }
	
	  _createClass(WsTransport, [{
	    key: 'start',
	    value: function start() {
	      var _this2 = this;
	
	      if (this.startPromise) {
	        return this.startPromise;
	      }
	
	      this.startPromise = new _bluebird2.default(function (resolve, reject) {
	        _this2.ws = new WebSocket(_this2.options.websocket);
	        _this2.ws.onerror = function (err) {
	          _this2.startPromise = null;
	          reject(err);
	        };
	        _this2.ws.onopen = function () {
	          _this2.isOpen = true;
	          _this2.ws.onerror = _this2.onError.bind(_this2);
	          _this2.ws.onmessage = _this2.onMessage.bind(_this2);
	          _this2.ws.onclose = _this2.onClose.bind(_this2);
	          resolve();
	        };
	      });
	      return this.startPromise;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      debug('Stopping...');
	
	      this.startPromise = null;
	      this.isOpen = false;
	      this._requests.clear();
	
	      if (this.ws) {
	        this.ws.onerror = this.ws.onmessage = this.ws.onclose = null;
	        this.ws.close();
	        this.ws = null;
	      }
	    }
	  }, {
	    key: 'send',
	    value: function send(api, data, callback) {
	      var _this3 = this;
	
	      debug('Steem::send', api, data);
	      return this.start().then(function () {
	        var deferral = {};
	        new _bluebird2.default(function (resolve, reject) {
	          deferral.resolve = function (val) {
	            resolve(val);
	            callback(null, val);
	          };
	          deferral.reject = function (val) {
	            reject(val);
	            callback(val);
	          };
	        });
	
	        if (_this3.options.useAppbaseApi) {
	          api = 'condenser_api';
	        }
	
	        var _request = {
	          deferral: deferral,
	          startedAt: Date.now(),
	          message: {
	            id: data.id || _this3.id++,
	            method: 'call',
	            jsonrpc: '2.0',
	            params: [api, data.method, data.params]
	          }
	        };
	        _this3.inFlight++;
	        _this3._requests.set(_request.message.id, _request);
	        _this3.ws.send(JSON.stringify(_request.message));
	        return deferral;
	      });
	    }
	  }, {
	    key: 'onError',
	    value: function onError(error) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _request = _step.value;
	
	          _request.deferral.reject(error);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.stop();
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var error = new Error('Connection was closed');
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this._requests[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _request = _step2.value;
	
	          _request.deferral.reject(error);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this._requests.clear();
	    }
	  }, {
	    key: 'onMessage',
	    value: function onMessage(websocketMessage) {
	      var message = JSON.parse(websocketMessage.data);
	      debug('-- Steem.onMessage -->', message.id);
	      if (!this._requests.has(message.id)) {
	        throw new Error('Panic: no request in queue for message id ' + message.id);
	      }
	      var _request = this._requests.get(message.id);
	      this._requests.delete(message.id);
	
	      var errorCause = message.error;
	      if (errorCause) {
	        var err = new Error(
	        // eslint-disable-next-line prefer-template
	        (errorCause.message || 'Failed to complete operation') + ' (see err.payload for the full error payload)');
	        err.payload = message;
	        _request.deferral.reject(err);
	      } else {
	        this.emit('track-performance', _request.message.method, Date.now() - _request.startedAt);
	        _request.deferral.resolve(message.result);
	      }
	    }
	  }]);
	
	  return WsTransport;
	}(_base2.default);
	
	exports.default = WsTransport;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	module.exports = false;
	
	// Only Node.JS has a process variable that is of [[Class]] process
	try {
	  module.exports = Object.prototype.toString.call(global.process) === '[object process]';
	} catch (e) {}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.camelCase = camelCase;
	exports.validateAccountName = validateAccountName;
	exports.buildWitnessUpdateOp = buildWitnessUpdateOp;
	exports.autoDetectApiVersion = autoDetectApiVersion;
	
	var _types = __webpack_require__(98);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _serializer = __webpack_require__(200);
	
	var _serializer2 = _interopRequireDefault(_serializer);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _http = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ByteBuffer = __webpack_require__(154);
	
	var uint16 = _types2.default.uint16,
	    uint32 = _types2.default.uint32,
	    string = _types2.default.string,
	    public_key = _types2.default.public_key,
	    asset = _types2.default.asset;
	
	
	var snakeCaseRe = /_([a-z])/g;
	function camelCase(str) {
	  return str.replace(snakeCaseRe, function (_m, l) {
	    return l.toUpperCase();
	  });
	}
	
	function validateAccountName(value) {
	  var i = void 0,
	      label = void 0,
	      len = void 0,
	      suffix = void 0;
	
	  suffix = "Account name should ";
	  if (!value) {
	    return suffix + "not be empty.";
	  }
	  var length = value.length;
	  if (length < 3) {
	    return suffix + "be longer.";
	  }
	  if (length > 16) {
	    return suffix + "be shorter.";
	  }
	  if (/\./.test(value)) {
	    suffix = "Each account segment should ";
	  }
	  var ref = value.split(".");
	  for (i = 0, len = ref.length; i < len; i++) {
	    label = ref[i];
	    if (!/^[a-z]/.test(label)) {
	      return suffix + "start with a letter.";
	    }
	    if (!/^[a-z0-9-]*$/.test(label)) {
	      return suffix + "have only letters, digits, or dashes.";
	    }
	    if (/--/.test(label)) {
	      return suffix + "have only one dash in a row.";
	    }
	    if (!/[a-z0-9]$/.test(label)) {
	      return suffix + "end with a letter or digit.";
	    }
	    if (!(label.length >= 3)) {
	      return suffix + "be longer";
	    }
	  }
	  return null;
	}
	
	// Hack to be able to generate a valid witness_set_properties op
	// Can hopefully be removed when hived's JSON representation is fixed
	var price = new _serializer2.default("price", {
	  base: asset,
	  quote: asset
	});
	
	function serialize(serializer, data) {
	  var buffer = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	  serializer.appendByteBuffer(buffer, data);
	  buffer.flip();
	  return buffer.toString('hex');
	}
	function buildWitnessUpdateOp(owner, props) {
	  var data = {
	    extensions: [],
	    owner: owner,
	    props: []
	  };
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      var type = void 0;
	      switch (key) {
	        case "key":
	        case "new_signing_key":
	          type = public_key;
	          break;
	        case "account_subsidy_budget":
	        case "account_subsidy_decay":
	        case "maximum_block_size":
	          type = uint32;
	          break;
	        case "hbd_interest_rate":
	          type = uint16;
	          break;
	        case "url":
	          type = string;
	          break;
	        case "hbd_exchange_rate":
	          type = price;
	          break;
	        case "account_creation_fee":
	          type = asset;
	          break;
	        default:
	          throw new Error("Unknown witness prop: " + key);
	      }
	      data.props.push([key, serialize(type, props[key])]);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  data.props.sort(function (a, b) {
	    return a[0].localeCompare(b[0]);
	  });
	  return ["witness_set_properties", data];
	}
	
	function autoDetectApiVersion() {
	  console.log('Warning: call to autoDetectApiVersion() is deprecated and can safely be removed');
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ecc = __webpack_require__(103);
	
	var _number_utils = __webpack_require__(195);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Low-level types that make up operations
	
	var v = __webpack_require__(196);
	var ObjectId = __webpack_require__(198);
	var fp = __webpack_require__(199);
	var chain_types = __webpack_require__(197);
	//const BigInt = require('BigInt')
	
	var Types = {};
	module.exports = Types;
	
	var HEX_DUMP = process.env.npm_config__graphene_serializer_hex_dump;
	
	// Highly optimized implementation of Damm algorithm
	// https://en.wikipedia.org/wiki/Damm_algorithm
	function damm_checksum_8digit(value) {
	    if (value >= 100000000) throw new Error("Expected value less than 100000000, instead got " + value);
	
	    var t = [0, 30, 10, 70, 50, 90, 80, 60, 40, 20, 70, 0, 90, 20, 10, 50, 40, 80, 60, 30, 40, 20, 0, 60, 80, 70, 10, 30, 50, 90, 10, 70, 50, 0, 90, 80, 30, 40, 20, 60, 60, 10, 20, 30, 0, 40, 50, 90, 70, 80, 30, 60, 70, 40, 20, 0, 90, 50, 80, 10, 50, 80, 60, 90, 70, 20, 0, 10, 30, 40, 80, 90, 40, 50, 30, 60, 20, 0, 10, 70, 90, 40, 30, 80, 60, 10, 70, 20, 0, 50, 20, 50, 80, 10, 40, 30, 60, 70, 90, 0];
	
	    var q0 = value / 10;
	    var d0 = value % 10;
	    var q1 = q0 / 10;
	    var d1 = q0 % 10;
	    var q2 = q1 / 10;
	    var d2 = q1 % 10;
	    var q3 = q2 / 10;
	    var d3 = q2 % 10;
	    var q4 = q3 / 10;
	    var d4 = q3 % 10;
	    var q5 = q4 / 10;
	    var d5 = q4 % 10;
	    var d6 = q5 % 10;
	    var d7 = q5 / 10;
	
	    var x = t[d7];
	    x = t[x + d6];
	    x = t[x + d5];
	    x = t[x + d4];
	    x = t[x + d3];
	    x = t[x + d2];
	    x = t[x + d1];
	    x = t[x + d0];
	
	    return x / 10;
	}
	
	/**
	* Asset symbols contain the following information
	*
	*  4 bit PRECISION
	*  4 bit RESERVED
	*  CHAR[6] up to 6 upper case alpha numeric ascii characters,
	*  char = \0  null terminated
	*
	*  It is treated as a uint64_t for all internal operations, but
	*  is easily converted to something that can be displayed.
	*
	*  Legacy serialization of assets
	*  0000pppp aaaaaaaa bbbbbbbb cccccccc dddddddd eeeeeeee ffffffff 00000000
	*  Symbol = abcdef
	*
	*  NAI serialization of assets
	*  aaa1pppp bbbbbbbb cccccccc dddddddd
	*  NAI = (MSB to LSB) dddddddd cccccccc bbbbbbbb aaa
	*
	*  NAI internal storage of legacy assets
	*/
	Types.asset = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        var amount = b.readInt64();
	        var precision = b.readUint8();
	        var amount_string = "";
	        var symbol = "";
	
	        if (precision >= 16) {
	            // NAI Case
	            var b_copy = b.copy(b.offset - 1, b.offset + 3);
	            var nai = new Buffer(b_copy.toBinary(), "binary").readInt32();
	            nai = nai / 32;
	            symbol = "@@" + nai.toString().padStart(8, '0') + damm_checksum_8digit(nai).to_String();
	            precision = precision % 16;
	            b.skip(3);
	            amount_string = (0, _number_utils.fromImpliedDecimal)(amount, precision);
	        } else {
	            // Legacy Case
	            var _b_copy = b.copy(b.offset, b.offset + 7);
	            symbol = new Buffer(_b_copy.toBinary(), "binary").toString().replace(/\x00/g, "");
	            b.skip(7);
	            // "1.000 HIVE" always written with full precision
	            amount_string = (0, _number_utils.fromImpliedDecimal)(amount, precision);
	        }
	
	        return amount_string + " " + symbol;
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        var amount = "";
	        var symbol = "";
	        var nai = 0;
	        var precision = 0;
	
	        if (object["nai"]) {
	            symbol = object["nai"];
	            nai = parseInt(symbol.slice(2));
	            var checksum = nai % 10;
	            nai = Math.floor(nai / 10);
	            var expected_checksum = damm_checksum_8digit(nai);
	
	            switch (object["nai"]) {
	                case "@@000000021":
	                    precision = 3;
	                    symbol = _config2.default.get("address_prefix") == "STM" ? "STEEM" : "TESTS";
	                    break;
	                case "@@000000013":
	                    precision = 3;
	                    symbol = _config2.default.get("address_prefix") == "STM" ? "SBD" : "TBD";
	                    break;
	                case "@@000000037":
	                    precision = 6;
	                    symbol = "VESTS";
	                    break;
	            }
	
	            precision = parseInt(object["precision"]);
	            b.writeInt64(v.to_long(parseInt(object["amount"])));
	        } else {
	            object = object.trim();
	            if (!/^[0-9]+\.?[0-9]* [A-Za-z0-9@]+$/.test(object)) throw new Error("Expecting amount like '99.000 SYMBOL', instead got '" + object + "'");
	
	            var res = object.split(" ");
	            amount = res[0];
	            symbol = res[1];
	
	            // Hive workaround for now
	            symbol = symbol == "HIVE" ? "STEEM" : symbol == "HBD" ? "SBD" : symbol;
	
	            if (symbol.startsWith("@@")) {
	                // NAI Case
	                nai = parseInt(symbol.slice(2));
	                var _checksum = nai % 10;
	                nai = Math.floor(nai / 10);
	                var _expected_checksum = damm_checksum_8digit(nai);
	            } else if (symbol.length > 6) throw new Error("Symbols are not longer than 6 characters " + symbol + "-" + symbol.length);
	
	            b.writeInt64(v.to_long(amount.replace(".", "")));
	            var dot = amount.indexOf("."); // 0.000
	            precision = dot === -1 ? 0 : amount.length - dot - 1;
	        }
	
	        if (symbol.startsWith("@@")) {
	            nai = (nai << 5) + 16 + precision;
	            b.writeUint32(nai);
	        } else {
	            b.writeUint8(precision);
	            b.append(symbol.toUpperCase(), 'binary');
	            for (var i = 0; i < 7 - symbol.length; i++) {
	                b.writeUint8(0);
	            }
	        }
	
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0.000 HIVE";
	        }
	        return object;
	    }
	};
	
	Types.asset_symbol = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        var precision = b.readUint8();
	        var amount_string = "";
	        var nai_string = "";
	
	        if (precision >= 16) {
	            // NAI Case
	            var b_copy = b.copy(b.offset - 1, b.offset + 3);
	            var nai = new Buffer(b_copy.toBinary(), "binary").readInt32();
	            nai = nai / 32;
	            nai_string = "@@" + nai.toString().padStart(8, '0') + damm_checksum_8digit(nai).to_String();
	            precision = precision % 16;
	            b.skip(3);
	        } else {
	            // Legacy Case
	            var _b_copy2 = b.copy(b.offset, b.offset + 7);
	            var symbol = new Buffer(_b_copy2.toBinary(), "binary").toString().replace(/\x00/g, "");
	            if (symbol == "STEEM" || symbol == "TESTS") nai_string = "@@000000021";else if (symbol == "SBD" || symbol == "TBD") nai_string = "@@000000013";else if (symbol == "VESTS") nai_string = "@@000000037";else throw new Error("Expecting non-smt core asset symbol, instead got '" + symbol + "'");
	            b.skip(7);
	        }
	
	        return { "nai": nai_string, "precision": precision };
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	
	        var nai = 0;
	        if (!object["nai"].startsWith("@@")) throw new Error("Asset Symbols NAIs must be prefixed with '@@'. Was " + object["nai"]);
	
	        nai = parseInt(object["nai"].slice(2));
	        var checksum = nai % 10;
	        nai = Math.floor(nai / 10);
	        var expected_checksum = damm_checksum_8digit(nai);
	
	        var precision = 0;
	        var symbol = "";
	        switch (object["nai"]) {
	            case "@@000000021":
	                precision = 3;
	                symbol = _config2.default.get("address_prefix") == "STM" ? "STEEM" : "TESTS";
	                break;
	            case "@@000000013":
	                precision = 3;
	                symbol = _config2.default.get("address_prefix") == "STM" ? "SBD" : "TBD";
	                break;
	            case "@@000000037":
	                precision = 6;
	                symbol = "VESTS";
	                break;
	        }
	
	        if (precision > 0) {
	            //Core Symbol Case
	            b.writeUint8(precision);
	            b.append(symbol, 'binary');
	            for (var i = 0; i < 7 - symbol.length; i++) {
	                b.writeUint8(0);
	            }
	        } else {
	            nai = (nai << 5) + 16 + object["precision"];
	            b.writeUint32(nai);
	        }
	
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "STEEM";
	        }
	        return object;
	    }
	};
	
	Types.uint8 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint8();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.require_range(0, 0xFF, object, 'uint8 ' + object);
	        b.writeUint8(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.require_range(0, 0xFF, object, 'uint8 ' + object);
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return 0;
	        }
	        v.require_range(0, 0xFF, object, 'uint8 ' + object);
	        return parseInt(object);
	    }
	};
	
	Types.uint16 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint16();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.require_range(0, 0xFFFF, object, 'uint16 ' + object);
	        b.writeUint16(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.require_range(0, 0xFFFF, object, 'uint16 ' + object);
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return 0;
	        }
	        v.require_range(0, 0xFFFF, object, 'uint16 ' + object);
	        return parseInt(object);
	    }
	};
	
	Types.uint32 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint32();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
	        b.writeUint32(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return 0;
	        }
	        v.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
	        return parseInt(object);
	    }
	};
	
	var MIN_SIGNED_32 = -1 * Math.pow(2, 31);
	var MAX_SIGNED_32 = Math.pow(2, 31) - 1;
	
	Types.varint32 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readVarint32();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
	        b.writeVarint32(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return 0;
	        }
	        v.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
	        return parseInt(object);
	    }
	};
	
	Types.int16 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readInt16();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        b.writeInt16(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return object;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return 0;
	        }
	        return parseInt(object);
	    }
	};
	
	Types.int64 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readInt64();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.required(object);
	        b.writeInt64(v.to_long(object));
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	        return v.to_long(object);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0";
	        }
	        v.required(object);
	        return v.to_long(object).toString();
	    }
	};
	
	Types.uint64 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint64();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        b.writeUint64(v.to_long(v.unsigned(object)));
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return v.to_long(v.unsigned(object));
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0";
	        }
	        return v.to_long(object).toString();
	    }
	};
	
	Types.uint128 = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        b.readBigInt64();
	        return b.readBigInt64();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        b.writeUint64(v.to_long(v.unsigned(0)));
	        b.writeUint64(v.to_long(v.unsigned(object)));
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return v.to_long(v.unsigned(object));
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0";
	        }
	        return v.to_long(object).toString();
	    }
	};
	
	Types.string = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return new Buffer(b.readVString(), 'utf8');
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.required(object);
	        b.writeVString(object.toString());
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	        return new Buffer(object, 'utf8');
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "";
	        }
	        return object.toString('utf8');
	    }
	};
	
	Types.string_binary = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        var b_copy;
	        var len = b.readVarint32();
	        b_copy = b.copy(b.offset, b.offset + len), b.skip(len);
	        return new Buffer(b_copy.toBinary(), 'binary');
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        b.writeVarint32(object.length);
	        b.append(object.toString('binary'), 'binary');
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	        return new Buffer(object);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "";
	        }
	        return object.toString();
	    }
	};
	
	Types.bytes = function (size) {
	    return {
	        fromByteBuffer: function fromByteBuffer(b) {
	            if (size === undefined) {
	                var b_copy;
	                var len = b.readVarint32();
	                b_copy = b.copy(b.offset, b.offset + len), b.skip(len);
	                return new Buffer(b_copy.toBinary(), 'binary');
	            } else {
	                b_copy = b.copy(b.offset, b.offset + size), b.skip(size);
	                return new Buffer(b_copy.toBinary(), 'binary');
	            }
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            v.required(object);
	            if (typeof object === "string") object = new Buffer(object, "hex");
	
	            if (size === undefined) {
	                b.writeVarint32(object.length);
	            }
	            b.append(object.toString('binary'), 'binary');
	            return;
	        },
	        fromObject: function fromObject(object) {
	            v.required(object);
	            if (Buffer.isBuffer(object)) return object;
	
	            return new Buffer(object, 'hex');
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (debug.use_default && object === undefined) {
	                var zeros = function zeros(num) {
	                    return new Array(num).join("00");
	                };
	                return zeros(size);
	            }
	            v.required(object);
	            return object.toString('hex');
	        }
	    };
	};
	
	Types.bool = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint8() === 1;
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        // supports boolean or integer
	        b.writeUint8(JSON.parse(object) ? 1 : 0);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return JSON.parse(object) ? true : false;
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return false;
	        }
	        return JSON.parse(object) ? true : false;
	    }
	};
	
	Types.void = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        throw new Error("(void) undefined type");
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        throw new Error("(void) undefined type");
	    },
	    fromObject: function fromObject(object) {
	        throw new Error("(void) undefined type");
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return undefined;
	        }
	        throw new Error("(void) undefined type");
	    }
	};
	
	Types.array = function (st_operation) {
	    return {
	        fromByteBuffer: function fromByteBuffer(b) {
	            var size = b.readVarint32();
	            if (HEX_DUMP) {
	                console.log("varint32 size = " + size.toString(16));
	            }
	            var result = [];
	            for (var i = 0; 0 < size ? i < size : i > size; 0 < size ? i++ : i++) {
	                result.push(st_operation.fromByteBuffer(b));
	            }
	            return sortOperation(result, st_operation);
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            v.required(object);
	            object = sortOperation(object, st_operation);
	            b.writeVarint32(object.length);
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                st_operation.appendByteBuffer(b, o);
	            }
	        },
	        fromObject: function fromObject(object) {
	            v.required(object);
	            object = sortOperation(object, st_operation);
	            var result = [];
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                result.push(st_operation.fromObject(o));
	            }
	            return result;
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (debug.use_default && object === undefined) {
	                return [st_operation.toObject(object, debug)];
	            }
	            v.required(object);
	            object = sortOperation(object, st_operation);
	
	            var result = [];
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                result.push(st_operation.toObject(o, debug));
	            }
	            return result;
	        }
	    };
	};
	
	Types.time_point_sec = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return b.readUint32();
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        if (typeof object !== "number") object = Types.time_point_sec.fromObject(object);
	
	        b.writeUint32(object);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	
	        if (typeof object === "number") return object;
	
	        if (object.getTime) return Math.floor(object.getTime() / 1000);
	
	        if (typeof object !== "string") throw new Error("Unknown date type: " + object);
	
	        if (typeof object === "string" && !/Z$/.test(object)) object = object + "Z";
	
	        return Math.floor(new Date(object).getTime() / 1000);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) return new Date(0).toISOString().split('.')[0];
	
	        v.required(object);
	
	        if (typeof object === "string") return object;
	
	        if (object.getTime) return object.toISOString().split('.')[0];
	
	        var int = parseInt(object);
	        v.require_range(0, 0xFFFFFFFF, int, 'uint32 ' + object);
	        return new Date(int * 1000).toISOString().split('.')[0];
	    }
	};
	
	Types.set = function (st_operation) {
	    return {
	        validate: function validate(array) {
	            var dup_map = {};
	            for (var i = 0, o; i < array.length; i++) {
	                o = array[i];
	                var ref;
	                if (ref = typeof o === 'undefined' ? 'undefined' : _typeof(o), ['string', 'number'].indexOf(ref) >= 0) {
	                    if (dup_map[o] !== undefined) {
	                        throw new Error("duplicate (set)");
	                    }
	                    dup_map[o] = true;
	                }
	            }
	            return sortOperation(array, st_operation);
	        },
	        fromByteBuffer: function fromByteBuffer(b) {
	            var size = b.readVarint32();
	            if (HEX_DUMP) {
	                console.log("varint32 size = " + size.toString(16));
	            }
	            return this.validate(function () {
	                var result = [];
	                for (var i = 0; 0 < size ? i < size : i > size; 0 < size ? i++ : i++) {
	                    result.push(st_operation.fromByteBuffer(b));
	                }
	                return result;
	            }());
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            if (!object) {
	                object = [];
	            }
	            b.writeVarint32(object.length);
	            var iterable = this.validate(object);
	            for (var i = 0, o; i < iterable.length; i++) {
	                o = iterable[i];
	                st_operation.appendByteBuffer(b, o);
	            }
	            return;
	        },
	        fromObject: function fromObject(object) {
	            if (!object) {
	                object = [];
	            }
	            return this.validate(function () {
	                var result = [];
	                for (var i = 0, o; i < object.length; i++) {
	                    o = object[i];
	                    result.push(st_operation.fromObject(o));
	                }
	                return result;
	            }());
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (debug.use_default && object === undefined) {
	                return [st_operation.toObject(object, debug)];
	            }
	            if (!object) {
	                object = [];
	            }
	            return this.validate(function () {
	                var result = [];
	                for (var i = 0, o; i < object.length; i++) {
	                    o = object[i];
	                    result.push(st_operation.toObject(o, debug));
	                }
	                return result;
	            }());
	        }
	    };
	};
	
	// global_parameters_update_operation current_fees
	Types.fixed_array = function (count, st_operation) {
	    return {
	        fromByteBuffer: function fromByteBuffer(b) {
	            var i, j, ref, results;
	            results = [];
	            for (i = j = 0, ref = count; j < ref; i = j += 1) {
	                results.push(st_operation.fromByteBuffer(b));
	            }
	            return sortOperation(results, st_operation);
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            var i, j, ref;
	            if (count !== 0) {
	                v.required(object);
	                object = sortOperation(object, st_operation);
	            }
	            for (i = j = 0, ref = count; j < ref; i = j += 1) {
	                st_operation.appendByteBuffer(b, object[i]);
	            }
	        },
	        fromObject: function fromObject(object) {
	            var i, j, ref, results;
	            if (count !== 0) {
	                v.required(object);
	            }
	            results = [];
	            for (i = j = 0, ref = count; j < ref; i = j += 1) {
	                results.push(st_operation.fromObject(object[i]));
	            }
	            return results;
	        },
	        toObject: function toObject(object, debug) {
	            var i, j, k, ref, ref1, results, results1;
	            if (debug == null) {
	                debug = {};
	            }
	            if (debug.use_default && object === void 0) {
	                results = [];
	                for (i = j = 0, ref = count; j < ref; i = j += 1) {
	                    results.push(st_operation.toObject(void 0, debug));
	                }
	                return results;
	            }
	            if (count !== 0) {
	                v.required(object);
	            }
	            results1 = [];
	            for (i = k = 0, ref1 = count; k < ref1; i = k += 1) {
	                results1.push(st_operation.toObject(object[i], debug));
	            }
	            return results1;
	        }
	    };
	};
	
	/* Supports instance numbers (11) or object types (1.2.11).  Object type
	validation is enforced when an object type is used. */
	var id_type = function id_type(reserved_spaces, object_type) {
	    v.required(reserved_spaces, "reserved_spaces");
	    v.required(object_type, "object_type");
	    return {
	        fromByteBuffer: function fromByteBuffer(b) {
	            return b.readVarint32();
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            v.required(object);
	            if (object.resolve !== undefined) {
	                object = object.resolve;
	            }
	            // convert 1.2.n into just n
	            if (/^[0-9]+\.[0-9]+\.[0-9]+$/.test(object)) {
	                object = v.get_instance(reserved_spaces, object_type, object);
	            }
	            b.writeVarint32(v.to_number(object));
	            return;
	        },
	        fromObject: function fromObject(object) {
	            v.required(object);
	            if (object.resolve !== undefined) {
	                object = object.resolve;
	            }
	            if (v.is_digits(object)) {
	                return v.to_number(object);
	            }
	            return v.get_instance(reserved_spaces, object_type, object);
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var object_type_id = chain_types.object_type[object_type];
	            if (debug.use_default && object === undefined) {
	                return reserved_spaces + '.' + object_type_id + '.0';
	            }
	            v.required(object);
	            if (object.resolve !== undefined) {
	                object = object.resolve;
	            }
	            if (/^[0-9]+\.[0-9]+\.[0-9]+$/.test(object)) {
	                object = v.get_instance(reserved_spaces, object_type, object);
	            }
	
	            return reserved_spaces + '.' + object_type_id + '.' + object;
	        }
	    };
	};
	
	Types.protocol_id_type = function (name) {
	    v.required(name, "name");
	    return id_type(chain_types.reserved_spaces.protocol_ids, name);
	};
	
	Types.object_id_type = {
	    fromByteBuffer: function fromByteBuffer(b) {
	        return ObjectId.fromByteBuffer(b);
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.required(object);
	        if (object.resolve !== undefined) {
	            object = object.resolve;
	        }
	        object = ObjectId.fromString(object);
	        object.appendByteBuffer(b);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	        if (object.resolve !== undefined) {
	            object = object.resolve;
	        }
	        return ObjectId.fromString(object);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0.0.0";
	        }
	        v.required(object);
	        if (object.resolve !== undefined) {
	            object = object.resolve;
	        }
	        object = ObjectId.fromString(object);
	        return object.toString();
	    }
	};
	
	Types.vote_id = { TYPE: 0x000000FF,
	    ID: 0xFFFFFF00,
	    fromByteBuffer: function fromByteBuffer(b) {
	        var value = b.readUint32();
	        return {
	            type: value & this.TYPE,
	            id: value & this.ID
	        };
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.required(object);
	        if (object === "string") object = Types.vote_id.fromObject(object);
	
	        var value = object.id << 8 | object.type;
	        b.writeUint32(value);
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object, "(type vote_id)");
	        if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) === "object") {
	            v.required(object.type, "type");
	            v.required(object.id, "id");
	            return object;
	        }
	        v.require_test(/^[0-9]+:[0-9]+$/, object, 'vote_id format ' + object);
	
	        var _object$split = object.split(':'),
	            _object$split2 = _slicedToArray(_object$split, 2),
	            type = _object$split2[0],
	            id = _object$split2[1];
	
	        v.require_range(0, 0xff, type, 'vote type ' + object);
	        v.require_range(0, 0xffffff, id, 'vote id ' + object);
	        return { type: type, id: id };
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return "0:0";
	        }
	        v.required(object);
	        if (typeof object === "string") object = Types.vote_id.fromObject(object);
	
	        return object.type + ":" + object.id;
	    },
	    compare: function compare(a, b) {
	        if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== "object") a = Types.vote_id.fromObject(a);
	        if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== "object") b = Types.vote_id.fromObject(b);
	        return parseInt(a.id) - parseInt(b.id);
	    }
	};
	
	Types.optional = function (st_operation) {
	    v.required(st_operation, "st_operation");
	    return {
	        fromByteBuffer: function fromByteBuffer(b) {
	            if (!(b.readUint8() === 1)) {
	                return undefined;
	            }
	            return st_operation.fromByteBuffer(b);
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            if (object !== null && object !== undefined) {
	                b.writeUint8(1);
	                st_operation.appendByteBuffer(b, object);
	            } else {
	                b.writeUint8(0);
	            }
	            return;
	        },
	        fromObject: function fromObject(object) {
	            if (object === undefined) {
	                return undefined;
	            }
	            return st_operation.fromObject(object);
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // toObject is only null save if use_default is true
	            var result_object = function () {
	                if (!debug.use_default && object === undefined) {
	                    return undefined;
	                } else {
	                    return st_operation.toObject(object, debug);
	                }
	            }();
	
	            if (debug.annotate) {
	                if ((typeof result_object === 'undefined' ? 'undefined' : _typeof(result_object)) === "object") {
	                    result_object.__optional = "parent is optional";
	                } else {
	                    result_object = { __optional: result_object };
	                }
	            }
	            return result_object;
	        }
	    };
	};
	
	Types.static_variant = function (_st_operations) {
	    return {
	        nosort: true,
	        st_operations: _st_operations,
	        opTypeId: function opTypeId(value) {
	            var pos = 0,
	                type_id = void 0;
	            if (typeof value === "number") type_id = value;else {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.st_operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var op = _step.value;
	
	                        if (op.operation_name === value) {
	                            type_id = pos;
	                            break;
	                        }
	                        pos++;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	            return type_id;
	        },
	        fromByteBuffer: function fromByteBuffer(b) {
	            var type_id = b.readVarint32();
	            var st_operation = this.st_operations[type_id];
	            if (HEX_DUMP) {
	                console.error('static_variant id 0x' + type_id.toString(16) + ' (' + type_id + ')');
	            }
	            v.required(st_operation, 'operation ' + type_id);
	            return [type_id, st_operation.fromByteBuffer(b)];
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            v.required(object);
	            var type_id = this.opTypeId(object[0]);
	            var st_operation = this.st_operations[type_id];
	            v.required(st_operation, 'operation ' + type_id);
	            b.writeVarint32(type_id);
	            st_operation.appendByteBuffer(b, object[1]);
	            return;
	        },
	        fromObject: function fromObject(object) {
	            v.required(object);
	            var type_id = this.opTypeId(object[0]);
	            var st_operation = this.st_operations[type_id];
	            v.required(st_operation, 'operation ' + type_id);
	            return [type_id, st_operation.fromObject(object[1])];
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (debug.use_default && object === undefined) {
	                return [this.st_operations[0].operation_name, this.st_operations[0].toObject(undefined, debug)];
	            }
	            v.required(object);
	            var type_id = this.opTypeId(object[0]);
	            var st_operation = this.st_operations[type_id];
	            v.required(st_operation, 'operation ' + type_id);
	            return [st_operation.operation_name, st_operation.toObject(object[1], debug)];
	        },
	        compare: function compare(a, b) {
	            return strCmp(this.opTypeId(a[0]), this.opTypeId(b[0]));
	        }
	    };
	};
	
	Types.map = function (key_st_operation, value_st_operation) {
	    return {
	        validate: function validate(array) {
	            if (!Array.isArray(array)) {
	                throw new Error("expecting array");
	            }
	            var dup_map = {};
	            for (var i = 0, o; i < array.length; i++) {
	                o = array[i];
	                var ref;
	                if (!(o.length === 2)) {
	                    throw new Error("expecting two elements");
	                }
	                if (ref = _typeof(o[0]), ['number', 'string'].indexOf(ref) >= 0) {
	                    if (dup_map[o[0]] !== undefined) {
	                        throw new Error("duplicate (map)");
	                    }
	                    dup_map[o[0]] = true;
	                }
	            }
	            return sortOperation(array, key_st_operation);
	        },
	        fromByteBuffer: function fromByteBuffer(b) {
	            var result = [];
	            var end = b.readVarint32();
	            for (var i = 0; 0 < end ? i < end : i > end; 0 < end ? i++ : i++) {
	                result.push([key_st_operation.fromByteBuffer(b), value_st_operation.fromByteBuffer(b)]);
	            }
	            return this.validate(result);
	        },
	        appendByteBuffer: function appendByteBuffer(b, object) {
	            this.validate(object);
	            b.writeVarint32(object.length);
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                key_st_operation.appendByteBuffer(b, o[0]);
	                value_st_operation.appendByteBuffer(b, o[1]);
	            }
	            return;
	        },
	        fromObject: function fromObject(object) {
	            v.required(object);
	            var result = [];
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                result.push([key_st_operation.fromObject(o[0]), value_st_operation.fromObject(o[1])]);
	            }
	            return this.validate(result);
	        },
	        toObject: function toObject(object) {
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (debug.use_default && object === undefined) {
	                return [[key_st_operation.toObject(undefined, debug), value_st_operation.toObject(undefined, debug)]];
	            }
	            v.required(object);
	            object = this.validate(object);
	            var result = [];
	            for (var i = 0, o; i < object.length; i++) {
	                o = object[i];
	                result.push([key_st_operation.toObject(o[0], debug), value_st_operation.toObject(o[1], debug)]);
	            }
	            return result;
	        }
	    };
	};
	
	Types.public_key = {
	    toPublic: function toPublic(object) {
	        if (object.resolve !== undefined) {
	            object = object.resolve;
	        }
	        return object == null ? object : object.Q ? object : _ecc.PublicKey.fromStringOrThrow(object);
	    },
	    fromByteBuffer: function fromByteBuffer(b) {
	        return fp.public_key(b);
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        v.required(object);
	        fp.public_key(b, Types.public_key.toPublic(object));
	        return;
	    },
	    fromObject: function fromObject(object) {
	        v.required(object);
	        if (object.Q) {
	            return object;
	        }
	        return Types.public_key.toPublic(object);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return _ecc.ecc_config.get('address_prefix') + "859gxfnXyUriMgUeThh1fWv3oqcpLFyHa3TfFYC4PK2HqhToVM";
	        }
	        v.required(object);
	        return object.toString();
	    },
	    compare: function compare(a, b) {
	        // sort ascending
	        return 1 * strCmp(a.toString(), b.toString());
	    }
	};
	
	Types.address = {
	    _to_address: function _to_address(object) {
	        v.required(object);
	        if (object.addy) {
	            return object;
	        }
	        return _ecc.Address.fromString(object);
	    },
	    fromByteBuffer: function fromByteBuffer(b) {
	        return new _ecc.Address(fp.ripemd160(b));
	    },
	    appendByteBuffer: function appendByteBuffer(b, object) {
	        fp.ripemd160(b, Types.address._to_address(object).toBuffer());
	        return;
	    },
	    fromObject: function fromObject(object) {
	        return Types.address._to_address(object);
	    },
	    toObject: function toObject(object) {
	        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (debug.use_default && object === undefined) {
	            return _ecc.ecc_config.get('address_prefix') + "664KmHxSuQyDsfwo4WEJvWpzg1QKdg67S";
	        }
	        return Types.address._to_address(object).toString();
	    },
	    compare: function compare(a, b) {
	        // sort decending
	        return -1 * strCmp(a.toString(), b.toString());
	    }
	};
	
	var strCmp = function strCmp(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	};
	var firstEl = function firstEl(el) {
	    return Array.isArray(el) ? el[0] : el;
	};
	var sortOperation = function sortOperation(array, st_operation) {
	    // console.log('operation.nosort', st_operation.nosort)
	    return st_operation.nosort ? array : st_operation.compare ? array.sort(function (a, b) {
	        return st_operation.compare(firstEl(a), firstEl(b));
	    }) : // custom compare operation
	    array.sort(function (a, b) {
	        return typeof firstEl(a) === "number" && typeof firstEl(b) === "number" ? firstEl(a) - firstEl(b) :
	        // A binary string compare does not work. Performanance is very good so HEX is used..  localeCompare is another option.
	        Buffer.isBuffer(firstEl(a)) && Buffer.isBuffer(firstEl(b)) ? strCmp(firstEl(a).toString("hex"), firstEl(b).toString("hex")) : strCmp(firstEl(a).toString(), firstEl(b).toString());
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(99).Buffer))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(100);
	var ieee754 = __webpack_require__(101);
	var isArray = __webpack_require__(102);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength();
	
	function typedArraySupport() {
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42 && // typed array instances can be augmented
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	function createBuffer(that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length');
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }
	
	  return that;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length);
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(this, arg);
	  }
	  return from(this, arg, encodingOrOffset, length);
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr;
	};
	
	function from(that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset);
	  }
	
	  return fromObject(that, value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length);
	};
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    });
	  }
	}
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
	  }
	  return createBuffer(that, size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding);
	};
	
	function allocUnsafe(that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size);
	};
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);
	
	  var actual = that.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }
	
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that;
	}
	
	function fromObject(that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);
	
	    if (that.length === 0) {
	      return that;
	    }
	
	    obj.copy(that, 0, 0, len);
	    return that;
	  }
	
	  if (obj) {
	    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0);
	      }
	      return fromArrayLike(that, obj);
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	function isnan(val) {
	  return val !== val; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}
	
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;
	
	function placeHoldersCount(b64) {
	  var len = b64.length;
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4');
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
	}
	
	function byteLength(b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64);
	}
	
	function toByteArray(b64) {
	  var i, l, tmp, placeHolders, arr;
	  var len = b64.length;
	  placeHolders = placeHoldersCount(b64);
	
	  arr = new Arr(len * 3 / 4 - placeHolders);
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len;
	
	  var L = 0;
	
	  for (i = 0; i < l; i += 4) {
	    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
	    arr[L++] = tmp >> 16 & 0xFF;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  if (placeHolders === 2) {
	    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
	    arr[L++] = tmp & 0xFF;
	  } else if (placeHolders === 1) {
	    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  return arr;
	}
	
	function tripletToBase64(num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
	}
	
	function encodeChunk(uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('');
	}
	
	function fromByteArray(uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var output = '';
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    output += lookup[tmp >> 2];
	    output += lookup[tmp << 4 & 0x3F];
	    output += '==';
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    output += lookup[tmp >> 10];
	    output += lookup[tmp >> 4 & 0x3F];
	    output += lookup[tmp << 2 & 0x3F];
	    output += '=';
	  }
	
	  parts.push(output);
	
	  return parts.join('');
	}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	    Address: __webpack_require__(104),
	    Aes: __webpack_require__(151),
	    PrivateKey: __webpack_require__(188),
	    PublicKey: __webpack_require__(178),
	    Signature: __webpack_require__(189),
	    brainKey: __webpack_require__(193),
	    key_utils: __webpack_require__(194),
	    hash: __webpack_require__(109),
	    ecc_config: __webpack_require__(42)
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var assert = __webpack_require__(105);
	var config = __webpack_require__(42);
	var hash = __webpack_require__(109);
	var base58 = __webpack_require__(149);
	
	/** Addresses are shortened non-reversable hashes of a public key.  The full PublicKey is preferred.
	    @deprecated
	*/
	
	var Address = function () {
	    function Address(addy) {
	        _classCallCheck(this, Address);
	
	        this.addy = addy;
	    }
	
	    _createClass(Address, [{
	        key: 'toBuffer',
	        value: function toBuffer() {
	            return this.addy;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            var address_prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config.get('address_prefix');
	
	            var checksum = hash.ripemd160(this.addy);
	            var addy = Buffer.concat([this.addy, checksum.slice(0, 4)]);
	            return address_prefix + base58.encode(addy);
	        }
	    }], [{
	        key: 'fromBuffer',
	        value: function fromBuffer(buffer) {
	            var _hash = hash.sha512(buffer);
	            var addy = hash.ripemd160(_hash);
	            return new Address(addy);
	        }
	    }, {
	        key: 'fromString',
	        value: function fromString(string) {
	            var address_prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.get('address_prefix');
	
	            var prefix = string.slice(0, address_prefix.length);
	            assert.equal(address_prefix, prefix, 'Expecting key to begin with ' + address_prefix + ', instead got ' + prefix);
	            var addy = string.slice(address_prefix.length);
	            addy = new Buffer(base58.decode(addy), 'binary');
	            var checksum = addy.slice(-4);
	            addy = addy.slice(0, -4);
	            var new_checksum = hash.ripemd160(addy);
	            new_checksum = new_checksum.slice(0, 4);
	            assert.deepEqual(checksum, new_checksum, 'Checksum did not match');
	            return new Address(addy);
	        }
	
	        /** @return Address - Compressed PTS format (by default) */
	
	    }, {
	        key: 'fromPublic',
	        value: function fromPublic(public_key) {
	            var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 56;
	
	            var sha2 = hash.sha256(public_key.toBuffer(compressed));
	            var rep = hash.ripemd160(sha2);
	            var versionBuffer = new Buffer(1);
	            versionBuffer.writeUInt8(0xFF & version, 0);
	            var addr = Buffer.concat([versionBuffer, rep]);
	            var check = hash.sha256(addr);
	            check = hash.sha256(check);
	            var buffer = Buffer.concat([addr, check.slice(0, 4)]);
	            return new Address(hash.ripemd160(buffer));
	        }
	    }]);
	
	    return Address;
	}();
	
	module.exports = Address;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(106);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = function () {
	  return function foo() {}.name === 'foo';
	}();
	function pToString(obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' + name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' + self.operator + ' ' + truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	    // 7.2. If the expected value is a Date object, the actual value is
	    // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	    // 7.3 If the expected value is a RegExp object, the actual value is
	    // equivalent if it is also a RegExp object with the same source and
	    // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
	
	    // 7.4. Other pairs that do not both pass typeof value == 'object',
	    // equivalence is determined by ==.
	  } else if ((actual === null || (typeof actual === 'undefined' ? 'undefined' : _typeof(actual)) !== 'object') && (expected === null || (typeof expected === 'undefined' ? 'undefined' : _typeof(expected)) !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	    // If both values are instances of typed arrays, wrap their underlying
	    // ArrayBuffers in a Buffer each to increase performance
	    // This optimization requires the arrays to have the same type as checked by
	    // Object.prototype.toString (aka pToString). Never perform binary
	    // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	    // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
	
	    // 7.5 For all other Object pairs, including Array objects, equivalence is
	    // determined by having the same number of owned properties (as verified
	    // with Object.prototype.hasOwnProperty.call), the same set of keys
	    // (although not necessarily the same order), equivalent values for every
	    // corresponding key, and an identical 'prototype' property. Note: this
	    // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || { actual: [], expected: [] };
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined) return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length) return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i]) return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function (block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function (block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function (err) {
	  if (err) throw err;
	};
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function (f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function (x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s':
	        return String(args[i++]);
	      case '%d':
	        return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function (fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function () {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function (set) {
	  if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function () {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function () {};
	    }
	  }
	  return debugs[set];
	};
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold': [1, 22],
	  'italic': [3, 23],
	  'underline': [4, 24],
	  'inverse': [7, 27],
	  'white': [37, 39],
	  'grey': [90, 39],
	  'black': [30, 39],
	  'blue': [34, 39],
	  'cyan': [36, 39],
	  'green': [32, 39],
	  'magenta': [35, 39],
	  'red': [31, 39],
	  'yellow': [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\x1B[' + inspect.colors[style][0] + 'm' + str + '\x1B[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function (val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect && value && isFunction(value.inspect) &&
	  // Filter out the util module, it's inspect function is special
	  value.inspect !== exports.inspect &&
	  // Also filter out any prototype objects using the circular check.
	  !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '',
	      array = false,
	      braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function (key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value)) return ctx.stylize('' + value, 'number');
	  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value)) return ctx.stylize('null', 'null');
	}
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function (key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
	    }
	  });
	  return output;
	}
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function (line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function (line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function (prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
	  typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(107);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function () {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(108);
	
	exports._extend = function (origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function isBuffer(arg) {
	  return arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function TempCtor() {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  };
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createHash = __webpack_require__(110);
	
	var _createHash2 = _interopRequireDefault(_createHash);
	
	var _createHmac = __webpack_require__(147);
	
	var _createHmac2 = _interopRequireDefault(_createHmac);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @arg {string|Buffer} data
	    @arg {string} [digest = null] - 'hex', 'binary' or 'base64'
	    @return {string|Buffer} - Buffer when digest is null, or string
	*/
	function sha1(data, encoding) {
	    return (0, _createHash2.default)('sha1').update(data).digest(encoding);
	}
	
	/** @arg {string|Buffer} data
	    @arg {string} [digest = null] - 'hex', 'binary' or 'base64'
	    @return {string|Buffer} - Buffer when digest is null, or string
	*/
	function sha256(data, encoding) {
	    return (0, _createHash2.default)('sha256').update(data).digest(encoding);
	}
	
	/** @arg {string|Buffer} data
	    @arg {string} [digest = null] - 'hex', 'binary' or 'base64'
	    @return {string|Buffer} - Buffer when digest is null, or string
	*/
	function sha512(data, encoding) {
	    return (0, _createHash2.default)('sha512').update(data).digest(encoding);
	}
	
	function HmacSHA256(buffer, secret) {
	    return (0, _createHmac2.default)('sha256', secret).update(buffer).digest();
	}
	
	function ripemd160(data) {
	    return (0, _createHash2.default)('rmd160').update(data).digest();
	}
	
	// function hash160(buffer) {
	//   return ripemd160(sha256(buffer))
	// }
	// 
	// function hash256(buffer) {
	//   return sha256(sha256(buffer))
	// }
	
	// 
	// function HmacSHA512(buffer, secret) {
	//   return crypto.createHmac('sha512', secret).update(buffer).digest()
	// }
	
	module.exports = {
	    sha1: sha1,
	    sha256: sha256,
	    sha512: sha512,
	    HmacSHA256: HmacSHA256,
	    ripemd160: ripemd160
	    // hash160: hash160,
	    // hash256: hash256,
	    // HmacSHA512: HmacSHA512
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var inherits = __webpack_require__(111);
	var md5 = __webpack_require__(112);
	var RIPEMD160 = __webpack_require__(114);
	var sha = __webpack_require__(137);
	
	var Base = __webpack_require__(145);
	
	function HashNoConstructor(hash) {
	  Base.call(this, 'digest');
	
	  this._hash = hash;
	  this.buffers = [];
	}
	
	inherits(HashNoConstructor, Base);
	
	HashNoConstructor.prototype._update = function (data) {
	  this.buffers.push(data);
	};
	
	HashNoConstructor.prototype._final = function () {
	  var buf = Buffer.concat(this.buffers);
	  var r = this._hash(buf);
	  this.buffers = null;
	
	  return r;
	};
	
	function Hash(hash) {
	  Base.call(this, 'digest');
	
	  this._hash = hash;
	}
	
	inherits(Hash, Base);
	
	Hash.prototype._update = function (data) {
	  this._hash.update(data);
	};
	
	Hash.prototype._final = function () {
	  return this._hash.digest();
	};
	
	module.exports = function createHash(alg) {
	  alg = alg.toLowerCase();
	  if (alg === 'md5') return new HashNoConstructor(md5);
	  if (alg === 'rmd160' || alg === 'ripemd160') return new Hash(new RIPEMD160());
	
	  return new Hash(sha(alg));
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 111 */
108,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var makeHash = __webpack_require__(113);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (var i = 0; i < x.length; i += 16) {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
	    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
	    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t) {
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	}
	
	function md5_ff(a, b, c, d, x, s, t) {
	  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5_gg(a, b, c, d, x, s, t) {
	  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5_hh(a, b, c, d, x, s, t) {
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5_ii(a, b, c, d, x, s, t) {
	  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y) {
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xFFFF;
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	
	module.exports = function md5(buf) {
	  return makeHash(buf, core_md5);
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var intSize = 4;
	var zeroBuffer = new Buffer(intSize);
	zeroBuffer.fill(0);
	
	var charSize = 8;
	var hashSize = 16;
	
	function toArray(buf) {
	  if (buf.length % intSize !== 0) {
	    var len = buf.length + (intSize - buf.length % intSize);
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = new Array(buf.length >>> 2);
	  for (var i = 0, j = 0; i < buf.length; i += intSize, j++) {
	    arr[j] = buf.readInt32LE(i);
	  }
	
	  return arr;
	}
	
	module.exports = function hash(buf, fn) {
	  var arr = fn(toArray(buf), buf.length * charSize);
	  buf = new Buffer(hashSize);
	  for (var i = 0; i < arr.length; i++) {
	    buf.writeInt32LE(arr[i], i << 2, true);
	  }
	  return buf;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var inherits = __webpack_require__(111);
	var HashBase = __webpack_require__(115);
	
	function RIPEMD160() {
	  HashBase.call(this, 64);
	
	  // state
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	}
	
	inherits(RIPEMD160, HashBase);
	
	RIPEMD160.prototype._update = function () {
	  var m = new Array(16);
	  for (var i = 0; i < 16; ++i) {
	    m[i] = this._block.readInt32LE(i * 4);
	  }var al = this._a;
	  var bl = this._b;
	  var cl = this._c;
	  var dl = this._d;
	  var el = this._e;
	
	  // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
	  // K = 0x00000000
	  // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
	  al = fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);cl = rotl(cl, 10);
	  el = fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);bl = rotl(bl, 10);
	  dl = fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);al = rotl(al, 10);
	  cl = fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);el = rotl(el, 10);
	  bl = fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);dl = rotl(dl, 10);
	  al = fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);cl = rotl(cl, 10);
	  el = fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);bl = rotl(bl, 10);
	  dl = fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);al = rotl(al, 10);
	  cl = fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);el = rotl(el, 10);
	  bl = fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);dl = rotl(dl, 10);
	  al = fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);cl = rotl(cl, 10);
	  el = fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);bl = rotl(bl, 10);
	  dl = fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);al = rotl(al, 10);
	  cl = fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);el = rotl(el, 10);
	  bl = fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);dl = rotl(dl, 10);
	  al = fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);cl = rotl(cl, 10);
	
	  // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
	  // K = 0x5a827999
	  // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
	  el = fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);bl = rotl(bl, 10);
	  dl = fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);al = rotl(al, 10);
	  cl = fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);el = rotl(el, 10);
	  bl = fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);dl = rotl(dl, 10);
	  al = fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);cl = rotl(cl, 10);
	  el = fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);bl = rotl(bl, 10);
	  dl = fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);al = rotl(al, 10);
	  cl = fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);el = rotl(el, 10);
	  bl = fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);dl = rotl(dl, 10);
	  al = fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);cl = rotl(cl, 10);
	  el = fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);bl = rotl(bl, 10);
	  dl = fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);al = rotl(al, 10);
	  cl = fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);el = rotl(el, 10);
	  bl = fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);dl = rotl(dl, 10);
	  al = fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);cl = rotl(cl, 10);
	  el = fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);bl = rotl(bl, 10);
	
	  // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
	  // K = 0x6ed9eba1
	  // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
	  dl = fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);al = rotl(al, 10);
	  cl = fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);el = rotl(el, 10);
	  bl = fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);dl = rotl(dl, 10);
	  al = fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);cl = rotl(cl, 10);
	  el = fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);bl = rotl(bl, 10);
	  dl = fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);al = rotl(al, 10);
	  cl = fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);el = rotl(el, 10);
	  bl = fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);dl = rotl(dl, 10);
	  al = fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);cl = rotl(cl, 10);
	  el = fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);bl = rotl(bl, 10);
	  dl = fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);al = rotl(al, 10);
	  cl = fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);el = rotl(el, 10);
	  bl = fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);dl = rotl(dl, 10);
	  al = fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);cl = rotl(cl, 10);
	  el = fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);bl = rotl(bl, 10);
	  dl = fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);al = rotl(al, 10);
	
	  // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
	  // K = 0x8f1bbcdc
	  // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
	  cl = fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);el = rotl(el, 10);
	  bl = fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);dl = rotl(dl, 10);
	  al = fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);cl = rotl(cl, 10);
	  el = fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);bl = rotl(bl, 10);
	  dl = fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);al = rotl(al, 10);
	  cl = fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);el = rotl(el, 10);
	  bl = fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);dl = rotl(dl, 10);
	  al = fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);cl = rotl(cl, 10);
	  el = fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);bl = rotl(bl, 10);
	  dl = fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);al = rotl(al, 10);
	  cl = fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);el = rotl(el, 10);
	  bl = fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);dl = rotl(dl, 10);
	  al = fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);cl = rotl(cl, 10);
	  el = fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);bl = rotl(bl, 10);
	  dl = fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);al = rotl(al, 10);
	  cl = fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);el = rotl(el, 10);
	
	  // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	  // K = 0xa953fd4e
	  // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	  bl = fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);dl = rotl(dl, 10);
	  al = fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);cl = rotl(cl, 10);
	  el = fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);bl = rotl(bl, 10);
	  dl = fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);al = rotl(al, 10);
	  cl = fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);el = rotl(el, 10);
	  bl = fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);dl = rotl(dl, 10);
	  al = fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);cl = rotl(cl, 10);
	  el = fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);bl = rotl(bl, 10);
	  dl = fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);al = rotl(al, 10);
	  cl = fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);el = rotl(el, 10);
	  bl = fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);dl = rotl(dl, 10);
	  al = fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);cl = rotl(cl, 10);
	  el = fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);bl = rotl(bl, 10);
	  dl = fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);al = rotl(al, 10);
	  cl = fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);el = rotl(el, 10);
	  bl = fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);dl = rotl(dl, 10);
	
	  var ar = this._a;
	  var br = this._b;
	  var cr = this._c;
	  var dr = this._d;
	  var er = this._e;
	
	  // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
	  // K' = 0x50a28be6
	  // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
	  ar = fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);cr = rotl(cr, 10);
	  er = fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);br = rotl(br, 10);
	  dr = fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);ar = rotl(ar, 10);
	  cr = fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);er = rotl(er, 10);
	  br = fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);dr = rotl(dr, 10);
	  ar = fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);cr = rotl(cr, 10);
	  er = fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);br = rotl(br, 10);
	  dr = fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);ar = rotl(ar, 10);
	  cr = fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);er = rotl(er, 10);
	  br = fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);dr = rotl(dr, 10);
	  ar = fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);cr = rotl(cr, 10);
	  er = fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);br = rotl(br, 10);
	  dr = fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);ar = rotl(ar, 10);
	  cr = fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);er = rotl(er, 10);
	  br = fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);dr = rotl(dr, 10);
	  ar = fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);cr = rotl(cr, 10);
	
	  // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
	  // K' = 0x5c4dd124
	  // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
	  er = fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);br = rotl(br, 10);
	  dr = fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);ar = rotl(ar, 10);
	  cr = fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);er = rotl(er, 10);
	  br = fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);dr = rotl(dr, 10);
	  ar = fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);cr = rotl(cr, 10);
	  er = fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);br = rotl(br, 10);
	  dr = fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);ar = rotl(ar, 10);
	  cr = fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);er = rotl(er, 10);
	  br = fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);dr = rotl(dr, 10);
	  ar = fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);cr = rotl(cr, 10);
	  er = fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);br = rotl(br, 10);
	  dr = fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);ar = rotl(ar, 10);
	  cr = fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);er = rotl(er, 10);
	  br = fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);dr = rotl(dr, 10);
	  ar = fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);cr = rotl(cr, 10);
	  er = fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);br = rotl(br, 10);
	
	  // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
	  // K' = 0x6d703ef3
	  // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
	  dr = fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);ar = rotl(ar, 10);
	  cr = fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);er = rotl(er, 10);
	  br = fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);dr = rotl(dr, 10);
	  ar = fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);cr = rotl(cr, 10);
	  er = fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);br = rotl(br, 10);
	  dr = fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);ar = rotl(ar, 10);
	  cr = fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);er = rotl(er, 10);
	  br = fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);dr = rotl(dr, 10);
	  ar = fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);cr = rotl(cr, 10);
	  er = fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);br = rotl(br, 10);
	  dr = fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);ar = rotl(ar, 10);
	  cr = fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);er = rotl(er, 10);
	  br = fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);dr = rotl(dr, 10);
	  ar = fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);cr = rotl(cr, 10);
	  er = fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);br = rotl(br, 10);
	  dr = fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);ar = rotl(ar, 10);
	
	  // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
	  // K' = 0x7a6d76e9
	  // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
	  cr = fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);er = rotl(er, 10);
	  br = fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);dr = rotl(dr, 10);
	  ar = fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);cr = rotl(cr, 10);
	  er = fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);br = rotl(br, 10);
	  dr = fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);ar = rotl(ar, 10);
	  cr = fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);er = rotl(er, 10);
	  br = fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);dr = rotl(dr, 10);
	  ar = fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);cr = rotl(cr, 10);
	  er = fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);br = rotl(br, 10);
	  dr = fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);ar = rotl(ar, 10);
	  cr = fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);er = rotl(er, 10);
	  br = fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);dr = rotl(dr, 10);
	  ar = fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);cr = rotl(cr, 10);
	  er = fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);br = rotl(br, 10);
	  dr = fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);ar = rotl(ar, 10);
	  cr = fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);er = rotl(er, 10);
	
	  // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	  // K' = 0x00000000
	  // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	  br = fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);dr = rotl(dr, 10);
	  ar = fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);cr = rotl(cr, 10);
	  er = fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);br = rotl(br, 10);
	  dr = fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);ar = rotl(ar, 10);
	  cr = fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);er = rotl(er, 10);
	  br = fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);dr = rotl(dr, 10);
	  ar = fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);cr = rotl(cr, 10);
	  er = fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);br = rotl(br, 10);
	  dr = fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);ar = rotl(ar, 10);
	  cr = fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);er = rotl(er, 10);
	  br = fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);dr = rotl(dr, 10);
	  ar = fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);cr = rotl(cr, 10);
	  er = fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);br = rotl(br, 10);
	  dr = fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);ar = rotl(ar, 10);
	  cr = fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);er = rotl(er, 10);
	  br = fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);dr = rotl(dr, 10);
	
	  // change state
	  var t = this._b + cl + dr | 0;
	  this._b = this._c + dl + er | 0;
	  this._c = this._d + el + ar | 0;
	  this._d = this._e + al + br | 0;
	  this._e = this._a + bl + cr | 0;
	  this._a = t;
	};
	
	RIPEMD160.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80;
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64);
	    this._update();
	    this._blockOffset = 0;
	  }
	
	  this._block.fill(0, this._blockOffset, 56);
	  this._block.writeUInt32LE(this._length[0], 56);
	  this._block.writeUInt32LE(this._length[1], 60);
	  this._update();
	
	  // produce result
	  var buffer = new Buffer(20);
	  buffer.writeInt32LE(this._a, 0);
	  buffer.writeInt32LE(this._b, 4);
	  buffer.writeInt32LE(this._c, 8);
	  buffer.writeInt32LE(this._d, 12);
	  buffer.writeInt32LE(this._e, 16);
	  return buffer;
	};
	
	function rotl(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function fn1(a, b, c, d, e, m, k, s) {
	  return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
	}
	
	function fn2(a, b, c, d, e, m, k, s) {
	  return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
	}
	
	function fn3(a, b, c, d, e, m, k, s) {
	  return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
	}
	
	function fn4(a, b, c, d, e, m, k, s) {
	  return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
	}
	
	function fn5(a, b, c, d, e, m, k, s) {
	  return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
	}
	
	module.exports = RIPEMD160;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var Transform = __webpack_require__(116).Transform;
	var inherits = __webpack_require__(111);
	
	function HashBase(blockSize) {
	  Transform.call(this);
	
	  this._block = new Buffer(blockSize);
	  this._blockSize = blockSize;
	  this._blockOffset = 0;
	  this._length = [0, 0, 0, 0];
	
	  this._finalized = false;
	}
	
	inherits(HashBase, Transform);
	
	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null;
	  try {
	    if (encoding !== 'buffer') chunk = new Buffer(chunk, encoding);
	    this.update(chunk);
	  } catch (err) {
	    error = err;
	  }
	
	  callback(error);
	};
	
	HashBase.prototype._flush = function (callback) {
	  var error = null;
	  try {
	    this.push(this._digest());
	  } catch (err) {
	    error = err;
	  }
	
	  callback(error);
	};
	
	HashBase.prototype.update = function (data, encoding) {
	  if (!Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
	  if (this._finalized) throw new Error('Digest already called');
	  if (!Buffer.isBuffer(data)) data = new Buffer(data, encoding || 'binary');
	
	  // consume data
	  var block = this._block;
	  var offset = 0;
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) {
	      block[i++] = data[offset++];
	    }this._update();
	    this._blockOffset = 0;
	  }
	  while (offset < data.length) {
	    block[this._blockOffset++] = data[offset++];
	  } // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry;
	    carry = this._length[j] / 0x0100000000 | 0;
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
	  }
	
	  return this;
	};
	
	HashBase.prototype._update = function (data) {
	  throw new Error('_update is not implemented');
	};
	
	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called');
	  this._finalized = true;
	
	  var digest = this._digest();
	  if (encoding !== undefined) digest = digest.toString(encoding);
	  return digest;
	};
	
	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented');
	};
	
	module.exports = HashBase;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(2).EventEmitter;
	var inherits = __webpack_require__(111);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(117);
	Stream.Writable = __webpack_require__(133);
	Stream.Duplex = __webpack_require__(134);
	Stream.Transform = __webpack_require__(135);
	Stream.PassThrough = __webpack_require__(136);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function (dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(118);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(128);
	exports.Duplex = __webpack_require__(127);
	exports.Transform = __webpack_require__(131);
	exports.PassThrough = __webpack_require__(132);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(119);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(102);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(2).EventEmitter;
	
	var EElistenerCount = function EElistenerCount(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(120);
	/*</replacement>*/
	
	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(121).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(123);
	util.inherits = __webpack_require__(111);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(124);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function debug() {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(125);
	var destroyImpl = __webpack_require__(126);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(127);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(130).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(127);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function get() {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(130).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	    case 0:
	    case 1:
	      return process.nextTick(fn);
	    case 2:
	      return process.nextTick(function afterTickOne() {
	        fn.call(null, arg1);
	      });
	    case 3:
	      return process.nextTick(function afterTickTwo() {
	        fn.call(null, arg1, arg2);
	      });
	    case 4:
	      return process.nextTick(function afterTickThree() {
	        fn.call(null, arg1, arg2, arg3);
	      });
	    default:
	      args = new Array(len - 1);
	      i = 0;
	      while (i < args.length) {
	        args[i++] = arguments[i];
	      }
	      return process.nextTick(function afterTick() {
	        fn.apply(null, args);
	      });
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2).EventEmitter;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(122);
	var Buffer = buffer.Buffer;
	
	// alternative to using Object.keys for old browsers
	function copyProps(src, dst) {
	  for (var key in src) {
	    dst[key] = src[key];
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer;
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports);
	  exports.Buffer = SafeBuffer;
	}
	
	function SafeBuffer(arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length);
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer);
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number');
	  }
	  return Buffer(arg, encodingOrOffset, length);
	};
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  var buf = Buffer(size);
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding);
	    } else {
	      buf.fill(fill);
	    }
	  } else {
	    buf.fill(0);
	  }
	  return buf;
	};
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  return Buffer(size);
	};
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  return buffer.SlowBuffer(size);
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(100);
	var ieee754 = __webpack_require__(101);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	var K_MAX_LENGTH = 0x7fffffff;
	exports.kMaxLength = K_MAX_LENGTH;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
	  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
	}
	
	function typedArraySupport() {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42;
	  } catch (e) {
	    return false;
	  }
	}
	
	function createBuffer(length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('Invalid typed array length');
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length);
	  buf.__proto__ = Buffer.prototype;
	  return buf;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(arg);
	  }
	  return from(arg, encodingOrOffset, length);
	}
	
	// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	  Object.defineProperty(Buffer, Symbol.species, {
	    value: null,
	    configurable: true,
	    enumerable: false,
	    writable: false
	  });
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	function from(value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (isArrayBuffer(value)) {
	    return fromArrayBuffer(value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset);
	  }
	
	  return fromObject(value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length);
	};
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Buffer.prototype.__proto__ = Uint8Array.prototype;
	Buffer.__proto__ = Uint8Array;
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
	  }
	  return createBuffer(size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding);
	};
	
	function allocUnsafe(size) {
	  assertSize(size);
	  return createBuffer(size < 0 ? 0 : checked(size) | 0);
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size);
	};
	
	function fromString(string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  var buf = createBuffer(length);
	
	  var actual = buf.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual);
	  }
	
	  return buf;
	}
	
	function fromArrayLike(array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  var buf = createBuffer(length);
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255;
	  }
	  return buf;
	}
	
	function fromArrayBuffer(array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  var buf;
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array);
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset);
	  } else {
	    buf = new Uint8Array(array, byteOffset, length);
	  }
	
	  // Return an augmented `Uint8Array` instance
	  buf.__proto__ = Buffer.prototype;
	  return buf;
	}
	
	function fromObject(obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    var buf = createBuffer(len);
	
	    if (buf.length === 0) {
	      return buf;
	    }
	
	    obj.copy(buf, 0, 0, len);
	    return buf;
	  }
	
	  if (obj) {
	    if (isArrayBufferView(obj) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	        return createBuffer(0);
	      }
	      return fromArrayLike(obj);
	    }
	
	    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	      return fromArrayLike(obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return b != null && b._isBuffer === true;
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (isArrayBufferView(string) || isArrayBuffer(string)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (numberIsNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0;
	    if (isFinite(length)) {
	      length = length >>> 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf = this.subarray(start, end);
	  // Return an augmented `Uint8Array` instance
	  newBuf.__proto__ = Buffer.prototype;
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  offset = offset >>> 0;
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  byteLength = byteLength >>> 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  this[offset] = value & 0xff;
	  this[offset + 1] = value >>> 8;
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  this[offset] = value >>> 8;
	  this[offset + 1] = value & 0xff;
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  this[offset + 3] = value >>> 24;
	  this[offset + 2] = value >>> 16;
	  this[offset + 1] = value >>> 8;
	  this[offset] = value & 0xff;
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  this[offset] = value >>> 24;
	  this[offset + 1] = value >>> 16;
	  this[offset + 2] = value >>> 8;
	  this[offset + 3] = value & 0xff;
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  this[offset] = value & 0xff;
	  this[offset + 1] = value >>> 8;
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  this[offset] = value >>> 8;
	  this[offset + 1] = value & 0xff;
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  this[offset] = value & 0xff;
	  this[offset + 1] = value >>> 8;
	  this[offset + 2] = value >>> 16;
	  this[offset + 3] = value >>> 24;
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  this[offset] = value >>> 24;
	  this[offset + 1] = value >>> 16;
	  this[offset + 2] = value >>> 8;
	  this[offset + 3] = value & 0xff;
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  value = +value;
	  offset = offset >>> 0;
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : new Buffer(val, encoding);
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	// ArrayBuffers from another context (i.e. an iframe) do not pass the `instanceof` check
	// but they should be treated as valid. See: https://github.com/feross/buffer/issues/166
	function isArrayBuffer(obj) {
	  return obj instanceof ArrayBuffer || obj != null && obj.constructor != null && obj.constructor.name === 'ArrayBuffer' && typeof obj.byteLength === 'number';
	}
	
	// Node 0.10 supports `ArrayBuffer` but lacks `ArrayBuffer.isView`
	function isArrayBufferView(obj) {
	  return typeof ArrayBuffer.isView === 'function' && ArrayBuffer.isView(obj);
	}
	
	function numberIsNaN(obj) {
	  return obj !== obj; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return objectToString(e) === '[object Error]' || e instanceof Error;
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
	  typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 124 */
96,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var Buffer = __webpack_require__(121).Buffer;
	/*</replacement>*/
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(119);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(119);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(123);
	util.inherits = __webpack_require__(111);
	/*</replacement>*/
	
	var Readable = __webpack_require__(118);
	var Writable = __webpack_require__(128);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function get() {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(119);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(123);
	util.inherits = __webpack_require__(111);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(129)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(120);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(121).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(126);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(127);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function value(object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function realHasInstance(object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(127);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function get() {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function set(value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(10).setImmediate, (function() { return this; }())))

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate(fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config(name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\uFFFD'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\uFFFD'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\uFFFD'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\uFFFD'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(127);
	
	/*<replacement>*/
	var util = __webpack_require__(123);
	util.inherits = __webpack_require__(111);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(131);
	
	/*<replacement>*/
	var util = __webpack_require__(123);
	util.inherits = __webpack_require__(111);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(128);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(127);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(117).Transform;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(117).PassThrough;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _exports = module.exports = function SHA(algorithm) {
	  algorithm = algorithm.toLowerCase();
	
	  var Algorithm = _exports[algorithm];
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
	
	  return new Algorithm();
	};
	
	_exports.sha = __webpack_require__(138);
	_exports.sha1 = __webpack_require__(140);
	_exports.sha224 = __webpack_require__(141);
	_exports.sha256 = __webpack_require__(142);
	_exports.sha384 = __webpack_require__(143);
	_exports.sha512 = __webpack_require__(144);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
	 * in FIPS PUB 180-1
	 * This source code is derived from sha1.js of the same repository.
	 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
	 * operation was added.
	 */
	
	var inherits = __webpack_require__(111);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
	
	var W = new Array(80);
	
	function Sha() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha, Hash);
	
	Sha.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	
	  return this;
	};
	
	function rotl5(num) {
	  return num << 5 | num >>> 27;
	}
	
	function rotl30(num) {
	  return num << 30 | num >>> 2;
	}
	
	function ft(s, b, c, d) {
	  if (s === 0) return b & c | ~b & d;
	  if (s === 2) return b & c | b & d | c & d;
	  return b ^ c ^ d;
	}
	
	Sha.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 80; ++i) {
	    W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	  }for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
	
	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	};
	
	Sha.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);
	
	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);
	
	  return H;
	};
	
	module.exports = Sha;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	
	// prototype class for hash functions
	function Hash(blockSize, finalSize) {
	  this._block = Buffer.alloc(blockSize);
	  this._finalSize = finalSize;
	  this._blockSize = blockSize;
	  this._len = 0;
	}
	
	Hash.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8';
	    data = Buffer.from(data, enc);
	  }
	
	  var block = this._block;
	  var blockSize = this._blockSize;
	  var length = data.length;
	  var accum = this._len;
	
	  for (var offset = 0; offset < length;) {
	    var assigned = accum % blockSize;
	    var remainder = Math.min(length - offset, blockSize - assigned);
	
	    for (var i = 0; i < remainder; i++) {
	      block[assigned + i] = data[offset + i];
	    }
	
	    accum += remainder;
	    offset += remainder;
	
	    if (accum % blockSize === 0) {
	      this._update(block);
	    }
	  }
	
	  this._len += length;
	  return this;
	};
	
	Hash.prototype.digest = function (enc) {
	  var rem = this._len % this._blockSize;
	
	  this._block[rem] = 0x80;
	
	  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	  this._block.fill(0, rem + 1);
	
	  if (rem >= this._finalSize) {
	    this._update(this._block);
	    this._block.fill(0);
	  }
	
	  var bits = this._len * 8;
	
	  // uint32
	  if (bits <= 0xffffffff) {
	    this._block.writeUInt32BE(bits, this._blockSize - 4);
	
	    // uint64
	  } else {
	    var lowBits = bits & 0xffffffff;
	    var highBits = (bits - lowBits) / 0x100000000;
	
	    this._block.writeUInt32BE(highBits, this._blockSize - 8);
	    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	  }
	
	  this._update(this._block);
	  var hash = this._hash();
	
	  return enc ? hash.toString(enc) : hash;
	};
	
	Hash.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass');
	};
	
	module.exports = Hash;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(111);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
	
	var W = new Array(80);
	
	function Sha1() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha1, Hash);
	
	Sha1.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	
	  return this;
	};
	
	function rotl1(num) {
	  return num << 1 | num >>> 31;
	}
	
	function rotl5(num) {
	  return num << 5 | num >>> 27;
	}
	
	function rotl30(num) {
	  return num << 30 | num >>> 2;
	}
	
	function ft(s, b, c, d) {
	  if (s === 0) return b & c | ~b & d;
	  if (s === 2) return b & c | b & d | c & d;
	  return b ^ c ^ d;
	}
	
	Sha1.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 80; ++i) {
	    W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
	  }for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
	
	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	};
	
	Sha1.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);
	
	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);
	
	  return H;
	};
	
	module.exports = Sha1;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(111);
	var Sha256 = __webpack_require__(142);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var W = new Array(64);
	
	function Sha224() {
	  this.init();
	
	  this._w = W; // new Array(64)
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha224, Sha256);
	
	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8;
	  this._b = 0x367cd507;
	  this._c = 0x3070dd17;
	  this._d = 0xf70e5939;
	  this._e = 0xffc00b31;
	  this._f = 0x68581511;
	  this._g = 0x64f98fa7;
	  this._h = 0xbefa4fa4;
	
	  return this;
	};
	
	Sha224.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(28);
	
	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	
	  return H;
	};
	
	module.exports = Sha224;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(111);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var K = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];
	
	var W = new Array(64);
	
	function Sha256() {
	  this.init();
	
	  this._w = W; // new Array(64)
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha256, Hash);
	
	Sha256.prototype.init = function () {
	  this._a = 0x6a09e667;
	  this._b = 0xbb67ae85;
	  this._c = 0x3c6ef372;
	  this._d = 0xa54ff53a;
	  this._e = 0x510e527f;
	  this._f = 0x9b05688c;
	  this._g = 0x1f83d9ab;
	  this._h = 0x5be0cd19;
	
	  return this;
	};
	
	function ch(x, y, z) {
	  return z ^ x & (y ^ z);
	}
	
	function maj(x, y, z) {
	  return x & y | z & (x | y);
	}
	
	function sigma0(x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
	}
	
	function sigma1(x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
	}
	
	function gamma0(x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
	}
	
	function gamma1(x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
	}
	
	Sha256.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	  var f = this._f | 0;
	  var g = this._g | 0;
	  var h = this._h | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 64; ++i) {
	    W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
	  }for (var j = 0; j < 64; ++j) {
	    var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
	    var T2 = sigma0(a) + maj(a, b, c) | 0;
	
	    h = g;
	    g = f;
	    f = e;
	    e = d + T1 | 0;
	    d = c;
	    c = b;
	    b = a;
	    a = T1 + T2 | 0;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	  this._f = f + this._f | 0;
	  this._g = g + this._g | 0;
	  this._h = h + this._h | 0;
	};
	
	Sha256.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(32);
	
	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	  H.writeInt32BE(this._h, 28);
	
	  return H;
	};
	
	module.exports = Sha256;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(111);
	var SHA512 = __webpack_require__(144);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var W = new Array(160);
	
	function Sha384() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 128, 112);
	}
	
	inherits(Sha384, SHA512);
	
	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d;
	  this._bh = 0x629a292a;
	  this._ch = 0x9159015a;
	  this._dh = 0x152fecd8;
	  this._eh = 0x67332667;
	  this._fh = 0x8eb44a87;
	  this._gh = 0xdb0c2e0d;
	  this._hh = 0x47b5481d;
	
	  this._al = 0xc1059ed8;
	  this._bl = 0x367cd507;
	  this._cl = 0x3070dd17;
	  this._dl = 0xf70e5939;
	  this._el = 0xffc00b31;
	  this._fl = 0x68581511;
	  this._gl = 0x64f98fa7;
	  this._hl = 0xbefa4fa4;
	
	  return this;
	};
	
	Sha384.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(48);
	
	  function writeInt64BE(h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }
	
	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	
	  return H;
	};
	
	module.exports = Sha384;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(111);
	var Hash = __webpack_require__(139);
	var Buffer = __webpack_require__(121).Buffer;
	
	var K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
	
	var W = new Array(160);
	
	function Sha512() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 128, 112);
	}
	
	inherits(Sha512, Hash);
	
	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667;
	  this._bh = 0xbb67ae85;
	  this._ch = 0x3c6ef372;
	  this._dh = 0xa54ff53a;
	  this._eh = 0x510e527f;
	  this._fh = 0x9b05688c;
	  this._gh = 0x1f83d9ab;
	  this._hh = 0x5be0cd19;
	
	  this._al = 0xf3bcc908;
	  this._bl = 0x84caa73b;
	  this._cl = 0xfe94f82b;
	  this._dl = 0x5f1d36f1;
	  this._el = 0xade682d1;
	  this._fl = 0x2b3e6c1f;
	  this._gl = 0xfb41bd6b;
	  this._hl = 0x137e2179;
	
	  return this;
	};
	
	function Ch(x, y, z) {
	  return z ^ x & (y ^ z);
	}
	
	function maj(x, y, z) {
	  return x & y | z & (x | y);
	}
	
	function sigma0(x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
	}
	
	function sigma1(x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
	}
	
	function Gamma0(x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
	}
	
	function Gamma0l(x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
	}
	
	function Gamma1(x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
	}
	
	function Gamma1l(x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
	}
	
	function getCarry(a, b) {
	  return a >>> 0 < b >>> 0 ? 1 : 0;
	}
	
	Sha512.prototype._update = function (M) {
	  var W = this._w;
	
	  var ah = this._ah | 0;
	  var bh = this._bh | 0;
	  var ch = this._ch | 0;
	  var dh = this._dh | 0;
	  var eh = this._eh | 0;
	  var fh = this._fh | 0;
	  var gh = this._gh | 0;
	  var hh = this._hh | 0;
	
	  var al = this._al | 0;
	  var bl = this._bl | 0;
	  var cl = this._cl | 0;
	  var dl = this._dl | 0;
	  var el = this._el | 0;
	  var fl = this._fl | 0;
	  var gl = this._gl | 0;
	  var hl = this._hl | 0;
	
	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4);
	    W[i + 1] = M.readInt32BE(i * 4 + 4);
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2];
	    var xl = W[i - 15 * 2 + 1];
	    var gamma0 = Gamma0(xh, xl);
	    var gamma0l = Gamma0l(xl, xh);
	
	    xh = W[i - 2 * 2];
	    xl = W[i - 2 * 2 + 1];
	    var gamma1 = Gamma1(xh, xl);
	    var gamma1l = Gamma1l(xl, xh);
	
	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2];
	    var Wi7l = W[i - 7 * 2 + 1];
	
	    var Wi16h = W[i - 16 * 2];
	    var Wi16l = W[i - 16 * 2 + 1];
	
	    var Wil = gamma0l + Wi7l | 0;
	    var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
	    Wil = Wil + gamma1l | 0;
	    Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
	    Wil = Wil + Wi16l | 0;
	    Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
	
	    W[i] = Wih;
	    W[i + 1] = Wil;
	  }
	
	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j];
	    Wil = W[j + 1];
	
	    var majh = maj(ah, bh, ch);
	    var majl = maj(al, bl, cl);
	
	    var sigma0h = sigma0(ah, al);
	    var sigma0l = sigma0(al, ah);
	    var sigma1h = sigma1(eh, el);
	    var sigma1l = sigma1(el, eh);
	
	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K[j];
	    var Kil = K[j + 1];
	
	    var chh = Ch(eh, fh, gh);
	    var chl = Ch(el, fl, gl);
	
	    var t1l = hl + sigma1l | 0;
	    var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
	    t1l = t1l + chl | 0;
	    t1h = t1h + chh + getCarry(t1l, chl) | 0;
	    t1l = t1l + Kil | 0;
	    t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
	    t1l = t1l + Wil | 0;
	    t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
	
	    // t2 = sigma0 + maj
	    var t2l = sigma0l + majl | 0;
	    var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
	
	    hh = gh;
	    hl = gl;
	    gh = fh;
	    gl = fl;
	    fh = eh;
	    fl = el;
	    el = dl + t1l | 0;
	    eh = dh + t1h + getCarry(el, dl) | 0;
	    dh = ch;
	    dl = cl;
	    ch = bh;
	    cl = bl;
	    bh = ah;
	    bl = al;
	    al = t1l + t2l | 0;
	    ah = t1h + t2h + getCarry(al, t1l) | 0;
	  }
	
	  this._al = this._al + al | 0;
	  this._bl = this._bl + bl | 0;
	  this._cl = this._cl + cl | 0;
	  this._dl = this._dl + dl | 0;
	  this._el = this._el + el | 0;
	  this._fl = this._fl + fl | 0;
	  this._gl = this._gl + gl | 0;
	  this._hl = this._hl + hl | 0;
	
	  this._ah = this._ah + ah + getCarry(this._al, al) | 0;
	  this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
	  this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
	  this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
	  this._eh = this._eh + eh + getCarry(this._el, el) | 0;
	  this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
	  this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
	  this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
	};
	
	Sha512.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(64);
	
	  function writeInt64BE(h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }
	
	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	  writeInt64BE(this._gh, this._gl, 48);
	  writeInt64BE(this._hh, this._hl, 56);
	
	  return H;
	};
	
	module.exports = Sha512;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	var Transform = __webpack_require__(116).Transform;
	var StringDecoder = __webpack_require__(146).StringDecoder;
	var inherits = __webpack_require__(111);
	
	function CipherBase(hashMode) {
	  Transform.call(this);
	  this.hashMode = typeof hashMode === 'string';
	  if (this.hashMode) {
	    this[hashMode] = this._finalOrDigest;
	  } else {
	    this.final = this._finalOrDigest;
	  }
	  if (this._final) {
	    this.__final = this._final;
	    this._final = null;
	  }
	  this._decoder = null;
	  this._encoding = null;
	}
	inherits(CipherBase, Transform);
	
	CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	  if (typeof data === 'string') {
	    data = Buffer.from(data, inputEnc);
	  }
	
	  var outData = this._update(data);
	  if (this.hashMode) return this;
	
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc);
	  }
	
	  return outData;
	};
	
	CipherBase.prototype.setAutoPadding = function () {};
	CipherBase.prototype.getAuthTag = function () {
	  throw new Error('trying to get auth tag in unsupported state');
	};
	
	CipherBase.prototype.setAuthTag = function () {
	  throw new Error('trying to set auth tag in unsupported state');
	};
	
	CipherBase.prototype.setAAD = function () {
	  throw new Error('trying to set aad in unsupported state');
	};
	
	CipherBase.prototype._transform = function (data, _, next) {
	  var err;
	  try {
	    if (this.hashMode) {
	      this._update(data);
	    } else {
	      this.push(this._update(data));
	    }
	  } catch (e) {
	    err = e;
	  } finally {
	    next(err);
	  }
	};
	CipherBase.prototype._flush = function (done) {
	  var err;
	  try {
	    this.push(this.__final());
	  } catch (e) {
	    err = e;
	  }
	
	  done(err);
	};
	CipherBase.prototype._finalOrDigest = function (outputEnc) {
	  var outData = this.__final() || Buffer.alloc(0);
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc, true);
	  }
	  return outData;
	};
	
	CipherBase.prototype._toString = function (value, enc, fin) {
	  if (!this._decoder) {
	    this._decoder = new StringDecoder(enc);
	    this._encoding = enc;
	  }
	
	  if (this._encoding !== enc) throw new Error('can\'t switch encodings');
	
	  var out = this._decoder.write(value);
	  if (fin) {
	    out += this._decoder.end();
	  }
	
	  return out;
	};
	
	module.exports = CipherBase;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(122).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding || function (encoding) {
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function (encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function (buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function (buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = buffer.length >= 3 ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function (buffer) {
	  var res = '';
	  if (buffer && buffer.length) res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(111);
	var Legacy = __webpack_require__(148);
	var Base = __webpack_require__(145);
	var Buffer = __webpack_require__(121).Buffer;
	var md5 = __webpack_require__(112);
	var RIPEMD160 = __webpack_require__(114);
	
	var sha = __webpack_require__(137);
	
	var ZEROS = Buffer.alloc(128);
	
	function Hmac(alg, key) {
	  Base.call(this, 'digest');
	  if (typeof key === 'string') {
	    key = Buffer.from(key);
	  }
	
	  var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
	
	  this._alg = alg;
	  this._key = key;
	  if (key.length > blocksize) {
	    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
	    key = hash.update(key).digest();
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize);
	  }
	
	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
	  var opad = this._opad = Buffer.allocUnsafe(blocksize);
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }
	  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
	  this._hash.update(ipad);
	}
	
	inherits(Hmac, Base);
	
	Hmac.prototype._update = function (data) {
	  this._hash.update(data);
	};
	
	Hmac.prototype._final = function () {
	  var h = this._hash.digest();
	  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg);
	  return hash.update(this._opad).update(h).digest();
	};
	
	module.exports = function createHmac(alg, key) {
	  alg = alg.toLowerCase();
	  if (alg === 'rmd160' || alg === 'ripemd160') {
	    return new Hmac('rmd160', key);
	  }
	  if (alg === 'md5') {
	    return new Legacy(md5, key);
	  }
	  return new Hmac(alg, key);
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(111);
	var Buffer = __webpack_require__(121).Buffer;
	
	var Base = __webpack_require__(145);
	
	var ZEROS = Buffer.alloc(128);
	var blocksize = 64;
	
	function Hmac(alg, key) {
	  Base.call(this, 'digest');
	  if (typeof key === 'string') {
	    key = Buffer.from(key);
	  }
	
	  this._alg = alg;
	  this._key = key;
	
	  if (key.length > blocksize) {
	    key = alg(key);
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize);
	  }
	
	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
	  var opad = this._opad = Buffer.allocUnsafe(blocksize);
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }
	
	  this._hash = [ipad];
	}
	
	inherits(Hmac, Base);
	
	Hmac.prototype._update = function (data) {
	  this._hash.push(data);
	};
	
	Hmac.prototype._final = function () {
	  var h = this._alg(Buffer.concat(this._hash));
	  return this._alg(Buffer.concat([this._opad, h]));
	};
	module.exports = Hmac;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var basex = __webpack_require__(150);
	var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
	
	module.exports = basex(ALPHABET);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// base-x encoding
	// Forked from https://github.com/cryptocoinjs/bs58
	// Originally written by Mike Hearn for BitcoinJ
	// Copyright (c) 2011 Google Inc
	// Ported to JavaScript by Stefan Thomas
	// Merged Buffer refactorings from base58-native by Stephen Pair
	// Copyright (c) 2013 BitPay Inc
	
	var Buffer = __webpack_require__(121).Buffer;
	
	module.exports = function base(ALPHABET) {
	  var ALPHABET_MAP = {};
	  var BASE = ALPHABET.length;
	  var LEADER = ALPHABET.charAt(0);
	
	  // pre-compute lookup table
	  for (var z = 0; z < ALPHABET.length; z++) {
	    var x = ALPHABET.charAt(z);
	
	    if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous');
	    ALPHABET_MAP[x] = z;
	  }
	
	  function encode(source) {
	    if (source.length === 0) return '';
	
	    var digits = [0];
	    for (var i = 0; i < source.length; ++i) {
	      for (var j = 0, carry = source[i]; j < digits.length; ++j) {
	        carry += digits[j] << 8;
	        digits[j] = carry % BASE;
	        carry = carry / BASE | 0;
	      }
	
	      while (carry > 0) {
	        digits.push(carry % BASE);
	        carry = carry / BASE | 0;
	      }
	    }
	
	    var string = '';
	
	    // deal with leading zeros
	    for (var k = 0; source[k] === 0 && k < source.length - 1; ++k) {
	      string += ALPHABET[0];
	    } // convert digits to a string
	    for (var q = digits.length - 1; q >= 0; --q) {
	      string += ALPHABET[digits[q]];
	    }return string;
	  }
	
	  function decodeUnsafe(string) {
	    if (typeof string !== 'string') throw new TypeError('Expected String');
	    if (string.length === 0) return Buffer.allocUnsafe(0);
	
	    var bytes = [0];
	    for (var i = 0; i < string.length; i++) {
	      var value = ALPHABET_MAP[string[i]];
	      if (value === undefined) return;
	
	      for (var j = 0, carry = value; j < bytes.length; ++j) {
	        carry += bytes[j] * BASE;
	        bytes[j] = carry & 0xff;
	        carry >>= 8;
	      }
	
	      while (carry > 0) {
	        bytes.push(carry & 0xff);
	        carry >>= 8;
	      }
	    }
	
	    // deal with leading zeros
	    for (var k = 0; string[k] === LEADER && k < string.length - 1; ++k) {
	      bytes.push(0);
	    }
	
	    return Buffer.from(bytes.reverse());
	  }
	
	  function decode(string) {
	    var buffer = decodeUnsafe(string);
	    if (buffer) return buffer;
	
	    throw new Error('Non-base' + BASE + ' character');
	  }
	
	  return {
	    encode: encode,
	    decodeUnsafe: decodeUnsafe,
	    decode: decode
	  };
	};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.encrypt = encrypt;
	exports.decrypt = decrypt;
	
	var _secureRandom = __webpack_require__(152);
	
	var _secureRandom2 = _interopRequireDefault(_secureRandom);
	
	var _bytebuffer = __webpack_require__(154);
	
	var _bytebuffer2 = _interopRequireDefault(_bytebuffer);
	
	var _browserifyAes = __webpack_require__(157);
	
	var _browserifyAes2 = _interopRequireDefault(_browserifyAes);
	
	var _assert = __webpack_require__(105);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _key_public = __webpack_require__(178);
	
	var _key_public2 = _interopRequireDefault(_key_public);
	
	var _key_private = __webpack_require__(188);
	
	var _key_private2 = _interopRequireDefault(_key_private);
	
	var _hash = __webpack_require__(109);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Long = _bytebuffer2.default.Long;
	
	/**
	    Spec: http://localhost:3002/steem/@dantheman/how-to-encrypt-a-memo-when-transferring-steem
	    @throws {Error|TypeError} - "Invalid Key, ..."
	    @arg {PrivateKey} private_key - required and used for decryption
	    @arg {PublicKey} public_key - required and used to calcualte the shared secret
	    @arg {string} [nonce = uniqueNonce()] - assigned a random unique uint64
	
	    @return {object}
	    @property {string} nonce - random or unique uint64, provides entropy when re-using the same private/public keys.
	    @property {Buffer} message - Plain text message
	    @property {number} checksum - shared secret checksum
	*/
	function encrypt(private_key, public_key, message) {
	    var nonce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : uniqueNonce();
	
	    return crypt(private_key, public_key, nonce, message);
	}
	
	/**
	    Spec: http://localhost:3002/steem/@dantheman/how-to-encrypt-a-memo-when-transferring-steem
	    @arg {PrivateKey} private_key - required and used for decryption
	    @arg {PublicKey} public_key - required and used to calcualte the shared secret
	    @arg {string} nonce - random or unique uint64, provides entropy when re-using the same private/public keys.
	    @arg {Buffer} message - Encrypted or plain text message
	    @arg {number} checksum - shared secret checksum
	    @throws {Error|TypeError} - "Invalid Key, ..."
	    @return {Buffer} - message
	*/
	function decrypt(private_key, public_key, nonce, message, checksum) {
	    return crypt(private_key, public_key, nonce, message, checksum).message;
	}
	
	/**
	    @arg {Buffer} message - Encrypted or plain text message (see checksum)
	    @arg {number} checksum - shared secret checksum (null to encrypt, non-null to decrypt)
	*/
	function crypt(private_key, public_key, nonce, message, checksum) {
	    private_key = toPrivateObj(private_key);
	    if (!private_key) throw new TypeError('private_key is required');
	
	    public_key = toPublicObj(public_key);
	    if (!public_key) throw new TypeError('public_key is required');
	
	    nonce = toLongObj(nonce);
	    if (!nonce) throw new TypeError('nonce is required');
	
	    if (!Buffer.isBuffer(message)) {
	        if (typeof message !== 'string') throw new TypeError('message should be buffer or string');
	        message = new Buffer(message, 'binary');
	    }
	    if (checksum && typeof checksum !== 'number') throw new TypeError('checksum should be a number');
	
	    var S = private_key.get_shared_secret(public_key);
	    var ebuf = new _bytebuffer2.default(_bytebuffer2.default.DEFAULT_CAPACITY, _bytebuffer2.default.LITTLE_ENDIAN);
	    ebuf.writeUint64(nonce);
	    ebuf.append(S.toString('binary'), 'binary');
	    ebuf = new Buffer(ebuf.copy(0, ebuf.offset).toBinary(), 'binary');
	    var encryption_key = _hash2.default.sha512(ebuf);
	
	    // D E B U G
	    // console.log('crypt', {
	    //     priv_to_pub: private_key.toPublicKey().toString(),
	    //     pub: public_key.toString(),
	    //     nonce: nonce.toString(),
	    //     message: message.length,
	    //     checksum,
	    //     S: S.toString('hex'),
	    //     encryption_key: encryption_key.toString('hex'),
	    // })
	
	    var iv = encryption_key.slice(32, 48);
	    var key = encryption_key.slice(0, 32);
	
	    // check is first 64 bit of sha256 hash treated as uint64_t truncated to 32 bits.
	    var check = _hash2.default.sha256(encryption_key);
	    check = check.slice(0, 4);
	    var cbuf = _bytebuffer2.default.fromBinary(check.toString('binary'), _bytebuffer2.default.DEFAULT_CAPACITY, _bytebuffer2.default.LITTLE_ENDIAN);
	    check = cbuf.readUint32();
	
	    if (checksum) {
	        if (check !== checksum) throw new Error('Invalid key');
	        message = cryptoJsDecrypt(message, key, iv);
	    } else {
	        message = cryptoJsEncrypt(message, key, iv);
	    }
	    return { nonce: nonce, message: message, checksum: check };
	}
	
	/** This method does not use a checksum, the returned data must be validated some other way.
	    @arg {string|Buffer} ciphertext - binary format
	    @return {Buffer}
	*/
	function cryptoJsDecrypt(message, key, iv) {
	    (0, _assert2.default)(message, "Missing cipher text");
	    message = toBinaryBuffer(message);
	    var decipher = _browserifyAes2.default.createDecipheriv('aes-256-cbc', key, iv);
	    // decipher.setAutoPadding(true)
	    message = Buffer.concat([decipher.update(message), decipher.final()]);
	    return message;
	}
	
	/** This method does not use a checksum, the returned data must be validated some other way.
	    @arg {string|Buffer} plaintext - binary format
	    @return {Buffer} binary
	*/
	function cryptoJsEncrypt(message, key, iv) {
	    (0, _assert2.default)(message, "Missing plain text");
	    message = toBinaryBuffer(message);
	    var cipher = _browserifyAes2.default.createCipheriv('aes-256-cbc', key, iv);
	    // cipher.setAutoPadding(true)
	    message = Buffer.concat([cipher.update(message), cipher.final()]);
	    return message;
	}
	
	/** @return {string} unique 64 bit unsigned number string.  Being time based, this is careful to never choose the same nonce twice.  This value could be recorded in the blockchain for a long time.
	*/
	function uniqueNonce() {
	    if (unique_nonce_entropy === null) {
	        var b = _secureRandom2.default.randomUint8Array(2);
	        unique_nonce_entropy = parseInt(b[0] << 8 | b[1], 10);
	    }
	    var long = Long.fromNumber(Date.now());
	    var entropy = ++unique_nonce_entropy % 0xFFFF;
	    // console.log('uniqueNonce date\t', ByteBuffer.allocate(8).writeUint64(long).toHex(0))
	    // console.log('uniqueNonce entropy\t', ByteBuffer.allocate(8).writeUint64(Long.fromNumber(entropy)).toHex(0))
	    long = long.shiftLeft(16).or(Long.fromNumber(entropy));
	    // console.log('uniqueNonce final\t', ByteBuffer.allocate(8).writeUint64(long).toHex(0))
	    return long.toString();
	}
	var unique_nonce_entropy = null;
	// for(let i=1; i < 10; i++) key.uniqueNonce()
	
	var toPrivateObj = function toPrivateObj(o) {
	    return o ? o.d ? o : _key_private2.default.fromWif(o) : o /*null or undefined*/;
	};
	var toPublicObj = function toPublicObj(o) {
	    return o ? o.Q ? o : _key_public2.default.fromString(o) : o /*null or undefined*/;
	};
	var toLongObj = function toLongObj(o) {
	    return o ? Long.isLong(o) ? o : Long.fromString(o) : o;
	};
	var toBinaryBuffer = function toBinaryBuffer(o) {
	    return o ? Buffer.isBuffer(o) ? o : new Buffer(o, 'binary') : o;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, Buffer) {'use strict';
	
	!function (globals) {
	  'use strict';
	
	  //*** UMD BEGIN
	
	  if (true) {
	    //require.js / AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return secureRandom;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports) {
	    //CommonJS
	    module.exports = secureRandom;
	  } else {
	    //script / browser
	    globals.secureRandom = secureRandom;
	  }
	  //*** UMD END
	
	  //options.type is the only valid option
	  function secureRandom(count, options) {
	    options = options || { type: 'Array'
	      //we check for process.pid to prevent browserify from tricking us
	    };if (typeof process != 'undefined' && typeof process.pid == 'number' && process.versions && process.versions.node) {
	      return nodeRandom(count, options);
	    } else {
	      var crypto = window.crypto || window.msCrypto;
	      if (!crypto) throw new Error("Your browser does not support window.crypto.");
	      return browserRandom(count, options);
	    }
	  }
	
	  function nodeRandom(count, options) {
	    var crypto = __webpack_require__(153);
	    var buf = crypto.randomBytes(count);
	
	    switch (options.type) {
	      case 'Array':
	        return [].slice.call(buf);
	      case 'Buffer':
	        return buf;
	      case 'Uint8Array':
	        var arr = new Uint8Array(count);
	        for (var i = 0; i < count; ++i) {
	          arr[i] = buf.readUInt8(i);
	        }
	        return arr;
	      default:
	        throw new Error(options.type + " is unsupported.");
	    }
	  }
	
	  function browserRandom(count, options) {
	    var nativeArr = new Uint8Array(count);
	    var crypto = window.crypto || window.msCrypto;
	    crypto.getRandomValues(nativeArr);
	
	    switch (options.type) {
	      case 'Array':
	        return [].slice.call(nativeArr);
	      case 'Buffer':
	        try {
	          var b = new Buffer(1);
	        } catch (e) {
	          throw new Error('Buffer not supported in this environment. Use Node.js or Browserify for browser support.');
	        }
	        return new Buffer(nativeArr);
	      case 'Uint8Array':
	        return nativeArr;
	      default:
	        throw new Error(options.type + " is unsupported.");
	    }
	  }
	
	  secureRandom.randomArray = function (byteCount) {
	    return secureRandom(byteCount, { type: 'Array' });
	  };
	
	  secureRandom.randomUint8Array = function (byteCount) {
	    return secureRandom(byteCount, { type: 'Uint8Array' });
	  };
	
	  secureRandom.randomBuffer = function (byteCount) {
	    return secureRandom(byteCount, { type: 'Buffer' });
	  };
	}(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(99).Buffer))

/***/ }),
/* 153 */
96,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Copyright 2013-2014 Daniel Wirtz <dcode@dcode.io>
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	/**
	 * @license bytebuffer.js (c) 2015 Daniel Wirtz <dcode@dcode.io>
	 * Backing buffer: ArrayBuffer, Accessor: Uint8Array
	 * Released under the Apache License, Version 2.0
	 * see: https://github.com/dcodeIO/bytebuffer.js for details
	 */
	(function (global, factory) {
	
	    /* AMD */if ("function" === 'function' && __webpack_require__(155)["amd"]) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(156)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    /* CommonJS */else if ("function" === 'function' && ( false ? "undefined" : _typeof(module)) === "object" && module && module["exports"]) module['exports'] = function () {
	            var Long;try {
	                Long = __webpack_require__(156);
	            } catch (e) {}
	            return factory(Long);
	        }();
	        /* Global */else (global["dcodeIO"] = global["dcodeIO"] || {})["ByteBuffer"] = factory(global["dcodeIO"]["Long"]);
	})(undefined, function (Long) {
	    "use strict";
	
	    /**
	     * Constructs a new ByteBuffer.
	     * @class The swiss army knife for binary data in JavaScript.
	     * @exports ByteBuffer
	     * @constructor
	     * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @expose
	     */
	
	    var ByteBuffer = function ByteBuffer(capacity, littleEndian, noAssert) {
	        if (typeof capacity === 'undefined') capacity = ByteBuffer.DEFAULT_CAPACITY;
	        if (typeof littleEndian === 'undefined') littleEndian = ByteBuffer.DEFAULT_ENDIAN;
	        if (typeof noAssert === 'undefined') noAssert = ByteBuffer.DEFAULT_NOASSERT;
	        if (!noAssert) {
	            capacity = capacity | 0;
	            if (capacity < 0) throw RangeError("Illegal capacity");
	            littleEndian = !!littleEndian;
	            noAssert = !!noAssert;
	        }
	
	        /**
	         * Backing ArrayBuffer.
	         * @type {!ArrayBuffer}
	         * @expose
	         */
	        this.buffer = capacity === 0 ? EMPTY_BUFFER : new ArrayBuffer(capacity);
	
	        /**
	         * Uint8Array utilized to manipulate the backing buffer. Becomes `null` if the backing buffer has a capacity of `0`.
	         * @type {?Uint8Array}
	         * @expose
	         */
	        this.view = capacity === 0 ? null : new Uint8Array(this.buffer);
	
	        /**
	         * Absolute read/write offset.
	         * @type {number}
	         * @expose
	         * @see ByteBuffer#flip
	         * @see ByteBuffer#clear
	         */
	        this.offset = 0;
	
	        /**
	         * Marked offset.
	         * @type {number}
	         * @expose
	         * @see ByteBuffer#mark
	         * @see ByteBuffer#reset
	         */
	        this.markedOffset = -1;
	
	        /**
	         * Absolute limit of the contained data. Set to the backing buffer's capacity upon allocation.
	         * @type {number}
	         * @expose
	         * @see ByteBuffer#flip
	         * @see ByteBuffer#clear
	         */
	        this.limit = capacity;
	
	        /**
	         * Whether to use little endian byte order, defaults to `false` for big endian.
	         * @type {boolean}
	         * @expose
	         */
	        this.littleEndian = littleEndian;
	
	        /**
	         * Whether to skip assertions of offsets and values, defaults to `false`.
	         * @type {boolean}
	         * @expose
	         */
	        this.noAssert = noAssert;
	    };
	
	    /**
	     * ByteBuffer version.
	     * @type {string}
	     * @const
	     * @expose
	     */
	    ByteBuffer.VERSION = "5.0.1";
	
	    /**
	     * Little endian constant that can be used instead of its boolean value. Evaluates to `true`.
	     * @type {boolean}
	     * @const
	     * @expose
	     */
	    ByteBuffer.LITTLE_ENDIAN = true;
	
	    /**
	     * Big endian constant that can be used instead of its boolean value. Evaluates to `false`.
	     * @type {boolean}
	     * @const
	     * @expose
	     */
	    ByteBuffer.BIG_ENDIAN = false;
	
	    /**
	     * Default initial capacity of `16`.
	     * @type {number}
	     * @expose
	     */
	    ByteBuffer.DEFAULT_CAPACITY = 16;
	
	    /**
	     * Default endianess of `false` for big endian.
	     * @type {boolean}
	     * @expose
	     */
	    ByteBuffer.DEFAULT_ENDIAN = ByteBuffer.BIG_ENDIAN;
	
	    /**
	     * Default no assertions flag of `false`.
	     * @type {boolean}
	     * @expose
	     */
	    ByteBuffer.DEFAULT_NOASSERT = false;
	
	    /**
	     * A `Long` class for representing a 64-bit two's-complement integer value. May be `null` if Long.js has not been loaded
	     *  and int64 support is not available.
	     * @type {?Long}
	     * @const
	     * @see https://github.com/dcodeIO/long.js
	     * @expose
	     */
	    ByteBuffer.Long = Long || null;
	
	    /**
	     * @alias ByteBuffer.prototype
	     * @inner
	     */
	    var ByteBufferPrototype = ByteBuffer.prototype;
	
	    /**
	     * An indicator used to reliably determine if an object is a ByteBuffer or not.
	     * @type {boolean}
	     * @const
	     * @expose
	     * @private
	     */
	    ByteBufferPrototype.__isByteBuffer__;
	
	    Object.defineProperty(ByteBufferPrototype, "__isByteBuffer__", {
	        value: true,
	        enumerable: false,
	        configurable: false
	    });
	
	    // helpers
	
	    /**
	     * @type {!ArrayBuffer}
	     * @inner
	     */
	    var EMPTY_BUFFER = new ArrayBuffer(0);
	
	    /**
	     * String.fromCharCode reference for compile-time renaming.
	     * @type {function(...number):string}
	     * @inner
	     */
	    var stringFromCharCode = String.fromCharCode;
	
	    /**
	     * Creates a source function for a string.
	     * @param {string} s String to read from
	     * @returns {function():number|null} Source function returning the next char code respectively `null` if there are
	     *  no more characters left.
	     * @throws {TypeError} If the argument is invalid
	     * @inner
	     */
	    function stringSource(s) {
	        var i = 0;return function () {
	            return i < s.length ? s.charCodeAt(i++) : null;
	        };
	    }
	
	    /**
	     * Creates a destination function for a string.
	     * @returns {function(number=):undefined|string} Destination function successively called with the next char code.
	     *  Returns the final string when called without arguments.
	     * @inner
	     */
	    function stringDestination() {
	        var cs = [],
	            ps = [];return function () {
	            if (arguments.length === 0) return ps.join('') + stringFromCharCode.apply(String, cs);
	            if (cs.length + arguments.length > 1024) ps.push(stringFromCharCode.apply(String, cs)), cs.length = 0;
	            Array.prototype.push.apply(cs, arguments);
	        };
	    }
	
	    /**
	     * Gets the accessor type.
	     * @returns {Function} `Buffer` under node.js, `Uint8Array` respectively `DataView` in the browser (classes)
	     * @expose
	     */
	    ByteBuffer.accessor = function () {
	        return Uint8Array;
	    };
	    /**
	     * Allocates a new ByteBuffer backed by a buffer of the specified capacity.
	     * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer}
	     * @expose
	     */
	    ByteBuffer.allocate = function (capacity, littleEndian, noAssert) {
	        return new ByteBuffer(capacity, littleEndian, noAssert);
	    };
	
	    /**
	     * Concatenates multiple ByteBuffers into one.
	     * @param {!Array.<!ByteBuffer|!ArrayBuffer|!Uint8Array|string>} buffers Buffers to concatenate
	     * @param {(string|boolean)=} encoding String encoding if `buffers` contains a string ("base64", "hex", "binary",
	     *  defaults to "utf8")
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order for the resulting ByteBuffer. Defaults
	     *  to {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values for the resulting ByteBuffer. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer} Concatenated ByteBuffer
	     * @expose
	     */
	    ByteBuffer.concat = function (buffers, encoding, littleEndian, noAssert) {
	        if (typeof encoding === 'boolean' || typeof encoding !== 'string') {
	            noAssert = littleEndian;
	            littleEndian = encoding;
	            encoding = undefined;
	        }
	        var capacity = 0;
	        for (var i = 0, k = buffers.length, length; i < k; ++i) {
	            if (!ByteBuffer.isByteBuffer(buffers[i])) buffers[i] = ByteBuffer.wrap(buffers[i], encoding);
	            length = buffers[i].limit - buffers[i].offset;
	            if (length > 0) capacity += length;
	        }
	        if (capacity === 0) return new ByteBuffer(0, littleEndian, noAssert);
	        var bb = new ByteBuffer(capacity, littleEndian, noAssert),
	            bi;
	        i = 0;while (i < k) {
	            bi = buffers[i++];
	            length = bi.limit - bi.offset;
	            if (length <= 0) continue;
	            bb.view.set(bi.view.subarray(bi.offset, bi.limit), bb.offset);
	            bb.offset += length;
	        }
	        bb.limit = bb.offset;
	        bb.offset = 0;
	        return bb;
	    };
	
	    /**
	     * Tests if the specified type is a ByteBuffer.
	     * @param {*} bb ByteBuffer to test
	     * @returns {boolean} `true` if it is a ByteBuffer, otherwise `false`
	     * @expose
	     */
	    ByteBuffer.isByteBuffer = function (bb) {
	        return (bb && bb["__isByteBuffer__"]) === true;
	    };
	    /**
	     * Gets the backing buffer type.
	     * @returns {Function} `Buffer` under node.js, `ArrayBuffer` in the browser (classes)
	     * @expose
	     */
	    ByteBuffer.type = function () {
	        return ArrayBuffer;
	    };
	    /**
	     * Wraps a buffer or a string. Sets the allocated ByteBuffer's {@link ByteBuffer#offset} to `0` and its
	     *  {@link ByteBuffer#limit} to the length of the wrapped data.
	     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string|!Array.<number>} buffer Anything that can be wrapped
	     * @param {(string|boolean)=} encoding String encoding if `buffer` is a string ("base64", "hex", "binary", defaults to
	     *  "utf8")
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer} A ByteBuffer wrapping `buffer`
	     * @expose
	     */
	    ByteBuffer.wrap = function (buffer, encoding, littleEndian, noAssert) {
	        if (typeof encoding !== 'string') {
	            noAssert = littleEndian;
	            littleEndian = encoding;
	            encoding = undefined;
	        }
	        if (typeof buffer === 'string') {
	            if (typeof encoding === 'undefined') encoding = "utf8";
	            switch (encoding) {
	                case "base64":
	                    return ByteBuffer.fromBase64(buffer, littleEndian);
	                case "hex":
	                    return ByteBuffer.fromHex(buffer, littleEndian);
	                case "binary":
	                    return ByteBuffer.fromBinary(buffer, littleEndian);
	                case "utf8":
	                    return ByteBuffer.fromUTF8(buffer, littleEndian);
	                case "debug":
	                    return ByteBuffer.fromDebug(buffer, littleEndian);
	                default:
	                    throw Error("Unsupported encoding: " + encoding);
	            }
	        }
	        if (buffer === null || (typeof buffer === "undefined" ? "undefined" : _typeof(buffer)) !== 'object') throw TypeError("Illegal buffer");
	        var bb;
	        if (ByteBuffer.isByteBuffer(buffer)) {
	            bb = ByteBufferPrototype.clone.call(buffer);
	            bb.markedOffset = -1;
	            return bb;
	        }
	        if (buffer instanceof Uint8Array) {
	            // Extract ArrayBuffer from Uint8Array
	            bb = new ByteBuffer(0, littleEndian, noAssert);
	            if (buffer.length > 0) {
	                // Avoid references to more than one EMPTY_BUFFER
	                bb.buffer = buffer.buffer;
	                bb.offset = buffer.byteOffset;
	                bb.limit = buffer.byteOffset + buffer.byteLength;
	                bb.view = new Uint8Array(buffer.buffer);
	            }
	        } else if (buffer instanceof ArrayBuffer) {
	            // Reuse ArrayBuffer
	            bb = new ByteBuffer(0, littleEndian, noAssert);
	            if (buffer.byteLength > 0) {
	                bb.buffer = buffer;
	                bb.offset = 0;
	                bb.limit = buffer.byteLength;
	                bb.view = buffer.byteLength > 0 ? new Uint8Array(buffer) : null;
	            }
	        } else if (Object.prototype.toString.call(buffer) === "[object Array]") {
	            // Create from octets
	            bb = new ByteBuffer(buffer.length, littleEndian, noAssert);
	            bb.limit = buffer.length;
	            for (var i = 0; i < buffer.length; ++i) {
	                bb.view[i] = buffer[i];
	            }
	        } else throw TypeError("Illegal buffer"); // Otherwise fail
	        return bb;
	    };
	
	    /**
	     * Writes the array as a bitset.
	     * @param {Array<boolean>} value Array of booleans to write
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
	     * @returns {!ByteBuffer}
	     * @expose
	     */
	    ByteBufferPrototype.writeBitSet = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (!(value instanceof Array)) throw TypeError("Illegal BitSet: Not an array");
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	
	        var start = offset,
	            bits = value.length,
	            bytes = bits >> 3,
	            bit = 0,
	            k;
	
	        offset += this.writeVarint32(bits, offset);
	
	        while (bytes--) {
	            k = !!value[bit++] & 1 | (!!value[bit++] & 1) << 1 | (!!value[bit++] & 1) << 2 | (!!value[bit++] & 1) << 3 | (!!value[bit++] & 1) << 4 | (!!value[bit++] & 1) << 5 | (!!value[bit++] & 1) << 6 | (!!value[bit++] & 1) << 7;
	            this.writeByte(k, offset++);
	        }
	
	        if (bit < bits) {
	            var m = 0;k = 0;
	            while (bit < bits) {
	                k = k | (!!value[bit++] & 1) << m++;
	            }this.writeByte(k, offset++);
	        }
	
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return offset - start;
	    };
	
	    /**
	     * Reads a BitSet as an array of booleans.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
	     * @returns {Array<boolean>
	     * @expose
	     */
	    ByteBufferPrototype.readBitSet = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	
	        var ret = this.readVarint32(offset),
	            bits = ret.value,
	            bytes = bits >> 3,
	            bit = 0,
	            value = [],
	            k;
	
	        offset += ret.length;
	
	        while (bytes--) {
	            k = this.readByte(offset++);
	            value[bit++] = !!(k & 0x01);
	            value[bit++] = !!(k & 0x02);
	            value[bit++] = !!(k & 0x04);
	            value[bit++] = !!(k & 0x08);
	            value[bit++] = !!(k & 0x10);
	            value[bit++] = !!(k & 0x20);
	            value[bit++] = !!(k & 0x40);
	            value[bit++] = !!(k & 0x80);
	        }
	
	        if (bit < bits) {
	            var m = 0;
	            k = this.readByte(offset++);
	            while (bit < bits) {
	                value[bit++] = !!(k >> m++ & 1);
	            }
	        }
	
	        if (relative) {
	            this.offset = offset;
	        }
	        return value;
	    };
	    /**
	     * Reads the specified number of bytes.
	     * @param {number} length Number of bytes to read
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
	     * @returns {!ByteBuffer}
	     * @expose
	     */
	    ByteBufferPrototype.readBytes = function (length, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + length > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + length + ") <= " + this.buffer.byteLength);
	        }
	        var slice = this.slice(offset, offset + length);
	        if (relative) this.offset += length;
	        return slice;
	    };
	
	    /**
	     * Writes a payload of bytes. This is an alias of {@link ByteBuffer#append}.
	     * @function
	     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to write. If `source` is a ByteBuffer, its offsets
	     *  will be modified according to the performed read operation.
	     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeBytes = ByteBufferPrototype.append;
	
	    // types/ints/int8
	
	    /**
	     * Writes an 8bit signed integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeInt8 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value |= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 1;
	        var capacity0 = this.buffer.byteLength;
	        if (offset > capacity0) this.resize((capacity0 *= 2) > offset ? capacity0 : offset);
	        offset -= 1;
	        this.view[offset] = value;
	        if (relative) this.offset += 1;
	        return this;
	    };
	
	    /**
	     * Writes an 8bit signed integer. This is an alias of {@link ByteBuffer#writeInt8}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeByte = ByteBufferPrototype.writeInt8;
	
	    /**
	     * Reads an 8bit signed integer.
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readInt8 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	        }
	        var value = this.view[offset];
	        if ((value & 0x80) === 0x80) value = -(0xFF - value + 1); // Cast to signed
	        if (relative) this.offset += 1;
	        return value;
	    };
	
	    /**
	     * Reads an 8bit signed integer. This is an alias of {@link ByteBuffer#readInt8}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readByte = ByteBufferPrototype.readInt8;
	
	    /**
	     * Writes an 8bit unsigned integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeUint8 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value >>>= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 1;
	        var capacity1 = this.buffer.byteLength;
	        if (offset > capacity1) this.resize((capacity1 *= 2) > offset ? capacity1 : offset);
	        offset -= 1;
	        this.view[offset] = value;
	        if (relative) this.offset += 1;
	        return this;
	    };
	
	    /**
	     * Writes an 8bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint8}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeUInt8 = ByteBufferPrototype.writeUint8;
	
	    /**
	     * Reads an 8bit unsigned integer.
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readUint8 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	        }
	        var value = this.view[offset];
	        if (relative) this.offset += 1;
	        return value;
	    };
	
	    /**
	     * Reads an 8bit unsigned integer. This is an alias of {@link ByteBuffer#readUint8}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readUInt8 = ByteBufferPrototype.readUint8;
	
	    // types/ints/int16
	
	    /**
	     * Writes a 16bit signed integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @throws {TypeError} If `offset` or `value` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.writeInt16 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value |= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 2;
	        var capacity2 = this.buffer.byteLength;
	        if (offset > capacity2) this.resize((capacity2 *= 2) > offset ? capacity2 : offset);
	        offset -= 2;
	        if (this.littleEndian) {
	            this.view[offset + 1] = (value & 0xFF00) >>> 8;
	            this.view[offset] = value & 0x00FF;
	        } else {
	            this.view[offset] = (value & 0xFF00) >>> 8;
	            this.view[offset + 1] = value & 0x00FF;
	        }
	        if (relative) this.offset += 2;
	        return this;
	    };
	
	    /**
	     * Writes a 16bit signed integer. This is an alias of {@link ByteBuffer#writeInt16}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @throws {TypeError} If `offset` or `value` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.writeShort = ByteBufferPrototype.writeInt16;
	
	    /**
	     * Reads a 16bit signed integer.
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @returns {number} Value read
	     * @throws {TypeError} If `offset` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.readInt16 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 2 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 2 + ") <= " + this.buffer.byteLength);
	        }
	        var value = 0;
	        if (this.littleEndian) {
	            value = this.view[offset];
	            value |= this.view[offset + 1] << 8;
	        } else {
	            value = this.view[offset] << 8;
	            value |= this.view[offset + 1];
	        }
	        if ((value & 0x8000) === 0x8000) value = -(0xFFFF - value + 1); // Cast to signed
	        if (relative) this.offset += 2;
	        return value;
	    };
	
	    /**
	     * Reads a 16bit signed integer. This is an alias of {@link ByteBuffer#readInt16}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @returns {number} Value read
	     * @throws {TypeError} If `offset` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.readShort = ByteBufferPrototype.readInt16;
	
	    /**
	     * Writes a 16bit unsigned integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @throws {TypeError} If `offset` or `value` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.writeUint16 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value >>>= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 2;
	        var capacity3 = this.buffer.byteLength;
	        if (offset > capacity3) this.resize((capacity3 *= 2) > offset ? capacity3 : offset);
	        offset -= 2;
	        if (this.littleEndian) {
	            this.view[offset + 1] = (value & 0xFF00) >>> 8;
	            this.view[offset] = value & 0x00FF;
	        } else {
	            this.view[offset] = (value & 0xFF00) >>> 8;
	            this.view[offset + 1] = value & 0x00FF;
	        }
	        if (relative) this.offset += 2;
	        return this;
	    };
	
	    /**
	     * Writes a 16bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint16}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @throws {TypeError} If `offset` or `value` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.writeUInt16 = ByteBufferPrototype.writeUint16;
	
	    /**
	     * Reads a 16bit unsigned integer.
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @returns {number} Value read
	     * @throws {TypeError} If `offset` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.readUint16 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 2 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 2 + ") <= " + this.buffer.byteLength);
	        }
	        var value = 0;
	        if (this.littleEndian) {
	            value = this.view[offset];
	            value |= this.view[offset + 1] << 8;
	        } else {
	            value = this.view[offset] << 8;
	            value |= this.view[offset + 1];
	        }
	        if (relative) this.offset += 2;
	        return value;
	    };
	
	    /**
	     * Reads a 16bit unsigned integer. This is an alias of {@link ByteBuffer#readUint16}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
	     * @returns {number} Value read
	     * @throws {TypeError} If `offset` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.readUInt16 = ByteBufferPrototype.readUint16;
	
	    // types/ints/int32
	
	    /**
	     * Writes a 32bit signed integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @expose
	     */
	    ByteBufferPrototype.writeInt32 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value |= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 4;
	        var capacity4 = this.buffer.byteLength;
	        if (offset > capacity4) this.resize((capacity4 *= 2) > offset ? capacity4 : offset);
	        offset -= 4;
	        if (this.littleEndian) {
	            this.view[offset + 3] = value >>> 24 & 0xFF;
	            this.view[offset + 2] = value >>> 16 & 0xFF;
	            this.view[offset + 1] = value >>> 8 & 0xFF;
	            this.view[offset] = value & 0xFF;
	        } else {
	            this.view[offset] = value >>> 24 & 0xFF;
	            this.view[offset + 1] = value >>> 16 & 0xFF;
	            this.view[offset + 2] = value >>> 8 & 0xFF;
	            this.view[offset + 3] = value & 0xFF;
	        }
	        if (relative) this.offset += 4;
	        return this;
	    };
	
	    /**
	     * Writes a 32bit signed integer. This is an alias of {@link ByteBuffer#writeInt32}.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @expose
	     */
	    ByteBufferPrototype.writeInt = ByteBufferPrototype.writeInt32;
	
	    /**
	     * Reads a 32bit signed integer.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readInt32 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 4 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 4 + ") <= " + this.buffer.byteLength);
	        }
	        var value = 0;
	        if (this.littleEndian) {
	            value = this.view[offset + 2] << 16;
	            value |= this.view[offset + 1] << 8;
	            value |= this.view[offset];
	            value += this.view[offset + 3] << 24 >>> 0;
	        } else {
	            value = this.view[offset + 1] << 16;
	            value |= this.view[offset + 2] << 8;
	            value |= this.view[offset + 3];
	            value += this.view[offset] << 24 >>> 0;
	        }
	        value |= 0; // Cast to signed
	        if (relative) this.offset += 4;
	        return value;
	    };
	
	    /**
	     * Reads a 32bit signed integer. This is an alias of {@link ByteBuffer#readInt32}.
	     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readInt = ByteBufferPrototype.readInt32;
	
	    /**
	     * Writes a 32bit unsigned integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @expose
	     */
	    ByteBufferPrototype.writeUint32 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value >>>= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 4;
	        var capacity5 = this.buffer.byteLength;
	        if (offset > capacity5) this.resize((capacity5 *= 2) > offset ? capacity5 : offset);
	        offset -= 4;
	        if (this.littleEndian) {
	            this.view[offset + 3] = value >>> 24 & 0xFF;
	            this.view[offset + 2] = value >>> 16 & 0xFF;
	            this.view[offset + 1] = value >>> 8 & 0xFF;
	            this.view[offset] = value & 0xFF;
	        } else {
	            this.view[offset] = value >>> 24 & 0xFF;
	            this.view[offset + 1] = value >>> 16 & 0xFF;
	            this.view[offset + 2] = value >>> 8 & 0xFF;
	            this.view[offset + 3] = value & 0xFF;
	        }
	        if (relative) this.offset += 4;
	        return this;
	    };
	
	    /**
	     * Writes a 32bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint32}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @expose
	     */
	    ByteBufferPrototype.writeUInt32 = ByteBufferPrototype.writeUint32;
	
	    /**
	     * Reads a 32bit unsigned integer.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readUint32 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 4 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 4 + ") <= " + this.buffer.byteLength);
	        }
	        var value = 0;
	        if (this.littleEndian) {
	            value = this.view[offset + 2] << 16;
	            value |= this.view[offset + 1] << 8;
	            value |= this.view[offset];
	            value += this.view[offset + 3] << 24 >>> 0;
	        } else {
	            value = this.view[offset + 1] << 16;
	            value |= this.view[offset + 2] << 8;
	            value |= this.view[offset + 3];
	            value += this.view[offset] << 24 >>> 0;
	        }
	        if (relative) this.offset += 4;
	        return value;
	    };
	
	    /**
	     * Reads a 32bit unsigned integer. This is an alias of {@link ByteBuffer#readUint32}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number} Value read
	     * @expose
	     */
	    ByteBufferPrototype.readUInt32 = ByteBufferPrototype.readUint32;
	
	    // types/ints/int64
	
	    if (Long) {
	
	        /**
	         * Writes a 64bit signed integer.
	         * @param {number|!Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!ByteBuffer} this
	         * @expose
	         */
	        ByteBufferPrototype.writeInt64 = function (value, offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);else if (!(value && value instanceof Long)) throw TypeError("Illegal value: " + value + " (not an integer or Long)");
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	            }
	            if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);
	            offset += 8;
	            var capacity6 = this.buffer.byteLength;
	            if (offset > capacity6) this.resize((capacity6 *= 2) > offset ? capacity6 : offset);
	            offset -= 8;
	            var lo = value.low,
	                hi = value.high;
	            if (this.littleEndian) {
	                this.view[offset + 3] = lo >>> 24 & 0xFF;
	                this.view[offset + 2] = lo >>> 16 & 0xFF;
	                this.view[offset + 1] = lo >>> 8 & 0xFF;
	                this.view[offset] = lo & 0xFF;
	                offset += 4;
	                this.view[offset + 3] = hi >>> 24 & 0xFF;
	                this.view[offset + 2] = hi >>> 16 & 0xFF;
	                this.view[offset + 1] = hi >>> 8 & 0xFF;
	                this.view[offset] = hi & 0xFF;
	            } else {
	                this.view[offset] = hi >>> 24 & 0xFF;
	                this.view[offset + 1] = hi >>> 16 & 0xFF;
	                this.view[offset + 2] = hi >>> 8 & 0xFF;
	                this.view[offset + 3] = hi & 0xFF;
	                offset += 4;
	                this.view[offset] = lo >>> 24 & 0xFF;
	                this.view[offset + 1] = lo >>> 16 & 0xFF;
	                this.view[offset + 2] = lo >>> 8 & 0xFF;
	                this.view[offset + 3] = lo & 0xFF;
	            }
	            if (relative) this.offset += 8;
	            return this;
	        };
	
	        /**
	         * Writes a 64bit signed integer. This is an alias of {@link ByteBuffer#writeInt64}.
	         * @param {number|!Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!ByteBuffer} this
	         * @expose
	         */
	        ByteBufferPrototype.writeLong = ByteBufferPrototype.writeInt64;
	
	        /**
	         * Reads a 64bit signed integer.
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!Long}
	         * @expose
	         */
	        ByteBufferPrototype.readInt64 = function (offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 8 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 8 + ") <= " + this.buffer.byteLength);
	            }
	            var lo = 0,
	                hi = 0;
	            if (this.littleEndian) {
	                lo = this.view[offset + 2] << 16;
	                lo |= this.view[offset + 1] << 8;
	                lo |= this.view[offset];
	                lo += this.view[offset + 3] << 24 >>> 0;
	                offset += 4;
	                hi = this.view[offset + 2] << 16;
	                hi |= this.view[offset + 1] << 8;
	                hi |= this.view[offset];
	                hi += this.view[offset + 3] << 24 >>> 0;
	            } else {
	                hi = this.view[offset + 1] << 16;
	                hi |= this.view[offset + 2] << 8;
	                hi |= this.view[offset + 3];
	                hi += this.view[offset] << 24 >>> 0;
	                offset += 4;
	                lo = this.view[offset + 1] << 16;
	                lo |= this.view[offset + 2] << 8;
	                lo |= this.view[offset + 3];
	                lo += this.view[offset] << 24 >>> 0;
	            }
	            var value = new Long(lo, hi, false);
	            if (relative) this.offset += 8;
	            return value;
	        };
	
	        /**
	         * Reads a 64bit signed integer. This is an alias of {@link ByteBuffer#readInt64}.
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!Long}
	         * @expose
	         */
	        ByteBufferPrototype.readLong = ByteBufferPrototype.readInt64;
	
	        /**
	         * Writes a 64bit unsigned integer.
	         * @param {number|!Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!ByteBuffer} this
	         * @expose
	         */
	        ByteBufferPrototype.writeUint64 = function (value, offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);else if (!(value && value instanceof Long)) throw TypeError("Illegal value: " + value + " (not an integer or Long)");
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	            }
	            if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);
	            offset += 8;
	            var capacity7 = this.buffer.byteLength;
	            if (offset > capacity7) this.resize((capacity7 *= 2) > offset ? capacity7 : offset);
	            offset -= 8;
	            var lo = value.low,
	                hi = value.high;
	            if (this.littleEndian) {
	                this.view[offset + 3] = lo >>> 24 & 0xFF;
	                this.view[offset + 2] = lo >>> 16 & 0xFF;
	                this.view[offset + 1] = lo >>> 8 & 0xFF;
	                this.view[offset] = lo & 0xFF;
	                offset += 4;
	                this.view[offset + 3] = hi >>> 24 & 0xFF;
	                this.view[offset + 2] = hi >>> 16 & 0xFF;
	                this.view[offset + 1] = hi >>> 8 & 0xFF;
	                this.view[offset] = hi & 0xFF;
	            } else {
	                this.view[offset] = hi >>> 24 & 0xFF;
	                this.view[offset + 1] = hi >>> 16 & 0xFF;
	                this.view[offset + 2] = hi >>> 8 & 0xFF;
	                this.view[offset + 3] = hi & 0xFF;
	                offset += 4;
	                this.view[offset] = lo >>> 24 & 0xFF;
	                this.view[offset + 1] = lo >>> 16 & 0xFF;
	                this.view[offset + 2] = lo >>> 8 & 0xFF;
	                this.view[offset + 3] = lo & 0xFF;
	            }
	            if (relative) this.offset += 8;
	            return this;
	        };
	
	        /**
	         * Writes a 64bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint64}.
	         * @function
	         * @param {number|!Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!ByteBuffer} this
	         * @expose
	         */
	        ByteBufferPrototype.writeUInt64 = ByteBufferPrototype.writeUint64;
	
	        /**
	         * Reads a 64bit unsigned integer.
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!Long}
	         * @expose
	         */
	        ByteBufferPrototype.readUint64 = function (offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 8 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 8 + ") <= " + this.buffer.byteLength);
	            }
	            var lo = 0,
	                hi = 0;
	            if (this.littleEndian) {
	                lo = this.view[offset + 2] << 16;
	                lo |= this.view[offset + 1] << 8;
	                lo |= this.view[offset];
	                lo += this.view[offset + 3] << 24 >>> 0;
	                offset += 4;
	                hi = this.view[offset + 2] << 16;
	                hi |= this.view[offset + 1] << 8;
	                hi |= this.view[offset];
	                hi += this.view[offset + 3] << 24 >>> 0;
	            } else {
	                hi = this.view[offset + 1] << 16;
	                hi |= this.view[offset + 2] << 8;
	                hi |= this.view[offset + 3];
	                hi += this.view[offset] << 24 >>> 0;
	                offset += 4;
	                lo = this.view[offset + 1] << 16;
	                lo |= this.view[offset + 2] << 8;
	                lo |= this.view[offset + 3];
	                lo += this.view[offset] << 24 >>> 0;
	            }
	            var value = new Long(lo, hi, true);
	            if (relative) this.offset += 8;
	            return value;
	        };
	
	        /**
	         * Reads a 64bit unsigned integer. This is an alias of {@link ByteBuffer#readUint64}.
	         * @function
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	         * @returns {!Long}
	         * @expose
	         */
	        ByteBufferPrototype.readUInt64 = ByteBufferPrototype.readUint64;
	    } // Long
	
	
	    // types/floats/float32
	
	    /*
	     ieee754 - https://github.com/feross/ieee754
	       The MIT License (MIT)
	       Copyright (c) Feross Aboukhadijeh
	       Permission is hereby granted, free of charge, to any person obtaining a copy
	     of this software and associated documentation files (the "Software"), to deal
	     in the Software without restriction, including without limitation the rights
	     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	     copies of the Software, and to permit persons to whom the Software is
	     furnished to do so, subject to the following conditions:
	       The above copyright notice and this permission notice shall be included in
	     all copies or substantial portions of the Software.
	       THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	     IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	     AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	     THE SOFTWARE.
	    */
	
	    /**
	     * Reads an IEEE754 float from a byte array.
	     * @param {!Array} buffer
	     * @param {number} offset
	     * @param {boolean} isLE
	     * @param {number} mLen
	     * @param {number} nBytes
	     * @returns {number}
	     * @inner
	     */
	    function ieee754_read(buffer, offset, isLE, mLen, nBytes) {
	        var e,
	            m,
	            eLen = nBytes * 8 - mLen - 1,
	            eMax = (1 << eLen) - 1,
	            eBias = eMax >> 1,
	            nBits = -7,
	            i = isLE ? nBytes - 1 : 0,
	            d = isLE ? -1 : 1,
	            s = buffer[offset + i];
	
	        i += d;
	
	        e = s & (1 << -nBits) - 1;
	        s >>= -nBits;
	        nBits += eLen;
	        for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	        m = e & (1 << -nBits) - 1;
	        e >>= -nBits;
	        nBits += mLen;
	        for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	        if (e === 0) {
	            e = 1 - eBias;
	        } else if (e === eMax) {
	            return m ? NaN : (s ? -1 : 1) * Infinity;
	        } else {
	            m = m + Math.pow(2, mLen);
	            e = e - eBias;
	        }
	        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	    }
	
	    /**
	     * Writes an IEEE754 float to a byte array.
	     * @param {!Array} buffer
	     * @param {number} value
	     * @param {number} offset
	     * @param {boolean} isLE
	     * @param {number} mLen
	     * @param {number} nBytes
	     * @inner
	     */
	    function ieee754_write(buffer, value, offset, isLE, mLen, nBytes) {
	        var e,
	            m,
	            c,
	            eLen = nBytes * 8 - mLen - 1,
	            eMax = (1 << eLen) - 1,
	            eBias = eMax >> 1,
	            rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
	            i = isLE ? 0 : nBytes - 1,
	            d = isLE ? 1 : -1,
	            s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	        value = Math.abs(value);
	
	        if (isNaN(value) || value === Infinity) {
	            m = isNaN(value) ? 1 : 0;
	            e = eMax;
	        } else {
	            e = Math.floor(Math.log(value) / Math.LN2);
	            if (value * (c = Math.pow(2, -e)) < 1) {
	                e--;
	                c *= 2;
	            }
	            if (e + eBias >= 1) {
	                value += rt / c;
	            } else {
	                value += rt * Math.pow(2, 1 - eBias);
	            }
	            if (value * c >= 2) {
	                e++;
	                c /= 2;
	            }
	
	            if (e + eBias >= eMax) {
	                m = 0;
	                e = eMax;
	            } else if (e + eBias >= 1) {
	                m = (value * c - 1) * Math.pow(2, mLen);
	                e = e + eBias;
	            } else {
	                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	                e = 0;
	            }
	        }
	
	        for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	        e = e << mLen | m;
	        eLen += mLen;
	        for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	        buffer[offset + i - d] |= s * 128;
	    }
	
	    /**
	     * Writes a 32bit float.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeFloat32 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number') throw TypeError("Illegal value: " + value + " (not a number)");
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 4;
	        var capacity8 = this.buffer.byteLength;
	        if (offset > capacity8) this.resize((capacity8 *= 2) > offset ? capacity8 : offset);
	        offset -= 4;
	        ieee754_write(this.view, value, offset, this.littleEndian, 23, 4);
	        if (relative) this.offset += 4;
	        return this;
	    };
	
	    /**
	     * Writes a 32bit float. This is an alias of {@link ByteBuffer#writeFloat32}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeFloat = ByteBufferPrototype.writeFloat32;
	
	    /**
	     * Reads a 32bit float.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number}
	     * @expose
	     */
	    ByteBufferPrototype.readFloat32 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 4 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 4 + ") <= " + this.buffer.byteLength);
	        }
	        var value = ieee754_read(this.view, offset, this.littleEndian, 23, 4);
	        if (relative) this.offset += 4;
	        return value;
	    };
	
	    /**
	     * Reads a 32bit float. This is an alias of {@link ByteBuffer#readFloat32}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
	     * @returns {number}
	     * @expose
	     */
	    ByteBufferPrototype.readFloat = ByteBufferPrototype.readFloat32;
	
	    // types/floats/float64
	
	    /**
	     * Writes a 64bit float.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeFloat64 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number') throw TypeError("Illegal value: " + value + " (not a number)");
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        offset += 8;
	        var capacity9 = this.buffer.byteLength;
	        if (offset > capacity9) this.resize((capacity9 *= 2) > offset ? capacity9 : offset);
	        offset -= 8;
	        ieee754_write(this.view, value, offset, this.littleEndian, 52, 8);
	        if (relative) this.offset += 8;
	        return this;
	    };
	
	    /**
	     * Writes a 64bit float. This is an alias of {@link ByteBuffer#writeFloat64}.
	     * @function
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.writeDouble = ByteBufferPrototype.writeFloat64;
	
	    /**
	     * Reads a 64bit float.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	     * @returns {number}
	     * @expose
	     */
	    ByteBufferPrototype.readFloat64 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 8 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 8 + ") <= " + this.buffer.byteLength);
	        }
	        var value = ieee754_read(this.view, offset, this.littleEndian, 52, 8);
	        if (relative) this.offset += 8;
	        return value;
	    };
	
	    /**
	     * Reads a 64bit float. This is an alias of {@link ByteBuffer#readFloat64}.
	     * @function
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
	     * @returns {number}
	     * @expose
	     */
	    ByteBufferPrototype.readDouble = ByteBufferPrototype.readFloat64;
	
	    // types/varints/varint32
	
	    /**
	     * Maximum number of bytes required to store a 32bit base 128 variable-length integer.
	     * @type {number}
	     * @const
	     * @expose
	     */
	    ByteBuffer.MAX_VARINT32_BYTES = 5;
	
	    /**
	     * Calculates the actual number of bytes required to store a 32bit base 128 variable-length integer.
	     * @param {number} value Value to encode
	     * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT32_BYTES}
	     * @expose
	     */
	    ByteBuffer.calculateVarint32 = function (value) {
	        // ref: src/google/protobuf/io/coded_stream.cc
	        value = value >>> 0;
	        if (value < 1 << 7) return 1;else if (value < 1 << 14) return 2;else if (value < 1 << 21) return 3;else if (value < 1 << 28) return 4;else return 5;
	    };
	
	    /**
	     * Zigzag encodes a signed 32bit integer so that it can be effectively used with varint encoding.
	     * @param {number} n Signed 32bit integer
	     * @returns {number} Unsigned zigzag encoded 32bit integer
	     * @expose
	     */
	    ByteBuffer.zigZagEncode32 = function (n) {
	        return ((n |= 0) << 1 ^ n >> 31) >>> 0; // ref: src/google/protobuf/wire_format_lite.h
	    };
	
	    /**
	     * Decodes a zigzag encoded signed 32bit integer.
	     * @param {number} n Unsigned zigzag encoded 32bit integer
	     * @returns {number} Signed 32bit integer
	     * @expose
	     */
	    ByteBuffer.zigZagDecode32 = function (n) {
	        return n >>> 1 ^ -(n & 1) | 0; // // ref: src/google/protobuf/wire_format_lite.h
	    };
	
	    /**
	     * Writes a 32bit base 128 variable-length integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
	     * @expose
	     */
	    ByteBufferPrototype.writeVarint32 = function (value, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value |= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        var size = ByteBuffer.calculateVarint32(value),
	            b;
	        offset += size;
	        var capacity10 = this.buffer.byteLength;
	        if (offset > capacity10) this.resize((capacity10 *= 2) > offset ? capacity10 : offset);
	        offset -= size;
	        value >>>= 0;
	        while (value >= 0x80) {
	            b = value & 0x7f | 0x80;
	            this.view[offset++] = b;
	            value >>>= 7;
	        }
	        this.view[offset++] = value;
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return size;
	    };
	
	    /**
	     * Writes a zig-zag encoded (signed) 32bit base 128 variable-length integer.
	     * @param {number} value Value to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
	     * @expose
	     */
	    ByteBufferPrototype.writeVarint32ZigZag = function (value, offset) {
	        return this.writeVarint32(ByteBuffer.zigZagEncode32(value), offset);
	    };
	
	    /**
	     * Reads a 32bit base 128 variable-length integer.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
	     *  and the actual number of bytes read.
	     * @throws {Error} If it's not a valid varint. Has a property `truncated = true` if there is not enough data available
	     *  to fully decode the varint.
	     * @expose
	     */
	    ByteBufferPrototype.readVarint32 = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	        }
	        var c = 0,
	            value = 0 >>> 0,
	            b;
	        do {
	            if (!this.noAssert && offset > this.limit) {
	                var err = Error("Truncated");
	                err['truncated'] = true;
	                throw err;
	            }
	            b = this.view[offset++];
	            if (c < 5) value |= (b & 0x7f) << 7 * c;
	            ++c;
	        } while ((b & 0x80) !== 0);
	        value |= 0;
	        if (relative) {
	            this.offset = offset;
	            return value;
	        }
	        return {
	            "value": value,
	            "length": c
	        };
	    };
	
	    /**
	     * Reads a zig-zag encoded (signed) 32bit base 128 variable-length integer.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
	     *  and the actual number of bytes read.
	     * @throws {Error} If it's not a valid varint
	     * @expose
	     */
	    ByteBufferPrototype.readVarint32ZigZag = function (offset) {
	        var val = this.readVarint32(offset);
	        if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === 'object') val["value"] = ByteBuffer.zigZagDecode32(val["value"]);else val = ByteBuffer.zigZagDecode32(val);
	        return val;
	    };
	
	    // types/varints/varint64
	
	    if (Long) {
	
	        /**
	         * Maximum number of bytes required to store a 64bit base 128 variable-length integer.
	         * @type {number}
	         * @const
	         * @expose
	         */
	        ByteBuffer.MAX_VARINT64_BYTES = 10;
	
	        /**
	         * Calculates the actual number of bytes required to store a 64bit base 128 variable-length integer.
	         * @param {number|!Long} value Value to encode
	         * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT64_BYTES}
	         * @expose
	         */
	        ByteBuffer.calculateVarint64 = function (value) {
	            if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);
	            // ref: src/google/protobuf/io/coded_stream.cc
	            var part0 = value.toInt() >>> 0,
	                part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
	                part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
	            if (part2 == 0) {
	                if (part1 == 0) {
	                    if (part0 < 1 << 14) return part0 < 1 << 7 ? 1 : 2;else return part0 < 1 << 21 ? 3 : 4;
	                } else {
	                    if (part1 < 1 << 14) return part1 < 1 << 7 ? 5 : 6;else return part1 < 1 << 21 ? 7 : 8;
	                }
	            } else return part2 < 1 << 7 ? 9 : 10;
	        };
	
	        /**
	         * Zigzag encodes a signed 64bit integer so that it can be effectively used with varint encoding.
	         * @param {number|!Long} value Signed long
	         * @returns {!Long} Unsigned zigzag encoded long
	         * @expose
	         */
	        ByteBuffer.zigZagEncode64 = function (value) {
	            if (typeof value === 'number') value = Long.fromNumber(value, false);else if (typeof value === 'string') value = Long.fromString(value, false);else if (value.unsigned !== false) value = value.toSigned();
	            // ref: src/google/protobuf/wire_format_lite.h
	            return value.shiftLeft(1).xor(value.shiftRight(63)).toUnsigned();
	        };
	
	        /**
	         * Decodes a zigzag encoded signed 64bit integer.
	         * @param {!Long|number} value Unsigned zigzag encoded long or JavaScript number
	         * @returns {!Long} Signed long
	         * @expose
	         */
	        ByteBuffer.zigZagDecode64 = function (value) {
	            if (typeof value === 'number') value = Long.fromNumber(value, false);else if (typeof value === 'string') value = Long.fromString(value, false);else if (value.unsigned !== false) value = value.toSigned();
	            // ref: src/google/protobuf/wire_format_lite.h
	            return value.shiftRightUnsigned(1).xor(value.and(Long.ONE).toSigned().negate()).toSigned();
	        };
	
	        /**
	         * Writes a 64bit base 128 variable-length integer.
	         * @param {number|Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	         *  written if omitted.
	         * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
	         * @expose
	         */
	        ByteBufferPrototype.writeVarint64 = function (value, offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof value === 'number') value = Long.fromNumber(value);else if (typeof value === 'string') value = Long.fromString(value);else if (!(value && value instanceof Long)) throw TypeError("Illegal value: " + value + " (not an integer or Long)");
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	            }
	            if (typeof value === 'number') value = Long.fromNumber(value, false);else if (typeof value === 'string') value = Long.fromString(value, false);else if (value.unsigned !== false) value = value.toSigned();
	            var size = ByteBuffer.calculateVarint64(value),
	                part0 = value.toInt() >>> 0,
	                part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
	                part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
	            offset += size;
	            var capacity11 = this.buffer.byteLength;
	            if (offset > capacity11) this.resize((capacity11 *= 2) > offset ? capacity11 : offset);
	            offset -= size;
	            switch (size) {
	                case 10:
	                    this.view[offset + 9] = part2 >>> 7 & 0x01;
	                case 9:
	                    this.view[offset + 8] = size !== 9 ? part2 | 0x80 : part2 & 0x7F;
	                case 8:
	                    this.view[offset + 7] = size !== 8 ? part1 >>> 21 | 0x80 : part1 >>> 21 & 0x7F;
	                case 7:
	                    this.view[offset + 6] = size !== 7 ? part1 >>> 14 | 0x80 : part1 >>> 14 & 0x7F;
	                case 6:
	                    this.view[offset + 5] = size !== 6 ? part1 >>> 7 | 0x80 : part1 >>> 7 & 0x7F;
	                case 5:
	                    this.view[offset + 4] = size !== 5 ? part1 | 0x80 : part1 & 0x7F;
	                case 4:
	                    this.view[offset + 3] = size !== 4 ? part0 >>> 21 | 0x80 : part0 >>> 21 & 0x7F;
	                case 3:
	                    this.view[offset + 2] = size !== 3 ? part0 >>> 14 | 0x80 : part0 >>> 14 & 0x7F;
	                case 2:
	                    this.view[offset + 1] = size !== 2 ? part0 >>> 7 | 0x80 : part0 >>> 7 & 0x7F;
	                case 1:
	                    this.view[offset] = size !== 1 ? part0 | 0x80 : part0 & 0x7F;
	            }
	            if (relative) {
	                this.offset += size;
	                return this;
	            } else {
	                return size;
	            }
	        };
	
	        /**
	         * Writes a zig-zag encoded 64bit base 128 variable-length integer.
	         * @param {number|Long} value Value to write
	         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	         *  written if omitted.
	         * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
	         * @expose
	         */
	        ByteBufferPrototype.writeVarint64ZigZag = function (value, offset) {
	            return this.writeVarint64(ByteBuffer.zigZagEncode64(value), offset);
	        };
	
	        /**
	         * Reads a 64bit base 128 variable-length integer. Requires Long.js.
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	         *  read if omitted.
	         * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
	         *  the actual number of bytes read.
	         * @throws {Error} If it's not a valid varint
	         * @expose
	         */
	        ByteBufferPrototype.readVarint64 = function (offset) {
	            var relative = typeof offset === 'undefined';
	            if (relative) offset = this.offset;
	            if (!this.noAssert) {
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	            }
	            // ref: src/google/protobuf/io/coded_stream.cc
	            var start = offset,
	                part0 = 0,
	                part1 = 0,
	                part2 = 0,
	                b = 0;
	            b = this.view[offset++];part0 = b & 0x7F;if (b & 0x80) {
	                b = this.view[offset++];part0 |= (b & 0x7F) << 7;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                    b = this.view[offset++];part0 |= (b & 0x7F) << 14;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                        b = this.view[offset++];part0 |= (b & 0x7F) << 21;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                            b = this.view[offset++];part1 = b & 0x7F;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                b = this.view[offset++];part1 |= (b & 0x7F) << 7;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                    b = this.view[offset++];part1 |= (b & 0x7F) << 14;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                        b = this.view[offset++];part1 |= (b & 0x7F) << 21;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                            b = this.view[offset++];part2 = b & 0x7F;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                                b = this.view[offset++];part2 |= (b & 0x7F) << 7;if (b & 0x80 || this.noAssert && typeof b === 'undefined') {
	                                                    throw Error("Buffer overrun");
	                                                }
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            var value = Long.fromBits(part0 | part1 << 28, part1 >>> 4 | part2 << 24, false);
	            if (relative) {
	                this.offset = offset;
	                return value;
	            } else {
	                return {
	                    'value': value,
	                    'length': offset - start
	                };
	            }
	        };
	
	        /**
	         * Reads a zig-zag encoded 64bit base 128 variable-length integer. Requires Long.js.
	         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	         *  read if omitted.
	         * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
	         *  the actual number of bytes read.
	         * @throws {Error} If it's not a valid varint
	         * @expose
	         */
	        ByteBufferPrototype.readVarint64ZigZag = function (offset) {
	            var val = this.readVarint64(offset);
	            if (val && val['value'] instanceof Long) val["value"] = ByteBuffer.zigZagDecode64(val["value"]);else val = ByteBuffer.zigZagDecode64(val);
	            return val;
	        };
	    } // Long
	
	
	    // types/strings/cstring
	
	    /**
	     * Writes a NULL-terminated UTF8 encoded string. For this to work the specified string must not contain any NULL
	     *  characters itself.
	     * @param {string} str String to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  contained in `str` + 1 if omitted.
	     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written
	     * @expose
	     */
	    ByteBufferPrototype.writeCString = function (str, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        var i,
	            k = str.length;
	        if (!this.noAssert) {
	            if (typeof str !== 'string') throw TypeError("Illegal str: Not a string");
	            for (i = 0; i < k; ++i) {
	                if (str.charCodeAt(i) === 0) throw RangeError("Illegal str: Contains NULL-characters");
	            }
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        // UTF8 strings do not contain zero bytes in between except for the zero character, so:
	        k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
	        offset += k + 1;
	        var capacity12 = this.buffer.byteLength;
	        if (offset > capacity12) this.resize((capacity12 *= 2) > offset ? capacity12 : offset);
	        offset -= k + 1;
	        utfx.encodeUTF16toUTF8(stringSource(str), function (b) {
	            this.view[offset++] = b;
	        }.bind(this));
	        this.view[offset++] = 0;
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return k;
	    };
	
	    /**
	     * Reads a NULL-terminated UTF8 encoded string. For this to work the string read must not contain any NULL characters
	     *  itself.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
	     *  read and the actual number of bytes read.
	     * @expose
	     */
	    ByteBufferPrototype.readCString = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	        }
	        var start = offset,
	            temp;
	        // UTF8 strings do not contain zero bytes in between except for the zero character itself, so:
	        var sd,
	            b = -1;
	        utfx.decodeUTF8toUTF16(function () {
	            if (b === 0) return null;
	            if (offset >= this.limit) throw RangeError("Illegal range: Truncated data, " + offset + " < " + this.limit);
	            b = this.view[offset++];
	            return b === 0 ? null : b;
	        }.bind(this), sd = stringDestination(), true);
	        if (relative) {
	            this.offset = offset;
	            return sd();
	        } else {
	            return {
	                "string": sd(),
	                "length": offset - start
	            };
	        }
	    };
	
	    // types/strings/istring
	
	    /**
	     * Writes a length as uint32 prefixed UTF8 encoded string.
	     * @param {string} str String to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
	     * @expose
	     * @see ByteBuffer#writeVarint32
	     */
	    ByteBufferPrototype.writeIString = function (str, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof str !== 'string') throw TypeError("Illegal str: Not a string");
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        var start = offset,
	            k;
	        k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
	        offset += 4 + k;
	        var capacity13 = this.buffer.byteLength;
	        if (offset > capacity13) this.resize((capacity13 *= 2) > offset ? capacity13 : offset);
	        offset -= 4 + k;
	        if (this.littleEndian) {
	            this.view[offset + 3] = k >>> 24 & 0xFF;
	            this.view[offset + 2] = k >>> 16 & 0xFF;
	            this.view[offset + 1] = k >>> 8 & 0xFF;
	            this.view[offset] = k & 0xFF;
	        } else {
	            this.view[offset] = k >>> 24 & 0xFF;
	            this.view[offset + 1] = k >>> 16 & 0xFF;
	            this.view[offset + 2] = k >>> 8 & 0xFF;
	            this.view[offset + 3] = k & 0xFF;
	        }
	        offset += 4;
	        utfx.encodeUTF16toUTF8(stringSource(str), function (b) {
	            this.view[offset++] = b;
	        }.bind(this));
	        if (offset !== start + 4 + k) throw RangeError("Illegal range: Truncated data, " + offset + " == " + (offset + 4 + k));
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return offset - start;
	    };
	
	    /**
	     * Reads a length as uint32 prefixed UTF8 encoded string.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
	     *  read and the actual number of bytes read.
	     * @expose
	     * @see ByteBuffer#readVarint32
	     */
	    ByteBufferPrototype.readIString = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 4 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 4 + ") <= " + this.buffer.byteLength);
	        }
	        var start = offset;
	        var len = this.readUint32(offset);
	        var str = this.readUTF8String(len, ByteBuffer.METRICS_BYTES, offset += 4);
	        offset += str['length'];
	        if (relative) {
	            this.offset = offset;
	            return str['string'];
	        } else {
	            return {
	                'string': str['string'],
	                'length': offset - start
	            };
	        }
	    };
	
	    // types/strings/utf8string
	
	    /**
	     * Metrics representing number of UTF8 characters. Evaluates to `c`.
	     * @type {string}
	     * @const
	     * @expose
	     */
	    ByteBuffer.METRICS_CHARS = 'c';
	
	    /**
	     * Metrics representing number of bytes. Evaluates to `b`.
	     * @type {string}
	     * @const
	     * @expose
	     */
	    ByteBuffer.METRICS_BYTES = 'b';
	
	    /**
	     * Writes an UTF8 encoded string.
	     * @param {string} str String to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
	     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
	     * @expose
	     */
	    ByteBufferPrototype.writeUTF8String = function (str, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        var k;
	        var start = offset;
	        k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
	        offset += k;
	        var capacity14 = this.buffer.byteLength;
	        if (offset > capacity14) this.resize((capacity14 *= 2) > offset ? capacity14 : offset);
	        offset -= k;
	        utfx.encodeUTF16toUTF8(stringSource(str), function (b) {
	            this.view[offset++] = b;
	        }.bind(this));
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return offset - start;
	    };
	
	    /**
	     * Writes an UTF8 encoded string. This is an alias of {@link ByteBuffer#writeUTF8String}.
	     * @function
	     * @param {string} str String to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
	     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
	     * @expose
	     */
	    ByteBufferPrototype.writeString = ByteBufferPrototype.writeUTF8String;
	
	    /**
	     * Calculates the number of UTF8 characters of a string. JavaScript itself uses UTF-16, so that a string's
	     *  `length` property does not reflect its actual UTF8 size if it contains code points larger than 0xFFFF.
	     * @param {string} str String to calculate
	     * @returns {number} Number of UTF8 characters
	     * @expose
	     */
	    ByteBuffer.calculateUTF8Chars = function (str) {
	        return utfx.calculateUTF16asUTF8(stringSource(str))[0];
	    };
	
	    /**
	     * Calculates the number of UTF8 bytes of a string.
	     * @param {string} str String to calculate
	     * @returns {number} Number of UTF8 bytes
	     * @expose
	     */
	    ByteBuffer.calculateUTF8Bytes = function (str) {
	        return utfx.calculateUTF16asUTF8(stringSource(str))[1];
	    };
	
	    /**
	     * Calculates the number of UTF8 bytes of a string. This is an alias of {@link ByteBuffer.calculateUTF8Bytes}.
	     * @function
	     * @param {string} str String to calculate
	     * @returns {number} Number of UTF8 bytes
	     * @expose
	     */
	    ByteBuffer.calculateString = ByteBuffer.calculateUTF8Bytes;
	
	    /**
	     * Reads an UTF8 encoded string.
	     * @param {number} length Number of characters or bytes to read.
	     * @param {string=} metrics Metrics specifying what `length` is meant to count. Defaults to
	     *  {@link ByteBuffer.METRICS_CHARS}.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
	     *  read and the actual number of bytes read.
	     * @expose
	     */
	    ByteBufferPrototype.readUTF8String = function (length, metrics, offset) {
	        if (typeof metrics === 'number') {
	            offset = metrics;
	            metrics = undefined;
	        }
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (typeof metrics === 'undefined') metrics = ByteBuffer.METRICS_CHARS;
	        if (!this.noAssert) {
	            if (typeof length !== 'number' || length % 1 !== 0) throw TypeError("Illegal length: " + length + " (not an integer)");
	            length |= 0;
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        var i = 0,
	            start = offset,
	            sd;
	        if (metrics === ByteBuffer.METRICS_CHARS) {
	            // The same for node and the browser
	            sd = stringDestination();
	            utfx.decodeUTF8(function () {
	                return i < length && offset < this.limit ? this.view[offset++] : null;
	            }.bind(this), function (cp) {
	                ++i;utfx.UTF8toUTF16(cp, sd);
	            });
	            if (i !== length) throw RangeError("Illegal range: Truncated data, " + i + " == " + length);
	            if (relative) {
	                this.offset = offset;
	                return sd();
	            } else {
	                return {
	                    "string": sd(),
	                    "length": offset - start
	                };
	            }
	        } else if (metrics === ByteBuffer.METRICS_BYTES) {
	            if (!this.noAssert) {
	                if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	                offset >>>= 0;
	                if (offset < 0 || offset + length > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + length + ") <= " + this.buffer.byteLength);
	            }
	            var k = offset + length;
	            utfx.decodeUTF8toUTF16(function () {
	                return offset < k ? this.view[offset++] : null;
	            }.bind(this), sd = stringDestination(), this.noAssert);
	            if (offset !== k) throw RangeError("Illegal range: Truncated data, " + offset + " == " + k);
	            if (relative) {
	                this.offset = offset;
	                return sd();
	            } else {
	                return {
	                    'string': sd(),
	                    'length': offset - start
	                };
	            }
	        } else throw TypeError("Unsupported metrics: " + metrics);
	    };
	
	    /**
	     * Reads an UTF8 encoded string. This is an alias of {@link ByteBuffer#readUTF8String}.
	     * @function
	     * @param {number} length Number of characters or bytes to read
	     * @param {number=} metrics Metrics specifying what `n` is meant to count. Defaults to
	     *  {@link ByteBuffer.METRICS_CHARS}.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
	     *  read and the actual number of bytes read.
	     * @expose
	     */
	    ByteBufferPrototype.readString = ByteBufferPrototype.readUTF8String;
	
	    // types/strings/vstring
	
	    /**
	     * Writes a length as varint32 prefixed UTF8 encoded string.
	     * @param {string} str String to write
	     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
	     * @expose
	     * @see ByteBuffer#writeVarint32
	     */
	    ByteBufferPrototype.writeVString = function (str, offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof str !== 'string') throw TypeError("Illegal str: Not a string");
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        var start = offset,
	            k,
	            l;
	        k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
	        l = ByteBuffer.calculateVarint32(k);
	        offset += l + k;
	        var capacity15 = this.buffer.byteLength;
	        if (offset > capacity15) this.resize((capacity15 *= 2) > offset ? capacity15 : offset);
	        offset -= l + k;
	        offset += this.writeVarint32(k, offset);
	        utfx.encodeUTF16toUTF8(stringSource(str), function (b) {
	            this.view[offset++] = b;
	        }.bind(this));
	        if (offset !== start + k + l) throw RangeError("Illegal range: Truncated data, " + offset + " == " + (offset + k + l));
	        if (relative) {
	            this.offset = offset;
	            return this;
	        }
	        return offset - start;
	    };
	
	    /**
	     * Reads a length as varint32 prefixed UTF8 encoded string.
	     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
	     *  read and the actual number of bytes read.
	     * @expose
	     * @see ByteBuffer#readVarint32
	     */
	    ByteBufferPrototype.readVString = function (offset) {
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 1 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 1 + ") <= " + this.buffer.byteLength);
	        }
	        var start = offset;
	        var len = this.readVarint32(offset);
	        var str = this.readUTF8String(len['value'], ByteBuffer.METRICS_BYTES, offset += len['length']);
	        offset += str['length'];
	        if (relative) {
	            this.offset = offset;
	            return str['string'];
	        } else {
	            return {
	                'string': str['string'],
	                'length': offset - start
	            };
	        }
	    };
	
	    /**
	     * Appends some data to this ByteBuffer. This will overwrite any contents behind the specified offset up to the appended
	     *  data's length.
	     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to append. If `source` is a ByteBuffer, its offsets
	     *  will be modified according to the performed read operation.
	     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
	     * @param {number=} offset Offset to append at. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     * @example A relative `<01 02>03.append(<04 05>)` will result in `<01 02 04 05>, 04 05|`
	     * @example An absolute `<01 02>03.append(04 05>, 1)` will result in `<01 04>05, 04 05|`
	     */
	    ByteBufferPrototype.append = function (source, encoding, offset) {
	        if (typeof encoding === 'number' || typeof encoding !== 'string') {
	            offset = encoding;
	            encoding = undefined;
	        }
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        if (!(source instanceof ByteBuffer)) source = ByteBuffer.wrap(source, encoding);
	        var length = source.limit - source.offset;
	        if (length <= 0) return this; // Nothing to append
	        offset += length;
	        var capacity16 = this.buffer.byteLength;
	        if (offset > capacity16) this.resize((capacity16 *= 2) > offset ? capacity16 : offset);
	        offset -= length;
	        this.view.set(source.view.subarray(source.offset, source.limit), offset);
	        source.offset += length;
	        if (relative) this.offset += length;
	        return this;
	    };
	
	    /**
	     * Appends this ByteBuffer's contents to another ByteBuffer. This will overwrite any contents at and after the
	        specified offset up to the length of this ByteBuffer's data.
	     * @param {!ByteBuffer} target Target ByteBuffer
	     * @param {number=} offset Offset to append to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  read if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     * @see ByteBuffer#append
	     */
	    ByteBufferPrototype.appendTo = function (target, offset) {
	        target.append(this, offset);
	        return this;
	    };
	
	    /**
	     * Enables or disables assertions of argument types and offsets. Assertions are enabled by default but you can opt to
	     *  disable them if your code already makes sure that everything is valid.
	     * @param {boolean} assert `true` to enable assertions, otherwise `false`
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.assert = function (assert) {
	        this.noAssert = !assert;
	        return this;
	    };
	
	    /**
	     * Gets the capacity of this ByteBuffer's backing buffer.
	     * @returns {number} Capacity of the backing buffer
	     * @expose
	     */
	    ByteBufferPrototype.capacity = function () {
	        return this.buffer.byteLength;
	    };
	    /**
	     * Clears this ByteBuffer's offsets by setting {@link ByteBuffer#offset} to `0` and {@link ByteBuffer#limit} to the
	     *  backing buffer's capacity. Discards {@link ByteBuffer#markedOffset}.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.clear = function () {
	        this.offset = 0;
	        this.limit = this.buffer.byteLength;
	        this.markedOffset = -1;
	        return this;
	    };
	
	    /**
	     * Creates a cloned instance of this ByteBuffer, preset with this ByteBuffer's values for {@link ByteBuffer#offset},
	     *  {@link ByteBuffer#markedOffset} and {@link ByteBuffer#limit}.
	     * @param {boolean=} copy Whether to copy the backing buffer or to return another view on the same, defaults to `false`
	     * @returns {!ByteBuffer} Cloned instance
	     * @expose
	     */
	    ByteBufferPrototype.clone = function (copy) {
	        var bb = new ByteBuffer(0, this.littleEndian, this.noAssert);
	        if (copy) {
	            bb.buffer = new ArrayBuffer(this.buffer.byteLength);
	            bb.view = new Uint8Array(bb.buffer);
	        } else {
	            bb.buffer = this.buffer;
	            bb.view = this.view;
	        }
	        bb.offset = this.offset;
	        bb.markedOffset = this.markedOffset;
	        bb.limit = this.limit;
	        return bb;
	    };
	
	    /**
	     * Compacts this ByteBuffer to be backed by a {@link ByteBuffer#buffer} of its contents' length. Contents are the bytes
	     *  between {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will set `offset = 0` and `limit = capacity` and
	     *  adapt {@link ByteBuffer#markedOffset} to the same relative position if set.
	     * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
	     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.compact = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        if (begin === 0 && end === this.buffer.byteLength) return this; // Already compacted
	        var len = end - begin;
	        if (len === 0) {
	            this.buffer = EMPTY_BUFFER;
	            this.view = null;
	            if (this.markedOffset >= 0) this.markedOffset -= begin;
	            this.offset = 0;
	            this.limit = 0;
	            return this;
	        }
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        view.set(this.view.subarray(begin, end));
	        this.buffer = buffer;
	        this.view = view;
	        if (this.markedOffset >= 0) this.markedOffset -= begin;
	        this.offset = 0;
	        this.limit = len;
	        return this;
	    };
	
	    /**
	     * Creates a copy of this ByteBuffer's contents. Contents are the bytes between {@link ByteBuffer#offset} and
	     *  {@link ByteBuffer#limit}.
	     * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
	     * @returns {!ByteBuffer} Copy
	     * @expose
	     */
	    ByteBufferPrototype.copy = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        if (begin === end) return new ByteBuffer(0, this.littleEndian, this.noAssert);
	        var capacity = end - begin,
	            bb = new ByteBuffer(capacity, this.littleEndian, this.noAssert);
	        bb.offset = 0;
	        bb.limit = capacity;
	        if (bb.markedOffset >= 0) bb.markedOffset -= begin;
	        this.copyTo(bb, 0, begin, end);
	        return bb;
	    };
	
	    /**
	     * Copies this ByteBuffer's contents to another ByteBuffer. Contents are the bytes between {@link ByteBuffer#offset} and
	     *  {@link ByteBuffer#limit}.
	     * @param {!ByteBuffer} target Target ByteBuffer
	     * @param {number=} targetOffset Offset to copy to. Will use and increase the target's {@link ByteBuffer#offset}
	     *  by the number of bytes copied if omitted.
	     * @param {number=} sourceOffset Offset to start copying from. Will use and increase {@link ByteBuffer#offset} by the
	     *  number of bytes copied if omitted.
	     * @param {number=} sourceLimit Offset to end copying from, defaults to {@link ByteBuffer#limit}
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.copyTo = function (target, targetOffset, sourceOffset, sourceLimit) {
	        var relative, targetRelative;
	        if (!this.noAssert) {
	            if (!ByteBuffer.isByteBuffer(target)) throw TypeError("Illegal target: Not a ByteBuffer");
	        }
	        targetOffset = (targetRelative = typeof targetOffset === 'undefined') ? target.offset : targetOffset | 0;
	        sourceOffset = (relative = typeof sourceOffset === 'undefined') ? this.offset : sourceOffset | 0;
	        sourceLimit = typeof sourceLimit === 'undefined' ? this.limit : sourceLimit | 0;
	
	        if (targetOffset < 0 || targetOffset > target.buffer.byteLength) throw RangeError("Illegal target range: 0 <= " + targetOffset + " <= " + target.buffer.byteLength);
	        if (sourceOffset < 0 || sourceLimit > this.buffer.byteLength) throw RangeError("Illegal source range: 0 <= " + sourceOffset + " <= " + this.buffer.byteLength);
	
	        var len = sourceLimit - sourceOffset;
	        if (len === 0) return target; // Nothing to copy
	
	        target.ensureCapacity(targetOffset + len);
	
	        target.view.set(this.view.subarray(sourceOffset, sourceLimit), targetOffset);
	
	        if (relative) this.offset += len;
	        if (targetRelative) target.offset += len;
	
	        return this;
	    };
	
	    /**
	     * Makes sure that this ByteBuffer is backed by a {@link ByteBuffer#buffer} of at least the specified capacity. If the
	     *  current capacity is exceeded, it will be doubled. If double the current capacity is less than the required capacity,
	     *  the required capacity will be used instead.
	     * @param {number} capacity Required capacity
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.ensureCapacity = function (capacity) {
	        var current = this.buffer.byteLength;
	        if (current < capacity) return this.resize((current *= 2) > capacity ? current : capacity);
	        return this;
	    };
	
	    /**
	     * Overwrites this ByteBuffer's contents with the specified value. Contents are the bytes between
	     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
	     * @param {number|string} value Byte value to fill with. If given as a string, the first character is used.
	     * @param {number=} begin Begin offset. Will use and increase {@link ByteBuffer#offset} by the number of bytes
	     *  written if omitted. defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
	     * @returns {!ByteBuffer} this
	     * @expose
	     * @example `someByteBuffer.clear().fill(0)` fills the entire backing buffer with zeroes
	     */
	    ByteBufferPrototype.fill = function (value, begin, end) {
	        var relative = typeof begin === 'undefined';
	        if (relative) begin = this.offset;
	        if (typeof value === 'string' && value.length > 0) value = value.charCodeAt(0);
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof value !== 'number' || value % 1 !== 0) throw TypeError("Illegal value: " + value + " (not an integer)");
	            value |= 0;
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        if (begin >= end) return this; // Nothing to fill
	        while (begin < end) {
	            this.view[begin++] = value;
	        }if (relative) this.offset = begin;
	        return this;
	    };
	
	    /**
	     * Makes this ByteBuffer ready for a new sequence of write or relative read operations. Sets `limit = offset` and
	     *  `offset = 0`. Make sure always to flip a ByteBuffer when all relative read or write operations are complete.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.flip = function () {
	        this.limit = this.offset;
	        this.offset = 0;
	        return this;
	    };
	    /**
	     * Marks an offset on this ByteBuffer to be used later.
	     * @param {number=} offset Offset to mark. Defaults to {@link ByteBuffer#offset}.
	     * @returns {!ByteBuffer} this
	     * @throws {TypeError} If `offset` is not a valid number
	     * @throws {RangeError} If `offset` is out of bounds
	     * @see ByteBuffer#reset
	     * @expose
	     */
	    ByteBufferPrototype.mark = function (offset) {
	        offset = typeof offset === 'undefined' ? this.offset : offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        this.markedOffset = offset;
	        return this;
	    };
	    /**
	     * Sets the byte order.
	     * @param {boolean} littleEndian `true` for little endian byte order, `false` for big endian
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.order = function (littleEndian) {
	        if (!this.noAssert) {
	            if (typeof littleEndian !== 'boolean') throw TypeError("Illegal littleEndian: Not a boolean");
	        }
	        this.littleEndian = !!littleEndian;
	        return this;
	    };
	
	    /**
	     * Switches (to) little endian byte order.
	     * @param {boolean=} littleEndian Defaults to `true`, otherwise uses big endian
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.LE = function (littleEndian) {
	        this.littleEndian = typeof littleEndian !== 'undefined' ? !!littleEndian : true;
	        return this;
	    };
	
	    /**
	     * Switches (to) big endian byte order.
	     * @param {boolean=} bigEndian Defaults to `true`, otherwise uses little endian
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.BE = function (bigEndian) {
	        this.littleEndian = typeof bigEndian !== 'undefined' ? !bigEndian : false;
	        return this;
	    };
	    /**
	     * Prepends some data to this ByteBuffer. This will overwrite any contents before the specified offset up to the
	     *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
	     *  will be resized and its contents moved accordingly.
	     * @param {!ByteBuffer|string|!ArrayBuffer} source Data to prepend. If `source` is a ByteBuffer, its offset will be
	     *  modified according to the performed read operation.
	     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
	     * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
	     *  prepended if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     * @example A relative `00<01 02 03>.prepend(<04 05>)` results in `<04 05 01 02 03>, 04 05|`
	     * @example An absolute `00<01 02 03>.prepend(<04 05>, 2)` results in `04<05 02 03>, 04 05|`
	     */
	    ByteBufferPrototype.prepend = function (source, encoding, offset) {
	        if (typeof encoding === 'number' || typeof encoding !== 'string') {
	            offset = encoding;
	            encoding = undefined;
	        }
	        var relative = typeof offset === 'undefined';
	        if (relative) offset = this.offset;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: " + offset + " (not an integer)");
	            offset >>>= 0;
	            if (offset < 0 || offset + 0 > this.buffer.byteLength) throw RangeError("Illegal offset: 0 <= " + offset + " (+" + 0 + ") <= " + this.buffer.byteLength);
	        }
	        if (!(source instanceof ByteBuffer)) source = ByteBuffer.wrap(source, encoding);
	        var len = source.limit - source.offset;
	        if (len <= 0) return this; // Nothing to prepend
	        var diff = len - offset;
	        if (diff > 0) {
	            // Not enough space before offset, so resize + move
	            var buffer = new ArrayBuffer(this.buffer.byteLength + diff);
	            var view = new Uint8Array(buffer);
	            view.set(this.view.subarray(offset, this.buffer.byteLength), len);
	            this.buffer = buffer;
	            this.view = view;
	            this.offset += diff;
	            if (this.markedOffset >= 0) this.markedOffset += diff;
	            this.limit += diff;
	            offset += diff;
	        } else {
	            var arrayView = new Uint8Array(this.buffer);
	        }
	        this.view.set(source.view.subarray(source.offset, source.limit), offset - len);
	
	        source.offset = source.limit;
	        if (relative) this.offset -= len;
	        return this;
	    };
	
	    /**
	     * Prepends this ByteBuffer to another ByteBuffer. This will overwrite any contents before the specified offset up to the
	     *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
	     *  will be resized and its contents moved accordingly.
	     * @param {!ByteBuffer} target Target ByteBuffer
	     * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
	     *  prepended if omitted.
	     * @returns {!ByteBuffer} this
	     * @expose
	     * @see ByteBuffer#prepend
	     */
	    ByteBufferPrototype.prependTo = function (target, offset) {
	        target.prepend(this, offset);
	        return this;
	    };
	    /**
	     * Prints debug information about this ByteBuffer's contents.
	     * @param {function(string)=} out Output function to call, defaults to console.log
	     * @expose
	     */
	    ByteBufferPrototype.printDebug = function (out) {
	        if (typeof out !== 'function') out = console.log.bind(console);
	        out(this.toString() + "\n" + "-------------------------------------------------------------------\n" + this.toDebug( /* columns */true));
	    };
	
	    /**
	     * Gets the number of remaining readable bytes. Contents are the bytes between {@link ByteBuffer#offset} and
	     *  {@link ByteBuffer#limit}, so this returns `limit - offset`.
	     * @returns {number} Remaining readable bytes. May be negative if `offset > limit`.
	     * @expose
	     */
	    ByteBufferPrototype.remaining = function () {
	        return this.limit - this.offset;
	    };
	    /**
	     * Resets this ByteBuffer's {@link ByteBuffer#offset}. If an offset has been marked through {@link ByteBuffer#mark}
	     *  before, `offset` will be set to {@link ByteBuffer#markedOffset}, which will then be discarded. If no offset has been
	     *  marked, sets `offset = 0`.
	     * @returns {!ByteBuffer} this
	     * @see ByteBuffer#mark
	     * @expose
	     */
	    ByteBufferPrototype.reset = function () {
	        if (this.markedOffset >= 0) {
	            this.offset = this.markedOffset;
	            this.markedOffset = -1;
	        } else {
	            this.offset = 0;
	        }
	        return this;
	    };
	    /**
	     * Resizes this ByteBuffer to be backed by a buffer of at least the given capacity. Will do nothing if already that
	     *  large or larger.
	     * @param {number} capacity Capacity required
	     * @returns {!ByteBuffer} this
	     * @throws {TypeError} If `capacity` is not a number
	     * @throws {RangeError} If `capacity < 0`
	     * @expose
	     */
	    ByteBufferPrototype.resize = function (capacity) {
	        if (!this.noAssert) {
	            if (typeof capacity !== 'number' || capacity % 1 !== 0) throw TypeError("Illegal capacity: " + capacity + " (not an integer)");
	            capacity |= 0;
	            if (capacity < 0) throw RangeError("Illegal capacity: 0 <= " + capacity);
	        }
	        if (this.buffer.byteLength < capacity) {
	            var buffer = new ArrayBuffer(capacity);
	            var view = new Uint8Array(buffer);
	            view.set(this.view);
	            this.buffer = buffer;
	            this.view = view;
	        }
	        return this;
	    };
	    /**
	     * Reverses this ByteBuffer's contents.
	     * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
	     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.reverse = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        if (begin === end) return this; // Nothing to reverse
	        Array.prototype.reverse.call(this.view.subarray(begin, end));
	        return this;
	    };
	    /**
	     * Skips the next `length` bytes. This will just advance
	     * @param {number} length Number of bytes to skip. May also be negative to move the offset back.
	     * @returns {!ByteBuffer} this
	     * @expose
	     */
	    ByteBufferPrototype.skip = function (length) {
	        if (!this.noAssert) {
	            if (typeof length !== 'number' || length % 1 !== 0) throw TypeError("Illegal length: " + length + " (not an integer)");
	            length |= 0;
	        }
	        var offset = this.offset + length;
	        if (!this.noAssert) {
	            if (offset < 0 || offset > this.buffer.byteLength) throw RangeError("Illegal length: 0 <= " + this.offset + " + " + length + " <= " + this.buffer.byteLength);
	        }
	        this.offset = offset;
	        return this;
	    };
	
	    /**
	     * Slices this ByteBuffer by creating a cloned instance with `offset = begin` and `limit = end`.
	     * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
	     * @returns {!ByteBuffer} Clone of this ByteBuffer with slicing applied, backed by the same {@link ByteBuffer#buffer}
	     * @expose
	     */
	    ByteBufferPrototype.slice = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        var bb = this.clone();
	        bb.offset = begin;
	        bb.limit = end;
	        return bb;
	    };
	    /**
	     * Returns a copy of the backing buffer that contains this ByteBuffer's contents. Contents are the bytes between
	     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
	     * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory if
	     *  possible. Defaults to `false`
	     * @returns {!ArrayBuffer} Contents as an ArrayBuffer
	     * @expose
	     */
	    ByteBufferPrototype.toBuffer = function (forceCopy) {
	        var offset = this.offset,
	            limit = this.limit;
	        if (!this.noAssert) {
	            if (typeof offset !== 'number' || offset % 1 !== 0) throw TypeError("Illegal offset: Not an integer");
	            offset >>>= 0;
	            if (typeof limit !== 'number' || limit % 1 !== 0) throw TypeError("Illegal limit: Not an integer");
	            limit >>>= 0;
	            if (offset < 0 || offset > limit || limit > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + offset + " <= " + limit + " <= " + this.buffer.byteLength);
	        }
	        // NOTE: It's not possible to have another ArrayBuffer reference the same memory as the backing buffer. This is
	        // possible with Uint8Array#subarray only, but we have to return an ArrayBuffer by contract. So:
	        if (!forceCopy && offset === 0 && limit === this.buffer.byteLength) return this.buffer;
	        if (offset === limit) return EMPTY_BUFFER;
	        var buffer = new ArrayBuffer(limit - offset);
	        new Uint8Array(buffer).set(new Uint8Array(this.buffer).subarray(offset, limit), 0);
	        return buffer;
	    };
	
	    /**
	     * Returns a raw buffer compacted to contain this ByteBuffer's contents. Contents are the bytes between
	     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. This is an alias of {@link ByteBuffer#toBuffer}.
	     * @function
	     * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory.
	     *  Defaults to `false`
	     * @returns {!ArrayBuffer} Contents as an ArrayBuffer
	     * @expose
	     */
	    ByteBufferPrototype.toArrayBuffer = ByteBufferPrototype.toBuffer;
	
	    /**
	     * Converts the ByteBuffer's contents to a string.
	     * @param {string=} encoding Output encoding. Returns an informative string representation if omitted but also allows
	     *  direct conversion to "utf8", "hex", "base64" and "binary" encoding. "debug" returns a hex representation with
	     *  highlighted offsets.
	     * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}
	     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
	     * @returns {string} String representation
	     * @throws {Error} If `encoding` is invalid
	     * @expose
	     */
	    ByteBufferPrototype.toString = function (encoding, begin, end) {
	        if (typeof encoding === 'undefined') return "ByteBufferAB(offset=" + this.offset + ",markedOffset=" + this.markedOffset + ",limit=" + this.limit + ",capacity=" + this.capacity() + ")";
	        if (typeof encoding === 'number') encoding = "utf8", begin = encoding, end = begin;
	        switch (encoding) {
	            case "utf8":
	                return this.toUTF8(begin, end);
	            case "base64":
	                return this.toBase64(begin, end);
	            case "hex":
	                return this.toHex(begin, end);
	            case "binary":
	                return this.toBinary(begin, end);
	            case "debug":
	                return this.toDebug();
	            case "columns":
	                return this.toColumns();
	            default:
	                throw Error("Unsupported encoding: " + encoding);
	        }
	    };
	
	    // lxiv-embeddable
	
	    /**
	     * lxiv-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
	     * Released under the Apache License, Version 2.0
	     * see: https://github.com/dcodeIO/lxiv for details
	     */
	    var lxiv = function () {
	        "use strict";
	
	        /**
	         * lxiv namespace.
	         * @type {!Object.<string,*>}
	         * @exports lxiv
	         */
	
	        var lxiv = {};
	
	        /**
	         * Character codes for output.
	         * @type {!Array.<number>}
	         * @inner
	         */
	        var aout = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47];
	
	        /**
	         * Character codes for input.
	         * @type {!Array.<number>}
	         * @inner
	         */
	        var ain = [];
	        for (var i = 0, k = aout.length; i < k; ++i) {
	            ain[aout[i]] = i;
	        } /**
	           * Encodes bytes to base64 char codes.
	           * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if
	           *  there are no more bytes left.
	           * @param {!function(number)} dst Characters destination as a function successively called with each encoded char
	           *  code.
	           */
	        lxiv.encode = function (src, dst) {
	            var b, t;
	            while ((b = src()) !== null) {
	                dst(aout[b >> 2 & 0x3f]);
	                t = (b & 0x3) << 4;
	                if ((b = src()) !== null) {
	                    t |= b >> 4 & 0xf;
	                    dst(aout[(t | b >> 4 & 0xf) & 0x3f]);
	                    t = (b & 0xf) << 2;
	                    if ((b = src()) !== null) dst(aout[(t | b >> 6 & 0x3) & 0x3f]), dst(aout[b & 0x3f]);else dst(aout[t & 0x3f]), dst(61);
	                } else dst(aout[t & 0x3f]), dst(61), dst(61);
	            }
	        };
	
	        /**
	         * Decodes base64 char codes to bytes.
	         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
	         *  `null` if there are no more characters left.
	         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
	         * @throws {Error} If a character code is invalid
	         */
	        lxiv.decode = function (src, dst) {
	            var c, t1, t2;
	            function fail(c) {
	                throw Error("Illegal character code: " + c);
	            }
	            while ((c = src()) !== null) {
	                t1 = ain[c];
	                if (typeof t1 === 'undefined') fail(c);
	                if ((c = src()) !== null) {
	                    t2 = ain[c];
	                    if (typeof t2 === 'undefined') fail(c);
	                    dst(t1 << 2 >>> 0 | (t2 & 0x30) >> 4);
	                    if ((c = src()) !== null) {
	                        t1 = ain[c];
	                        if (typeof t1 === 'undefined') if (c === 61) break;else fail(c);
	                        dst((t2 & 0xf) << 4 >>> 0 | (t1 & 0x3c) >> 2);
	                        if ((c = src()) !== null) {
	                            t2 = ain[c];
	                            if (typeof t2 === 'undefined') if (c === 61) break;else fail(c);
	                            dst((t1 & 0x3) << 6 >>> 0 | t2);
	                        }
	                    }
	                }
	            }
	        };
	
	        /**
	         * Tests if a string is valid base64.
	         * @param {string} str String to test
	         * @returns {boolean} `true` if valid, otherwise `false`
	         */
	        lxiv.test = function (str) {
	            return (/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(str)
	            );
	        };
	
	        return lxiv;
	    }();
	
	    // encodings/base64
	
	    /**
	     * Encodes this ByteBuffer's contents to a base64 encoded string.
	     * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}.
	     * @returns {string} Base64 encoded string
	     * @throws {RangeError} If `begin` or `end` is out of bounds
	     * @expose
	     */
	    ByteBufferPrototype.toBase64 = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        begin = begin | 0;end = end | 0;
	        if (begin < 0 || end > this.capacity || begin > end) throw RangeError("begin, end");
	        var sd;lxiv.encode(function () {
	            return begin < end ? this.view[begin++] : null;
	        }.bind(this), sd = stringDestination());
	        return sd();
	    };
	
	    /**
	     * Decodes a base64 encoded string to a ByteBuffer.
	     * @param {string} str String to decode
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @returns {!ByteBuffer} ByteBuffer
	     * @expose
	     */
	    ByteBuffer.fromBase64 = function (str, littleEndian) {
	        if (typeof str !== 'string') throw TypeError("str");
	        var bb = new ByteBuffer(str.length / 4 * 3, littleEndian),
	            i = 0;
	        lxiv.decode(stringSource(str), function (b) {
	            bb.view[i++] = b;
	        });
	        bb.limit = i;
	        return bb;
	    };
	
	    /**
	     * Encodes a binary string to base64 like `window.btoa` does.
	     * @param {string} str Binary string
	     * @returns {string} Base64 encoded string
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa
	     * @expose
	     */
	    ByteBuffer.btoa = function (str) {
	        return ByteBuffer.fromBinary(str).toBase64();
	    };
	
	    /**
	     * Decodes a base64 encoded string to binary like `window.atob` does.
	     * @param {string} b64 Base64 encoded string
	     * @returns {string} Binary string
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.atob
	     * @expose
	     */
	    ByteBuffer.atob = function (b64) {
	        return ByteBuffer.fromBase64(b64).toBinary();
	    };
	
	    // encodings/binary
	
	    /**
	     * Encodes this ByteBuffer to a binary encoded string, that is using only characters 0x00-0xFF as bytes.
	     * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
	     * @returns {string} Binary encoded string
	     * @throws {RangeError} If `offset > limit`
	     * @expose
	     */
	    ByteBufferPrototype.toBinary = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        begin |= 0;end |= 0;
	        if (begin < 0 || end > this.capacity() || begin > end) throw RangeError("begin, end");
	        if (begin === end) return "";
	        var chars = [],
	            parts = [];
	        while (begin < end) {
	            chars.push(this.view[begin++]);
	            if (chars.length >= 1024) parts.push(String.fromCharCode.apply(String, chars)), chars = [];
	        }
	        return parts.join('') + String.fromCharCode.apply(String, chars);
	    };
	
	    /**
	     * Decodes a binary encoded string, that is using only characters 0x00-0xFF as bytes, to a ByteBuffer.
	     * @param {string} str String to decode
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @returns {!ByteBuffer} ByteBuffer
	     * @expose
	     */
	    ByteBuffer.fromBinary = function (str, littleEndian) {
	        if (typeof str !== 'string') throw TypeError("str");
	        var i = 0,
	            k = str.length,
	            charCode,
	            bb = new ByteBuffer(k, littleEndian);
	        while (i < k) {
	            charCode = str.charCodeAt(i);
	            if (charCode > 0xff) throw RangeError("illegal char code: " + charCode);
	            bb.view[i++] = charCode;
	        }
	        bb.limit = k;
	        return bb;
	    };
	
	    // encodings/debug
	
	    /**
	     * Encodes this ByteBuffer to a hex encoded string with marked offsets. Offset symbols are:
	     * * `<` : offset,
	     * * `'` : markedOffset,
	     * * `>` : limit,
	     * * `|` : offset and limit,
	     * * `[` : offset and markedOffset,
	     * * `]` : markedOffset and limit,
	     * * `!` : offset, markedOffset and limit
	     * @param {boolean=} columns If `true` returns two columns hex + ascii, defaults to `false`
	     * @returns {string|!Array.<string>} Debug string or array of lines if `asArray = true`
	     * @expose
	     * @example `>00'01 02<03` contains four bytes with `limit=0, markedOffset=1, offset=3`
	     * @example `00[01 02 03>` contains four bytes with `offset=markedOffset=1, limit=4`
	     * @example `00|01 02 03` contains four bytes with `offset=limit=1, markedOffset=-1`
	     * @example `|` contains zero bytes with `offset=limit=0, markedOffset=-1`
	     */
	    ByteBufferPrototype.toDebug = function (columns) {
	        var i = -1,
	            k = this.buffer.byteLength,
	            b,
	            hex = "",
	            asc = "",
	            out = "";
	        while (i < k) {
	            if (i !== -1) {
	                b = this.view[i];
	                if (b < 0x10) hex += "0" + b.toString(16).toUpperCase();else hex += b.toString(16).toUpperCase();
	                if (columns) asc += b > 32 && b < 127 ? String.fromCharCode(b) : '.';
	            }
	            ++i;
	            if (columns) {
	                if (i > 0 && i % 16 === 0 && i !== k) {
	                    while (hex.length < 3 * 16 + 3) {
	                        hex += " ";
	                    }out += hex + asc + "\n";
	                    hex = asc = "";
	                }
	            }
	            if (i === this.offset && i === this.limit) hex += i === this.markedOffset ? "!" : "|";else if (i === this.offset) hex += i === this.markedOffset ? "[" : "<";else if (i === this.limit) hex += i === this.markedOffset ? "]" : ">";else hex += i === this.markedOffset ? "'" : columns || i !== 0 && i !== k ? " " : "";
	        }
	        if (columns && hex !== " ") {
	            while (hex.length < 3 * 16 + 3) {
	                hex += " ";
	            }out += hex + asc + "\n";
	        }
	        return columns ? out : hex;
	    };
	
	    /**
	     * Decodes a hex encoded string with marked offsets to a ByteBuffer.
	     * @param {string} str Debug string to decode (not be generated with `columns = true`)
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer} ByteBuffer
	     * @expose
	     * @see ByteBuffer#toDebug
	     */
	    ByteBuffer.fromDebug = function (str, littleEndian, noAssert) {
	        var k = str.length,
	            bb = new ByteBuffer((k + 1) / 3 | 0, littleEndian, noAssert);
	        var i = 0,
	            j = 0,
	            ch,
	            b,
	            rs = false,
	            // Require symbol next
	        ho = false,
	            hm = false,
	            hl = false,
	            // Already has offset (ho), markedOffset (hm), limit (hl)?
	        fail = false;
	        while (i < k) {
	            switch (ch = str.charAt(i++)) {
	                case '!':
	                    if (!noAssert) {
	                        if (ho || hm || hl) {
	                            fail = true;
	                            break;
	                        }
	                        ho = hm = hl = true;
	                    }
	                    bb.offset = bb.markedOffset = bb.limit = j;
	                    rs = false;
	                    break;
	                case '|':
	                    if (!noAssert) {
	                        if (ho || hl) {
	                            fail = true;
	                            break;
	                        }
	                        ho = hl = true;
	                    }
	                    bb.offset = bb.limit = j;
	                    rs = false;
	                    break;
	                case '[':
	                    if (!noAssert) {
	                        if (ho || hm) {
	                            fail = true;
	                            break;
	                        }
	                        ho = hm = true;
	                    }
	                    bb.offset = bb.markedOffset = j;
	                    rs = false;
	                    break;
	                case '<':
	                    if (!noAssert) {
	                        if (ho) {
	                            fail = true;
	                            break;
	                        }
	                        ho = true;
	                    }
	                    bb.offset = j;
	                    rs = false;
	                    break;
	                case ']':
	                    if (!noAssert) {
	                        if (hl || hm) {
	                            fail = true;
	                            break;
	                        }
	                        hl = hm = true;
	                    }
	                    bb.limit = bb.markedOffset = j;
	                    rs = false;
	                    break;
	                case '>':
	                    if (!noAssert) {
	                        if (hl) {
	                            fail = true;
	                            break;
	                        }
	                        hl = true;
	                    }
	                    bb.limit = j;
	                    rs = false;
	                    break;
	                case "'":
	                    if (!noAssert) {
	                        if (hm) {
	                            fail = true;
	                            break;
	                        }
	                        hm = true;
	                    }
	                    bb.markedOffset = j;
	                    rs = false;
	                    break;
	                case ' ':
	                    rs = false;
	                    break;
	                default:
	                    if (!noAssert) {
	                        if (rs) {
	                            fail = true;
	                            break;
	                        }
	                    }
	                    b = parseInt(ch + str.charAt(i++), 16);
	                    if (!noAssert) {
	                        if (isNaN(b) || b < 0 || b > 255) throw TypeError("Illegal str: Not a debug encoded string");
	                    }
	                    bb.view[j++] = b;
	                    rs = true;
	            }
	            if (fail) throw TypeError("Illegal str: Invalid symbol at " + i);
	        }
	        if (!noAssert) {
	            if (!ho || !hl) throw TypeError("Illegal str: Missing offset or limit");
	            if (j < bb.buffer.byteLength) throw TypeError("Illegal str: Not a debug encoded string (is it hex?) " + j + " < " + k);
	        }
	        return bb;
	    };
	
	    // encodings/hex
	
	    /**
	     * Encodes this ByteBuffer's contents to a hex encoded string.
	     * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
	     * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
	     * @returns {string} Hex encoded string
	     * @expose
	     */
	    ByteBufferPrototype.toHex = function (begin, end) {
	        begin = typeof begin === 'undefined' ? this.offset : begin;
	        end = typeof end === 'undefined' ? this.limit : end;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        var out = new Array(end - begin),
	            b;
	        while (begin < end) {
	            b = this.view[begin++];
	            if (b < 0x10) out.push("0", b.toString(16));else out.push(b.toString(16));
	        }
	        return out.join('');
	    };
	
	    /**
	     * Decodes a hex encoded string to a ByteBuffer.
	     * @param {string} str String to decode
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer} ByteBuffer
	     * @expose
	     */
	    ByteBuffer.fromHex = function (str, littleEndian, noAssert) {
	        if (!noAssert) {
	            if (typeof str !== 'string') throw TypeError("Illegal str: Not a string");
	            if (str.length % 2 !== 0) throw TypeError("Illegal str: Length not a multiple of 2");
	        }
	        var k = str.length,
	            bb = new ByteBuffer(k / 2 | 0, littleEndian),
	            b;
	        for (var i = 0, j = 0; i < k; i += 2) {
	            b = parseInt(str.substring(i, i + 2), 16);
	            if (!noAssert) if (!isFinite(b) || b < 0 || b > 255) throw TypeError("Illegal str: Contains non-hex characters");
	            bb.view[j++] = b;
	        }
	        bb.limit = j;
	        return bb;
	    };
	
	    // utfx-embeddable
	
	    /**
	     * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
	     * Released under the Apache License, Version 2.0
	     * see: https://github.com/dcodeIO/utfx for details
	     */
	    var utfx = function () {
	        "use strict";
	
	        /**
	         * utfx namespace.
	         * @inner
	         * @type {!Object.<string,*>}
	         */
	
	        var utfx = {};
	
	        /**
	         * Maximum valid code point.
	         * @type {number}
	         * @const
	         */
	        utfx.MAX_CODEPOINT = 0x10FFFF;
	
	        /**
	         * Encodes UTF8 code points to UTF8 bytes.
	         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
	         *  respectively `null` if there are no more code points left or a single numeric code point.
	         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
	         */
	        utfx.encodeUTF8 = function (src, dst) {
	            var cp = null;
	            if (typeof src === 'number') cp = src, src = function src() {
	                return null;
	            };
	            while (cp !== null || (cp = src()) !== null) {
	                if (cp < 0x80) dst(cp & 0x7F);else if (cp < 0x800) dst(cp >> 6 & 0x1F | 0xC0), dst(cp & 0x3F | 0x80);else if (cp < 0x10000) dst(cp >> 12 & 0x0F | 0xE0), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);else dst(cp >> 18 & 0x07 | 0xF0), dst(cp >> 12 & 0x3F | 0x80), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);
	                cp = null;
	            }
	        };
	
	        /**
	         * Decodes UTF8 bytes to UTF8 code points.
	         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
	         *  are no more bytes left.
	         * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
	         * @throws {RangeError} If a starting byte is invalid in UTF8
	         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
	         *  remaining bytes.
	         */
	        utfx.decodeUTF8 = function (src, dst) {
	            var a,
	                b,
	                c,
	                d,
	                fail = function fail(b) {
	                b = b.slice(0, b.indexOf(null));
	                var err = Error(b.toString());
	                err.name = "TruncatedError";
	                err['bytes'] = b;
	                throw err;
	            };
	            while ((a = src()) !== null) {
	                if ((a & 0x80) === 0) dst(a);else if ((a & 0xE0) === 0xC0) (b = src()) === null && fail([a, b]), dst((a & 0x1F) << 6 | b & 0x3F);else if ((a & 0xF0) === 0xE0) ((b = src()) === null || (c = src()) === null) && fail([a, b, c]), dst((a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F);else if ((a & 0xF8) === 0xF0) ((b = src()) === null || (c = src()) === null || (d = src()) === null) && fail([a, b, c, d]), dst((a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F);else throw RangeError("Illegal starting byte: " + a);
	            }
	        };
	
	        /**
	         * Converts UTF16 characters to UTF8 code points.
	         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
	         *  `null` if there are no more characters left.
	         * @param {!function(number)} dst Code points destination as a function successively called with each converted code
	         *  point.
	         */
	        utfx.UTF16toUTF8 = function (src, dst) {
	            var c1,
	                c2 = null;
	            while (true) {
	                if ((c1 = c2 !== null ? c2 : src()) === null) break;
	                if (c1 >= 0xD800 && c1 <= 0xDFFF) {
	                    if ((c2 = src()) !== null) {
	                        if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
	                            dst((c1 - 0xD800) * 0x400 + c2 - 0xDC00 + 0x10000);
	                            c2 = null;continue;
	                        }
	                    }
	                }
	                dst(c1);
	            }
	            if (c2 !== null) dst(c2);
	        };
	
	        /**
	         * Converts UTF8 code points to UTF16 characters.
	         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
	         *  respectively `null` if there are no more code points left or a single numeric code point.
	         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
	         * @throws {RangeError} If a code point is out of range
	         */
	        utfx.UTF8toUTF16 = function (src, dst) {
	            var cp = null;
	            if (typeof src === 'number') cp = src, src = function src() {
	                return null;
	            };
	            while (cp !== null || (cp = src()) !== null) {
	                if (cp <= 0xFFFF) dst(cp);else cp -= 0x10000, dst((cp >> 10) + 0xD800), dst(cp % 0x400 + 0xDC00);
	                cp = null;
	            }
	        };
	
	        /**
	         * Converts and encodes UTF16 characters to UTF8 bytes.
	         * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
	         *  if there are no more characters left.
	         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
	         */
	        utfx.encodeUTF16toUTF8 = function (src, dst) {
	            utfx.UTF16toUTF8(src, function (cp) {
	                utfx.encodeUTF8(cp, dst);
	            });
	        };
	
	        /**
	         * Decodes and converts UTF8 bytes to UTF16 characters.
	         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
	         *  are no more bytes left.
	         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
	         * @throws {RangeError} If a starting byte is invalid in UTF8
	         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
	         */
	        utfx.decodeUTF8toUTF16 = function (src, dst) {
	            utfx.decodeUTF8(src, function (cp) {
	                utfx.UTF8toUTF16(cp, dst);
	            });
	        };
	
	        /**
	         * Calculates the byte length of an UTF8 code point.
	         * @param {number} cp UTF8 code point
	         * @returns {number} Byte length
	         */
	        utfx.calculateCodePoint = function (cp) {
	            return cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
	        };
	
	        /**
	         * Calculates the number of UTF8 bytes required to store UTF8 code points.
	         * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
	         *  `null` if there are no more code points left.
	         * @returns {number} The number of UTF8 bytes required
	         */
	        utfx.calculateUTF8 = function (src) {
	            var cp,
	                l = 0;
	            while ((cp = src()) !== null) {
	                l += cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
	            }return l;
	        };
	
	        /**
	         * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
	         * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
	         *  `null` if there are no more characters left.
	         * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
	         */
	        utfx.calculateUTF16asUTF8 = function (src) {
	            var n = 0,
	                l = 0;
	            utfx.UTF16toUTF8(src, function (cp) {
	                ++n;l += cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
	            });
	            return [n, l];
	        };
	
	        return utfx;
	    }();
	
	    // encodings/utf8
	
	    /**
	     * Encodes this ByteBuffer's contents between {@link ByteBuffer#offset} and {@link ByteBuffer#limit} to an UTF8 encoded
	     *  string.
	     * @returns {string} Hex encoded string
	     * @throws {RangeError} If `offset > limit`
	     * @expose
	     */
	    ByteBufferPrototype.toUTF8 = function (begin, end) {
	        if (typeof begin === 'undefined') begin = this.offset;
	        if (typeof end === 'undefined') end = this.limit;
	        if (!this.noAssert) {
	            if (typeof begin !== 'number' || begin % 1 !== 0) throw TypeError("Illegal begin: Not an integer");
	            begin >>>= 0;
	            if (typeof end !== 'number' || end % 1 !== 0) throw TypeError("Illegal end: Not an integer");
	            end >>>= 0;
	            if (begin < 0 || begin > end || end > this.buffer.byteLength) throw RangeError("Illegal range: 0 <= " + begin + " <= " + end + " <= " + this.buffer.byteLength);
	        }
	        var sd;try {
	            utfx.decodeUTF8toUTF16(function () {
	                return begin < end ? this.view[begin++] : null;
	            }.bind(this), sd = stringDestination());
	        } catch (e) {
	            if (begin !== end) throw RangeError("Illegal range: Truncated data, " + begin + " != " + end);
	        }
	        return sd();
	    };
	
	    /**
	     * Decodes an UTF8 encoded string to a ByteBuffer.
	     * @param {string} str String to decode
	     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
	     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
	     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
	     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
	     * @returns {!ByteBuffer} ByteBuffer
	     * @expose
	     */
	    ByteBuffer.fromUTF8 = function (str, littleEndian, noAssert) {
	        if (!noAssert) if (typeof str !== 'string') throw TypeError("Illegal str: Not a string");
	        var bb = new ByteBuffer(utfx.calculateUTF16asUTF8(stringSource(str), true)[1], littleEndian, noAssert),
	            i = 0;
	        utfx.encodeUTF16toUTF8(stringSource(str), function (b) {
	            bb.view[i++] = b;
	        });
	        bb.limit = i;
	        return bb;
	    };
	
	    return ByteBuffer;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Copyright 2013 Daniel Wirtz <dcode@dcode.io>
	 Copyright 2009 The Closure Library Authors. All Rights Reserved.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS-IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	/**
	 * @license long.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
	 * Released under the Apache License, Version 2.0
	 * see: https://github.com/dcodeIO/long.js for details
	 */
	(function (global, factory) {
	
	    /* AMD */if ("function" === 'function' && __webpack_require__(155)["amd"]) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    /* CommonJS */else if ("function" === 'function' && ( false ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) module["exports"] = factory();
	        /* Global */else (global["dcodeIO"] = global["dcodeIO"] || {})["Long"] = factory();
	})(undefined, function () {
	    "use strict";
	
	    /**
	     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
	     *  See the from* functions below for more convenient ways of constructing Longs.
	     * @exports Long
	     * @class A Long class for representing a 64 bit two's-complement integer value.
	     * @param {number} low The low (signed) 32 bits of the long
	     * @param {number} high The high (signed) 32 bits of the long
	     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
	     * @constructor
	     */
	
	    function Long(low, high, unsigned) {
	
	        /**
	         * The low 32 bits as a signed value.
	         * @type {number}
	         */
	        this.low = low | 0;
	
	        /**
	         * The high 32 bits as a signed value.
	         * @type {number}
	         */
	        this.high = high | 0;
	
	        /**
	         * Whether unsigned or not.
	         * @type {boolean}
	         */
	        this.unsigned = !!unsigned;
	    }
	
	    // The internal representation of a long is the two given signed, 32-bit values.
	    // We use 32-bit pieces because these are the size of integers on which
	    // Javascript performs bit-operations.  For operations like addition and
	    // multiplication, we split each number into 16 bit pieces, which can easily be
	    // multiplied within Javascript's floating-point representation without overflow
	    // or change in sign.
	    //
	    // In the algorithms below, we frequently reduce the negative case to the
	    // positive case by negating the input(s) and then post-processing the result.
	    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
	    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
	    // a positive number, it overflows back into a negative).  Not handling this
	    // case would often result in infinite recursion.
	    //
	    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
	    // methods on which they depend.
	
	    /**
	     * An indicator used to reliably determine if an object is a Long or not.
	     * @type {boolean}
	     * @const
	     * @private
	     */
	    Long.prototype.__isLong__;
	
	    Object.defineProperty(Long.prototype, "__isLong__", {
	        value: true,
	        enumerable: false,
	        configurable: false
	    });
	
	    /**
	     * @function
	     * @param {*} obj Object
	     * @returns {boolean}
	     * @inner
	     */
	    function isLong(obj) {
	        return (obj && obj["__isLong__"]) === true;
	    }
	
	    /**
	     * Tests if the specified object is a Long.
	     * @function
	     * @param {*} obj Object
	     * @returns {boolean}
	     */
	    Long.isLong = isLong;
	
	    /**
	     * A cache of the Long representations of small integer values.
	     * @type {!Object}
	     * @inner
	     */
	    var INT_CACHE = {};
	
	    /**
	     * A cache of the Long representations of small unsigned integer values.
	     * @type {!Object}
	     * @inner
	     */
	    var UINT_CACHE = {};
	
	    /**
	     * @param {number} value
	     * @param {boolean=} unsigned
	     * @returns {!Long}
	     * @inner
	     */
	    function fromInt(value, unsigned) {
	        var obj, cachedObj, cache;
	        if (unsigned) {
	            value >>>= 0;
	            if (cache = 0 <= value && value < 256) {
	                cachedObj = UINT_CACHE[value];
	                if (cachedObj) return cachedObj;
	            }
	            obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
	            if (cache) UINT_CACHE[value] = obj;
	            return obj;
	        } else {
	            value |= 0;
	            if (cache = -128 <= value && value < 128) {
	                cachedObj = INT_CACHE[value];
	                if (cachedObj) return cachedObj;
	            }
	            obj = fromBits(value, value < 0 ? -1 : 0, false);
	            if (cache) INT_CACHE[value] = obj;
	            return obj;
	        }
	    }
	
	    /**
	     * Returns a Long representing the given 32 bit integer value.
	     * @function
	     * @param {number} value The 32 bit integer in question
	     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
	     * @returns {!Long} The corresponding Long value
	     */
	    Long.fromInt = fromInt;
	
	    /**
	     * @param {number} value
	     * @param {boolean=} unsigned
	     * @returns {!Long}
	     * @inner
	     */
	    function fromNumber(value, unsigned) {
	        if (isNaN(value) || !isFinite(value)) return unsigned ? UZERO : ZERO;
	        if (unsigned) {
	            if (value < 0) return UZERO;
	            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
	        } else {
	            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
	            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
	        }
	        if (value < 0) return fromNumber(-value, unsigned).neg();
	        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
	    }
	
	    /**
	     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
	     * @function
	     * @param {number} value The number in question
	     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
	     * @returns {!Long} The corresponding Long value
	     */
	    Long.fromNumber = fromNumber;
	
	    /**
	     * @param {number} lowBits
	     * @param {number} highBits
	     * @param {boolean=} unsigned
	     * @returns {!Long}
	     * @inner
	     */
	    function fromBits(lowBits, highBits, unsigned) {
	        return new Long(lowBits, highBits, unsigned);
	    }
	
	    /**
	     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
	     *  assumed to use 32 bits.
	     * @function
	     * @param {number} lowBits The low 32 bits
	     * @param {number} highBits The high 32 bits
	     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
	     * @returns {!Long} The corresponding Long value
	     */
	    Long.fromBits = fromBits;
	
	    /**
	     * @function
	     * @param {number} base
	     * @param {number} exponent
	     * @returns {number}
	     * @inner
	     */
	    var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
	
	    /**
	     * @param {string} str
	     * @param {(boolean|number)=} unsigned
	     * @param {number=} radix
	     * @returns {!Long}
	     * @inner
	     */
	    function fromString(str, unsigned, radix) {
	        if (str.length === 0) throw Error('empty string');
	        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return ZERO;
	        if (typeof unsigned === 'number') {
	            // For goog.math.long compatibility
	            radix = unsigned, unsigned = false;
	        } else {
	            unsigned = !!unsigned;
	        }
	        radix = radix || 10;
	        if (radix < 2 || 36 < radix) throw RangeError('radix');
	
	        var p;
	        if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');else if (p === 0) {
	            return fromString(str.substring(1), unsigned, radix).neg();
	        }
	
	        // Do several (8) digits each time through the loop, so as to
	        // minimize the calls to the very expensive emulated div.
	        var radixToPower = fromNumber(pow_dbl(radix, 8));
	
	        var result = ZERO;
	        for (var i = 0; i < str.length; i += 8) {
	            var size = Math.min(8, str.length - i),
	                value = parseInt(str.substring(i, i + size), radix);
	            if (size < 8) {
	                var power = fromNumber(pow_dbl(radix, size));
	                result = result.mul(power).add(fromNumber(value));
	            } else {
	                result = result.mul(radixToPower);
	                result = result.add(fromNumber(value));
	            }
	        }
	        result.unsigned = unsigned;
	        return result;
	    }
	
	    /**
	     * Returns a Long representation of the given string, written using the specified radix.
	     * @function
	     * @param {string} str The textual representation of the Long
	     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to `false` for signed
	     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
	     * @returns {!Long} The corresponding Long value
	     */
	    Long.fromString = fromString;
	
	    /**
	     * @function
	     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
	     * @returns {!Long}
	     * @inner
	     */
	    function fromValue(val) {
	        if (val /* is compatible */ instanceof Long) return val;
	        if (typeof val === 'number') return fromNumber(val);
	        if (typeof val === 'string') return fromString(val);
	        // Throws for non-objects, converts non-instanceof Long:
	        return fromBits(val.low, val.high, val.unsigned);
	    }
	
	    /**
	     * Converts the specified value to a Long.
	     * @function
	     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
	     * @returns {!Long}
	     */
	    Long.fromValue = fromValue;
	
	    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
	    // no runtime penalty for these.
	
	    /**
	     * @type {number}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_16_DBL = 1 << 16;
	
	    /**
	     * @type {number}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_24_DBL = 1 << 24;
	
	    /**
	     * @type {number}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
	
	    /**
	     * @type {number}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
	
	    /**
	     * @type {number}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
	
	    /**
	     * @type {!Long}
	     * @const
	     * @inner
	     */
	    var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var ZERO = fromInt(0);
	
	    /**
	     * Signed zero.
	     * @type {!Long}
	     */
	    Long.ZERO = ZERO;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var UZERO = fromInt(0, true);
	
	    /**
	     * Unsigned zero.
	     * @type {!Long}
	     */
	    Long.UZERO = UZERO;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var ONE = fromInt(1);
	
	    /**
	     * Signed one.
	     * @type {!Long}
	     */
	    Long.ONE = ONE;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var UONE = fromInt(1, true);
	
	    /**
	     * Unsigned one.
	     * @type {!Long}
	     */
	    Long.UONE = UONE;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var NEG_ONE = fromInt(-1);
	
	    /**
	     * Signed negative one.
	     * @type {!Long}
	     */
	    Long.NEG_ONE = NEG_ONE;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var MAX_VALUE = fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0, false);
	
	    /**
	     * Maximum signed value.
	     * @type {!Long}
	     */
	    Long.MAX_VALUE = MAX_VALUE;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF | 0, 0xFFFFFFFF | 0, true);
	
	    /**
	     * Maximum unsigned value.
	     * @type {!Long}
	     */
	    Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
	
	    /**
	     * @type {!Long}
	     * @inner
	     */
	    var MIN_VALUE = fromBits(0, 0x80000000 | 0, false);
	
	    /**
	     * Minimum signed value.
	     * @type {!Long}
	     */
	    Long.MIN_VALUE = MIN_VALUE;
	
	    /**
	     * @alias Long.prototype
	     * @inner
	     */
	    var LongPrototype = Long.prototype;
	
	    /**
	     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
	     * @returns {number}
	     */
	    LongPrototype.toInt = function toInt() {
	        return this.unsigned ? this.low >>> 0 : this.low;
	    };
	
	    /**
	     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
	     * @returns {number}
	     */
	    LongPrototype.toNumber = function toNumber() {
	        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
	        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
	    };
	
	    /**
	     * Converts the Long to a string written in the specified radix.
	     * @param {number=} radix Radix (2-36), defaults to 10
	     * @returns {string}
	     * @override
	     * @throws {RangeError} If `radix` is out of range
	     */
	    LongPrototype.toString = function toString(radix) {
	        radix = radix || 10;
	        if (radix < 2 || 36 < radix) throw RangeError('radix');
	        if (this.isZero()) return '0';
	        if (this.isNegative()) {
	            // Unsigned Longs are never negative
	            if (this.eq(MIN_VALUE)) {
	                // We need to change the Long value before it can be negated, so we remove
	                // the bottom-most digit in this base and then recurse to do the rest.
	                var radixLong = fromNumber(radix),
	                    div = this.div(radixLong),
	                    rem1 = div.mul(radixLong).sub(this);
	                return div.toString(radix) + rem1.toInt().toString(radix);
	            } else return '-' + this.neg().toString(radix);
	        }
	
	        // Do several (6) digits each time through the loop, so as to
	        // minimize the calls to the very expensive emulated div.
	        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
	            rem = this;
	        var result = '';
	        while (true) {
	            var remDiv = rem.div(radixToPower),
	                intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
	                digits = intval.toString(radix);
	            rem = remDiv;
	            if (rem.isZero()) return digits + result;else {
	                while (digits.length < 6) {
	                    digits = '0' + digits;
	                }result = '' + digits + result;
	            }
	        }
	    };
	
	    /**
	     * Gets the high 32 bits as a signed integer.
	     * @returns {number} Signed high bits
	     */
	    LongPrototype.getHighBits = function getHighBits() {
	        return this.high;
	    };
	
	    /**
	     * Gets the high 32 bits as an unsigned integer.
	     * @returns {number} Unsigned high bits
	     */
	    LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
	        return this.high >>> 0;
	    };
	
	    /**
	     * Gets the low 32 bits as a signed integer.
	     * @returns {number} Signed low bits
	     */
	    LongPrototype.getLowBits = function getLowBits() {
	        return this.low;
	    };
	
	    /**
	     * Gets the low 32 bits as an unsigned integer.
	     * @returns {number} Unsigned low bits
	     */
	    LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
	        return this.low >>> 0;
	    };
	
	    /**
	     * Gets the number of bits needed to represent the absolute value of this Long.
	     * @returns {number}
	     */
	    LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
	        if (this.isNegative()) // Unsigned Longs are never negative
	            return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
	        var val = this.high != 0 ? this.high : this.low;
	        for (var bit = 31; bit > 0; bit--) {
	            if ((val & 1 << bit) != 0) break;
	        }return this.high != 0 ? bit + 33 : bit + 1;
	    };
	
	    /**
	     * Tests if this Long's value equals zero.
	     * @returns {boolean}
	     */
	    LongPrototype.isZero = function isZero() {
	        return this.high === 0 && this.low === 0;
	    };
	
	    /**
	     * Tests if this Long's value is negative.
	     * @returns {boolean}
	     */
	    LongPrototype.isNegative = function isNegative() {
	        return !this.unsigned && this.high < 0;
	    };
	
	    /**
	     * Tests if this Long's value is positive.
	     * @returns {boolean}
	     */
	    LongPrototype.isPositive = function isPositive() {
	        return this.unsigned || this.high >= 0;
	    };
	
	    /**
	     * Tests if this Long's value is odd.
	     * @returns {boolean}
	     */
	    LongPrototype.isOdd = function isOdd() {
	        return (this.low & 1) === 1;
	    };
	
	    /**
	     * Tests if this Long's value is even.
	     * @returns {boolean}
	     */
	    LongPrototype.isEven = function isEven() {
	        return (this.low & 1) === 0;
	    };
	
	    /**
	     * Tests if this Long's value equals the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.equals = function equals(other) {
	        if (!isLong(other)) other = fromValue(other);
	        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
	        return this.high === other.high && this.low === other.low;
	    };
	
	    /**
	     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.eq = LongPrototype.equals;
	
	    /**
	     * Tests if this Long's value differs from the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.notEquals = function notEquals(other) {
	        return !this.eq( /* validates */other);
	    };
	
	    /**
	     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.neq = LongPrototype.notEquals;
	
	    /**
	     * Tests if this Long's value is less than the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.lessThan = function lessThan(other) {
	        return this.comp( /* validates */other) < 0;
	    };
	
	    /**
	     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.lt = LongPrototype.lessThan;
	
	    /**
	     * Tests if this Long's value is less than or equal the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
	        return this.comp( /* validates */other) <= 0;
	    };
	
	    /**
	     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.lte = LongPrototype.lessThanOrEqual;
	
	    /**
	     * Tests if this Long's value is greater than the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.greaterThan = function greaterThan(other) {
	        return this.comp( /* validates */other) > 0;
	    };
	
	    /**
	     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.gt = LongPrototype.greaterThan;
	
	    /**
	     * Tests if this Long's value is greater than or equal the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
	        return this.comp( /* validates */other) >= 0;
	    };
	
	    /**
	     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {boolean}
	     */
	    LongPrototype.gte = LongPrototype.greaterThanOrEqual;
	
	    /**
	     * Compares this Long's value with the specified's.
	     * @param {!Long|number|string} other Other value
	     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	     *  if the given one is greater
	     */
	    LongPrototype.compare = function compare(other) {
	        if (!isLong(other)) other = fromValue(other);
	        if (this.eq(other)) return 0;
	        var thisNeg = this.isNegative(),
	            otherNeg = other.isNegative();
	        if (thisNeg && !otherNeg) return -1;
	        if (!thisNeg && otherNeg) return 1;
	        // At this point the sign bits are the same
	        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
	        // Both are positive if at least one is unsigned
	        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
	    };
	
	    /**
	     * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
	     * @function
	     * @param {!Long|number|string} other Other value
	     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	     *  if the given one is greater
	     */
	    LongPrototype.comp = LongPrototype.compare;
	
	    /**
	     * Negates this Long's value.
	     * @returns {!Long} Negated Long
	     */
	    LongPrototype.negate = function negate() {
	        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
	        return this.not().add(ONE);
	    };
	
	    /**
	     * Negates this Long's value. This is an alias of {@link Long#negate}.
	     * @function
	     * @returns {!Long} Negated Long
	     */
	    LongPrototype.neg = LongPrototype.negate;
	
	    /**
	     * Returns the sum of this and the specified Long.
	     * @param {!Long|number|string} addend Addend
	     * @returns {!Long} Sum
	     */
	    LongPrototype.add = function add(addend) {
	        if (!isLong(addend)) addend = fromValue(addend);
	
	        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
	
	        var a48 = this.high >>> 16;
	        var a32 = this.high & 0xFFFF;
	        var a16 = this.low >>> 16;
	        var a00 = this.low & 0xFFFF;
	
	        var b48 = addend.high >>> 16;
	        var b32 = addend.high & 0xFFFF;
	        var b16 = addend.low >>> 16;
	        var b00 = addend.low & 0xFFFF;
	
	        var c48 = 0,
	            c32 = 0,
	            c16 = 0,
	            c00 = 0;
	        c00 += a00 + b00;
	        c16 += c00 >>> 16;
	        c00 &= 0xFFFF;
	        c16 += a16 + b16;
	        c32 += c16 >>> 16;
	        c16 &= 0xFFFF;
	        c32 += a32 + b32;
	        c48 += c32 >>> 16;
	        c32 &= 0xFFFF;
	        c48 += a48 + b48;
	        c48 &= 0xFFFF;
	        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
	    };
	
	    /**
	     * Returns the difference of this and the specified Long.
	     * @param {!Long|number|string} subtrahend Subtrahend
	     * @returns {!Long} Difference
	     */
	    LongPrototype.subtract = function subtract(subtrahend) {
	        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
	        return this.add(subtrahend.neg());
	    };
	
	    /**
	     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
	     * @function
	     * @param {!Long|number|string} subtrahend Subtrahend
	     * @returns {!Long} Difference
	     */
	    LongPrototype.sub = LongPrototype.subtract;
	
	    /**
	     * Returns the product of this and the specified Long.
	     * @param {!Long|number|string} multiplier Multiplier
	     * @returns {!Long} Product
	     */
	    LongPrototype.multiply = function multiply(multiplier) {
	        if (this.isZero()) return ZERO;
	        if (!isLong(multiplier)) multiplier = fromValue(multiplier);
	        if (multiplier.isZero()) return ZERO;
	        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
	        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
	
	        if (this.isNegative()) {
	            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());else return this.neg().mul(multiplier).neg();
	        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
	
	        // If both longs are small, use float multiplication
	        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
	
	        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
	        // We can skip products that would overflow.
	
	        var a48 = this.high >>> 16;
	        var a32 = this.high & 0xFFFF;
	        var a16 = this.low >>> 16;
	        var a00 = this.low & 0xFFFF;
	
	        var b48 = multiplier.high >>> 16;
	        var b32 = multiplier.high & 0xFFFF;
	        var b16 = multiplier.low >>> 16;
	        var b00 = multiplier.low & 0xFFFF;
	
	        var c48 = 0,
	            c32 = 0,
	            c16 = 0,
	            c00 = 0;
	        c00 += a00 * b00;
	        c16 += c00 >>> 16;
	        c00 &= 0xFFFF;
	        c16 += a16 * b00;
	        c32 += c16 >>> 16;
	        c16 &= 0xFFFF;
	        c16 += a00 * b16;
	        c32 += c16 >>> 16;
	        c16 &= 0xFFFF;
	        c32 += a32 * b00;
	        c48 += c32 >>> 16;
	        c32 &= 0xFFFF;
	        c32 += a16 * b16;
	        c48 += c32 >>> 16;
	        c32 &= 0xFFFF;
	        c32 += a00 * b32;
	        c48 += c32 >>> 16;
	        c32 &= 0xFFFF;
	        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
	        c48 &= 0xFFFF;
	        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
	    };
	
	    /**
	     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
	     * @function
	     * @param {!Long|number|string} multiplier Multiplier
	     * @returns {!Long} Product
	     */
	    LongPrototype.mul = LongPrototype.multiply;
	
	    /**
	     * Returns this Long divided by the specified. The result is signed if this Long is signed or
	     *  unsigned if this Long is unsigned.
	     * @param {!Long|number|string} divisor Divisor
	     * @returns {!Long} Quotient
	     */
	    LongPrototype.divide = function divide(divisor) {
	        if (!isLong(divisor)) divisor = fromValue(divisor);
	        if (divisor.isZero()) throw Error('division by zero');
	        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
	        var approx, rem, res;
	        if (!this.unsigned) {
	            // This section is only relevant for signed longs and is derived from the
	            // closure library as a whole.
	            if (this.eq(MIN_VALUE)) {
	                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
	                else if (divisor.eq(MIN_VALUE)) return ONE;else {
	                        // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
	                        var halfThis = this.shr(1);
	                        approx = halfThis.div(divisor).shl(1);
	                        if (approx.eq(ZERO)) {
	                            return divisor.isNegative() ? ONE : NEG_ONE;
	                        } else {
	                            rem = this.sub(divisor.mul(approx));
	                            res = approx.add(rem.div(divisor));
	                            return res;
	                        }
	                    }
	            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
	            if (this.isNegative()) {
	                if (divisor.isNegative()) return this.neg().div(divisor.neg());
	                return this.neg().div(divisor).neg();
	            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
	            res = ZERO;
	        } else {
	            // The algorithm below has not been made for unsigned longs. It's therefore
	            // required to take special care of the MSB prior to running it.
	            if (!divisor.unsigned) divisor = divisor.toUnsigned();
	            if (divisor.gt(this)) return UZERO;
	            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
	                return UONE;
	            res = UZERO;
	        }
	
	        // Repeat the following until the remainder is less than other:  find a
	        // floating-point that approximates remainder / other *from below*, add this
	        // into the result, and subtract it from the remainder.  It is critical that
	        // the approximate value is less than or equal to the real value so that the
	        // remainder never becomes negative.
	        rem = this;
	        while (rem.gte(divisor)) {
	            // Approximate the result of division. This may be a little greater or
	            // smaller than the actual value.
	            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
	
	            // We will tweak the approximate result by changing it in the 48-th digit or
	            // the smallest non-fractional digit, whichever is larger.
	            var log2 = Math.ceil(Math.log(approx) / Math.LN2),
	                delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48),
	
	
	            // Decrease the approximation until it is smaller than the remainder.  Note
	            // that if it is too large, the product overflows and is negative.
	            approxRes = fromNumber(approx),
	                approxRem = approxRes.mul(divisor);
	            while (approxRem.isNegative() || approxRem.gt(rem)) {
	                approx -= delta;
	                approxRes = fromNumber(approx, this.unsigned);
	                approxRem = approxRes.mul(divisor);
	            }
	
	            // We know the answer can't be zero... and actually, zero would cause
	            // infinite recursion since we would make no progress.
	            if (approxRes.isZero()) approxRes = ONE;
	
	            res = res.add(approxRes);
	            rem = rem.sub(approxRem);
	        }
	        return res;
	    };
	
	    /**
	     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
	     * @function
	     * @param {!Long|number|string} divisor Divisor
	     * @returns {!Long} Quotient
	     */
	    LongPrototype.div = LongPrototype.divide;
	
	    /**
	     * Returns this Long modulo the specified.
	     * @param {!Long|number|string} divisor Divisor
	     * @returns {!Long} Remainder
	     */
	    LongPrototype.modulo = function modulo(divisor) {
	        if (!isLong(divisor)) divisor = fromValue(divisor);
	        return this.sub(this.div(divisor).mul(divisor));
	    };
	
	    /**
	     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	     * @function
	     * @param {!Long|number|string} divisor Divisor
	     * @returns {!Long} Remainder
	     */
	    LongPrototype.mod = LongPrototype.modulo;
	
	    /**
	     * Returns the bitwise NOT of this Long.
	     * @returns {!Long}
	     */
	    LongPrototype.not = function not() {
	        return fromBits(~this.low, ~this.high, this.unsigned);
	    };
	
	    /**
	     * Returns the bitwise AND of this Long and the specified.
	     * @param {!Long|number|string} other Other Long
	     * @returns {!Long}
	     */
	    LongPrototype.and = function and(other) {
	        if (!isLong(other)) other = fromValue(other);
	        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
	    };
	
	    /**
	     * Returns the bitwise OR of this Long and the specified.
	     * @param {!Long|number|string} other Other Long
	     * @returns {!Long}
	     */
	    LongPrototype.or = function or(other) {
	        if (!isLong(other)) other = fromValue(other);
	        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
	    };
	
	    /**
	     * Returns the bitwise XOR of this Long and the given one.
	     * @param {!Long|number|string} other Other Long
	     * @returns {!Long}
	     */
	    LongPrototype.xor = function xor(other) {
	        if (!isLong(other)) other = fromValue(other);
	        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
	    };
	
	    /**
	     * Returns this Long with bits shifted to the left by the given amount.
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shiftLeft = function shiftLeft(numBits) {
	        if (isLong(numBits)) numBits = numBits.toInt();
	        if ((numBits &= 63) === 0) return this;else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);else return fromBits(0, this.low << numBits - 32, this.unsigned);
	    };
	
	    /**
	     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
	     * @function
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shl = LongPrototype.shiftLeft;
	
	    /**
	     * Returns this Long with bits arithmetically shifted to the right by the given amount.
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shiftRight = function shiftRight(numBits) {
	        if (isLong(numBits)) numBits = numBits.toInt();
	        if ((numBits &= 63) === 0) return this;else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
	    };
	
	    /**
	     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
	     * @function
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shr = LongPrototype.shiftRight;
	
	    /**
	     * Returns this Long with bits logically shifted to the right by the given amount.
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
	        if (isLong(numBits)) numBits = numBits.toInt();
	        numBits &= 63;
	        if (numBits === 0) return this;else {
	            var high = this.high;
	            if (numBits < 32) {
	                var low = this.low;
	                return fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
	            } else if (numBits === 32) return fromBits(high, 0, this.unsigned);else return fromBits(high >>> numBits - 32, 0, this.unsigned);
	        }
	    };
	
	    /**
	     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	     * @function
	     * @param {number|!Long} numBits Number of bits
	     * @returns {!Long} Shifted Long
	     */
	    LongPrototype.shru = LongPrototype.shiftRightUnsigned;
	
	    /**
	     * Converts this Long to signed.
	     * @returns {!Long} Signed long
	     */
	    LongPrototype.toSigned = function toSigned() {
	        if (!this.unsigned) return this;
	        return fromBits(this.low, this.high, false);
	    };
	
	    /**
	     * Converts this Long to unsigned.
	     * @returns {!Long} Unsigned long
	     */
	    LongPrototype.toUnsigned = function toUnsigned() {
	        if (this.unsigned) return this;
	        return fromBits(this.low, this.high, true);
	    };
	
	    /**
	     * Converts this Long to its byte representation.
	     * @param {boolean=} le Whether little or big endian, defaults to big endian
	     * @returns {!Array.<number>} Byte representation
	     */
	    LongPrototype.toBytes = function (le) {
	        return le ? this.toBytesLE() : this.toBytesBE();
	    };
	
	    /**
	     * Converts this Long to its little endian byte representation.
	     * @returns {!Array.<number>} Little endian byte representation
	     */
	    LongPrototype.toBytesLE = function () {
	        var hi = this.high,
	            lo = this.low;
	        return [lo & 0xff, lo >>> 8 & 0xff, lo >>> 16 & 0xff, lo >>> 24 & 0xff, hi & 0xff, hi >>> 8 & 0xff, hi >>> 16 & 0xff, hi >>> 24 & 0xff];
	    };
	
	    /**
	     * Converts this Long to its big endian byte representation.
	     * @returns {!Array.<number>} Big endian byte representation
	     */
	    LongPrototype.toBytesBE = function () {
	        var hi = this.high,
	            lo = this.low;
	        return [hi >>> 24 & 0xff, hi >>> 16 & 0xff, hi >>> 8 & 0xff, hi & 0xff, lo >>> 24 & 0xff, lo >>> 16 & 0xff, lo >>> 8 & 0xff, lo & 0xff];
	    };
	
	    return Long;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)(module)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ciphers = __webpack_require__(158);
	var deciphers = __webpack_require__(177);
	var modes = __webpack_require__(169);
	
	function getCiphers() {
	  return Object.keys(modes);
	}
	
	exports.createCipher = exports.Cipher = ciphers.createCipher;
	exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv;
	exports.createDecipher = exports.Decipher = deciphers.createDecipher;
	exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv;
	exports.listCiphers = exports.getCiphers = getCiphers;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MODES = __webpack_require__(159);
	var AuthCipher = __webpack_require__(170);
	var Buffer = __webpack_require__(121).Buffer;
	var StreamCipher = __webpack_require__(173);
	var Transform = __webpack_require__(145);
	var aes = __webpack_require__(171);
	var ebtk = __webpack_require__(174);
	var inherits = __webpack_require__(111);
	
	function Cipher(mode, key, iv) {
	  Transform.call(this);
	
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._mode = mode;
	  this._autopadding = true;
	}
	
	inherits(Cipher, Transform);
	
	Cipher.prototype._update = function (data) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  var out = [];
	
	  while (chunk = this._cache.get()) {
	    thing = this._mode.encrypt(this, chunk);
	    out.push(thing);
	  }
	
	  return Buffer.concat(out);
	};
	
	var PADDING = Buffer.alloc(16, 0x10);
	
	Cipher.prototype._final = function () {
	  var chunk = this._cache.flush();
	  if (this._autopadding) {
	    chunk = this._mode.encrypt(this, chunk);
	    this._cipher.scrub();
	    return chunk;
	  }
	
	  if (!chunk.equals(PADDING)) {
	    this._cipher.scrub();
	    throw new Error('data not multiple of block length');
	  }
	};
	
	Cipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo;
	  return this;
	};
	
	function Splitter() {
	  this.cache = Buffer.allocUnsafe(0);
	}
	
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = Buffer.allocUnsafe(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	
	  return Buffer.concat([this.cache, padBuff]);
	};
	
	function createCipheriv(suite, password, iv) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type');
	
	  if (typeof password === 'string') password = Buffer.from(password);
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
	
	  if (typeof iv === 'string') iv = Buffer.from(iv);
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
	
	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv);
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv);
	  }
	
	  return new Cipher(config.module, password, iv);
	}
	
	function createCipher(suite, password) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type');
	
	  var keys = ebtk(password, false, config.key, config.iv);
	  return createCipheriv(suite, keys.key, keys.iv);
	}
	
	exports.createCipheriv = createCipheriv;
	exports.createCipher = createCipher;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var modeModules = {
	  ECB: __webpack_require__(160),
	  CBC: __webpack_require__(161),
	  CFB: __webpack_require__(163),
	  CFB8: __webpack_require__(164),
	  CFB1: __webpack_require__(165),
	  OFB: __webpack_require__(166),
	  CTR: __webpack_require__(167),
	  GCM: __webpack_require__(167)
	};
	
	var modes = __webpack_require__(169);
	
	for (var key in modes) {
	  modes[key].module = modeModules[modes[key].mode];
	}
	
	module.exports = modes;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xor = __webpack_require__(162);
	
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	
	  return xor(out, pad);
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	module.exports = function xor(a, b) {
	  var length = Math.min(a.length, b.length);
	  var buffer = new Buffer(length);
	
	  for (var i = 0; i < length; ++i) {
	    buffer[i] = a[i] ^ b[i];
	  }
	
	  return buffer;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	var xor = __webpack_require__(162);
	
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt ? data : out]);
	  return out;
	}
	
	exports.encrypt = function (self, data, decrypt) {
	  var out = Buffer.allocUnsafe(0);
	  var len;
	
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = Buffer.allocUnsafe(0);
	    }
	
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	
	  return out;
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	
	function encryptByte(self, byteParam, decrypt) {
	  var pad = self._cipher.encryptBlock(self._prev);
	  var out = pad[0] ^ byteParam;
	
	  self._prev = Buffer.concat([self._prev.slice(1), Buffer.from([decrypt ? byteParam : out])]);
	
	  return out;
	}
	
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length;
	  var out = Buffer.allocUnsafe(len);
	  var i = -1;
	
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt);
	  }
	
	  return out;
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	
	function encryptByte(self, byteParam, decrypt) {
	  var pad;
	  var i = -1;
	  var len = 8;
	  var out = 0;
	  var bit, value;
	  while (++i < len) {
	    pad = self._cipher.encryptBlock(self._prev);
	    bit = byteParam & 1 << 7 - i ? 0x80 : 0;
	    value = pad[0] ^ bit;
	    out += (value & 0x80) >> i % 8;
	    self._prev = shiftIn(self._prev, decrypt ? bit : value);
	  }
	  return out;
	}
	
	function shiftIn(buffer, value) {
	  var len = buffer.length;
	  var i = -1;
	  var out = Buffer.allocUnsafe(buffer.length);
	  buffer = Buffer.concat([buffer, Buffer.from([value])]);
	
	  while (++i < len) {
	    out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
	  }
	
	  return out;
	}
	
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length;
	  var out = Buffer.allocUnsafe(len);
	  var i = -1;
	
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt);
	  }
	
	  return out;
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var xor = __webpack_require__(162);
	
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xor = __webpack_require__(162);
	var Buffer = __webpack_require__(121).Buffer;
	var incr32 = __webpack_require__(168);
	
	function getBlock(self) {
	  var out = self._cipher.encryptBlockRaw(self._prev);
	  incr32(self._prev);
	  return out;
	}
	
	var blockSize = 16;
	exports.encrypt = function (self, chunk) {
	  var chunkNum = Math.ceil(chunk.length / blockSize);
	  var start = self._cache.length;
	  self._cache = Buffer.concat([self._cache, Buffer.allocUnsafe(chunkNum * blockSize)]);
	  for (var i = 0; i < chunkNum; i++) {
	    var out = getBlock(self);
	    var offset = start + i * blockSize;
	    self._cache.writeUInt32BE(out[0], offset + 0);
	    self._cache.writeUInt32BE(out[1], offset + 4);
	    self._cache.writeUInt32BE(out[2], offset + 8);
	    self._cache.writeUInt32BE(out[3], offset + 12);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	module.exports = incr32;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var aes = __webpack_require__(171);
	var Buffer = __webpack_require__(121).Buffer;
	var Transform = __webpack_require__(145);
	var inherits = __webpack_require__(111);
	var GHASH = __webpack_require__(172);
	var xor = __webpack_require__(162);
	var incr32 = __webpack_require__(168);
	
	function xorTest(a, b) {
	  var out = 0;
	  if (a.length !== b.length) out++;
	
	  var len = Math.min(a.length, b.length);
	  for (var i = 0; i < len; ++i) {
	    out += a[i] ^ b[i];
	  }
	
	  return out;
	}
	
	function calcIv(self, iv, ck) {
	  if (iv.length === 12) {
	    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])]);
	    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])]);
	  }
	  var ghash = new GHASH(ck);
	  var len = iv.length;
	  var toPad = len % 16;
	  ghash.update(iv);
	  if (toPad) {
	    toPad = 16 - toPad;
	    ghash.update(Buffer.alloc(toPad, 0));
	  }
	  ghash.update(Buffer.alloc(8, 0));
	  var ivBits = len * 8;
	  var tail = Buffer.alloc(8);
	  tail.writeUIntBE(ivBits, 0, 8);
	  ghash.update(tail);
	  self._finID = ghash.state;
	  var out = Buffer.from(self._finID);
	  incr32(out);
	  return out;
	}
	function StreamCipher(mode, key, iv, decrypt) {
	  Transform.call(this);
	
	  var h = Buffer.alloc(4, 0);
	
	  this._cipher = new aes.AES(key);
	  var ck = this._cipher.encryptBlock(h);
	  this._ghash = new GHASH(ck);
	  iv = calcIv(this, iv, ck);
	
	  this._prev = Buffer.from(iv);
	  this._cache = Buffer.allocUnsafe(0);
	  this._secCache = Buffer.allocUnsafe(0);
	  this._decrypt = decrypt;
	  this._alen = 0;
	  this._len = 0;
	  this._mode = mode;
	
	  this._authTag = null;
	  this._called = false;
	}
	
	inherits(StreamCipher, Transform);
	
	StreamCipher.prototype._update = function (chunk) {
	  if (!this._called && this._alen) {
	    var rump = 16 - this._alen % 16;
	    if (rump < 16) {
	      rump = Buffer.alloc(rump, 0);
	      this._ghash.update(rump);
	    }
	  }
	
	  this._called = true;
	  var out = this._mode.encrypt(this, chunk);
	  if (this._decrypt) {
	    this._ghash.update(chunk);
	  } else {
	    this._ghash.update(out);
	  }
	  this._len += chunk.length;
	  return out;
	};
	
	StreamCipher.prototype._final = function () {
	  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
	
	  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
	  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
	
	  this._authTag = tag;
	  this._cipher.scrub();
	};
	
	StreamCipher.prototype.getAuthTag = function getAuthTag() {
	  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
	
	  return this._authTag;
	};
	
	StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
	  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
	
	  this._authTag = tag;
	};
	
	StreamCipher.prototype.setAAD = function setAAD(buf) {
	  if (this._called) throw new Error('Attempting to set AAD in unsupported state');
	
	  this._ghash.update(buf);
	  this._alen += buf.length;
	};
	
	module.exports = StreamCipher;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// based on the aes implimentation in triple sec
	// https://github.com/keybase/triplesec
	// which is in turn based on the one from crypto-js
	// https://code.google.com/p/crypto-js/
	
	var Buffer = __webpack_require__(121).Buffer;
	
	function asUInt32Array(buf) {
	  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
	
	  var len = buf.length / 4 | 0;
	  var out = new Array(len);
	
	  for (var i = 0; i < len; i++) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	
	  return out;
	}
	
	function scrubVec(v) {
	  for (var i = 0; i < v.length; v++) {
	    v[i] = 0;
	  }
	}
	
	function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
	  var SUB_MIX0 = SUB_MIX[0];
	  var SUB_MIX1 = SUB_MIX[1];
	  var SUB_MIX2 = SUB_MIX[2];
	  var SUB_MIX3 = SUB_MIX[3];
	
	  var s0 = M[0] ^ keySchedule[0];
	  var s1 = M[1] ^ keySchedule[1];
	  var s2 = M[2] ^ keySchedule[2];
	  var s3 = M[3] ^ keySchedule[3];
	  var t0, t1, t2, t3;
	  var ksRow = 4;
	
	  for (var round = 1; round < nRounds; round++) {
	    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	
	  t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  t0 = t0 >>> 0;
	  t1 = t1 >>> 0;
	  t2 = t2 >>> 0;
	  t3 = t3 >>> 0;
	
	  return [t0, t1, t2, t3];
	}
	
	// AES constants
	var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	var G = function () {
	  // Compute double table
	  var d = new Array(256);
	  for (var j = 0; j < 256; j++) {
	    if (j < 128) {
	      d[j] = j << 1;
	    } else {
	      d[j] = j << 1 ^ 0x11b;
	    }
	  }
	
	  var SBOX = [];
	  var INV_SBOX = [];
	  var SUB_MIX = [[], [], [], []];
	  var INV_SUB_MIX = [[], [], [], []];
	
	  // Walk GF(2^8)
	  var x = 0;
	  var xi = 0;
	  for (var i = 0; i < 256; ++i) {
	    // Compute sbox
	    var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
	    sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
	    SBOX[x] = sx;
	    INV_SBOX[sx] = x;
	
	    // Compute multiplication
	    var x2 = d[x];
	    var x4 = d[x2];
	    var x8 = d[x4];
	
	    // Compute sub bytes, mix columns tables
	    var t = d[sx] * 0x101 ^ sx * 0x1010100;
	    SUB_MIX[0][x] = t << 24 | t >>> 8;
	    SUB_MIX[1][x] = t << 16 | t >>> 16;
	    SUB_MIX[2][x] = t << 8 | t >>> 24;
	    SUB_MIX[3][x] = t;
	
	    // Compute inv sub bytes, inv mix columns tables
	    t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	    INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
	    INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
	    INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
	    INV_SUB_MIX[3][sx] = t;
	
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	
	  return {
	    SBOX: SBOX,
	    INV_SBOX: INV_SBOX,
	    SUB_MIX: SUB_MIX,
	    INV_SUB_MIX: INV_SUB_MIX
	  };
	}();
	
	function AES(key) {
	  this._key = asUInt32Array(key);
	  this._reset();
	}
	
	AES.blockSize = 4 * 4;
	AES.keySize = 256 / 8;
	AES.prototype.blockSize = AES.blockSize;
	AES.prototype.keySize = AES.keySize;
	AES.prototype._reset = function () {
	  var keyWords = this._key;
	  var keySize = keyWords.length;
	  var nRounds = keySize + 6;
	  var ksRows = (nRounds + 1) * 4;
	
	  var keySchedule = [];
	  for (var k = 0; k < keySize; k++) {
	    keySchedule[k] = keyWords[k];
	  }
	
	  for (k = keySize; k < ksRows; k++) {
	    var t = keySchedule[k - 1];
	
	    if (k % keySize === 0) {
	      t = t << 8 | t >>> 24;
	      t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
	
	      t ^= RCON[k / keySize | 0] << 24;
	    } else if (keySize > 6 && k % keySize === 4) {
	      t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
	    }
	
	    keySchedule[k] = keySchedule[k - keySize] ^ t;
	  }
	
	  var invKeySchedule = [];
	  for (var ik = 0; ik < ksRows; ik++) {
	    var ksR = ksRows - ik;
	    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
	
	    if (ik < 4 || ksR <= 4) {
	      invKeySchedule[ik] = tt;
	    } else {
	      invKeySchedule[ik] = G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[tt >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[tt >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
	    }
	  }
	
	  this._nRounds = nRounds;
	  this._keySchedule = keySchedule;
	  this._invKeySchedule = invKeySchedule;
	};
	
	AES.prototype.encryptBlockRaw = function (M) {
	  M = asUInt32Array(M);
	  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
	};
	
	AES.prototype.encryptBlock = function (M) {
	  var out = this.encryptBlockRaw(M);
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function (M) {
	  M = asUInt32Array(M);
	
	  // swap
	  var m1 = M[1];
	  M[1] = M[3];
	  M[3] = m1;
	
	  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function () {
	  scrubVec(this._keySchedule);
	  scrubVec(this._invKeySchedule);
	  scrubVec(this._key);
	};
	
	module.exports.AES = AES;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	var ZEROES = Buffer.alloc(16, 0);
	
	function toArray(buf) {
	  return [buf.readUInt32BE(0), buf.readUInt32BE(4), buf.readUInt32BE(8), buf.readUInt32BE(12)];
	}
	
	function fromArray(out) {
	  var buf = Buffer.allocUnsafe(16);
	  buf.writeUInt32BE(out[0] >>> 0, 0);
	  buf.writeUInt32BE(out[1] >>> 0, 4);
	  buf.writeUInt32BE(out[2] >>> 0, 8);
	  buf.writeUInt32BE(out[3] >>> 0, 12);
	  return buf;
	}
	
	function GHASH(key) {
	  this.h = key;
	  this.state = Buffer.alloc(16, 0);
	  this.cache = Buffer.allocUnsafe(0);
	}
	
	// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
	// by Juho Vähä-Herttua
	GHASH.prototype.ghash = function (block) {
	  var i = -1;
	  while (++i < block.length) {
	    this.state[i] ^= block[i];
	  }
	  this._multiply();
	};
	
	GHASH.prototype._multiply = function () {
	  var Vi = toArray(this.h);
	  var Zi = [0, 0, 0, 0];
	  var j, xi, lsbVi;
	  var i = -1;
	  while (++i < 128) {
	    xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
	    if (xi) {
	      // Z_i+1 = Z_i ^ V_i
	      Zi[0] ^= Vi[0];
	      Zi[1] ^= Vi[1];
	      Zi[2] ^= Vi[2];
	      Zi[3] ^= Vi[3];
	    }
	
	    // Store the value of LSB(V_i)
	    lsbVi = (Vi[3] & 1) !== 0;
	
	    // V_i+1 = V_i >> 1
	    for (j = 3; j > 0; j--) {
	      Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
	    }
	    Vi[0] = Vi[0] >>> 1;
	
	    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
	    if (lsbVi) {
	      Vi[0] = Vi[0] ^ 0xe1 << 24;
	    }
	  }
	  this.state = fromArray(Zi);
	};
	
	GHASH.prototype.update = function (buf) {
	  this.cache = Buffer.concat([this.cache, buf]);
	  var chunk;
	  while (this.cache.length >= 16) {
	    chunk = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    this.ghash(chunk);
	  }
	};
	
	GHASH.prototype.final = function (abl, bl) {
	  if (this.cache.length) {
	    this.ghash(Buffer.concat([this.cache, ZEROES], 16));
	  }
	
	  this.ghash(fromArray([0, abl, 0, bl]));
	  return this.state;
	};
	
	module.exports = GHASH;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var aes = __webpack_require__(171);
	var Buffer = __webpack_require__(121).Buffer;
	var Transform = __webpack_require__(145);
	var inherits = __webpack_require__(111);
	
	function StreamCipher(mode, key, iv, decrypt) {
	  Transform.call(this);
	
	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._cache = Buffer.allocUnsafe(0);
	  this._secCache = Buffer.allocUnsafe(0);
	  this._decrypt = decrypt;
	  this._mode = mode;
	}
	
	inherits(StreamCipher, Transform);
	
	StreamCipher.prototype._update = function (chunk) {
	  return this._mode.encrypt(this, chunk, this._decrypt);
	};
	
	StreamCipher.prototype._final = function () {
	  this._cipher.scrub();
	};
	
	module.exports = StreamCipher;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	var MD5 = __webpack_require__(175);
	
	/* eslint-disable camelcase */
	function EVP_BytesToKey(password, salt, keyBits, ivLen) {
	  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary');
	  if (salt) {
	    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary');
	    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
	  }
	
	  var keyLen = keyBits / 8;
	  var key = Buffer.alloc(keyLen);
	  var iv = Buffer.alloc(ivLen || 0);
	  var tmp = Buffer.alloc(0);
	
	  while (keyLen > 0 || ivLen > 0) {
	    var hash = new MD5();
	    hash.update(tmp);
	    hash.update(password);
	    if (salt) hash.update(salt);
	    tmp = hash.digest();
	
	    var used = 0;
	
	    if (keyLen > 0) {
	      var keyStart = key.length - keyLen;
	      used = Math.min(keyLen, tmp.length);
	      tmp.copy(key, keyStart, 0, used);
	      keyLen -= used;
	    }
	
	    if (used < tmp.length && ivLen > 0) {
	      var ivStart = iv.length - ivLen;
	      var length = Math.min(ivLen, tmp.length - used);
	      tmp.copy(iv, ivStart, used, used + length);
	      ivLen -= length;
	    }
	  }
	
	  tmp.fill(0);
	  return { key: key, iv: iv };
	}
	
	module.exports = EVP_BytesToKey;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var inherits = __webpack_require__(111);
	var HashBase = __webpack_require__(176);
	
	var ARRAY16 = new Array(16);
	
	function MD5() {
	  HashBase.call(this, 64);
	
	  // state
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	}
	
	inherits(MD5, HashBase);
	
	MD5.prototype._update = function () {
	  var M = ARRAY16;
	  for (var i = 0; i < 16; ++i) {
	    M[i] = this._block.readInt32LE(i * 4);
	  }var a = this._a;
	  var b = this._b;
	  var c = this._c;
	  var d = this._d;
	
	  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
	  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
	  c = fnF(c, d, a, b, M[2], 0x242070db, 17);
	  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
	  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
	  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
	  c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
	  b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
	  a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
	  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
	  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
	  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
	  a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
	  d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
	  c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
	  b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
	
	  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
	  d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
	  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
	  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
	  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
	  d = fnG(d, a, b, c, M[10], 0x02441453, 9);
	  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
	  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
	  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
	  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
	  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
	  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
	  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
	  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
	  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
	  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
	
	  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
	  d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
	  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
	  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
	  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
	  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
	  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
	  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
	  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
	  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
	  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
	  b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
	  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
	  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
	  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
	  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
	
	  a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
	  d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
	  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
	  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
	  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
	  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
	  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
	  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
	  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
	  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
	  c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
	  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
	  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
	  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
	  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
	  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
	
	  this._a = this._a + a | 0;
	  this._b = this._b + b | 0;
	  this._c = this._c + c | 0;
	  this._d = this._d + d | 0;
	};
	
	MD5.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80;
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64);
	    this._update();
	    this._blockOffset = 0;
	  }
	
	  this._block.fill(0, this._blockOffset, 56);
	  this._block.writeUInt32LE(this._length[0], 56);
	  this._block.writeUInt32LE(this._length[1], 60);
	  this._update();
	
	  // produce result
	  var buffer = new Buffer(16);
	  buffer.writeInt32LE(this._a, 0);
	  buffer.writeInt32LE(this._b, 4);
	  buffer.writeInt32LE(this._c, 8);
	  buffer.writeInt32LE(this._d, 12);
	  return buffer;
	};
	
	function rotl(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function fnF(a, b, c, d, m, k, s) {
	  return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
	}
	
	function fnG(a, b, c, d, m, k, s) {
	  return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
	}
	
	function fnH(a, b, c, d, m, k, s) {
	  return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
	}
	
	function fnI(a, b, c, d, m, k, s) {
	  return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
	}
	
	module.exports = MD5;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(121).Buffer;
	var Transform = __webpack_require__(116).Transform;
	var inherits = __webpack_require__(111);
	
	function throwIfNotStringOrBuffer(val, prefix) {
	  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
	    throw new TypeError(prefix + ' must be a string or a buffer');
	  }
	}
	
	function HashBase(blockSize) {
	  Transform.call(this);
	
	  this._block = Buffer.allocUnsafe(blockSize);
	  this._blockSize = blockSize;
	  this._blockOffset = 0;
	  this._length = [0, 0, 0, 0];
	
	  this._finalized = false;
	}
	
	inherits(HashBase, Transform);
	
	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null;
	  try {
	    this.update(chunk, encoding);
	  } catch (err) {
	    error = err;
	  }
	
	  callback(error);
	};
	
	HashBase.prototype._flush = function (callback) {
	  var error = null;
	  try {
	    this.push(this.digest());
	  } catch (err) {
	    error = err;
	  }
	
	  callback(error);
	};
	
	HashBase.prototype.update = function (data, encoding) {
	  throwIfNotStringOrBuffer(data, 'Data');
	  if (this._finalized) throw new Error('Digest already called');
	  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
	
	  // consume data
	  var block = this._block;
	  var offset = 0;
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) {
	      block[i++] = data[offset++];
	    }this._update();
	    this._blockOffset = 0;
	  }
	  while (offset < data.length) {
	    block[this._blockOffset++] = data[offset++];
	  } // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry;
	    carry = this._length[j] / 0x0100000000 | 0;
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
	  }
	
	  return this;
	};
	
	HashBase.prototype._update = function () {
	  throw new Error('_update is not implemented');
	};
	
	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called');
	  this._finalized = true;
	
	  var digest = this._digest();
	  if (encoding !== undefined) digest = digest.toString(encoding);
	
	  // reset state
	  this._block.fill(0);
	  this._blockOffset = 0;
	  for (var i = 0; i < 4; ++i) {
	    this._length[i] = 0;
	  }return digest;
	};
	
	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented');
	};
	
	module.exports = HashBase;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AuthCipher = __webpack_require__(170);
	var Buffer = __webpack_require__(121).Buffer;
	var MODES = __webpack_require__(159);
	var StreamCipher = __webpack_require__(173);
	var Transform = __webpack_require__(145);
	var aes = __webpack_require__(171);
	var ebtk = __webpack_require__(174);
	var inherits = __webpack_require__(111);
	
	function Decipher(mode, key, iv) {
	  Transform.call(this);
	
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = Buffer.from(iv);
	  this._mode = mode;
	  this._autopadding = true;
	}
	
	inherits(Decipher, Transform);
	
	Decipher.prototype._update = function (data) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  var out = [];
	  while (chunk = this._cache.get(this._autopadding)) {
	    thing = this._mode.decrypt(this, chunk);
	    out.push(thing);
	  }
	  return Buffer.concat(out);
	};
	
	Decipher.prototype._final = function () {
	  var chunk = this._cache.flush();
	  if (this._autopadding) {
	    return unpad(this._mode.decrypt(this, chunk));
	  } else if (chunk) {
	    throw new Error('data not multiple of block length');
	  }
	};
	
	Decipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo;
	  return this;
	};
	
	function Splitter() {
	  this.cache = Buffer.allocUnsafe(0);
	}
	
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function (autoPadding) {
	  var out;
	  if (autoPadding) {
	    if (this.cache.length > 16) {
	      out = this.cache.slice(0, 16);
	      this.cache = this.cache.slice(16);
	      return out;
	    }
	  } else {
	    if (this.cache.length >= 16) {
	      out = this.cache.slice(0, 16);
	      this.cache = this.cache.slice(16);
	      return out;
	    }
	  }
	
	  return null;
	};
	
	Splitter.prototype.flush = function () {
	  if (this.cache.length) return this.cache;
	};
	
	function unpad(last) {
	  var padded = last[15];
	  var i = -1;
	  while (++i < padded) {
	    if (last[i + (16 - padded)] !== padded) {
	      throw new Error('unable to decrypt data');
	    }
	  }
	  if (padded === 16) return;
	
	  return last.slice(0, 16 - padded);
	}
	
	function createDecipheriv(suite, password, iv) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type');
	
	  if (typeof iv === 'string') iv = Buffer.from(iv);
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
	
	  if (typeof password === 'string') password = Buffer.from(password);
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
	
	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv, true);
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv, true);
	  }
	
	  return new Decipher(config.module, password, iv);
	}
	
	function createDecipher(suite, password) {
	  var config = MODES[suite.toLowerCase()];
	  if (!config) throw new TypeError('invalid suite type');
	
	  var keys = ebtk(password, false, config.key, config.iv);
	  return createDecipheriv(suite, keys.key, keys.iv);
	}
	
	exports.createDecipher = createDecipher;
	exports.createDecipheriv = createDecipheriv;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BigInteger = __webpack_require__(179);
	var ecurve = __webpack_require__(183);
	var secp256k1 = ecurve.getCurveByName('secp256k1');
	BigInteger = __webpack_require__(179);
	var base58 = __webpack_require__(149);
	var hash = __webpack_require__(109);
	var config = __webpack_require__(42);
	var assert = __webpack_require__(105);
	
	var G = secp256k1.G;
	var n = secp256k1.n;
	
	var PublicKey = function () {
	
	    /** @param {ecurve.Point} public key */
	    function PublicKey(Q) {
	        _classCallCheck(this, PublicKey);
	
	        this.Q = Q;
	    }
	
	    _createClass(PublicKey, [{
	        key: 'toBuffer',
	        value: function toBuffer() {
	            var compressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.Q ? this.Q.compressed : null;
	
	            if (this.Q === null) return Buffer.from("000000000000000000000000000000000000000000000000000000000000000000", "hex");
	            return this.Q.getEncoded(compressed);
	        }
	    }, {
	        key: 'toUncompressed',
	        value: function toUncompressed() {
	            var buf = this.Q.getEncoded(false);
	            var point = ecurve.Point.decodeFrom(secp256k1, buf);
	            return PublicKey.fromPoint(point);
	        }
	
	        /** bts::blockchain::address (unique but not a full public key) */
	
	    }, {
	        key: 'toBlockchainAddress',
	        value: function toBlockchainAddress() {
	            var pub_buf = this.toBuffer();
	            var pub_sha = hash.sha512(pub_buf);
	            return hash.ripemd160(pub_sha);
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            var address_prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config.get('address_prefix');
	
	            return this.toPublicKeyString(address_prefix);
	        }
	
	        /**
	            Full public key
	            {return} string
	        */
	
	    }, {
	        key: 'toPublicKeyString',
	        value: function toPublicKeyString() {
	            var address_prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config.get('address_prefix');
	
	            if (this.pubdata) return address_prefix + this.pubdata;
	            var pub_buf = this.toBuffer();
	            var checksum = hash.ripemd160(pub_buf);
	            var addy = Buffer.concat([pub_buf, checksum.slice(0, 4)]);
	            this.pubdata = base58.encode(addy);
	            return address_prefix + this.pubdata;
	        }
	
	        /**
	            @arg {string} public_key - like STMXyz...
	            @arg {string} address_prefix - like STM
	            @return PublicKey or `null` (if the public_key string is invalid)
	            @deprecated fromPublicKeyString (use fromString instead)
	        */
	
	    }, {
	        key: 'toAddressString',
	        value: function toAddressString() {
	            var address_prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config.get('address_prefix');
	
	            var pub_buf = this.toBuffer();
	            var pub_sha = hash.sha512(pub_buf);
	            var addy = hash.ripemd160(pub_sha);
	            var checksum = hash.ripemd160(addy);
	            addy = Buffer.concat([addy, checksum.slice(0, 4)]);
	            return address_prefix + base58.encode(addy);
	        }
	    }, {
	        key: 'toPtsAddy',
	        value: function toPtsAddy() {
	            var pub_buf = this.toBuffer();
	            var pub_sha = hash.sha256(pub_buf);
	            var addy = hash.ripemd160(pub_sha);
	            addy = Buffer.concat([new Buffer([0x38]), addy]); //version 56(decimal)
	
	            var checksum = hash.sha256(addy);
	            checksum = hash.sha256(checksum);
	
	            addy = Buffer.concat([addy, checksum.slice(0, 4)]);
	            return base58.encode(addy);
	        }
	    }, {
	        key: 'child',
	        value: function child(offset) {
	
	            assert(Buffer.isBuffer(offset), "Buffer required: offset");
	            assert.equal(offset.length, 32, "offset length");
	
	            offset = Buffer.concat([this.toBuffer(), offset]);
	            offset = hash.sha256(offset);
	
	            var c = BigInteger.fromBuffer(offset);
	
	            if (c.compareTo(n) >= 0) throw new Error("Child offset went out of bounds, try again");
	
	            var cG = G.multiply(c);
	            var Qprime = this.Q.add(cG);
	
	            if (secp256k1.isInfinity(Qprime)) throw new Error("Child offset derived to an invalid key, try again");
	
	            return PublicKey.fromPoint(Qprime);
	        }
	
	        // toByteBuffer() {
	        //     var b = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	        //     this.appendByteBuffer(b);
	        //     return b.copy(0, b.offset);
	        // }
	
	    }, {
	        key: 'toHex',
	        value: function toHex() {
	            return this.toBuffer().toString('hex');
	        }
	    }], [{
	        key: 'fromBinary',
	        value: function fromBinary(bin) {
	            return PublicKey.fromBuffer(new Buffer(bin, 'binary'));
	        }
	    }, {
	        key: 'fromBuffer',
	        value: function fromBuffer(buffer) {
	            if (buffer.toString("hex") === "000000000000000000000000000000000000000000000000000000000000000000") return new PublicKey(null);
	            return new PublicKey(ecurve.Point.decodeFrom(secp256k1, buffer));
	        }
	    }, {
	        key: 'fromPoint',
	        value: function fromPoint(point) {
	            return new PublicKey(point);
	        }
	    }, {
	        key: 'fromString',
	        value: function fromString(public_key) {
	            var address_prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.get('address_prefix');
	
	            try {
	                return PublicKey.fromStringOrThrow(public_key, address_prefix);
	            } catch (e) {
	                return null;
	            }
	        }
	
	        /**
	            @arg {string} public_key - like STMXyz...
	            @arg {string} address_prefix - like STM
	            @throws {Error} if public key is invalid
	            @return PublicKey
	        */
	
	    }, {
	        key: 'fromStringOrThrow',
	        value: function fromStringOrThrow(public_key) {
	            var address_prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.get('address_prefix');
	
	            var prefix = public_key.slice(0, address_prefix.length);
	            assert.equal(address_prefix, prefix, 'Expecting key to begin with ' + address_prefix + ', instead got ' + prefix);
	            public_key = public_key.slice(address_prefix.length);
	
	            public_key = new Buffer(base58.decode(public_key), 'binary');
	            var checksum = public_key.slice(-4);
	            public_key = public_key.slice(0, -4);
	            var new_checksum = hash.ripemd160(public_key);
	            new_checksum = new_checksum.slice(0, 4);
	            assert.deepEqual(checksum, new_checksum, 'Checksum did not match');
	            return PublicKey.fromBuffer(public_key);
	        }
	    }, {
	        key: 'fromHex',
	        value: function fromHex(hex) {
	            return PublicKey.fromBuffer(new Buffer(hex, 'hex'));
	        }
	    }, {
	        key: 'fromStringHex',
	        value: function fromStringHex(hex) {
	            return PublicKey.fromString(new Buffer(hex, 'hex'));
	        }
	
	        /* </HEX> */
	
	    }]);
	
	    return PublicKey;
	}();
	
	module.exports = PublicKey;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var BigInteger = __webpack_require__(180);
	
	//addons
	__webpack_require__(182);
	
	module.exports = BigInteger;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// (public) Constructor
	function BigInteger(a, b, c) {
	  if (!(this instanceof BigInteger)) return new BigInteger(a, b, c);
	
	  if (a != null) {
	    if ("number" == typeof a) this.fromNumber(a, b, c);else if (b == null && "string" != typeof a) this.fromString(a, 256);else this.fromString(a, b);
	  }
	}
	
	var proto = BigInteger.prototype;
	
	// duck-typed isBigInteger
	proto.__bigi = __webpack_require__(181).version;
	BigInteger.isBigInteger = function (obj, check_ver) {
	  return obj && obj.__bigi && (!check_ver || obj.__bigi === proto.__bigi);
	};
	
	// Bits per digit
	var dbits;
	
	// am: Compute w_j += (x*this_i), propagate carries,
	// c is initial carry, returns final carry.
	// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
	// We need to select the fastest one that works in this environment.
	
	// am1: use a single mult and divide to get the high bits,
	// max digit bits should be 26 because
	// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
	function am1(i, x, w, j, c, n) {
	  while (--n >= 0) {
	    var v = x * this[i++] + w[j] + c;
	    c = Math.floor(v / 0x4000000);
	    w[j++] = v & 0x3ffffff;
	  }
	  return c;
	}
	// am2 avoids a big mult-and-extract completely.
	// Max digit bits should be <= 30 because we do bitwise ops
	// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
	function am2(i, x, w, j, c, n) {
	  var xl = x & 0x7fff,
	      xh = x >> 15;
	  while (--n >= 0) {
	    var l = this[i] & 0x7fff;
	    var h = this[i++] >> 15;
	    var m = xh * l + h * xl;
	    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
	    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
	    w[j++] = l & 0x3fffffff;
	  }
	  return c;
	}
	// Alternately, set max digit bits to 28 since some
	// browsers slow down when dealing with 32-bit numbers.
	function am3(i, x, w, j, c, n) {
	  var xl = x & 0x3fff,
	      xh = x >> 14;
	  while (--n >= 0) {
	    var l = this[i] & 0x3fff;
	    var h = this[i++] >> 14;
	    var m = xh * l + h * xl;
	    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
	    c = (l >> 28) + (m >> 14) + xh * h;
	    w[j++] = l & 0xfffffff;
	  }
	  return c;
	}
	
	// wtf?
	BigInteger.prototype.am = am1;
	dbits = 26;
	
	BigInteger.prototype.DB = dbits;
	BigInteger.prototype.DM = (1 << dbits) - 1;
	var DV = BigInteger.prototype.DV = 1 << dbits;
	
	var BI_FP = 52;
	BigInteger.prototype.FV = Math.pow(2, BI_FP);
	BigInteger.prototype.F1 = BI_FP - dbits;
	BigInteger.prototype.F2 = 2 * dbits - BI_FP;
	
	// Digit conversions
	var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
	var BI_RC = new Array();
	var rr, vv;
	rr = "0".charCodeAt(0);
	for (vv = 0; vv <= 9; ++vv) {
	  BI_RC[rr++] = vv;
	}rr = "a".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	  BI_RC[rr++] = vv;
	}rr = "A".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	  BI_RC[rr++] = vv;
	}function int2char(n) {
	  return BI_RM.charAt(n);
	}
	
	function intAt(s, i) {
	  var c = BI_RC[s.charCodeAt(i)];
	  return c == null ? -1 : c;
	}
	
	// (protected) copy this to r
	function bnpCopyTo(r) {
	  for (var i = this.t - 1; i >= 0; --i) {
	    r[i] = this[i];
	  }r.t = this.t;
	  r.s = this.s;
	}
	
	// (protected) set from integer value x, -DV <= x < DV
	function bnpFromInt(x) {
	  this.t = 1;
	  this.s = x < 0 ? -1 : 0;
	  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + DV;else this.t = 0;
	}
	
	// return bigint initialized to value
	function nbv(i) {
	  var r = new BigInteger();
	  r.fromInt(i);
	  return r;
	}
	
	// (protected) set from string and radix
	function bnpFromString(s, b) {
	  var self = this;
	
	  var k;
	  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 256) k = 8; // byte array
	  else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else {
	      self.fromRadix(s, b);
	      return;
	    }
	  self.t = 0;
	  self.s = 0;
	  var i = s.length,
	      mi = false,
	      sh = 0;
	  while (--i >= 0) {
	    var x = k == 8 ? s[i] & 0xff : intAt(s, i);
	    if (x < 0) {
	      if (s.charAt(i) == "-") mi = true;
	      continue;
	    }
	    mi = false;
	    if (sh == 0) self[self.t++] = x;else if (sh + k > self.DB) {
	      self[self.t - 1] |= (x & (1 << self.DB - sh) - 1) << sh;
	      self[self.t++] = x >> self.DB - sh;
	    } else self[self.t - 1] |= x << sh;
	    sh += k;
	    if (sh >= self.DB) sh -= self.DB;
	  }
	  if (k == 8 && (s[0] & 0x80) != 0) {
	    self.s = -1;
	    if (sh > 0) self[self.t - 1] |= (1 << self.DB - sh) - 1 << sh;
	  }
	  self.clamp();
	  if (mi) BigInteger.ZERO.subTo(self, self);
	}
	
	// (protected) clamp off excess high words
	function bnpClamp() {
	  var c = this.s & this.DM;
	  while (this.t > 0 && this[this.t - 1] == c) {
	    --this.t;
	  }
	}
	
	// (public) return string representation in given radix
	function bnToString(b) {
	  var self = this;
	  if (self.s < 0) return "-" + self.negate().toString(b);
	  var k;
	  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else return self.toRadix(b);
	  var km = (1 << k) - 1,
	      d,
	      m = false,
	      r = "",
	      i = self.t;
	  var p = self.DB - i * self.DB % k;
	  if (i-- > 0) {
	    if (p < self.DB && (d = self[i] >> p) > 0) {
	      m = true;
	      r = int2char(d);
	    }
	    while (i >= 0) {
	      if (p < k) {
	        d = (self[i] & (1 << p) - 1) << k - p;
	        d |= self[--i] >> (p += self.DB - k);
	      } else {
	        d = self[i] >> (p -= k) & km;
	        if (p <= 0) {
	          p += self.DB;
	          --i;
	        }
	      }
	      if (d > 0) m = true;
	      if (m) r += int2char(d);
	    }
	  }
	  return m ? r : "0";
	}
	
	// (public) -this
	function bnNegate() {
	  var r = new BigInteger();
	  BigInteger.ZERO.subTo(this, r);
	  return r;
	}
	
	// (public) |this|
	function bnAbs() {
	  return this.s < 0 ? this.negate() : this;
	}
	
	// (public) return + if this > a, - if this < a, 0 if equal
	function bnCompareTo(a) {
	  var r = this.s - a.s;
	  if (r != 0) return r;
	  var i = this.t;
	  r = i - a.t;
	  if (r != 0) return this.s < 0 ? -r : r;
	  while (--i >= 0) {
	    if ((r = this[i] - a[i]) != 0) return r;
	  }return 0;
	}
	
	// returns bit length of the integer x
	function nbits(x) {
	  var r = 1,
	      t;
	  if ((t = x >>> 16) != 0) {
	    x = t;
	    r += 16;
	  }
	  if ((t = x >> 8) != 0) {
	    x = t;
	    r += 8;
	  }
	  if ((t = x >> 4) != 0) {
	    x = t;
	    r += 4;
	  }
	  if ((t = x >> 2) != 0) {
	    x = t;
	    r += 2;
	  }
	  if ((t = x >> 1) != 0) {
	    x = t;
	    r += 1;
	  }
	  return r;
	}
	
	// (public) return the number of bits in "this"
	function bnBitLength() {
	  if (this.t <= 0) return 0;
	  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
	}
	
	// (public) return the number of bytes in "this"
	function bnByteLength() {
	  return this.bitLength() >> 3;
	}
	
	// (protected) r = this << n*DB
	function bnpDLShiftTo(n, r) {
	  var i;
	  for (i = this.t - 1; i >= 0; --i) {
	    r[i + n] = this[i];
	  }for (i = n - 1; i >= 0; --i) {
	    r[i] = 0;
	  }r.t = this.t + n;
	  r.s = this.s;
	}
	
	// (protected) r = this >> n*DB
	function bnpDRShiftTo(n, r) {
	  for (var i = n; i < this.t; ++i) {
	    r[i - n] = this[i];
	  }r.t = Math.max(this.t - n, 0);
	  r.s = this.s;
	}
	
	// (protected) r = this << n
	function bnpLShiftTo(n, r) {
	  var self = this;
	  var bs = n % self.DB;
	  var cbs = self.DB - bs;
	  var bm = (1 << cbs) - 1;
	  var ds = Math.floor(n / self.DB),
	      c = self.s << bs & self.DM,
	      i;
	  for (i = self.t - 1; i >= 0; --i) {
	    r[i + ds + 1] = self[i] >> cbs | c;
	    c = (self[i] & bm) << bs;
	  }
	  for (i = ds - 1; i >= 0; --i) {
	    r[i] = 0;
	  }r[ds] = c;
	  r.t = self.t + ds + 1;
	  r.s = self.s;
	  r.clamp();
	}
	
	// (protected) r = this >> n
	function bnpRShiftTo(n, r) {
	  var self = this;
	  r.s = self.s;
	  var ds = Math.floor(n / self.DB);
	  if (ds >= self.t) {
	    r.t = 0;
	    return;
	  }
	  var bs = n % self.DB;
	  var cbs = self.DB - bs;
	  var bm = (1 << bs) - 1;
	  r[0] = self[ds] >> bs;
	  for (var i = ds + 1; i < self.t; ++i) {
	    r[i - ds - 1] |= (self[i] & bm) << cbs;
	    r[i - ds] = self[i] >> bs;
	  }
	  if (bs > 0) r[self.t - ds - 1] |= (self.s & bm) << cbs;
	  r.t = self.t - ds;
	  r.clamp();
	}
	
	// (protected) r = this - a
	function bnpSubTo(a, r) {
	  var self = this;
	  var i = 0,
	      c = 0,
	      m = Math.min(a.t, self.t);
	  while (i < m) {
	    c += self[i] - a[i];
	    r[i++] = c & self.DM;
	    c >>= self.DB;
	  }
	  if (a.t < self.t) {
	    c -= a.s;
	    while (i < self.t) {
	      c += self[i];
	      r[i++] = c & self.DM;
	      c >>= self.DB;
	    }
	    c += self.s;
	  } else {
	    c += self.s;
	    while (i < a.t) {
	      c -= a[i];
	      r[i++] = c & self.DM;
	      c >>= self.DB;
	    }
	    c -= a.s;
	  }
	  r.s = c < 0 ? -1 : 0;
	  if (c < -1) r[i++] = self.DV + c;else if (c > 0) r[i++] = c;
	  r.t = i;
	  r.clamp();
	}
	
	// (protected) r = this * a, r != this,a (HAC 14.12)
	// "this" should be the larger one if appropriate.
	function bnpMultiplyTo(a, r) {
	  var x = this.abs(),
	      y = a.abs();
	  var i = x.t;
	  r.t = i + y.t;
	  while (--i >= 0) {
	    r[i] = 0;
	  }for (i = 0; i < y.t; ++i) {
	    r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
	  }r.s = 0;
	  r.clamp();
	  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
	}
	
	// (protected) r = this^2, r != this (HAC 14.16)
	function bnpSquareTo(r) {
	  var x = this.abs();
	  var i = r.t = 2 * x.t;
	  while (--i >= 0) {
	    r[i] = 0;
	  }for (i = 0; i < x.t - 1; ++i) {
	    var c = x.am(i, x[i], r, 2 * i, 0, 1);
	    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
	      r[i + x.t] -= x.DV;
	      r[i + x.t + 1] = 1;
	    }
	  }
	  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
	  r.s = 0;
	  r.clamp();
	}
	
	// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
	// r != q, this != m.  q or r may be null.
	function bnpDivRemTo(m, q, r) {
	  var self = this;
	  var pm = m.abs();
	  if (pm.t <= 0) return;
	  var pt = self.abs();
	  if (pt.t < pm.t) {
	    if (q != null) q.fromInt(0);
	    if (r != null) self.copyTo(r);
	    return;
	  }
	  if (r == null) r = new BigInteger();
	  var y = new BigInteger(),
	      ts = self.s,
	      ms = m.s;
	  var nsh = self.DB - nbits(pm[pm.t - 1]); // normalize modulus
	  if (nsh > 0) {
	    pm.lShiftTo(nsh, y);
	    pt.lShiftTo(nsh, r);
	  } else {
	    pm.copyTo(y);
	    pt.copyTo(r);
	  }
	  var ys = y.t;
	  var y0 = y[ys - 1];
	  if (y0 == 0) return;
	  var yt = y0 * (1 << self.F1) + (ys > 1 ? y[ys - 2] >> self.F2 : 0);
	  var d1 = self.FV / yt,
	      d2 = (1 << self.F1) / yt,
	      e = 1 << self.F2;
	  var i = r.t,
	      j = i - ys,
	      t = q == null ? new BigInteger() : q;
	  y.dlShiftTo(j, t);
	  if (r.compareTo(t) >= 0) {
	    r[r.t++] = 1;
	    r.subTo(t, r);
	  }
	  BigInteger.ONE.dlShiftTo(ys, t);
	  t.subTo(y, y); // "negative" y so we can replace sub with am later
	  while (y.t < ys) {
	    y[y.t++] = 0;
	  }while (--j >= 0) {
	    // Estimate quotient digit
	    var qd = r[--i] == y0 ? self.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
	    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
	      // Try it out
	      y.dlShiftTo(j, t);
	      r.subTo(t, r);
	      while (r[i] < --qd) {
	        r.subTo(t, r);
	      }
	    }
	  }
	  if (q != null) {
	    r.drShiftTo(ys, q);
	    if (ts != ms) BigInteger.ZERO.subTo(q, q);
	  }
	  r.t = ys;
	  r.clamp();
	  if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
	  if (ts < 0) BigInteger.ZERO.subTo(r, r);
	}
	
	// (public) this mod a
	function bnMod(a) {
	  var r = new BigInteger();
	  this.abs().divRemTo(a, null, r);
	  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
	  return r;
	}
	
	// Modular reduction using "classic" algorithm
	function Classic(m) {
	  this.m = m;
	}
	
	function cConvert(x) {
	  if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);else return x;
	}
	
	function cRevert(x) {
	  return x;
	}
	
	function cReduce(x) {
	  x.divRemTo(this.m, null, x);
	}
	
	function cMulTo(x, y, r) {
	  x.multiplyTo(y, r);
	  this.reduce(r);
	}
	
	function cSqrTo(x, r) {
	  x.squareTo(r);
	  this.reduce(r);
	}
	
	Classic.prototype.convert = cConvert;
	Classic.prototype.revert = cRevert;
	Classic.prototype.reduce = cReduce;
	Classic.prototype.mulTo = cMulTo;
	Classic.prototype.sqrTo = cSqrTo;
	
	// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
	// justification:
	//         xy == 1 (mod m)
	//         xy =  1+km
	//   xy(2-xy) = (1+km)(1-km)
	// x[y(2-xy)] = 1-k^2m^2
	// x[y(2-xy)] == 1 (mod m^2)
	// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
	// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
	// JS multiply "overflows" differently from C/C++, so care is needed here.
	function bnpInvDigit() {
	  if (this.t < 1) return 0;
	  var x = this[0];
	  if ((x & 1) == 0) return 0;
	  var y = x & 3; // y == 1/x mod 2^2
	  y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
	  y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
	  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
	  // last step - calculate inverse mod DV directly
	  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	  y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
	  // we really want the negative inverse, and -DV < y < DV
	  return y > 0 ? this.DV - y : -y;
	}
	
	// Montgomery reduction
	function Montgomery(m) {
	  this.m = m;
	  this.mp = m.invDigit();
	  this.mpl = this.mp & 0x7fff;
	  this.mph = this.mp >> 15;
	  this.um = (1 << m.DB - 15) - 1;
	  this.mt2 = 2 * m.t;
	}
	
	// xR mod m
	function montConvert(x) {
	  var r = new BigInteger();
	  x.abs().dlShiftTo(this.m.t, r);
	  r.divRemTo(this.m, null, r);
	  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
	  return r;
	}
	
	// x/R mod m
	function montRevert(x) {
	  var r = new BigInteger();
	  x.copyTo(r);
	  this.reduce(r);
	  return r;
	}
	
	// x = x/R mod m (HAC 14.32)
	function montReduce(x) {
	  while (x.t <= this.mt2) {
	    // pad x so am has enough room later
	    x[x.t++] = 0;
	  }for (var i = 0; i < this.m.t; ++i) {
	    // faster way of calculating u0 = x[i]*mp mod DV
	    var j = x[i] & 0x7fff;
	    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
	    // use am to combine the multiply-shift-add into one call
	    j = i + this.m.t;
	    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
	    // propagate carry
	    while (x[j] >= x.DV) {
	      x[j] -= x.DV;
	      x[++j]++;
	    }
	  }
	  x.clamp();
	  x.drShiftTo(this.m.t, x);
	  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
	}
	
	// r = "x^2/R mod m"; x != r
	function montSqrTo(x, r) {
	  x.squareTo(r);
	  this.reduce(r);
	}
	
	// r = "xy/R mod m"; x,y != r
	function montMulTo(x, y, r) {
	  x.multiplyTo(y, r);
	  this.reduce(r);
	}
	
	Montgomery.prototype.convert = montConvert;
	Montgomery.prototype.revert = montRevert;
	Montgomery.prototype.reduce = montReduce;
	Montgomery.prototype.mulTo = montMulTo;
	Montgomery.prototype.sqrTo = montSqrTo;
	
	// (protected) true iff this is even
	function bnpIsEven() {
	  return (this.t > 0 ? this[0] & 1 : this.s) == 0;
	}
	
	// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
	function bnpExp(e, z) {
	  if (e > 0xffffffff || e < 1) return BigInteger.ONE;
	  var r = new BigInteger(),
	      r2 = new BigInteger(),
	      g = z.convert(this),
	      i = nbits(e) - 1;
	  g.copyTo(r);
	  while (--i >= 0) {
	    z.sqrTo(r, r2);
	    if ((e & 1 << i) > 0) z.mulTo(r2, g, r);else {
	      var t = r;
	      r = r2;
	      r2 = t;
	    }
	  }
	  return z.revert(r);
	}
	
	// (public) this^e % m, 0 <= e < 2^32
	function bnModPowInt(e, m) {
	  var z;
	  if (e < 256 || m.isEven()) z = new Classic(m);else z = new Montgomery(m);
	  return this.exp(e, z);
	}
	
	// protected
	proto.copyTo = bnpCopyTo;
	proto.fromInt = bnpFromInt;
	proto.fromString = bnpFromString;
	proto.clamp = bnpClamp;
	proto.dlShiftTo = bnpDLShiftTo;
	proto.drShiftTo = bnpDRShiftTo;
	proto.lShiftTo = bnpLShiftTo;
	proto.rShiftTo = bnpRShiftTo;
	proto.subTo = bnpSubTo;
	proto.multiplyTo = bnpMultiplyTo;
	proto.squareTo = bnpSquareTo;
	proto.divRemTo = bnpDivRemTo;
	proto.invDigit = bnpInvDigit;
	proto.isEven = bnpIsEven;
	proto.exp = bnpExp;
	
	// public
	proto.toString = bnToString;
	proto.negate = bnNegate;
	proto.abs = bnAbs;
	proto.compareTo = bnCompareTo;
	proto.bitLength = bnBitLength;
	proto.byteLength = bnByteLength;
	proto.mod = bnMod;
	proto.modPowInt = bnModPowInt;
	
	// (public)
	function bnClone() {
	  var r = new BigInteger();
	  this.copyTo(r);
	  return r;
	}
	
	// (public) return value as integer
	function bnIntValue() {
	  if (this.s < 0) {
	    if (this.t == 1) return this[0] - this.DV;else if (this.t == 0) return -1;
	  } else if (this.t == 1) return this[0];else if (this.t == 0) return 0;
	  // assumes 16 < DB < 32
	  return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
	}
	
	// (public) return value as byte
	function bnByteValue() {
	  return this.t == 0 ? this.s : this[0] << 24 >> 24;
	}
	
	// (public) return value as short (assumes DB>=16)
	function bnShortValue() {
	  return this.t == 0 ? this.s : this[0] << 16 >> 16;
	}
	
	// (protected) return x s.t. r^x < DV
	function bnpChunkSize(r) {
	  return Math.floor(Math.LN2 * this.DB / Math.log(r));
	}
	
	// (public) 0 if this == 0, 1 if this > 0
	function bnSigNum() {
	  if (this.s < 0) return -1;else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;else return 1;
	}
	
	// (protected) convert to radix string
	function bnpToRadix(b) {
	  if (b == null) b = 10;
	  if (this.signum() == 0 || b < 2 || b > 36) return "0";
	  var cs = this.chunkSize(b);
	  var a = Math.pow(b, cs);
	  var d = nbv(a),
	      y = new BigInteger(),
	      z = new BigInteger(),
	      r = "";
	  this.divRemTo(d, y, z);
	  while (y.signum() > 0) {
	    r = (a + z.intValue()).toString(b).substr(1) + r;
	    y.divRemTo(d, y, z);
	  }
	  return z.intValue().toString(b) + r;
	}
	
	// (protected) convert from radix string
	function bnpFromRadix(s, b) {
	  var self = this;
	  self.fromInt(0);
	  if (b == null) b = 10;
	  var cs = self.chunkSize(b);
	  var d = Math.pow(b, cs),
	      mi = false,
	      j = 0,
	      w = 0;
	  for (var i = 0; i < s.length; ++i) {
	    var x = intAt(s, i);
	    if (x < 0) {
	      if (s.charAt(i) == "-" && self.signum() == 0) mi = true;
	      continue;
	    }
	    w = b * w + x;
	    if (++j >= cs) {
	      self.dMultiply(d);
	      self.dAddOffset(w, 0);
	      j = 0;
	      w = 0;
	    }
	  }
	  if (j > 0) {
	    self.dMultiply(Math.pow(b, j));
	    self.dAddOffset(w, 0);
	  }
	  if (mi) BigInteger.ZERO.subTo(self, self);
	}
	
	// (protected) alternate constructor
	function bnpFromNumber(a, b, c) {
	  var self = this;
	  if ("number" == typeof b) {
	    // new BigInteger(int,int,RNG)
	    if (a < 2) self.fromInt(1);else {
	      self.fromNumber(a, c);
	      if (!self.testBit(a - 1)) // force MSB set
	        self.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, self);
	      if (self.isEven()) self.dAddOffset(1, 0); // force odd
	      while (!self.isProbablePrime(b)) {
	        self.dAddOffset(2, 0);
	        if (self.bitLength() > a) self.subTo(BigInteger.ONE.shiftLeft(a - 1), self);
	      }
	    }
	  } else {
	    // new BigInteger(int,RNG)
	    var x = new Array(),
	        t = a & 7;
	    x.length = (a >> 3) + 1;
	    b.nextBytes(x);
	    if (t > 0) x[0] &= (1 << t) - 1;else x[0] = 0;
	    self.fromString(x, 256);
	  }
	}
	
	// (public) convert to bigendian byte array
	function bnToByteArray() {
	  var self = this;
	  var i = self.t,
	      r = new Array();
	  r[0] = self.s;
	  var p = self.DB - i * self.DB % 8,
	      d,
	      k = 0;
	  if (i-- > 0) {
	    if (p < self.DB && (d = self[i] >> p) != (self.s & self.DM) >> p) r[k++] = d | self.s << self.DB - p;
	    while (i >= 0) {
	      if (p < 8) {
	        d = (self[i] & (1 << p) - 1) << 8 - p;
	        d |= self[--i] >> (p += self.DB - 8);
	      } else {
	        d = self[i] >> (p -= 8) & 0xff;
	        if (p <= 0) {
	          p += self.DB;
	          --i;
	        }
	      }
	      if ((d & 0x80) != 0) d |= -256;
	      if (k === 0 && (self.s & 0x80) != (d & 0x80)) ++k;
	      if (k > 0 || d != self.s) r[k++] = d;
	    }
	  }
	  return r;
	}
	
	function bnEquals(a) {
	  return this.compareTo(a) == 0;
	}
	
	function bnMin(a) {
	  return this.compareTo(a) < 0 ? this : a;
	}
	
	function bnMax(a) {
	  return this.compareTo(a) > 0 ? this : a;
	}
	
	// (protected) r = this op a (bitwise)
	function bnpBitwiseTo(a, op, r) {
	  var self = this;
	  var i,
	      f,
	      m = Math.min(a.t, self.t);
	  for (i = 0; i < m; ++i) {
	    r[i] = op(self[i], a[i]);
	  }if (a.t < self.t) {
	    f = a.s & self.DM;
	    for (i = m; i < self.t; ++i) {
	      r[i] = op(self[i], f);
	    }r.t = self.t;
	  } else {
	    f = self.s & self.DM;
	    for (i = m; i < a.t; ++i) {
	      r[i] = op(f, a[i]);
	    }r.t = a.t;
	  }
	  r.s = op(self.s, a.s);
	  r.clamp();
	}
	
	// (public) this & a
	function op_and(x, y) {
	  return x & y;
	}
	
	function bnAnd(a) {
	  var r = new BigInteger();
	  this.bitwiseTo(a, op_and, r);
	  return r;
	}
	
	// (public) this | a
	function op_or(x, y) {
	  return x | y;
	}
	
	function bnOr(a) {
	  var r = new BigInteger();
	  this.bitwiseTo(a, op_or, r);
	  return r;
	}
	
	// (public) this ^ a
	function op_xor(x, y) {
	  return x ^ y;
	}
	
	function bnXor(a) {
	  var r = new BigInteger();
	  this.bitwiseTo(a, op_xor, r);
	  return r;
	}
	
	// (public) this & ~a
	function op_andnot(x, y) {
	  return x & ~y;
	}
	
	function bnAndNot(a) {
	  var r = new BigInteger();
	  this.bitwiseTo(a, op_andnot, r);
	  return r;
	}
	
	// (public) ~this
	function bnNot() {
	  var r = new BigInteger();
	  for (var i = 0; i < this.t; ++i) {
	    r[i] = this.DM & ~this[i];
	  }r.t = this.t;
	  r.s = ~this.s;
	  return r;
	}
	
	// (public) this << n
	function bnShiftLeft(n) {
	  var r = new BigInteger();
	  if (n < 0) this.rShiftTo(-n, r);else this.lShiftTo(n, r);
	  return r;
	}
	
	// (public) this >> n
	function bnShiftRight(n) {
	  var r = new BigInteger();
	  if (n < 0) this.lShiftTo(-n, r);else this.rShiftTo(n, r);
	  return r;
	}
	
	// return index of lowest 1-bit in x, x < 2^31
	function lbit(x) {
	  if (x == 0) return -1;
	  var r = 0;
	  if ((x & 0xffff) == 0) {
	    x >>= 16;
	    r += 16;
	  }
	  if ((x & 0xff) == 0) {
	    x >>= 8;
	    r += 8;
	  }
	  if ((x & 0xf) == 0) {
	    x >>= 4;
	    r += 4;
	  }
	  if ((x & 3) == 0) {
	    x >>= 2;
	    r += 2;
	  }
	  if ((x & 1) == 0) ++r;
	  return r;
	}
	
	// (public) returns index of lowest 1-bit (or -1 if none)
	function bnGetLowestSetBit() {
	  for (var i = 0; i < this.t; ++i) {
	    if (this[i] != 0) return i * this.DB + lbit(this[i]);
	  }if (this.s < 0) return this.t * this.DB;
	  return -1;
	}
	
	// return number of 1 bits in x
	function cbit(x) {
	  var r = 0;
	  while (x != 0) {
	    x &= x - 1;
	    ++r;
	  }
	  return r;
	}
	
	// (public) return number of set bits
	function bnBitCount() {
	  var r = 0,
	      x = this.s & this.DM;
	  for (var i = 0; i < this.t; ++i) {
	    r += cbit(this[i] ^ x);
	  }return r;
	}
	
	// (public) true iff nth bit is set
	function bnTestBit(n) {
	  var j = Math.floor(n / this.DB);
	  if (j >= this.t) return this.s != 0;
	  return (this[j] & 1 << n % this.DB) != 0;
	}
	
	// (protected) this op (1<<n)
	function bnpChangeBit(n, op) {
	  var r = BigInteger.ONE.shiftLeft(n);
	  this.bitwiseTo(r, op, r);
	  return r;
	}
	
	// (public) this | (1<<n)
	function bnSetBit(n) {
	  return this.changeBit(n, op_or);
	}
	
	// (public) this & ~(1<<n)
	function bnClearBit(n) {
	  return this.changeBit(n, op_andnot);
	}
	
	// (public) this ^ (1<<n)
	function bnFlipBit(n) {
	  return this.changeBit(n, op_xor);
	}
	
	// (protected) r = this + a
	function bnpAddTo(a, r) {
	  var self = this;
	
	  var i = 0,
	      c = 0,
	      m = Math.min(a.t, self.t);
	  while (i < m) {
	    c += self[i] + a[i];
	    r[i++] = c & self.DM;
	    c >>= self.DB;
	  }
	  if (a.t < self.t) {
	    c += a.s;
	    while (i < self.t) {
	      c += self[i];
	      r[i++] = c & self.DM;
	      c >>= self.DB;
	    }
	    c += self.s;
	  } else {
	    c += self.s;
	    while (i < a.t) {
	      c += a[i];
	      r[i++] = c & self.DM;
	      c >>= self.DB;
	    }
	    c += a.s;
	  }
	  r.s = c < 0 ? -1 : 0;
	  if (c > 0) r[i++] = c;else if (c < -1) r[i++] = self.DV + c;
	  r.t = i;
	  r.clamp();
	}
	
	// (public) this + a
	function bnAdd(a) {
	  var r = new BigInteger();
	  this.addTo(a, r);
	  return r;
	}
	
	// (public) this - a
	function bnSubtract(a) {
	  var r = new BigInteger();
	  this.subTo(a, r);
	  return r;
	}
	
	// (public) this * a
	function bnMultiply(a) {
	  var r = new BigInteger();
	  this.multiplyTo(a, r);
	  return r;
	}
	
	// (public) this^2
	function bnSquare() {
	  var r = new BigInteger();
	  this.squareTo(r);
	  return r;
	}
	
	// (public) this / a
	function bnDivide(a) {
	  var r = new BigInteger();
	  this.divRemTo(a, r, null);
	  return r;
	}
	
	// (public) this % a
	function bnRemainder(a) {
	  var r = new BigInteger();
	  this.divRemTo(a, null, r);
	  return r;
	}
	
	// (public) [this/a,this%a]
	function bnDivideAndRemainder(a) {
	  var q = new BigInteger(),
	      r = new BigInteger();
	  this.divRemTo(a, q, r);
	  return new Array(q, r);
	}
	
	// (protected) this *= n, this >= 0, 1 < n < DV
	function bnpDMultiply(n) {
	  this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
	  ++this.t;
	  this.clamp();
	}
	
	// (protected) this += n << w words, this >= 0
	function bnpDAddOffset(n, w) {
	  if (n == 0) return;
	  while (this.t <= w) {
	    this[this.t++] = 0;
	  }this[w] += n;
	  while (this[w] >= this.DV) {
	    this[w] -= this.DV;
	    if (++w >= this.t) this[this.t++] = 0;
	    ++this[w];
	  }
	}
	
	// A "null" reducer
	function NullExp() {}
	
	function nNop(x) {
	  return x;
	}
	
	function nMulTo(x, y, r) {
	  x.multiplyTo(y, r);
	}
	
	function nSqrTo(x, r) {
	  x.squareTo(r);
	}
	
	NullExp.prototype.convert = nNop;
	NullExp.prototype.revert = nNop;
	NullExp.prototype.mulTo = nMulTo;
	NullExp.prototype.sqrTo = nSqrTo;
	
	// (public) this^e
	function bnPow(e) {
	  return this.exp(e, new NullExp());
	}
	
	// (protected) r = lower n words of "this * a", a.t <= n
	// "this" should be the larger one if appropriate.
	function bnpMultiplyLowerTo(a, n, r) {
	  var i = Math.min(this.t + a.t, n);
	  r.s = 0; // assumes a,this >= 0
	  r.t = i;
	  while (i > 0) {
	    r[--i] = 0;
	  }var j;
	  for (j = r.t - this.t; i < j; ++i) {
	    r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
	  }for (j = Math.min(a.t, n); i < j; ++i) {
	    this.am(0, a[i], r, i, 0, n - i);
	  }r.clamp();
	}
	
	// (protected) r = "this * a" without lower n words, n > 0
	// "this" should be the larger one if appropriate.
	function bnpMultiplyUpperTo(a, n, r) {
	  --n;
	  var i = r.t = this.t + a.t - n;
	  r.s = 0; // assumes a,this >= 0
	  while (--i >= 0) {
	    r[i] = 0;
	  }for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
	    r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
	  }r.clamp();
	  r.drShiftTo(1, r);
	}
	
	// Barrett modular reduction
	function Barrett(m) {
	  // setup Barrett
	  this.r2 = new BigInteger();
	  this.q3 = new BigInteger();
	  BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
	  this.mu = this.r2.divide(m);
	  this.m = m;
	}
	
	function barrettConvert(x) {
	  if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);else if (x.compareTo(this.m) < 0) return x;else {
	    var r = new BigInteger();
	    x.copyTo(r);
	    this.reduce(r);
	    return r;
	  }
	}
	
	function barrettRevert(x) {
	  return x;
	}
	
	// x = x mod m (HAC 14.42)
	function barrettReduce(x) {
	  var self = this;
	  x.drShiftTo(self.m.t - 1, self.r2);
	  if (x.t > self.m.t + 1) {
	    x.t = self.m.t + 1;
	    x.clamp();
	  }
	  self.mu.multiplyUpperTo(self.r2, self.m.t + 1, self.q3);
	  self.m.multiplyLowerTo(self.q3, self.m.t + 1, self.r2);
	  while (x.compareTo(self.r2) < 0) {
	    x.dAddOffset(1, self.m.t + 1);
	  }x.subTo(self.r2, x);
	  while (x.compareTo(self.m) >= 0) {
	    x.subTo(self.m, x);
	  }
	}
	
	// r = x^2 mod m; x != r
	function barrettSqrTo(x, r) {
	  x.squareTo(r);
	  this.reduce(r);
	}
	
	// r = x*y mod m; x,y != r
	function barrettMulTo(x, y, r) {
	  x.multiplyTo(y, r);
	  this.reduce(r);
	}
	
	Barrett.prototype.convert = barrettConvert;
	Barrett.prototype.revert = barrettRevert;
	Barrett.prototype.reduce = barrettReduce;
	Barrett.prototype.mulTo = barrettMulTo;
	Barrett.prototype.sqrTo = barrettSqrTo;
	
	// (public) this^e % m (HAC 14.85)
	function bnModPow(e, m) {
	  var i = e.bitLength(),
	      k,
	      r = nbv(1),
	      z;
	  if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;
	  if (i < 8) z = new Classic(m);else if (m.isEven()) z = new Barrett(m);else z = new Montgomery(m);
	
	  // precomputation
	  var g = new Array(),
	      n = 3,
	      k1 = k - 1,
	      km = (1 << k) - 1;
	  g[1] = z.convert(this);
	  if (k > 1) {
	    var g2 = new BigInteger();
	    z.sqrTo(g[1], g2);
	    while (n <= km) {
	      g[n] = new BigInteger();
	      z.mulTo(g2, g[n - 2], g[n]);
	      n += 2;
	    }
	  }
	
	  var j = e.t - 1,
	      w,
	      is1 = true,
	      r2 = new BigInteger(),
	      t;
	  i = nbits(e[j]) - 1;
	  while (j >= 0) {
	    if (i >= k1) w = e[j] >> i - k1 & km;else {
	      w = (e[j] & (1 << i + 1) - 1) << k1 - i;
	      if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
	    }
	
	    n = k;
	    while ((w & 1) == 0) {
	      w >>= 1;
	      --n;
	    }
	    if ((i -= n) < 0) {
	      i += this.DB;
	      --j;
	    }
	    if (is1) {
	      // ret == 1, don't bother squaring or multiplying it
	      g[w].copyTo(r);
	      is1 = false;
	    } else {
	      while (n > 1) {
	        z.sqrTo(r, r2);
	        z.sqrTo(r2, r);
	        n -= 2;
	      }
	      if (n > 0) z.sqrTo(r, r2);else {
	        t = r;
	        r = r2;
	        r2 = t;
	      }
	      z.mulTo(r2, g[w], r);
	    }
	
	    while (j >= 0 && (e[j] & 1 << i) == 0) {
	      z.sqrTo(r, r2);
	      t = r;
	      r = r2;
	      r2 = t;
	      if (--i < 0) {
	        i = this.DB - 1;
	        --j;
	      }
	    }
	  }
	  return z.revert(r);
	}
	
	// (public) gcd(this,a) (HAC 14.54)
	function bnGCD(a) {
	  var x = this.s < 0 ? this.negate() : this.clone();
	  var y = a.s < 0 ? a.negate() : a.clone();
	  if (x.compareTo(y) < 0) {
	    var t = x;
	    x = y;
	    y = t;
	  }
	  var i = x.getLowestSetBit(),
	      g = y.getLowestSetBit();
	  if (g < 0) return x;
	  if (i < g) g = i;
	  if (g > 0) {
	    x.rShiftTo(g, x);
	    y.rShiftTo(g, y);
	  }
	  while (x.signum() > 0) {
	    if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
	    if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
	    if (x.compareTo(y) >= 0) {
	      x.subTo(y, x);
	      x.rShiftTo(1, x);
	    } else {
	      y.subTo(x, y);
	      y.rShiftTo(1, y);
	    }
	  }
	  if (g > 0) y.lShiftTo(g, y);
	  return y;
	}
	
	// (protected) this % n, n < 2^26
	function bnpModInt(n) {
	  if (n <= 0) return 0;
	  var d = this.DV % n,
	      r = this.s < 0 ? n - 1 : 0;
	  if (this.t > 0) if (d == 0) r = this[0] % n;else for (var i = this.t - 1; i >= 0; --i) {
	    r = (d * r + this[i]) % n;
	  }return r;
	}
	
	// (public) 1/this % m (HAC 14.61)
	function bnModInverse(m) {
	  var ac = m.isEven();
	  if (this.signum() === 0) throw new Error('division by zero');
	  if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
	  var u = m.clone(),
	      v = this.clone();
	  var a = nbv(1),
	      b = nbv(0),
	      c = nbv(0),
	      d = nbv(1);
	  while (u.signum() != 0) {
	    while (u.isEven()) {
	      u.rShiftTo(1, u);
	      if (ac) {
	        if (!a.isEven() || !b.isEven()) {
	          a.addTo(this, a);
	          b.subTo(m, b);
	        }
	        a.rShiftTo(1, a);
	      } else if (!b.isEven()) b.subTo(m, b);
	      b.rShiftTo(1, b);
	    }
	    while (v.isEven()) {
	      v.rShiftTo(1, v);
	      if (ac) {
	        if (!c.isEven() || !d.isEven()) {
	          c.addTo(this, c);
	          d.subTo(m, d);
	        }
	        c.rShiftTo(1, c);
	      } else if (!d.isEven()) d.subTo(m, d);
	      d.rShiftTo(1, d);
	    }
	    if (u.compareTo(v) >= 0) {
	      u.subTo(v, u);
	      if (ac) a.subTo(c, a);
	      b.subTo(d, b);
	    } else {
	      v.subTo(u, v);
	      if (ac) c.subTo(a, c);
	      d.subTo(b, d);
	    }
	  }
	  if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
	  while (d.compareTo(m) >= 0) {
	    d.subTo(m, d);
	  }while (d.signum() < 0) {
	    d.addTo(m, d);
	  }return d;
	}
	
	var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
	
	var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
	
	// (public) test primality with certainty >= 1-.5^t
	function bnIsProbablePrime(t) {
	  var i,
	      x = this.abs();
	  if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
	    for (i = 0; i < lowprimes.length; ++i) {
	      if (x[0] == lowprimes[i]) return true;
	    }return false;
	  }
	  if (x.isEven()) return false;
	  i = 1;
	  while (i < lowprimes.length) {
	    var m = lowprimes[i],
	        j = i + 1;
	    while (j < lowprimes.length && m < lplim) {
	      m *= lowprimes[j++];
	    }m = x.modInt(m);
	    while (i < j) {
	      if (m % lowprimes[i++] == 0) return false;
	    }
	  }
	  return x.millerRabin(t);
	}
	
	// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
	function bnpMillerRabin(t) {
	  var n1 = this.subtract(BigInteger.ONE);
	  var k = n1.getLowestSetBit();
	  if (k <= 0) return false;
	  var r = n1.shiftRight(k);
	  t = t + 1 >> 1;
	  if (t > lowprimes.length) t = lowprimes.length;
	  var a = new BigInteger(null);
	  var j,
	      bases = [];
	  for (var i = 0; i < t; ++i) {
	    for (;;) {
	      j = lowprimes[Math.floor(Math.random() * lowprimes.length)];
	      if (bases.indexOf(j) == -1) break;
	    }
	    bases.push(j);
	    a.fromInt(j);
	    var y = a.modPow(r, this);
	    if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
	      var j = 1;
	      while (j++ < k && y.compareTo(n1) != 0) {
	        y = y.modPowInt(2, this);
	        if (y.compareTo(BigInteger.ONE) == 0) return false;
	      }
	      if (y.compareTo(n1) != 0) return false;
	    }
	  }
	  return true;
	}
	
	// protected
	proto.chunkSize = bnpChunkSize;
	proto.toRadix = bnpToRadix;
	proto.fromRadix = bnpFromRadix;
	proto.fromNumber = bnpFromNumber;
	proto.bitwiseTo = bnpBitwiseTo;
	proto.changeBit = bnpChangeBit;
	proto.addTo = bnpAddTo;
	proto.dMultiply = bnpDMultiply;
	proto.dAddOffset = bnpDAddOffset;
	proto.multiplyLowerTo = bnpMultiplyLowerTo;
	proto.multiplyUpperTo = bnpMultiplyUpperTo;
	proto.modInt = bnpModInt;
	proto.millerRabin = bnpMillerRabin;
	
	// public
	proto.clone = bnClone;
	proto.intValue = bnIntValue;
	proto.byteValue = bnByteValue;
	proto.shortValue = bnShortValue;
	proto.signum = bnSigNum;
	proto.toByteArray = bnToByteArray;
	proto.equals = bnEquals;
	proto.min = bnMin;
	proto.max = bnMax;
	proto.and = bnAnd;
	proto.or = bnOr;
	proto.xor = bnXor;
	proto.andNot = bnAndNot;
	proto.not = bnNot;
	proto.shiftLeft = bnShiftLeft;
	proto.shiftRight = bnShiftRight;
	proto.getLowestSetBit = bnGetLowestSetBit;
	proto.bitCount = bnBitCount;
	proto.testBit = bnTestBit;
	proto.setBit = bnSetBit;
	proto.clearBit = bnClearBit;
	proto.flipBit = bnFlipBit;
	proto.add = bnAdd;
	proto.subtract = bnSubtract;
	proto.multiply = bnMultiply;
	proto.divide = bnDivide;
	proto.remainder = bnRemainder;
	proto.divideAndRemainder = bnDivideAndRemainder;
	proto.modPow = bnModPow;
	proto.modInverse = bnModInverse;
	proto.pow = bnPow;
	proto.gcd = bnGCD;
	proto.isProbablePrime = bnIsProbablePrime;
	
	// JSBN-specific extension
	proto.square = bnSquare;
	
	// constants
	BigInteger.ZERO = nbv(0);
	BigInteger.ONE = nbv(1);
	BigInteger.valueOf = nbv;
	
	module.exports = BigInteger;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = {"name":"bigi","version":"1.4.2","description":"Big integers.","keywords":["cryptography","math","bitcoin","arbitrary","precision","arithmetic","big","integer","int","number","biginteger","bigint","bignumber","decimal","float"],"devDependencies":{"coveralls":"^2.11.2","istanbul":"^0.3.5","jshint":"^2.5.1","mocha":"^2.1.0","mochify":"^2.1.0"},"repository":{"url":"https://github.com/cryptocoinjs/bigi","type":"git"},"main":"./lib/index.js","scripts":{"browser-test":"./node_modules/.bin/mochify --wd -R spec","test":"./node_modules/.bin/_mocha -- test/*.js","jshint":"./node_modules/.bin/jshint --config jshint.json lib/*.js ; true","unit":"./node_modules/.bin/mocha","coverage":"./node_modules/.bin/istanbul cover ./node_modules/.bin/_mocha -- --reporter list test/*.js","coveralls":"npm run-script coverage && node ./node_modules/.bin/coveralls < coverage/lcov.info"},"dependencies":{},"testling":{"files":"test/*.js","harness":"mocha","browsers":["ie/9..latest","firefox/latest","chrome/latest","safari/6.0..latest","iphone/6.0..latest","android-browser/4.2..latest"]}}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	// FIXME: Kind of a weird way to throw exceptions, consider removing
	var assert = __webpack_require__(105);
	var BigInteger = __webpack_require__(180);
	
	/**
	 * Turns a byte array into a big integer.
	 *
	 * This function will interpret a byte array as a big integer in big
	 * endian notation.
	 */
	BigInteger.fromByteArrayUnsigned = function (byteArray) {
	  // BigInteger expects a DER integer conformant byte array
	  if (byteArray[0] & 0x80) {
	    return new BigInteger([0].concat(byteArray));
	  }
	
	  return new BigInteger(byteArray);
	};
	
	/**
	 * Returns a byte array representation of the big integer.
	 *
	 * This returns the absolute of the contained value in big endian
	 * form. A value of zero results in an empty array.
	 */
	BigInteger.prototype.toByteArrayUnsigned = function () {
	  var byteArray = this.toByteArray();
	  return byteArray[0] === 0 ? byteArray.slice(1) : byteArray;
	};
	
	BigInteger.fromDERInteger = function (byteArray) {
	  return new BigInteger(byteArray);
	};
	
	/*
	 * Converts BigInteger to a DER integer representation.
	 *
	 * The format for this value uses the most significant bit as a sign
	 * bit.  If the most significant bit is already set and the integer is
	 * positive, a 0x00 is prepended.
	 *
	 * Examples:
	 *
	 *      0 =>     0x00
	 *      1 =>     0x01
	 *     -1 =>     0xff
	 *    127 =>     0x7f
	 *   -127 =>     0x81
	 *    128 =>   0x0080
	 *   -128 =>     0x80
	 *    255 =>   0x00ff
	 *   -255 =>   0xff01
	 *  16300 =>   0x3fac
	 * -16300 =>   0xc054
	 *  62300 => 0x00f35c
	 * -62300 => 0xff0ca4
	*/
	BigInteger.prototype.toDERInteger = BigInteger.prototype.toByteArray;
	
	BigInteger.fromBuffer = function (buffer) {
	  // BigInteger expects a DER integer conformant byte array
	  if (buffer[0] & 0x80) {
	    var byteArray = Array.prototype.slice.call(buffer);
	
	    return new BigInteger([0].concat(byteArray));
	  }
	
	  return new BigInteger(buffer);
	};
	
	BigInteger.fromHex = function (hex) {
	  if (hex === '') return BigInteger.ZERO;
	
	  assert.equal(hex, hex.match(/^[A-Fa-f0-9]+/), 'Invalid hex string');
	  assert.equal(hex.length % 2, 0, 'Incomplete hex');
	  return new BigInteger(hex, 16);
	};
	
	BigInteger.prototype.toBuffer = function (size) {
	  var byteArray = this.toByteArrayUnsigned();
	  var zeros = [];
	
	  var padding = size - byteArray.length;
	  while (zeros.length < padding) {
	    zeros.push(0);
	  }return new Buffer(zeros.concat(byteArray));
	};
	
	BigInteger.prototype.toHex = function (size) {
	  return this.toBuffer(size).toString('hex');
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Point = __webpack_require__(184);
	var Curve = __webpack_require__(185);
	
	var getCurveByName = __webpack_require__(186);
	
	module.exports = {
	  Curve: Curve,
	  Point: Point,
	  getCurveByName: getCurveByName
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(105);
	var Buffer = __webpack_require__(121).Buffer;
	var BigInteger = __webpack_require__(179);
	
	var THREE = BigInteger.valueOf(3);
	
	function Point(curve, x, y, z) {
	  assert.notStrictEqual(z, undefined, 'Missing Z coordinate');
	
	  this.curve = curve;
	  this.x = x;
	  this.y = y;
	  this.z = z;
	  this._zInv = null;
	
	  this.compressed = true;
	}
	
	Object.defineProperty(Point.prototype, 'zInv', {
	  get: function get() {
	    if (this._zInv === null) {
	      this._zInv = this.z.modInverse(this.curve.p);
	    }
	
	    return this._zInv;
	  }
	});
	
	Object.defineProperty(Point.prototype, 'affineX', {
	  get: function get() {
	    return this.x.multiply(this.zInv).mod(this.curve.p);
	  }
	});
	
	Object.defineProperty(Point.prototype, 'affineY', {
	  get: function get() {
	    return this.y.multiply(this.zInv).mod(this.curve.p);
	  }
	});
	
	Point.fromAffine = function (curve, x, y) {
	  return new Point(curve, x, y, BigInteger.ONE);
	};
	
	Point.prototype.equals = function (other) {
	  if (other === this) return true;
	  if (this.curve.isInfinity(this)) return this.curve.isInfinity(other);
	  if (this.curve.isInfinity(other)) return this.curve.isInfinity(this);
	
	  // u = Y2 * Z1 - Y1 * Z2
	  var u = other.y.multiply(this.z).subtract(this.y.multiply(other.z)).mod(this.curve.p);
	
	  if (u.signum() !== 0) return false;
	
	  // v = X2 * Z1 - X1 * Z2
	  var v = other.x.multiply(this.z).subtract(this.x.multiply(other.z)).mod(this.curve.p);
	
	  return v.signum() === 0;
	};
	
	Point.prototype.negate = function () {
	  var y = this.curve.p.subtract(this.y);
	
	  return new Point(this.curve, this.x, y, this.z);
	};
	
	Point.prototype.add = function (b) {
	  if (this.curve.isInfinity(this)) return b;
	  if (this.curve.isInfinity(b)) return this;
	
	  var x1 = this.x;
	  var y1 = this.y;
	  var x2 = b.x;
	  var y2 = b.y;
	
	  // u = Y2 * Z1 - Y1 * Z2
	  var u = y2.multiply(this.z).subtract(y1.multiply(b.z)).mod(this.curve.p);
	  // v = X2 * Z1 - X1 * Z2
	  var v = x2.multiply(this.z).subtract(x1.multiply(b.z)).mod(this.curve.p);
	
	  if (v.signum() === 0) {
	    if (u.signum() === 0) {
	      return this.twice(); // this == b, so double
	    }
	
	    return this.curve.infinity; // this = -b, so infinity
	  }
	
	  var v2 = v.square();
	  var v3 = v2.multiply(v);
	  var x1v2 = x1.multiply(v2);
	  var zu2 = u.square().multiply(this.z);
	
	  // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
	  var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.p);
	  // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
	  var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.p);
	  // z3 = v^3 * z1 * z2
	  var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.p);
	
	  return new Point(this.curve, x3, y3, z3);
	};
	
	Point.prototype.twice = function () {
	  if (this.curve.isInfinity(this)) return this;
	  if (this.y.signum() === 0) return this.curve.infinity;
	
	  var x1 = this.x;
	  var y1 = this.y;
	
	  var y1z1 = y1.multiply(this.z).mod(this.curve.p);
	  var y1sqz1 = y1z1.multiply(y1).mod(this.curve.p);
	  var a = this.curve.a;
	
	  // w = 3 * x1^2 + a * z1^2
	  var w = x1.square().multiply(THREE);
	
	  if (a.signum() !== 0) {
	    w = w.add(this.z.square().multiply(a));
	  }
	
	  w = w.mod(this.curve.p);
	  // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
	  var x3 = w.square().subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.p);
	  // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
	  var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.pow(3)).mod(this.curve.p);
	  // z3 = 8 * (y1 * z1)^3
	  var z3 = y1z1.pow(3).shiftLeft(3).mod(this.curve.p);
	
	  return new Point(this.curve, x3, y3, z3);
	};
	
	// Simple NAF (Non-Adjacent Form) multiplication algorithm
	// TODO: modularize the multiplication algorithm
	Point.prototype.multiply = function (k) {
	  if (this.curve.isInfinity(this)) return this;
	  if (k.signum() === 0) return this.curve.infinity;
	
	  var e = k;
	  var h = e.multiply(THREE);
	
	  var neg = this.negate();
	  var R = this;
	
	  for (var i = h.bitLength() - 2; i > 0; --i) {
	    var hBit = h.testBit(i);
	    var eBit = e.testBit(i);
	
	    R = R.twice();
	
	    if (hBit !== eBit) {
	      R = R.add(hBit ? this : neg);
	    }
	  }
	
	  return R;
	};
	
	// Compute this*j + x*k (simultaneous multiplication)
	Point.prototype.multiplyTwo = function (j, x, k) {
	  var i = Math.max(j.bitLength(), k.bitLength()) - 1;
	  var R = this.curve.infinity;
	  var both = this.add(x);
	
	  while (i >= 0) {
	    var jBit = j.testBit(i);
	    var kBit = k.testBit(i);
	
	    R = R.twice();
	
	    if (jBit) {
	      if (kBit) {
	        R = R.add(both);
	      } else {
	        R = R.add(this);
	      }
	    } else if (kBit) {
	      R = R.add(x);
	    }
	    --i;
	  }
	
	  return R;
	};
	
	Point.prototype.getEncoded = function (compressed) {
	  if (compressed == null) compressed = this.compressed;
	  if (this.curve.isInfinity(this)) return Buffer.alloc(1, 0); // Infinity point encoded is simply '00'
	
	  var x = this.affineX;
	  var y = this.affineY;
	  var byteLength = this.curve.pLength;
	  var buffer;
	
	  // 0x02/0x03 | X
	  if (compressed) {
	    buffer = Buffer.allocUnsafe(1 + byteLength);
	    buffer.writeUInt8(y.isEven() ? 0x02 : 0x03, 0);
	
	    // 0x04 | X | Y
	  } else {
	    buffer = Buffer.allocUnsafe(1 + byteLength + byteLength);
	    buffer.writeUInt8(0x04, 0);
	
	    y.toBuffer(byteLength).copy(buffer, 1 + byteLength);
	  }
	
	  x.toBuffer(byteLength).copy(buffer, 1);
	
	  return buffer;
	};
	
	Point.decodeFrom = function (curve, buffer) {
	  var type = buffer.readUInt8(0);
	  var compressed = type !== 4;
	
	  var byteLength = Math.floor((curve.p.bitLength() + 7) / 8);
	  var x = BigInteger.fromBuffer(buffer.slice(1, 1 + byteLength));
	
	  var Q;
	  if (compressed) {
	    assert.equal(buffer.length, byteLength + 1, 'Invalid sequence length');
	    assert(type === 0x02 || type === 0x03, 'Invalid sequence tag');
	
	    var isOdd = type === 0x03;
	    Q = curve.pointFromX(isOdd, x);
	  } else {
	    assert.equal(buffer.length, 1 + byteLength + byteLength, 'Invalid sequence length');
	
	    var y = BigInteger.fromBuffer(buffer.slice(1 + byteLength));
	    Q = Point.fromAffine(curve, x, y);
	  }
	
	  Q.compressed = compressed;
	  return Q;
	};
	
	Point.prototype.toString = function () {
	  if (this.curve.isInfinity(this)) return '(INFINITY)';
	
	  return '(' + this.affineX.toString() + ',' + this.affineY.toString() + ')';
	};
	
	module.exports = Point;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(105);
	var BigInteger = __webpack_require__(179);
	
	var Point = __webpack_require__(184);
	
	function Curve(p, a, b, Gx, Gy, n, h) {
	  this.p = p;
	  this.a = a;
	  this.b = b;
	  this.G = Point.fromAffine(this, Gx, Gy);
	  this.n = n;
	  this.h = h;
	
	  this.infinity = new Point(this, null, null, BigInteger.ZERO);
	
	  // result caching
	  this.pOverFour = p.add(BigInteger.ONE).shiftRight(2);
	
	  // determine size of p in bytes
	  this.pLength = Math.floor((this.p.bitLength() + 7) / 8);
	}
	
	Curve.prototype.pointFromX = function (isOdd, x) {
	  var alpha = x.pow(3).add(this.a.multiply(x)).add(this.b).mod(this.p);
	  var beta = alpha.modPow(this.pOverFour, this.p); // XXX: not compatible with all curves
	
	  var y = beta;
	  if (beta.isEven() ^ !isOdd) {
	    y = this.p.subtract(y); // -y % p
	  }
	
	  return Point.fromAffine(this, x, y);
	};
	
	Curve.prototype.isInfinity = function (Q) {
	  if (Q === this.infinity) return true;
	
	  return Q.z.signum() === 0 && Q.y.signum() !== 0;
	};
	
	Curve.prototype.isOnCurve = function (Q) {
	  if (this.isInfinity(Q)) return true;
	
	  var x = Q.affineX;
	  var y = Q.affineY;
	  var a = this.a;
	  var b = this.b;
	  var p = this.p;
	
	  // Check that xQ and yQ are integers in the interval [0, p - 1]
	  if (x.signum() < 0 || x.compareTo(p) >= 0) return false;
	  if (y.signum() < 0 || y.compareTo(p) >= 0) return false;
	
	  // and check that y^2 = x^3 + ax + b (mod p)
	  var lhs = y.square().mod(p);
	  var rhs = x.pow(3).add(a.multiply(x)).add(b).mod(p);
	  return lhs.equals(rhs);
	};
	
	/**
	 * Validate an elliptic curve point.
	 *
	 * See SEC 1, section 3.2.2.1: Elliptic Curve Public Key Validation Primitive
	 */
	Curve.prototype.validate = function (Q) {
	  // Check Q != O
	  assert(!this.isInfinity(Q), 'Point is at infinity');
	  assert(this.isOnCurve(Q), 'Point is not on the curve');
	
	  // Check nQ = O (where Q is a scalar multiple of G)
	  var nQ = Q.multiply(this.n);
	  assert(this.isInfinity(nQ), 'Point is not a scalar multiple of G');
	
	  return true;
	};
	
	module.exports = Curve;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var BigInteger = __webpack_require__(179);
	
	var curves = __webpack_require__(187);
	var Curve = __webpack_require__(185);
	
	function getCurveByName(name) {
	  var curve = curves[name];
	  if (!curve) return null;
	
	  var p = new BigInteger(curve.p, 16);
	  var a = new BigInteger(curve.a, 16);
	  var b = new BigInteger(curve.b, 16);
	  var n = new BigInteger(curve.n, 16);
	  var h = new BigInteger(curve.h, 16);
	  var Gx = new BigInteger(curve.Gx, 16);
	  var Gy = new BigInteger(curve.Gy, 16);
	
	  return new Curve(p, a, b, Gx, Gy, n, h);
	}
	
	module.exports = getCurveByName;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = {"secp128r1":{"p":"fffffffdffffffffffffffffffffffff","a":"fffffffdfffffffffffffffffffffffc","b":"e87579c11079f43dd824993c2cee5ed3","n":"fffffffe0000000075a30d1b9038a115","h":"01","Gx":"161ff7528b899b2d0c28607ca52c5b86","Gy":"cf5ac8395bafeb13c02da292dded7a83"},"secp160k1":{"p":"fffffffffffffffffffffffffffffffeffffac73","a":"00","b":"07","n":"0100000000000000000001b8fa16dfab9aca16b6b3","h":"01","Gx":"3b4c382ce37aa192a4019e763036f4f5dd4d7ebb","Gy":"938cf935318fdced6bc28286531733c3f03c4fee"},"secp160r1":{"p":"ffffffffffffffffffffffffffffffff7fffffff","a":"ffffffffffffffffffffffffffffffff7ffffffc","b":"1c97befc54bd7a8b65acf89f81d4d4adc565fa45","n":"0100000000000000000001f4c8f927aed3ca752257","h":"01","Gx":"4a96b5688ef573284664698968c38bb913cbfc82","Gy":"23a628553168947d59dcc912042351377ac5fb32"},"secp192k1":{"p":"fffffffffffffffffffffffffffffffffffffffeffffee37","a":"00","b":"03","n":"fffffffffffffffffffffffe26f2fc170f69466a74defd8d","h":"01","Gx":"db4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d","Gy":"9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"},"secp192r1":{"p":"fffffffffffffffffffffffffffffffeffffffffffffffff","a":"fffffffffffffffffffffffffffffffefffffffffffffffc","b":"64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1","n":"ffffffffffffffffffffffff99def836146bc9b1b4d22831","h":"01","Gx":"188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012","Gy":"07192b95ffc8da78631011ed6b24cdd573f977a11e794811"},"secp256k1":{"p":"fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f","a":"00","b":"07","n":"fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141","h":"01","Gx":"79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","Gy":"483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"},"secp256r1":{"p":"ffffffff00000001000000000000000000000000ffffffffffffffffffffffff","a":"ffffffff00000001000000000000000000000000fffffffffffffffffffffffc","b":"5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b","n":"ffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551","h":"01","Gx":"6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296","Gy":"4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"}}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ecurve = __webpack_require__(183);
	var Point = ecurve.Point;
	var secp256k1 = ecurve.getCurveByName('secp256k1');
	var BigInteger = __webpack_require__(179);
	var base58 = __webpack_require__(149);
	var assert = __webpack_require__(105);
	var hash = __webpack_require__(109);
	var PublicKey = __webpack_require__(178);
	
	var G = secp256k1.G;
	var n = secp256k1.n;
	
	var PrivateKey = function () {
	
	    /**
	        @private see static functions
	        @param {BigInteger}
	    */
	    function PrivateKey(d) {
	        _classCallCheck(this, PrivateKey);
	
	        this.d = d;
	    }
	
	    _createClass(PrivateKey, [{
	        key: 'toWif',
	        value: function toWif() {
	            var private_key = this.toBuffer();
	            // checksum includes the version
	            private_key = Buffer.concat([new Buffer([0x80]), private_key]);
	            var checksum = hash.sha256(private_key);
	            checksum = hash.sha256(checksum);
	            checksum = checksum.slice(0, 4);
	            var private_wif = Buffer.concat([private_key, checksum]);
	            return base58.encode(private_wif);
	        }
	
	        /** Alias for {@link toWif} */
	
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.toWif();
	        }
	
	        /**
	            @return {Point}
	        */
	
	    }, {
	        key: 'toPublicKeyPoint',
	        value: function toPublicKeyPoint() {
	            var Q;
	            return Q = secp256k1.G.multiply(this.d);
	        }
	    }, {
	        key: 'toPublic',
	        value: function toPublic() {
	            if (this.public_key) {
	                return this.public_key;
	            }
	            return this.public_key = PublicKey.fromPoint(this.toPublicKeyPoint());
	        }
	    }, {
	        key: 'toBuffer',
	        value: function toBuffer() {
	            return this.d.toBuffer(32);
	        }
	
	        /** ECIES */
	
	    }, {
	        key: 'get_shared_secret',
	        value: function get_shared_secret(public_key) {
	            public_key = toPublic(public_key);
	            var KB = public_key.toUncompressed().toBuffer();
	            var KBP = Point.fromAffine(secp256k1, BigInteger.fromBuffer(KB.slice(1, 33)), // x
	            BigInteger.fromBuffer(KB.slice(33, 65)) // y
	            );
	            var r = this.toBuffer();
	            var P = KBP.multiply(BigInteger.fromBuffer(r));
	            var S = P.affineX.toBuffer({ size: 32 });
	            // SHA512 used in ECIES
	            return hash.sha512(S);
	        }
	
	        // /** ECIES (does not always match the Point.fromAffine version above) */
	        // get_shared_secret(public_key){
	        //     public_key = toPublic(public_key)
	        //     var P = public_key.Q.multiply( this.d );
	        //     var S = P.affineX.toBuffer({size: 32});
	        //     // ECIES, adds an extra sha512
	        //     return hash.sha512(S);
	        // }
	
	        /** @throws {Error} - overflow of the key could not be derived */
	
	    }, {
	        key: 'child',
	        value: function child(offset) {
	            offset = Buffer.concat([this.toPublicKey().toBuffer(), offset]);
	            offset = hash.sha256(offset);
	            var c = BigInteger.fromBuffer(offset);
	
	            if (c.compareTo(n) >= 0) throw new Error("Child offset went out of bounds, try again");
	
	            var derived = this.d.add(c); //.mod(n)
	
	            if (derived.signum() === 0) throw new Error("Child offset derived to an invalid key, try again");
	
	            return new PrivateKey(derived);
	        }
	
	        // toByteBuffer() {
	        //     var b = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	        //     this.appendByteBuffer(b);
	        //     return b.copy(0, b.offset);
	        // }
	
	    }, {
	        key: 'toHex',
	        value: function toHex() {
	            return this.toBuffer().toString('hex');
	        }
	    }, {
	        key: 'toPublicKey',
	        value: function toPublicKey() {
	            return this.toPublic();
	        }
	
	        /* </helper_functions> */
	
	    }], [{
	        key: 'fromBuffer',
	        value: function fromBuffer(buf) {
	            if (!Buffer.isBuffer(buf)) {
	                throw new Error("Expecting paramter to be a Buffer type");
	            }
	            if (32 !== buf.length) {
	                console.log('WARN: Expecting 32 bytes, instead got ' + buf.length + ', stack trace:', new Error().stack);
	            }
	            if (buf.length === 0) {
	                throw new Error("Empty buffer");
	            }
	            return new PrivateKey(BigInteger.fromBuffer(buf));
	        }
	
	        /** @arg {string} seed - any length string.  This is private, the same seed produces the same private key every time.  */
	
	    }, {
	        key: 'fromSeed',
	        value: function fromSeed(seed) {
	            // generate_private_key
	            if (!(typeof seed === 'string')) {
	                throw new Error('seed must be of type string');
	            }
	            return PrivateKey.fromBuffer(hash.sha256(seed));
	        }
	    }, {
	        key: 'isWif',
	        value: function isWif(text) {
	            try {
	                this.fromWif(text);
	                return true;
	            } catch (e) {
	                return false;
	            }
	        }
	
	        /**
	            @throws {AssertError|Error} parsing key
	            @return {string} Wallet Import Format (still a secret, Not encrypted)
	        */
	
	    }, {
	        key: 'fromWif',
	        value: function fromWif(_private_wif) {
	            var private_wif = new Buffer(base58.decode(_private_wif));
	            var version = private_wif.readUInt8(0);
	            assert.equal(0x80, version, 'Expected version ' + 0x80 + ', instead got ' + version);
	            // checksum includes the version
	            var private_key = private_wif.slice(0, -4);
	            var checksum = private_wif.slice(-4);
	            var new_checksum = hash.sha256(private_key);
	            new_checksum = hash.sha256(new_checksum);
	            new_checksum = new_checksum.slice(0, 4);
	            if (checksum.toString() !== new_checksum.toString()) throw new Error('Invalid WIF key (checksum miss-match)');
	
	            private_key = private_key.slice(1);
	            return PrivateKey.fromBuffer(private_key);
	        }
	    }, {
	        key: 'fromHex',
	        value: function fromHex(hex) {
	            return PrivateKey.fromBuffer(new Buffer(hex, 'hex'));
	        }
	    }]);
	
	    return PrivateKey;
	}();
	
	module.exports = PrivateKey;
	
	var toPublic = function toPublic(data) {
	    return data == null ? data : data.Q ? data : PublicKey.fromStringOrThrow(data);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ecdsa = __webpack_require__(190);
	var hash = __webpack_require__(109);
	var curve = __webpack_require__(183).getCurveByName('secp256k1');
	var assert = __webpack_require__(105);
	var BigInteger = __webpack_require__(179);
	var PublicKey = __webpack_require__(178);
	var PrivateKey = __webpack_require__(188);
	
	var Signature = function () {
	    function Signature(r1, s1, i1) {
	        _classCallCheck(this, Signature);
	
	        this.r = r1;
	        this.s = s1;
	        this.i = i1;
	        assert.equal(this.r != null, true, 'Missing parameter');
	        assert.equal(this.s != null, true, 'Missing parameter');
	        assert.equal(this.i != null, true, 'Missing parameter');
	    }
	
	    _createClass(Signature, [{
	        key: 'toBuffer',
	        value: function toBuffer() {
	            var buf;
	            buf = new Buffer(65);
	            buf.writeUInt8(this.i, 0);
	            this.r.toBuffer(32).copy(buf, 1);
	            this.s.toBuffer(32).copy(buf, 33);
	            return buf;
	        }
	    }, {
	        key: 'recoverPublicKeyFromBuffer',
	        value: function recoverPublicKeyFromBuffer(buffer) {
	            return this.recoverPublicKey(hash.sha256(buffer));
	        }
	    }, {
	        key: 'recoverPublicKey',
	
	
	        /**
	            @return {PublicKey}
	        */
	        value: function recoverPublicKey(sha256_buffer) {
	            var Q = void 0,
	                e = void 0,
	                i = void 0;
	            e = BigInteger.fromBuffer(sha256_buffer);
	            i = this.i;
	            i -= 27;
	            i = i & 3;
	            Q = ecdsa.recoverPubKey(curve, e, this, i);
	            return PublicKey.fromPoint(Q);
	        }
	    }, {
	        key: 'verifyBuffer',
	
	
	        /**
	            @param {Buffer} un-hashed
	            @param {./PublicKey}
	            @return {boolean}
	        */
	        value: function verifyBuffer(buf, public_key) {
	            var _hash = hash.sha256(buf);
	            return this.verifyHash(_hash, public_key);
	        }
	    }, {
	        key: 'verifyHash',
	        value: function verifyHash(hash, public_key) {
	            assert.equal(hash.length, 32, "A SHA 256 should be 32 bytes long, instead got " + hash.length);
	            return ecdsa.verify(curve, hash, {
	                r: this.r,
	                s: this.s
	            }, public_key.Q);
	        }
	    }, {
	        key: 'toHex',
	        value: function toHex() {
	            return this.toBuffer().toString("hex");
	        }
	    }, {
	        key: 'verifyHex',
	        value: function verifyHex(hex, public_key) {
	            var buf;
	            buf = new Buffer(hex, 'hex');
	            return this.verifyBuffer(buf, public_key);
	        }
	    }], [{
	        key: 'fromBuffer',
	        value: function fromBuffer(buf) {
	            var i, r, s;
	            assert.equal(buf.length, 65, 'Invalid signature length');
	            i = buf.readUInt8(0);
	            assert.equal(i - 27, i - 27 & 7, 'Invalid signature parameter');
	            r = BigInteger.fromBuffer(buf.slice(1, 33));
	            s = BigInteger.fromBuffer(buf.slice(33));
	            return new Signature(r, s, i);
	        }
	    }, {
	        key: 'signBuffer',
	
	
	        /**
	            @param {Buffer} buf
	            @param {PrivateKey} private_key
	            @return {Signature}
	        */
	        value: function signBuffer(buf, private_key) {
	            var _hash = hash.sha256(buf);
	            return Signature.signBufferSha256(_hash, private_key);
	        }
	
	        /** Sign a buffer of exactally 32 bytes in size (sha256(text))
	            @param {Buffer} buf - 32 bytes binary
	            @param {PrivateKey} private_key
	            @return {Signature}
	        */
	
	    }, {
	        key: 'signBufferSha256',
	        value: function signBufferSha256(buf_sha256, private_key) {
	            if (buf_sha256.length !== 32 || !Buffer.isBuffer(buf_sha256)) throw new Error("buf_sha256: 32 byte buffer requred");
	            private_key = toPrivateObj(private_key);
	            assert(private_key, 'private_key required');
	
	            var der, e, ecsignature, i, lenR, lenS, nonce;
	            i = null;
	            nonce = 0;
	            e = BigInteger.fromBuffer(buf_sha256);
	            while (true) {
	                ecsignature = ecdsa.sign(curve, buf_sha256, private_key.d, nonce++);
	                der = ecsignature.toDER();
	                lenR = der[3];
	                lenS = der[5 + lenR];
	                if (lenR === 32 && lenS === 32) {
	                    i = ecdsa.calcPubKeyRecoveryParam(curve, e, ecsignature, private_key.toPublicKey().Q);
	                    i += 4; // compressed
	                    i += 27; // compact  //  24 or 27 :( forcing odd-y 2nd key candidate)
	                    break;
	                }
	                if (nonce % 10 === 0) {
	                    console.log("WARN: " + nonce + " attempts to find canonical signature");
	                }
	            }
	            return new Signature(ecsignature.r, ecsignature.s, i);
	        }
	    }, {
	        key: 'sign',
	        value: function sign(string, private_key) {
	            return Signature.signBuffer(new Buffer(string), private_key);
	        }
	    }, {
	        key: 'fromHex',
	
	
	        // toByteBuffer() {
	        //     var b;
	        //     b = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	        //     this.appendByteBuffer(b);
	        //     return b.copy(0, b.offset);
	        // };
	
	        value: function fromHex(hex) {
	            return Signature.fromBuffer(new Buffer(hex, "hex"));
	        }
	    }, {
	        key: 'signHex',
	        value: function signHex(hex, private_key) {
	            var buf;
	            buf = new Buffer(hex, 'hex');
	            return Signature.signBuffer(buf, private_key);
	        }
	    }]);
	
	    return Signature;
	}();
	
	var toPrivateObj = function toPrivateObj(o) {
	    return o ? o.d ? o : PrivateKey.fromWif(o) : o /*null or undefined*/;
	};
	module.exports = Signature;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var assert = __webpack_require__(105); // from github.com/bitcoinjs/bitcoinjs-lib from github.com/cryptocoinjs/ecdsa
	var crypto = __webpack_require__(109);
	var enforceType = __webpack_require__(191);
	
	var BigInteger = __webpack_require__(179);
	var ECSignature = __webpack_require__(192);
	
	// https://tools.ietf.org/html/rfc6979#section-3.2
	function deterministicGenerateK(curve, hash, d, checkSig, nonce) {
	
	  enforceType('Buffer', hash);
	  enforceType(BigInteger, d);
	
	  if (nonce) {
	    hash = crypto.sha256(Buffer.concat([hash, new Buffer(nonce)]));
	  }
	
	  // sanity check
	  assert.equal(hash.length, 32, 'Hash must be 256 bit');
	
	  var x = d.toBuffer(32);
	  var k = new Buffer(32);
	  var v = new Buffer(32);
	
	  // Step B
	  v.fill(1);
	
	  // Step C
	  k.fill(0);
	
	  // Step D
	  k = crypto.HmacSHA256(Buffer.concat([v, new Buffer([0]), x, hash]), k);
	
	  // Step E
	  v = crypto.HmacSHA256(v, k);
	
	  // Step F
	  k = crypto.HmacSHA256(Buffer.concat([v, new Buffer([1]), x, hash]), k);
	
	  // Step G
	  v = crypto.HmacSHA256(v, k);
	
	  // Step H1/H2a, ignored as tlen === qlen (256 bit)
	  // Step H2b
	  v = crypto.HmacSHA256(v, k);
	
	  var T = BigInteger.fromBuffer(v);
	
	  // Step H3, repeat until T is within the interval [1, n - 1]
	  while (T.signum() <= 0 || T.compareTo(curve.n) >= 0 || !checkSig(T)) {
	    k = crypto.HmacSHA256(Buffer.concat([v, new Buffer([0])]), k);
	    v = crypto.HmacSHA256(v, k);
	
	    // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
	    // Step H2b again
	    v = crypto.HmacSHA256(v, k);
	
	    T = BigInteger.fromBuffer(v);
	  }
	
	  return T;
	}
	
	function sign(curve, hash, d, nonce) {
	
	  var e = BigInteger.fromBuffer(hash);
	  var n = curve.n;
	  var G = curve.G;
	
	  var r, s;
	  var k = deterministicGenerateK(curve, hash, d, function (k) {
	    // find canonically valid signature
	    var Q = G.multiply(k);
	
	    if (curve.isInfinity(Q)) return false;
	
	    r = Q.affineX.mod(n);
	    if (r.signum() === 0) return false;
	
	    s = k.modInverse(n).multiply(e.add(d.multiply(r))).mod(n);
	    if (s.signum() === 0) return false;
	
	    return true;
	  }, nonce);
	
	  var N_OVER_TWO = n.shiftRight(1);
	
	  // enforce low S values, see bip62: 'low s values in signatures'
	  if (s.compareTo(N_OVER_TWO) > 0) {
	    s = n.subtract(s);
	  }
	
	  return new ECSignature(r, s);
	}
	
	function verifyRaw(curve, e, signature, Q) {
	  var n = curve.n;
	  var G = curve.G;
	
	  var r = signature.r;
	  var s = signature.s;
	
	  // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1]
	  if (r.signum() <= 0 || r.compareTo(n) >= 0) return false;
	  if (s.signum() <= 0 || s.compareTo(n) >= 0) return false;
	
	  // c = s^-1 mod n
	  var c = s.modInverse(n);
	
	  // 1.4.4 Compute u1 = es^−1 mod n
	  //               u2 = rs^−1 mod n
	  var u1 = e.multiply(c).mod(n);
	  var u2 = r.multiply(c).mod(n);
	
	  // 1.4.5 Compute R = (xR, yR) = u1G + u2Q
	  var R = G.multiplyTwo(u1, Q, u2);
	
	  // 1.4.5 (cont.) Enforce R is not at infinity
	  if (curve.isInfinity(R)) return false;
	
	  // 1.4.6 Convert the field element R.x to an integer
	  var xR = R.affineX;
	
	  // 1.4.7 Set v = xR mod n
	  var v = xR.mod(n);
	
	  // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
	  return v.equals(r);
	}
	
	function verify(curve, hash, signature, Q) {
	  // 1.4.2 H = Hash(M), already done by the user
	  // 1.4.3 e = H
	  var e = BigInteger.fromBuffer(hash);
	  return verifyRaw(curve, e, signature, Q);
	}
	
	/**
	  * Recover a public key from a signature.
	  *
	  * See SEC 1: Elliptic Curve Cryptography, section 4.1.6, "Public
	  * Key Recovery Operation".
	  *
	  * http://www.secg.org/download/aid-780/sec1-v2.pdf
	  */
	function recoverPubKey(curve, e, signature, i) {
	  assert.strictEqual(i & 3, i, 'Recovery param is more than two bits');
	
	  var n = curve.n;
	  var G = curve.G;
	
	  var r = signature.r;
	  var s = signature.s;
	
	  assert(r.signum() > 0 && r.compareTo(n) < 0, 'Invalid r value');
	  assert(s.signum() > 0 && s.compareTo(n) < 0, 'Invalid s value');
	
	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = i & 1;
	
	  // The more significant bit specifies whether we should use the
	  // first or second candidate key.
	  var isSecondKey = i >> 1;
	
	  // 1.1 Let x = r + jn
	  var x = isSecondKey ? r.add(n) : r;
	  var R = curve.pointFromX(isYOdd, x);
	
	  // 1.4 Check that nR is at infinity
	  var nR = R.multiply(n);
	  assert(curve.isInfinity(nR), 'nR is not a valid curve point');
	
	  // Compute -e from e
	  var eNeg = e.negate().mod(n);
	
	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  var rInv = r.modInverse(n);
	
	  var Q = R.multiplyTwo(s, G, eNeg).multiply(rInv);
	  curve.validate(Q);
	
	  return Q;
	}
	
	/**
	  * Calculate pubkey extraction parameter.
	  *
	  * When extracting a pubkey from a signature, we have to
	  * distinguish four different cases. Rather than putting this
	  * burden on the verifier, Bitcoin includes a 2-bit value with the
	  * signature.
	  *
	  * This function simply tries all four cases and returns the value
	  * that resulted in a successful pubkey recovery.
	  */
	function calcPubKeyRecoveryParam(curve, e, signature, Q) {
	  for (var i = 0; i < 4; i++) {
	    var Qprime = recoverPubKey(curve, e, signature, i);
	
	    // 1.6.2 Verify Q
	    if (Qprime.equals(Q)) {
	      return i;
	    }
	  }
	
	  throw new Error('Unable to find valid recovery factor');
	}
	
	module.exports = {
	  calcPubKeyRecoveryParam: calcPubKeyRecoveryParam,
	  deterministicGenerateK: deterministicGenerateK,
	  recoverPubKey: recoverPubKey,
	  sign: sign,
	  verify: verify,
	  verifyRaw: verifyRaw
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = function enforce(type, value) {
	  // Copied from https://github.com/bitcoinjs/bitcoinjs-lib
	  switch (type) {
	    case 'Array':
	      {
	        if (Array.isArray(value)) return;
	        break;
	      }
	
	    case 'Boolean':
	      {
	        if (typeof value === 'boolean') return;
	        break;
	      }
	
	    case 'Buffer':
	      {
	        if (Buffer.isBuffer(value)) return;
	        break;
	      }
	
	    case 'Number':
	      {
	        if (typeof value === 'number') return;
	        break;
	      }
	
	    case 'String':
	      {
	        if (typeof value === 'string') return;
	        break;
	      }
	
	    default:
	      {
	        if (getName(value.constructor) === getName(type)) return;
	      }
	  }
	
	  throw new TypeError('Expected ' + (getName(type) || type) + ', got ' + value);
	};
	
	function getName(fn) {
	  // Why not fn.name: https://kangax.github.io/compat-table/es6/#function_name_property
	  var match = fn.toString().match(/function (.*?)\(/);
	  return match ? match[1] : null;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var assert = __webpack_require__(105); // from https://github.com/bitcoinjs/bitcoinjs-lib
	var enforceType = __webpack_require__(191);
	
	var BigInteger = __webpack_require__(179);
	
	function ECSignature(r, s) {
	  enforceType(BigInteger, r);
	  enforceType(BigInteger, s);
	
	  this.r = r;
	  this.s = s;
	}
	
	// Import operations
	ECSignature.parseCompact = function (buffer) {
	  assert.equal(buffer.length, 65, 'Invalid signature length');
	  var i = buffer.readUInt8(0) - 27;
	
	  // At most 3 bits
	  assert.equal(i, i & 7, 'Invalid signature parameter');
	  var compressed = !!(i & 4);
	
	  // Recovery param only
	  i = i & 3;
	
	  var r = BigInteger.fromBuffer(buffer.slice(1, 33));
	  var s = BigInteger.fromBuffer(buffer.slice(33));
	
	  return {
	    compressed: compressed,
	    i: i,
	    signature: new ECSignature(r, s)
	  };
	};
	
	ECSignature.fromDER = function (buffer) {
	  assert.equal(buffer.readUInt8(0), 0x30, 'Not a DER sequence');
	  assert.equal(buffer.readUInt8(1), buffer.length - 2, 'Invalid sequence length');
	  assert.equal(buffer.readUInt8(2), 0x02, 'Expected a DER integer');
	
	  var rLen = buffer.readUInt8(3);
	  assert(rLen > 0, 'R length is zero');
	
	  var offset = 4 + rLen;
	  assert.equal(buffer.readUInt8(offset), 0x02, 'Expected a DER integer (2)');
	
	  var sLen = buffer.readUInt8(offset + 1);
	  assert(sLen > 0, 'S length is zero');
	
	  var rB = buffer.slice(4, offset);
	  var sB = buffer.slice(offset + 2);
	  offset += 2 + sLen;
	
	  if (rLen > 1 && rB.readUInt8(0) === 0x00) {
	    assert(rB.readUInt8(1) & 0x80, 'R value excessively padded');
	  }
	
	  if (sLen > 1 && sB.readUInt8(0) === 0x00) {
	    assert(sB.readUInt8(1) & 0x80, 'S value excessively padded');
	  }
	
	  assert.equal(offset, buffer.length, 'Invalid DER encoding');
	  var r = BigInteger.fromDERInteger(rB);
	  var s = BigInteger.fromDERInteger(sB);
	
	  assert(r.signum() >= 0, 'R value is negative');
	  assert(s.signum() >= 0, 'S value is negative');
	
	  return new ECSignature(r, s);
	};
	
	// FIXME: 0x00, 0x04, 0x80 are SIGHASH_* boundary constants, importing Transaction causes a circular dependency
	ECSignature.parseScriptSignature = function (buffer) {
	  var hashType = buffer.readUInt8(buffer.length - 1);
	  var hashTypeMod = hashType & ~0x80;
	
	  assert(hashTypeMod > 0x00 && hashTypeMod < 0x04, 'Invalid hashType');
	
	  return {
	    signature: ECSignature.fromDER(buffer.slice(0, -1)),
	    hashType: hashType
	  };
	};
	
	// Export operations
	ECSignature.prototype.toCompact = function (i, compressed) {
	  if (compressed) i += 4;
	  i += 27;
	
	  var buffer = new Buffer(65);
	  buffer.writeUInt8(i, 0);
	
	  this.r.toBuffer(32).copy(buffer, 1);
	  this.s.toBuffer(32).copy(buffer, 33);
	
	  return buffer;
	};
	
	ECSignature.prototype.toDER = function () {
	  var rBa = this.r.toDERInteger();
	  var sBa = this.s.toDERInteger();
	
	  var sequence = [];
	
	  // INTEGER
	  sequence.push(0x02, rBa.length);
	  sequence = sequence.concat(rBa);
	
	  // INTEGER
	  sequence.push(0x02, sBa.length);
	  sequence = sequence.concat(sBa);
	
	  // SEQUENCE
	  sequence.unshift(0x30, sequence.length);
	
	  return new Buffer(sequence);
	};
	
	ECSignature.prototype.toScriptSignature = function (hashType) {
	  var hashTypeBuffer = new Buffer(1);
	  hashTypeBuffer.writeUInt8(hashType, 0);
	
	  return Buffer.concat([this.toDER(), hashTypeBuffer]);
	};
	
	module.exports = ECSignature;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.normalize = normalize;
	function normalize(brain_key) {
	    if (typeof brain_key !== 'string') {
	        throw new Error("string required for brain_key");
	    }
	    brain_key = brain_key.trim();
	    return brain_key.split(/[\t\n\v\f\r ]+/).join(' ');
	}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var PrivateKey = __webpack_require__(188);
	var hash = __webpack_require__(109);
	var secureRandom = __webpack_require__(152);
	
	// hash for .25 second
	var HASH_POWER_MILLS = 250;
	
	var entropyPos = 0,
	    entropyCount = 0;
	var entropyArray = secureRandom.randomBuffer(101);
	
	module.exports = {
	    addEntropy: function addEntropy() {
	        entropyCount++;
	
	        for (var _len = arguments.length, ints = Array(_len), _key = 0; _key < _len; _key++) {
	            ints[_key] = arguments[_key];
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = ints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var i = _step.value;
	
	                var pos = entropyPos++ % 101;
	                var i2 = entropyArray[pos] += i;
	                if (i2 > 9007199254740991) entropyArray[pos] = 0;
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	
	    /**
	        A week random number generator can run out of entropy.  This should ensure even the worst random number implementation will be reasonably safe.
	         @param1 string entropy of at least 32 bytes
	    */
	    random32ByteBuffer: function random32ByteBuffer() {
	        var entropy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.browserEntropy();
	
	
	        if (!(typeof entropy === 'string')) {
	            throw new Error("string required for entropy");
	        }
	
	        if (entropy.length < 32) {
	            throw new Error("expecting at least 32 bytes of entropy");
	        }
	
	        var start_t = Date.now();
	
	        while (Date.now() - start_t < HASH_POWER_MILLS) {
	            entropy = hash.sha256(entropy);
	        }var hash_array = [];
	        hash_array.push(entropy);
	
	        // Hashing for 1 second may helps the computer is not low on entropy (this method may be called back-to-back).
	        hash_array.push(secureRandom.randomBuffer(32));
	
	        return hash.sha256(Buffer.concat(hash_array));
	    },
	    get_random_key: function get_random_key(entropy) {
	        return PrivateKey.fromBuffer(this.random32ByteBuffer(entropy));
	    },
	
	
	    // Turn invisible space like characters into a single space
	    // normalize_brain_key(brain_key){
	    //     if (!(typeof brain_key === 'string')) {
	    //         throw new Error("string required for brain_key");
	    //     }
	    //     brain_key = brain_key.trim();
	    //     return brain_key.split(/[\t\n\v\f\r ]+/).join(' ');
	    // },
	
	    browserEntropy: function browserEntropy() {
	        var entropyStr = Array(entropyArray).join();
	        try {
	            entropyStr += new Date().toString() + " " + window.screen.height + " " + window.screen.width + " " + window.screen.colorDepth + " " + " " + window.screen.availHeight + " " + window.screen.availWidth + " " + window.screen.pixelDepth + navigator.language + " " + window.location + " " + window.history.length;
	
	            for (var i = 0, mimeType; i < navigator.mimeTypes.length; i++) {
	                mimeType = navigator.mimeTypes[i];
	                entropyStr += mimeType.description + " " + mimeType.type + " " + mimeType.suffixes + " ";
	            }
	            console.log("INFO\tbrowserEntropy gathered", entropyCount, 'events');
	        } catch (error) {
	            //nodejs:ReferenceError: window is not defined
	            entropyStr += hash.sha256(new Date().toString());
	        }
	
	        var b = new Buffer(entropyStr);
	        entropyStr += b.toString('binary') + " " + new Date().toString();
	        return entropyStr;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.toImpliedDecimal = toImpliedDecimal;
	exports.fromImpliedDecimal = fromImpliedDecimal;
	
	var _assert = __webpack_require__(105);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	    Convert 12.34 with a precision of 3 into 12340
	
	    @arg {number|string} number - Use strings for large numbers.  This may contain one decimal but no sign
	    @arg {number} precision - number of implied decimal places (usually causes right zero padding)
	    @return {string} -
	*/
	function toImpliedDecimal(number, precision) {
	
	    if (typeof number === "number") {
	        (0, _assert2.default)(number <= 9007199254740991, "overflow");
	        number = "" + number;
	    } else if (number.toString) number = number.toString();
	
	    (0, _assert2.default)(typeof number === "string", "number should be an actual number or string: " + (typeof number === "undefined" ? "undefined" : _typeof(number)));
	    number = number.trim();
	    (0, _assert2.default)(/^[0-9]*\.?[0-9]*$/.test(number), "Invalid decimal number " + number);
	
	    var _number$split = number.split("."),
	        _number$split2 = _slicedToArray(_number$split, 2),
	        _number$split2$ = _number$split2[0],
	        whole = _number$split2$ === undefined ? "" : _number$split2$,
	        _number$split2$2 = _number$split2[1],
	        decimal = _number$split2$2 === undefined ? "" : _number$split2$2;
	
	    var padding = precision - decimal.length;
	    (0, _assert2.default)(padding >= 0, "Too many decimal digits in " + number + " to create an implied decimal of " + precision);
	
	    for (var i = 0; i < padding; i++) {
	        decimal += "0";
	    }while (whole.charAt(0) === "0") {
	        whole = whole.substring(1);
	    }return whole + decimal;
	}
	
	function fromImpliedDecimal(number, precision) {
	    if (typeof number === "number") {
	        (0, _assert2.default)(number <= 9007199254740991, "overflow");
	        number = "" + number;
	    } else if (number.toString) number = number.toString();
	
	    while (number.length < precision + 1) {
	        // 0.123
	        number = "0" + number;
	    } // 44000 => 44.000
	    var dec_string = number.substring(number.length - precision);
	    return number.substring(0, number.length - precision) + (dec_string ? "." + dec_string : "");
	}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _my;
	var is_empty;
	var is_digits;
	var to_number;
	var require_match;
	var require_object_id;
	var require_object_type;
	var get_instance;
	var require_relative_type;
	var get_relative_instance;
	var require_protocol_type;
	var get_protocol_instance;
	var get_protocol_type;
	var require_implementation_type;
	var get_implementation_instance;
	var Long = __webpack_require__(154).Long;
	// var BigInteger = require('bigi');
	
	var chain_types = __webpack_require__(197);
	
	var MAX_SAFE_INT = 9007199254740991;
	var MIN_SAFE_INT = -9007199254740991;
	
	/**
	    Most validations are skipped and the value returned unchanged when an empty string, null, or undefined is encountered (except "required"). 
	
	    Validations support a string format for dealing with large numbers.
	*/
	module.exports = _my = {
	
	    is_empty: is_empty = function is_empty(value) {
	        return value === null || value === undefined;
	    },
	
	    required: function required(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            throw new Error('value required ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	    require_long: function require_long(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (!Long.isLong(value)) {
	            throw new Error('Long value required ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	    string: function string(value) {
	        if (is_empty(value)) {
	            return value;
	        }
	        if (typeof value !== "string") {
	            throw new Error('string required: ' + value);
	        }
	        return value;
	    },
	    number: function number(value) {
	        if (is_empty(value)) {
	            return value;
	        }
	        if (typeof value !== "number") {
	            throw new Error('number required: ' + value);
	        }
	        return value;
	    },
	    whole_number: function whole_number(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        if (/\./.test(value)) {
	            throw new Error('whole number required ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	    unsigned: function unsigned(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        if (/-/.test(value)) {
	            throw new Error('unsigned required ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	
	
	    is_digits: is_digits = function is_digits(value) {
	        if (typeof value === "numeric") {
	            return true;
	        }
	        return (/^[0-9]+$/.test(value)
	        );
	    },
	
	    to_number: to_number = function to_number(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        _my.no_overflow53(value, field_name);
	        var int_value = function () {
	            if (typeof value === "number") {
	                return value;
	            } else {
	                return parseInt(value);
	            }
	        }();
	        return int_value;
	    },
	
	    to_long: function to_long(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        if (Long.isLong(value)) {
	            return value;
	        }
	
	        _my.no_overflow64(value, field_name);
	        if (typeof value === "number") {
	            value = "" + value;
	        }
	        return Long.fromString(value);
	    },
	    to_string: function to_string(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        if (typeof value === "string") {
	            return value;
	        }
	        if (typeof value === "number") {
	            _my.no_overflow53(value, field_name);
	            return "" + value;
	        }
	        if (Long.isLong(value)) {
	            return value.toString();
	        }
	        throw 'unsupported type ' + field_name + ': (' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + ') ' + value;
	    },
	    require_test: function require_test(regex, value) {
	        var field_name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        if (!regex.test(value)) {
	            throw new Error('unmatched ' + regex + ' ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	
	
	    require_match: require_match = function require_match(regex, value) {
	        var field_name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        var match = value.match(regex);
	        if (match === null) {
	            throw new Error('unmatched ' + regex + ' ' + field_name + ' ' + value);
	        }
	        return match;
	    },
	
	    // require_object_id: require_object_id=function(value, field_name){
	    //     return require_match(
	    //         /^([0-9]+)\.([0-9]+)\.([0-9]+)$/,
	    //         value,
	    //         field_name
	    //     );
	    // },
	
	    // Does not support over 53 bits
	    require_range: function require_range(min, max, value) {
	        var field_name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        var number = to_number(value);
	        if (value < min || value > max) {
	            throw new Error('out of range ' + value + ' ' + field_name + ' ' + value);
	        }
	        return value;
	    },
	
	
	    require_object_type: require_object_type = function require_object_type() {
	        var reserved_spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var type = arguments[1];
	        var value = arguments[2];
	        var field_name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	
	        if (is_empty(value)) {
	            return value;
	        }
	        var object_type = chain_types.object_type[type];
	        if (!object_type) {
	            throw new Error('Unknown object type: ' + type + ', ' + field_name + ', ' + value);
	        }
	        var re = new RegExp(reserved_spaces + '.' + object_type + '.[0-9]+$');
	        if (!re.test(value)) {
	            throw new Error('Expecting ' + type + ' in format ' + (reserved_spaces + '.' + object_type + '.[0-9]+ ') + ('instead of ' + value + ' ' + field_name + ' ' + value));
	        }
	        return value;
	    },
	
	    get_instance: get_instance = function get_instance(reserve_spaces, type, value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        require_object_type(reserve_spaces, type, value, field_name);
	        return to_number(value.split('.')[2]);
	    },
	
	    require_relative_type: require_relative_type = function require_relative_type(type, value, field_name) {
	        require_object_type(0, type, value, field_name);
	        return value;
	    },
	
	    get_relative_instance: get_relative_instance = function get_relative_instance(type, value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        require_object_type(0, type, value, field_name);
	        return to_number(value.split('.')[2]);
	    },
	
	    require_protocol_type: require_protocol_type = function require_protocol_type(type, value, field_name) {
	        require_object_type(1, type, value, field_name);
	        return value;
	    },
	
	    get_protocol_instance: get_protocol_instance = function get_protocol_instance(type, value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        require_object_type(1, type, value, field_name);
	        return to_number(value.split('.')[2]);
	    },
	
	    get_protocol_type: get_protocol_type = function get_protocol_type(value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        require_object_id(value, field_name);
	        var values = value.split('.');
	        return to_number(values[1]);
	    },
	
	    get_protocol_type_name: function get_protocol_type_name(value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        var type_id = get_protocol_type(value, field_name);
	        return Object.keys(chain_types.object_type)[type_id];
	    },
	
	
	    require_implementation_type: require_implementation_type = function require_implementation_type(type, value, field_name) {
	        require_object_type(2, type, value, field_name);
	        return value;
	    },
	
	    get_implementation_instance: get_implementation_instance = function get_implementation_instance(type, value, field_name) {
	        if (is_empty(value)) {
	            return value;
	        }
	        require_object_type(2, type, value, field_name);
	        return to_number(value.split('.')[2]);
	    },
	
	    // signed / unsigned decimal
	    no_overflow53: function no_overflow53(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        if (typeof value === "number") {
	            if (value > MAX_SAFE_INT || value < MIN_SAFE_INT) {
	                throw new Error('overflow ' + field_name + ' ' + value);
	            }
	            return;
	        }
	        if (typeof value === "string") {
	            var int = parseInt(value);
	            if (value > MAX_SAFE_INT || value < MIN_SAFE_INT) {
	                throw new Error('overflow ' + field_name + ' ' + value);
	            }
	            return;
	        }
	        if (Long.isLong(value)) {
	            // typeof value.toInt() is 'number'
	            _my.no_overflow53(value.toInt(), field_name);
	            return;
	        }
	        throw 'unsupported type ' + field_name + ': (' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + ') ' + value;
	    },
	
	
	    // signed / unsigned whole numbers only
	    no_overflow64: function no_overflow64(value) {
	        var field_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	        // https://github.com/dcodeIO/Long.js/issues/20
	        if (Long.isLong(value)) {
	            return;
	        }
	
	        // BigInteger#isBigInteger https://github.com/cryptocoinjs/bigi/issues/20
	        if (value.t !== undefined && value.s !== undefined) {
	            _my.no_overflow64(value.toString(), field_name);
	            return;
	        }
	
	        if (typeof value === "string") {
	            // remove leading zeros, will cause a false positive
	            value = value.replace(/^0+/, '');
	            // remove trailing zeros
	            while (/0$/.test(value)) {
	                value = value.substring(0, value.length - 1);
	            }
	            if (/\.$/.test(value)) {
	                // remove trailing dot
	                value = value.substring(0, value.length - 1);
	            }
	            if (value === "") {
	                value = "0";
	            }
	            var long_string = Long.fromString(value).toString();
	            if (long_string !== value.trim()) {
	                throw new Error('overflow ' + field_name + ' ' + value);
	            }
	            return;
	        }
	        if (typeof value === "number") {
	            if (value > MAX_SAFE_INT || value < MIN_SAFE_INT) {
	                throw new Error('overflow ' + field_name + ' ' + value);
	            }
	            return;
	        }
	
	        throw 'unsupported type ' + field_name + ': (' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + ') ' + value;
	    }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	"use strict";
	
	var ChainTypes = {};
	
	ChainTypes.reserved_spaces = {
	  relative_protocol_ids: 0,
	  protocol_ids: 1,
	  implementation_ids: 2
	};
	
	ChainTypes.operations = {
	  vote: 0,
	  comment: 1,
	  transfer: 2,
	  transfer_to_vesting: 3,
	  withdraw_vesting: 4,
	  limit_order_create: 5,
	  limit_order_cancel: 6,
	  feed_publish: 7,
	  convert: 8,
	  account_create: 9,
	  account_update: 10,
	  witness_update: 11,
	  account_witness_vote: 12,
	  account_witness_proxy: 13,
	  pow: 14,
	  custom: 15,
	  report_over_production: 16,
	  delete_comment: 17,
	  custom_json: 18,
	  comment_options: 19,
	  set_withdraw_vesting_route: 20,
	  limit_order_create2: 21,
	  claim_account: 22,
	  create_claimed_account: 23,
	  request_account_recovery: 24,
	  recover_account: 25,
	  change_recovery_account: 26,
	  escrow_transfer: 27,
	  escrow_dispute: 28,
	  escrow_release: 29,
	  pow2: 30,
	  escrow_approve: 31,
	  transfer_to_savings: 32,
	  transfer_from_savings: 33,
	  cancel_transfer_from_savings: 34,
	  custom_binary: 35,
	  decline_voting_rights: 36,
	  reset_account: 37,
	  set_reset_account: 38,
	  claim_reward_balance: 39,
	  delegate_vesting_shares: 40,
	  account_create_with_delegation: 41,
	  witness_set_properties: 42,
	  account_update2: 43,
	  create_proposal: 44,
	  update_proposal_votes: 45,
	  remove_proposal: 46,
	  update_proposal: 47,
	  collateralized_convert: 48,
	  recurrent_transfer: 49,
	  // virtual ops
	  fill_convert_request: 50,
	  author_reward: 51,
	  curation_reward: 52,
	  comment_reward: 53,
	  liquidity_reward: 54,
	  interest: 55,
	  fill_vesting_withdraw: 56,
	  fill_order: 57,
	  shutdown_witness: 58,
	  fill_transfer_from_savings: 59,
	  hardfork: 60,
	  comment_payout_update: 61,
	  return_vesting_delegation: 62,
	  comment_benefactor_reward: 63,
	  producer_reward: 64,
	  clear_null_account_balance: 65,
	  proposal_pay: 66,
	  sps_fund: 67,
	  hardfork_hive: 68,
	  hardfork_hive_restore: 69,
	  delayed_voting: 70,
	  consolidate_treasury_balance: 71,
	  effective_comment_vote: 72,
	  ineffective_delete_comment: 73,
	  sps_convert: 74,
	  expired_account_notification: 75,
	  changed_recovery_account: 76,
	  transfer_to_vesting_completed: 77,
	  pow_reward: 78,
	  vesting_shares_split: 79,
	  account_created: 80,
	  fill_collateralized_convert_request: 81,
	  system_warning: 82,
	  fill_recurrent_transfer: 83,
	  failed_recurrent_transfer: 84
	};
	
	//types.hpp
	ChainTypes.object_type = {
	  "null": 0,
	  base: 1
	};
	
	module.exports = ChainTypes;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Long = __webpack_require__(154).Long;
	
	var v = __webpack_require__(196);
	var DB_MAX_INSTANCE_ID = Long.fromNumber(Math.pow(2, 48) - 1);
	
	var ObjectId = function () {
	    function ObjectId(space, type, instance) {
	        _classCallCheck(this, ObjectId);
	
	        this.space = space;
	        this.type = type;
	        this.instance = instance;
	        var instance_string = this.instance.toString();
	        var object_id = this.space + '.' + this.type + '.' + instance_string;
	        if (!v.is_digits(instance_string)) {
	            throw new ('Invalid object id ' + object_id)();
	        }
	    }
	
	    _createClass(ObjectId, [{
	        key: 'toLong',
	        value: function toLong() {
	            return Long.fromNumber(this.space).shiftLeft(56).or(Long.fromNumber(this.type).shiftLeft(48).or(this.instance));
	        }
	    }, {
	        key: 'appendByteBuffer',
	        value: function appendByteBuffer(b) {
	            return b.writeUint64(this.toLong());
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.space + '.' + this.type + '.' + this.instance.toString();
	        }
	    }], [{
	        key: 'fromString',
	        value: function fromString(value) {
	            if (value.space !== undefined && value.type !== undefined && value.instance !== undefined) {
	                return value;
	            }
	            var params = v.require_match(/^([0-9]+)\.([0-9]+)\.([0-9]+)$/, v.required(value, "object_id"), "object_id");
	            return new ObjectId(parseInt(params[1]), parseInt(params[2]), Long.fromString(params[3]));
	        }
	    }, {
	        key: 'fromLong',
	        value: function fromLong(long) {
	            var space = long.shiftRight(56).toInt();
	            var type = long.shiftRight(48).toInt() & 0x00ff;
	            var instance = long.and(DB_MAX_INSTANCE_ID);
	            return new ObjectId(space, type, instance);
	        }
	    }, {
	        key: 'fromByteBuffer',
	        value: function fromByteBuffer(b) {
	            return ObjectId.fromLong(b.readUint64());
	        }
	    }]);
	
	    return ObjectId;
	}();
	
	module.exports = ObjectId;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ecc = __webpack_require__(103);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FastParser = function () {
	    function FastParser() {
	        _classCallCheck(this, FastParser);
	    }
	
	    _createClass(FastParser, null, [{
	        key: 'fixed_data',
	        value: function fixed_data(b, len, buffer) {
	            if (!b) {
	                return;
	            }
	            if (buffer) {
	                var data = buffer.slice(0, len).toString('binary');
	                b.append(data, 'binary');
	                while (len-- > data.length) {
	                    b.writeUint8(0);
	                }
	            } else {
	                var b_copy = b.copy(b.offset, b.offset + len);
	                b.skip(len);
	                return new Buffer(b_copy.toBinary(), 'binary');
	            }
	        }
	    }, {
	        key: 'public_key',
	        value: function public_key(b, _public_key) {
	            if (!b) {
	                return;
	            }
	            if (_public_key) {
	                var buffer = _public_key.toBuffer();
	                b.append(buffer.toString('binary'), 'binary');
	                return;
	            } else {
	                buffer = FastParser.fixed_data(b, 33);
	                return _ecc.PublicKey.fromBuffer(buffer);
	            }
	        }
	    }, {
	        key: 'ripemd160',
	        value: function ripemd160(b, _ripemd) {
	            if (!b) {
	                return;
	            }
	            if (_ripemd) {
	                FastParser.fixed_data(b, 20, _ripemd);
	                return;
	            } else {
	                return FastParser.fixed_data(b, 20);
	            }
	        }
	    }, {
	        key: 'time_point_sec',
	        value: function time_point_sec(b, epoch) {
	            if (epoch) {
	                epoch = Math.ceil(epoch / 1000);
	                b.writeInt32(epoch);
	                return;
	            } else {
	                epoch = b.readInt32(); // fc::time_point_sec
	                return new Date(epoch * 1000);
	            }
	        }
	    }]);
	
	    return FastParser;
	}();
	
	module.exports = FastParser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ByteBuffer = __webpack_require__(154);
	var EC = __webpack_require__(201);
	
	var HEX_DUMP = process.env.npm_config__graphene_serializer_hex_dump;
	
	var Serializer = function () {
	    function Serializer(operation_name, types) {
	        _classCallCheck(this, Serializer);
	
	        this.operation_name = operation_name;
	        this.types = types;
	        if (this.types) this.keys = Object.keys(this.types);
	
	        Serializer.printDebug = true;
	    }
	
	    _createClass(Serializer, [{
	        key: 'fromByteBuffer',
	        value: function fromByteBuffer(b) {
	            var object = {};
	            var field = null;
	            try {
	                var iterable = this.keys;
	                for (var i = 0, field; i < iterable.length; i++) {
	                    field = iterable[i];
	                    var type = this.types[field];
	                    try {
	                        if (HEX_DUMP) {
	                            if (type.operation_name) {
	                                console.error(type.operation_name);
	                            } else {
	                                var o1 = b.offset;
	                                type.fromByteBuffer(b);
	                                var o2 = b.offset;
	                                b.offset = o1;
	                                //b.reset()
	                                var _b = b.copy(o1, o2);
	                                console.error(this.operation_name + '.' + field + '\t', _b.toHex());
	                            }
	                        }
	                        object[field] = type.fromByteBuffer(b);
	                    } catch (e) {
	                        if (Serializer.printDebug) {
	                            console.error('Error reading ' + this.operation_name + '.' + field + ' in data:');
	                            b.printDebug();
	                        }
	                        throw e;
	                    }
	                }
	            } catch (error) {
	                EC.throw(this.operation_name + '.' + field, error);
	            }
	
	            return object;
	        }
	    }, {
	        key: 'appendByteBuffer',
	        value: function appendByteBuffer(b, object) {
	            var field = null;
	            try {
	                var iterable = this.keys;
	                for (var i = 0, field; i < iterable.length; i++) {
	                    field = iterable[i];
	                    var type = this.types[field];
	                    type.appendByteBuffer(b, object[field]);
	                }
	            } catch (error) {
	                try {
	                    EC.throw(this.operation_name + '.' + field + " = " + JSON.stringify(object[field]), error);
	                } catch (e) {
	                    // circular ref
	                    EC.throw(this.operation_name + '.' + field + " = " + object[field], error);
	                }
	            }
	            return;
	        }
	    }, {
	        key: 'fromObject',
	        value: function fromObject(serialized_object) {
	            var result = {};
	            var field = null;
	            try {
	                var iterable = this.keys;
	                for (var i = 0, field; i < iterable.length; i++) {
	                    field = iterable[i];
	                    var type = this.types[field];
	                    var value = serialized_object[field];
	                    //DEBUG value = value.resolve if value.resolve
	                    //DEBUG console.log('... value',field,value)
	                    var object = type.fromObject(value);
	                    result[field] = object;
	                }
	            } catch (error) {
	                EC.throw(this.operation_name + '.' + field, error);
	            }
	
	            return result;
	        }
	
	        /**
	            @arg {boolean} [debug.use_default = false] - more template friendly
	            @arg {boolean} [debug.annotate = false] - add user-friendly information
	        */
	
	    }, {
	        key: 'toObject',
	        value: function toObject() {
	            var serialized_object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { use_default: false, annotate: false };
	
	            var result = {};
	            var field = null;
	            try {
	                if (!this.types) return result;
	
	                var iterable = this.keys;
	                for (var i = 0, field; i < iterable.length; i++) {
	                    field = iterable[i];
	                    var type = this.types[field];
	                    var object = type.toObject(typeof serialized_object !== "undefined" && serialized_object !== null ? serialized_object[field] : undefined, debug);
	                    result[field] = object;
	                    if (HEX_DUMP) {
	                        var b = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	                        var has_value = typeof serialized_object !== "undefined" && serialized_object !== null;
	                        if (has_value) {
	                            var value = serialized_object[field];
	                            if (value) type.appendByteBuffer(b, value);
	                        }
	                        b = b.copy(0, b.offset);
	                        console.error(this.operation_name + '.' + field, b.toHex());
	                    }
	                }
	            } catch (error) {
	                EC.throw(this.operation_name + '.' + field, error);
	            }
	
	            return result;
	        }
	
	        /** Sort by the first element in a operation */
	
	    }, {
	        key: 'compare',
	        value: function compare(a, b) {
	
	            var first_key = this.keys[0];
	            var first_type = this.types[first_key];
	
	            var valA = a[first_key];
	            var valB = b[first_key];
	
	            if (first_type.compare) return first_type.compare(valA, valB);
	
	            if (typeof valA === "number" && typeof valB === "number") return valA - valB;
	
	            var encoding = void 0;
	            if (Buffer.isBuffer(valA) && Buffer.isBuffer(valB)) {
	                // A binary string compare does not work.  If localeCompare is well supported that could replace HEX.  Performanance is very good so comparing HEX works.
	                encoding = "hex";
	            }
	
	            var strA = valA.toString(encoding);
	            var strB = valB.toString(encoding);
	            return strA > strB ? 1 : strA < strB ? -1 : 0;
	        }
	
	        // <helper_functions>
	
	    }, {
	        key: 'fromHex',
	        value: function fromHex(hex) {
	            var b = ByteBuffer.fromHex(hex, ByteBuffer.LITTLE_ENDIAN);
	            return this.fromByteBuffer(b);
	        }
	    }, {
	        key: 'fromBuffer',
	        value: function fromBuffer(buffer) {
	            var b = ByteBuffer.fromBinary(buffer.toString("binary"), ByteBuffer.LITTLE_ENDIAN);
	            return this.fromByteBuffer(b);
	        }
	    }, {
	        key: 'toHex',
	        value: function toHex(object) {
	            // return this.toBuffer(object).toString("hex")
	            var b = this.toByteBuffer(object);
	            return b.toHex();
	        }
	    }, {
	        key: 'toByteBuffer',
	        value: function toByteBuffer(object) {
	            var b = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, ByteBuffer.LITTLE_ENDIAN);
	            this.appendByteBuffer(b, object);
	            return b.copy(0, b.offset);
	        }
	    }, {
	        key: 'toBuffer',
	        value: function toBuffer(object) {
	            return new Buffer(this.toByteBuffer(object).toBinary(), 'binary');
	        }
	    }]);
	
	    return Serializer;
	}();
	
	module.exports = Serializer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(99).Buffer))

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Exception nesting.  */
	var ErrorWithCause = function () {
	    function ErrorWithCause(message, cause) {
	        _classCallCheck(this, ErrorWithCause);
	
	        this.message = message;
	        if (typeof cause !== "undefined" && cause !== null ? cause.message : undefined) {
	            this.message = "cause\t" + cause.message + "\t" + this.message;
	        }
	
	        var stack = ""; //(new Error).stack
	        if (typeof cause !== "undefined" && cause !== null ? cause.stack : undefined) {
	            stack = "caused by\n\t" + cause.stack + "\t" + stack;
	        }
	
	        this.stack = this.message + "\n" + stack;
	    }
	
	    _createClass(ErrorWithCause, null, [{
	        key: "throw",
	        value: function _throw(message, cause) {
	            var msg = message;
	            if (typeof cause !== "undefined" && cause !== null ? cause.message : undefined) {
	                msg += "\t cause: " + cause.message + " ";
	            }
	            if (typeof cause !== "undefined" && cause !== null ? cause.stack : undefined) {
	                msg += "\n stack: " + cause.stack + " ";
	            }
	            throw new Error(msg);
	        }
	    }]);
	
	    return ErrorWithCause;
	}();
	
	module.exports = ErrorWithCause;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	
	    // Primary class for creating operations
	    Serializer: __webpack_require__(200),
	
	    // helper functions for creating operations
	    fp: __webpack_require__(199),
	
	    // Low level types
	    types: __webpack_require__(98),
	
	    // Higher level operations (made out of generic types)
	    ops: __webpack_require__(203),
	
	    // Utility that generates JSON examples
	    template: __webpack_require__(204),
	
	    number_utils: __webpack_require__(195),
	
	    ChainTypes: __webpack_require__(197),
	
	    makeBitMaskFilter: __webpack_require__(205)
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _types = __webpack_require__(98);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _serializer = __webpack_require__(200);
	
	var _serializer2 = _interopRequireDefault(_serializer);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uint8 = _types2.default.uint8,
	    uint16 = _types2.default.uint16,
	    int16 = _types2.default.int16,
	    uint32 = _types2.default.uint32,
	    uint64 = _types2.default.uint64,
	    int64 = _types2.default.int64,
	    uint128 = _types2.default.uint128,
	    string = _types2.default.string,
	    string_binary = _types2.default.string_binary,
	    bytes = _types2.default.bytes,
	    bool = _types2.default.bool,
	    array = _types2.default.array,
	    static_variant = _types2.default.static_variant,
	    map = _types2.default.map,
	    set = _types2.default.set,
	    public_key = _types2.default.public_key,
	    time_point_sec = _types2.default.time_point_sec,
	    optional = _types2.default.optional,
	    asset = _types2.default.asset,
	    asset_symbol = _types2.default.asset_symbol; // This file is merge updated from hived's js_operation_serializer program.
	/*
	
	./js_operation_serializer |
	sed 's/void/future_extensions/g'|
	sed 's/steemit_protocol:://g'|
	sed 's/14static_variantIJNS_12fixed_stringINSt3__14pairIyyEEEEEEE/string/g'|
	sed 's/steemit_future_extensions/future_extensions/g'|
	sed 's/steemit_protocol_//g' > tmp.coffee
	
	*/
	// coffee tmp.coffee # fix errors until you see: `ChainTypes is not defined`
	
	/*
	
	   remove these 7 lines from tmp.coffee:
	
	static_variant [
	    pow2
	    equihash_pow
	] = static_variant [
	    pow2
	    equihash_pow
	]
	
	*/
	
	// npm i -g decaffeinate
	// decaffeinate tmp.coffee
	
	// Merge tmp.js - See "Generated code follows" below
	
	var future_extensions = _types2.default.void;
	var hardfork_version_vote = _types2.default.void;
	var version = _types2.default.void;
	var required_automated_actions = _types2.default.void;
	var optional_automated_actions = _types2.default.void;
	
	// Place-holder, their are dependencies on "operation" .. The final list of
	// operations is not avialble until the very end of the generated code.
	// See: operation.st_operations = ...
	var operation = static_variant();
	module.exports.operation = operation;
	
	// For module.exports
	var Serializer = function Serializer(operation_name, serilization_types_object) {
	    var s = new _serializer2.default(operation_name, serilization_types_object);
	    return module.exports[operation_name] = s;
	};
	
	var beneficiaries = new Serializer("beneficiaries", {
	    account: string,
	    weight: uint16
	});
	
	var comment_payout_beneficiaries = new Serializer(0, {
	    beneficiaries: set(beneficiaries)
	});
	
	var votable_asset_options = new Serializer("votable_asset_options", {
	    max_accepted_payout: int64,
	    allow_curation_rewards: bool,
	    beneficiaries: comment_payout_beneficiaries
	});
	
	var allowed_vote_assets = new Serializer(1, {
	    votable_assets: map(asset_symbol, votable_asset_options)
	});
	
	var smt_generation_unit = new Serializer("smt_generation_unit", {
	    hive_unit: map(string, uint16),
	    token_unit: map(string, uint16)
	});
	
	var smt_capped_generation_policy = new Serializer(0, {
	    generation_unit: smt_generation_unit,
	    extensions: set(future_extensions)
	});
	
	var smt_emissions_unit = new Serializer("smt_emissions_unit", {
	    token_unit: map(string, uint16)
	});
	
	var smt_param_allow_voting = new Serializer(0, {
	    value: bool
	});
	
	var smt_param_windows_v1 = new Serializer(0, {
	    cashout_window_seconds: uint32,
	    reverse_auction_window_seconds: uint32
	});
	
	var smt_param_vote_regeneration_period_seconds_v1 = new Serializer(1, {
	    vote_regeneration_period_seconds: uint32,
	    votes_per_regeneration_period: uint32
	});
	
	var smt_param_rewards_v1 = new Serializer(2, {
	    content_constant: uint128,
	    percent_curation_rewards: uint16,
	    author_reward_curve: int64,
	    curation_reward_curve: int64
	});
	
	var smt_param_allow_downvotes = new Serializer(3, {
	    value: bool
	});
	
	var update_proposal_end_date = new Serializer(1, {
	    end_date: time_point_sec
	});
	
	// Custom-types after Generated code
	
	// ##  Generated code follows
	// -------------------------------
	/*
	When updating generated code (fix closing notation)
	Replace:  var operation = static_variant([
	with:     operation.st_operations = [
	
	Delete (these are custom types instead):
	let public_key = new Serializer(
	    "public_key",
	    {key_data: bytes(33)}
	);
	
	let asset = new Serializer(
	    "asset",
	    {amount: int64,
	    symbol: uint64}
	);
	
	Replace: authority.prototype.account_authority_map
	With: map((string), (uint16))
	*/
	var signed_transaction = new Serializer("signed_transaction", {
	    ref_block_num: uint16,
	    ref_block_prefix: uint32,
	    expiration: time_point_sec,
	    operations: array(operation),
	    extensions: set(future_extensions),
	    signatures: array(bytes(65))
	});
	
	var signed_block = new Serializer("signed_block", {
	    previous: bytes(20),
	    timestamp: time_point_sec,
	    witness: string,
	    transaction_merkle_root: bytes(20),
	    extensions: set(static_variant([future_extensions, version, hardfork_version_vote, required_automated_actions, optional_automated_actions])),
	    witness_signature: bytes(65),
	    transactions: array(signed_transaction)
	});
	
	var block_header = new Serializer("block_header", {
	    previous: bytes(20),
	    timestamp: time_point_sec,
	    witness: string,
	    transaction_merkle_root: bytes(20),
	    extensions: set(static_variant([future_extensions, version, hardfork_version_vote]))
	});
	
	var signed_block_header = new Serializer("signed_block_header", {
	    previous: bytes(20),
	    timestamp: time_point_sec,
	    witness: string,
	    transaction_merkle_root: bytes(20),
	    extensions: set(static_variant([future_extensions, version, hardfork_version_vote, required_automated_actions, optional_automated_actions])),
	    witness_signature: bytes(65)
	});
	
	var vote = new Serializer("vote", {
	    voter: string,
	    author: string,
	    permlink: string,
	    weight: int16
	});
	
	var comment = new Serializer("comment", {
	    parent_author: string,
	    parent_permlink: string,
	    author: string,
	    permlink: string,
	    title: string,
	    body: string,
	    json_metadata: string
	});
	
	var transfer = new Serializer("transfer", {
	    from: string,
	    to: string,
	    amount: asset,
	    memo: string
	});
	
	var transfer_to_vesting = new Serializer("transfer_to_vesting", {
	    from: string,
	    to: string,
	    amount: asset
	});
	
	var withdraw_vesting = new Serializer("withdraw_vesting", {
	    account: string,
	    vesting_shares: asset
	});
	
	var limit_order_create = new Serializer("limit_order_create", {
	    owner: string,
	    orderid: uint32,
	    amount_to_sell: asset,
	    min_to_receive: asset,
	    fill_or_kill: bool,
	    expiration: time_point_sec
	});
	
	var limit_order_cancel = new Serializer("limit_order_cancel", {
	    owner: string,
	    orderid: uint32
	});
	
	var price = new Serializer("price", {
	    base: asset,
	    quote: asset
	});
	
	var feed_publish = new Serializer("feed_publish", {
	    publisher: string,
	    exchange_rate: price
	});
	
	var convert = new Serializer("convert", {
	    owner: string,
	    requestid: uint32,
	    amount: asset
	});
	
	var collateralized_convert = new Serializer("collateralized_convert", {
	    owner: string,
	    requestid: uint32,
	    amount: asset
	});
	
	var authority = new Serializer("authority", {
	    weight_threshold: uint32,
	    account_auths: map(string, uint16),
	    key_auths: map(public_key, uint16)
	});
	
	var account_create = new Serializer("account_create", {
	    fee: asset,
	    creator: string,
	    new_account_name: string,
	    owner: authority,
	    active: authority,
	    posting: authority,
	    memo_key: public_key,
	    json_metadata: string
	});
	
	var account_update = new Serializer("account_update", {
	    account: string,
	    owner: optional(authority),
	    active: optional(authority),
	    posting: optional(authority),
	    memo_key: public_key,
	    json_metadata: string
	});
	
	var chain_properties = new Serializer("chain_properties", {
	    account_creation_fee: asset,
	    maximum_block_size: uint32,
	    hbd_interest_rate: uint16
	});
	
	var witness_update = new Serializer("witness_update", {
	    owner: string,
	    url: string,
	    block_signing_key: public_key,
	    props: chain_properties,
	    fee: asset
	});
	
	var account_witness_vote = new Serializer("account_witness_vote", {
	    account: string,
	    witness: string,
	    approve: bool
	});
	
	var account_witness_proxy = new Serializer("account_witness_proxy", {
	    account: string,
	    proxy: string
	});
	
	var pow = new Serializer("pow", {
	    worker: public_key,
	    input: bytes(32),
	    signature: bytes(65),
	    work: bytes(32)
	});
	
	var custom = new Serializer("custom", {
	    required_auths: set(string),
	    id: uint16,
	    data: bytes()
	});
	
	var report_over_production = new Serializer("report_over_production", {
	    reporter: string,
	    first_block: signed_block_header,
	    second_block: signed_block_header
	});
	
	var delete_comment = new Serializer("delete_comment", {
	    author: string,
	    permlink: string
	});
	
	var custom_json = new Serializer("custom_json", {
	    required_auths: set(string),
	    required_posting_auths: set(string),
	    id: string,
	    json: string
	});
	
	var comment_options = new Serializer("comment_options", {
	    author: string,
	    permlink: string,
	    max_accepted_payout: asset,
	    percent_hbd: uint16,
	    allow_votes: bool,
	    allow_curation_rewards: bool,
	    extensions: set(static_variant([comment_payout_beneficiaries, allowed_vote_assets]))
	});
	
	var set_withdraw_vesting_route = new Serializer("set_withdraw_vesting_route", {
	    from_account: string,
	    to_account: string,
	    percent: uint16,
	    auto_vest: bool
	});
	
	var limit_order_create2 = new Serializer("limit_order_create2", {
	    owner: string,
	    orderid: uint32,
	    amount_to_sell: asset,
	    exchange_rate: price,
	    fill_or_kill: bool,
	    expiration: time_point_sec
	});
	
	var claim_account = new Serializer("claim_account", {
	    creator: string,
	    fee: asset,
	    extensions: set(future_extensions)
	});
	
	var create_claimed_account = new Serializer("create_claimed_account", {
	    creator: string,
	    new_account_name: string,
	    owner: authority,
	    active: authority,
	    posting: authority,
	    memo_key: public_key,
	    json_metadata: string,
	    extensions: set(future_extensions)
	});
	
	var request_account_recovery = new Serializer("request_account_recovery", {
	    recovery_account: string,
	    account_to_recover: string,
	    new_owner_authority: authority,
	    extensions: set(future_extensions)
	});
	
	var recover_account = new Serializer("recover_account", {
	    account_to_recover: string,
	    new_owner_authority: authority,
	    recent_owner_authority: authority,
	    extensions: set(future_extensions)
	});
	
	var change_recovery_account = new Serializer("change_recovery_account", {
	    account_to_recover: string,
	    new_recovery_account: string,
	    extensions: set(future_extensions)
	});
	
	var escrow_transfer = new Serializer("escrow_transfer", {
	    from: string,
	    to: string,
	    hbd_amount: asset,
	    hive_amount: asset,
	    escrow_id: uint32,
	    agent: string,
	    fee: asset,
	    json_meta: string,
	    ratification_deadline: time_point_sec,
	    escrow_expiration: time_point_sec
	});
	
	var escrow_dispute = new Serializer("escrow_dispute", {
	    from: string,
	    to: string,
	    agent: string,
	    who: string,
	    escrow_id: uint32
	});
	
	var escrow_release = new Serializer("escrow_release", {
	    from: string,
	    to: string,
	    agent: string,
	    who: string,
	    receiver: string,
	    escrow_id: uint32,
	    hbd_amount: asset,
	    hive_amount: asset
	});
	
	var pow2_input = new Serializer("pow2_input", {
	    worker_account: string,
	    prev_block: bytes(20),
	    nonce: uint64
	});
	
	var pow2 = new Serializer("pow2", {
	    input: pow2_input,
	    pow_summary: uint32
	});
	
	var equihash_proof = new Serializer("equihash_proof", {
	    n: uint32,
	    k: uint32,
	    seed: bytes(32),
	    inputs: array(uint32)
	});
	
	var equihash_pow = new Serializer("equihash_pow", {
	    input: pow2_input,
	    proof: equihash_proof,
	    prev_block: bytes(20),
	    pow_summary: uint32
	});
	
	var escrow_approve = new Serializer("escrow_approve", {
	    from: string,
	    to: string,
	    agent: string,
	    who: string,
	    escrow_id: uint32,
	    approve: bool
	});
	
	var transfer_to_savings = new Serializer("transfer_to_savings", {
	    from: string,
	    to: string,
	    amount: asset,
	    memo: string
	});
	
	var transfer_from_savings = new Serializer("transfer_from_savings", {
	    from: string,
	    request_id: uint32,
	    to: string,
	    amount: asset,
	    memo: string
	});
	
	var cancel_transfer_from_savings = new Serializer("cancel_transfer_from_savings", {
	    from: string,
	    request_id: uint32
	});
	
	var custom_binary = new Serializer("custom_binary", {
	    required_owner_auths: set(string),
	    required_active_auths: set(string),
	    required_posting_auths: set(string),
	    required_auths: array(authority),
	    id: string,
	    data: bytes()
	});
	
	var decline_voting_rights = new Serializer("decline_voting_rights", {
	    account: string,
	    decline: bool
	});
	
	var reset_account = new Serializer("reset_account", {
	    reset_account: string,
	    account_to_reset: string,
	    new_owner_authority: authority
	});
	
	var set_reset_account = new Serializer("set_reset_account", {
	    account: string,
	    current_reset_account: string,
	    reset_account: string
	});
	
	var claim_reward_balance = new Serializer("claim_reward_balance", {
	    account: string,
	    reward_hive: asset,
	    reward_hbd: asset,
	    reward_vests: asset
	});
	
	var delegate_vesting_shares = new Serializer("delegate_vesting_shares", {
	    delegator: string,
	    delegatee: string,
	    vesting_shares: asset
	});
	
	var account_create_with_delegation = new Serializer("account_create_with_delegation", {
	    fee: asset,
	    delegation: asset,
	    creator: string,
	    new_account_name: string,
	    owner: authority,
	    active: authority,
	    posting: authority,
	    memo_key: public_key,
	    json_metadata: string,
	    extensions: set(future_extensions)
	});
	
	var witness_set_properties = new Serializer("witness_set_properties", {
	    owner: string,
	    props: map(string, bytes()),
	    extensions: set(future_extensions)
	});
	
	var account_update2 = new Serializer("account_update2", {
	    account: string,
	    owner: optional(authority),
	    active: optional(authority),
	    posting: optional(authority),
	    memo_key: optional(public_key),
	    json_metadata: string,
	    posting_json_metadata: string,
	    extensions: set(future_extensions)
	});
	
	var create_proposal = new Serializer("create_proposal", {
	    creator: string,
	    receiver: string,
	    start_date: time_point_sec,
	    end_date: time_point_sec,
	    daily_pay: asset,
	    subject: string,
	    permlink: string,
	    extensions: set(future_extensions)
	});
	
	var update_proposal_votes = new Serializer("update_proposal_votes", {
	    voter: string,
	    proposal_ids: array(uint64),
	    approve: bool,
	    extensions: set(future_extensions)
	});
	
	var remove_proposal = new Serializer("remove_proposal", {
	    proposal_owner: string,
	    proposal_ids: array(uint64),
	    extensions: set(future_extensions)
	});
	
	var update_proposal = new Serializer("update_proposal", {
	    proposal_id: uint64,
	    creator: string,
	    daily_pay: asset,
	    subject: string,
	    permlink: string,
	    extensions: set(static_variant([future_extensions, update_proposal_end_date]))
	});
	
	var recurrent_transfer = new Serializer("recurrent_transfer", {
	    from: string,
	    to: string,
	    amount: asset,
	    memo: string,
	    recurrence: uint16,
	    executions: uint16,
	    extensions: set(future_extensions)
	});
	
	var claim_reward_balance2 = new Serializer("claim_reward_balance2", {
	    account: string,
	    reward_tokens: array(asset),
	    extensions: set(future_extensions)
	});
	
	var vote2 = new Serializer("vote2", {
	    voter: string,
	    author: string,
	    permlink: string,
	    rshares: map(asset_symbol, int64),
	    extensions: set(future_extensions)
	});
	
	var smt_create = new Serializer("smt_create", {
	    control_account: string,
	    symbol: asset_symbol,
	    smt_creation_fee: asset,
	    precision: uint8,
	    extensions: set(future_extensions)
	});
	
	var smt_setup = new Serializer("smt_setup", {
	    control_account: string,
	    symbol: asset_symbol,
	    max_supply: int64,
	    contribution_begin_time: time_point_sec,
	    contribution_end_time: time_point_sec,
	    launch_time: time_point_sec,
	    hive_units_min: int64,
	    min_unit_ratio: uint32,
	    max_unit_ratio: uint32,
	    extensions: set(future_extensions)
	});
	
	var smt_setup_emissions = new Serializer("smt_setup_emissions", {
	    control_account: string,
	    symbol: asset_symbol,
	    schedule_time: time_point_sec,
	    emissions_unit: smt_emissions_unit,
	    interval_seconds: uint32,
	    emission_count: uint32,
	    lep_time: time_point_sec,
	    rep_time: time_point_sec,
	    lep_abs_amount: int64,
	    rep_abs_amount: int64,
	    lep_rel_amount_numerator: uint32,
	    rep_rel_amount_numerator: uint32,
	    rel_amount_denom_bits: uint8,
	    remove: bool,
	    floor_emissions: bool,
	    extensions: set(future_extensions)
	});
	
	var smt_setup_ico_tier = new Serializer("smt_setup_ico_tier", {
	    control_account: string,
	    symbol: asset_symbol,
	    hive_units_cap: int64,
	    generation_policy: static_variant([smt_capped_generation_policy]),
	    remove: bool,
	    extensions: set(future_extensions)
	});
	
	var smt_set_setup_parameters = new Serializer("smt_set_setup_parameters", {
	    control_account: string,
	    symbol: asset_symbol,
	    setup_parameters: set(static_variant([smt_param_allow_voting])),
	    extensions: set(future_extensions)
	});
	
	var smt_set_runtime_parameters = new Serializer("smt_set_runtime_parameters", {
	    control_account: string,
	    symbol: asset_symbol,
	    runtime_parameters: set(static_variant([smt_param_windows_v1, smt_param_vote_regeneration_period_seconds_v1, smt_param_rewards_v1, smt_param_allow_downvotes])),
	    extensions: set(future_extensions)
	});
	
	var smt_contribute = new Serializer("smt_contribute", {
	    contributor: string,
	    symbol: asset_symbol,
	    contribution_id: uint32,
	    contribution: asset,
	    extensions: set(future_extensions)
	});
	
	var fill_convert_request = new Serializer("fill_convert_request", {
	    owner: string,
	    requestid: uint32,
	    amount_in: asset,
	    amount_out: asset
	});
	
	var author_reward = new Serializer("author_reward", {
	    author: string,
	    permlink: string,
	    hbd_payout: asset,
	    hive_payout: asset,
	    vesting_payout: asset
	});
	
	var curation_reward = new Serializer("curation_reward", {
	    curator: string,
	    reward: asset,
	    comment_author: string,
	    comment_permlink: string
	});
	
	var comment_reward = new Serializer("comment_reward", {
	    author: string,
	    permlink: string,
	    payout: asset
	});
	
	var liquidity_reward = new Serializer("liquidity_reward", {
	    owner: string,
	    payout: asset
	});
	
	var interest = new Serializer("interest", {
	    owner: string,
	    interest: asset
	});
	
	var fill_vesting_withdraw = new Serializer("fill_vesting_withdraw", {
	    from_account: string,
	    to_account: string,
	    withdrawn: asset,
	    deposited: asset
	});
	
	var fill_order = new Serializer("fill_order", {
	    current_owner: string,
	    current_orderid: uint32,
	    current_pays: asset,
	    open_owner: string,
	    open_orderid: uint32,
	    open_pays: asset
	});
	
	var shutdown_witness = new Serializer("shutdown_witness", { owner: string });
	
	var fill_transfer_from_savings = new Serializer("fill_transfer_from_savings", {
	    from: string,
	    to: string,
	    amount: asset,
	    request_id: uint32,
	    memo: string
	});
	
	var hardfork = new Serializer("hardfork", { hardfork_id: uint32 });
	
	var comment_payout_update = new Serializer("comment_payout_update", {
	    author: string,
	    permlink: string
	});
	
	var return_vesting_delegation = new Serializer("return_vesting_delegation", {
	    account: string,
	    vesting_shares: asset
	});
	
	var comment_benefactor_reward = new Serializer("comment_benefactor_reward", {
	    benefactor: string,
	    author: string,
	    permlink: string,
	    reward: asset
	});
	
	operation.st_operations = [vote, comment, transfer, transfer_to_vesting, withdraw_vesting, limit_order_create, limit_order_cancel, feed_publish, convert, account_create, account_update, witness_update, account_witness_vote, account_witness_proxy, pow, custom, report_over_production, delete_comment, custom_json, comment_options, set_withdraw_vesting_route, limit_order_create2, claim_account, create_claimed_account, request_account_recovery, recover_account, change_recovery_account, escrow_transfer, escrow_dispute, escrow_release, pow2, escrow_approve, transfer_to_savings, transfer_from_savings, cancel_transfer_from_savings, custom_binary, decline_voting_rights, reset_account, set_reset_account, claim_reward_balance, delegate_vesting_shares, account_create_with_delegation, witness_set_properties, account_update2, create_proposal, update_proposal_votes, remove_proposal, update_proposal, collateralized_convert, recurrent_transfer, claim_reward_balance2, vote2, smt_setup, smt_setup_emissions, smt_setup_ico_tier, smt_set_setup_parameters, smt_set_runtime_parameters, smt_create, smt_contribute, fill_convert_request, author_reward, curation_reward, comment_reward, liquidity_reward, interest, fill_vesting_withdraw, fill_order, shutdown_witness, fill_transfer_from_savings, hardfork, comment_payout_update, return_vesting_delegation, comment_benefactor_reward];
	
	var transaction = new Serializer("transaction", {
	    ref_block_num: uint16,
	    ref_block_prefix: uint32,
	    expiration: time_point_sec,
	    operations: array(operation),
	    extensions: set(future_extensions)
	});
	
	//# -------------------------------
	//#  Generated code end  S T O P
	//# -------------------------------
	
	// Custom Types (do not over-write)
	
	var encrypted_memo = new Serializer("encrypted_memo", { from: public_key,
	    to: public_key,
	    nonce: uint64,
	    check: uint32,
	    encrypted: string_binary });
	/*
	
	// Make sure all tests pass

	npm test

	*/

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	"use strict";
	
	/** Console print any transaction object with zero default values. */
	module.exports = function template(op) {
	
	    var object = op.toObject(void 0, { use_default: true, annotate: true });
	
	    // visual (with descriptions)
	    console.error(JSON.stringify(object, null, 4));
	
	    // usable in a copy-paste
	
	    object = op.toObject(void 0, { use_default: true, annotate: false });
	
	    // copy-paste one-lineer
	    console.error(JSON.stringify(object));
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jsbi = __webpack_require__(206);
	
	var _jsbi2 = _interopRequireDefault(_jsbi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeBitMaskFilter = function makeBitMaskFilter(allowedOperations) {
	  return allowedOperations.reduce(function (_ref, allowedOperation) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        low = _ref2[0],
	        high = _ref2[1];
	
	    return allowedOperation < 64 ? [_jsbi2.default.bitwiseOr(low, _jsbi2.default.leftShift(_jsbi2.default.BigInt(1), _jsbi2.default.BigInt(allowedOperation))), high] : [low, _jsbi2.default.bitwiseOr(high, _jsbi2.default.leftShift(_jsbi2.default.BigInt(1), _jsbi2.default.BigInt(allowedOperation - 64)))];
	  }, [_jsbi2.default.BigInt(0), _jsbi2.default.BigInt(0)]).map(function (value) {
	    return _jsbi2.default.notEqual(value, _jsbi2.default.BigInt(0)) ? value.toString() : null;
	  });
	};
	
	module.exports = makeBitMaskFilter;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (e, t) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (e = e || self, e.JSBI = t());
	})(undefined, function () {
	  'use strict';
	  var v = Math.imul,
	      f = Math.clz32;function e(t) {
	    "@babel/helpers - typeof";
	    return e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	      return typeof e === "undefined" ? "undefined" : _typeof(e);
	    } : function (e) {
	      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	    }, e(t);
	  }function t(e, t) {
	    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	  }function i(e, t) {
	    for (var _, n = 0; n < t.length; n++) {
	      _ = t[n], _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(e, _.key, _);
	    }
	  }function _(e, t, _) {
	    return t && i(e.prototype, t), _ && i(e, _), e;
	  }function n(e, t) {
	    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && g(e, t);
	  }function l(e) {
	    return l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	      return e.__proto__ || Object.getPrototypeOf(e);
	    }, l(e);
	  }function g(e, t) {
	    return g = Object.setPrototypeOf || function (e, t) {
	      return e.__proto__ = t, e;
	    }, g(e, t);
	  }function o() {
	    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
	      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
	    } catch (t) {
	      return !1;
	    }
	  }function a() {
	    return a = o() ? Reflect.construct : function (e, t, i) {
	      var _ = [null];_.push.apply(_, t);var n = Function.bind.apply(e, _),
	          l = new n();return i && g(l, i.prototype), l;
	    }, a.apply(null, arguments);
	  }function s(e) {
	    return -1 !== Function.toString.call(e).indexOf("[native code]");
	  }function u(e) {
	    var t = "function" == typeof Map ? new Map() : void 0;return u = function u(e) {
	      function i() {
	        return a(e, arguments, l(this).constructor);
	      }if (null === e || !s(e)) return e;if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");if ("undefined" != typeof t) {
	        if (t.has(e)) return t.get(e);t.set(e, i);
	      }return i.prototype = Object.create(e.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), g(i, e);
	    }, u(e);
	  }function r(e) {
	    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	  }function d(e, t) {
	    return t && ("object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) || "function" == typeof t) ? t : r(e);
	  }function h(e) {
	    var t = o();return function () {
	      var i,
	          _ = l(e);if (t) {
	        var n = l(this).constructor;i = Reflect.construct(_, arguments, n);
	      } else i = _.apply(this, arguments);return d(this, i);
	    };
	  }function b(e, t) {
	    if (e) {
	      if ("string" == typeof e) return m(e, t);var i = Object.prototype.toString.call(e).slice(8, -1);return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? m(e, t) : void 0;
	    }
	  }function m(e, t) {
	    (null == t || t > e.length) && (t = e.length);for (var _ = 0, n = Array(t); _ < t; _++) {
	      n[_] = e[_];
	    }return n;
	  }function c(e, t) {
	    var _;if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
	      if (Array.isArray(e) || (_ = b(e)) || t && e && "number" == typeof e.length) {
	        _ && (e = _);var _n = 0,
	            l = function l() {};return { s: l, n: function n() {
	            return _n >= e.length ? { done: !0 } : { done: !1, value: e[_n++] };
	          }, e: function e(t) {
	            throw t;
	          }, f: l };
	      }throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	    }var g,
	        a = !0,
	        s = !1;return { s: function s() {
	        _ = e[Symbol.iterator]();
	      }, n: function n() {
	        var e = _.next();return a = e.done, e;
	      }, e: function e(t) {
	        s = !0, g = t;
	      }, f: function f() {
	        try {
	          a || null == _.return || _.return();
	        } finally {
	          if (s) throw g;
	        }
	      } };
	  }var y = function (i) {
	    var g = Math.abs,
	        o = Math.max;function l(e, i) {
	      var _;if (t(this, l), e > l.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");return _ = a.call(this, e), _.sign = i, _;
	    }n(l, i);var a = h(l);return _(l, [{ key: "toDebugString", value: function value() {
	        var e,
	            t = ["BigInt["],
	            i = c(this);try {
	          for (i.s(); !(e = i.n()).done;) {
	            var _ = e.value;t.push((_ ? (_ >>> 0).toString(16) : _) + ", ");
	          }
	        } catch (e) {
	          i.e(e);
	        } finally {
	          i.f();
	        }return t.push("]"), t.join("");
	      } }, { key: "toString", value: function value() {
	        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 10;if (2 > e || 36 < e) throw new RangeError("toString() radix argument must be between 2 and 36");return 0 === this.length ? "0" : 0 == (e & e - 1) ? l.__toStringBasePowerOfTwo(this, e) : l.__toStringGeneric(this, e, !1);
	      } }, { key: "__copy", value: function value() {
	        for (var e = new l(this.length, this.sign), t = 0; t < this.length; t++) {
	          e[t] = this[t];
	        }return e;
	      } }, { key: "__trim", value: function value() {
	        for (var e = this.length, t = this[e - 1]; 0 === t;) {
	          e--, t = this[e - 1], this.pop();
	        }return 0 === e && (this.sign = !1), this;
	      } }, { key: "__initializeDigits", value: function value() {
	        for (var e = 0; e < this.length; e++) {
	          this[e] = 0;
	        }
	      } }, { key: "__clzmsd", value: function value() {
	        return l.__clz32(this[this.length - 1]);
	      } }, { key: "__inplaceMultiplyAdd", value: function value(e, t, _) {
	        _ > this.length && (_ = this.length);for (var n = 65535 & e, g = e >>> 16, o = 0, a = 65535 & t, s = t >>> 16, u = 0; u < _; u++) {
	          var r = this.__digit(u),
	              d = 65535 & r,
	              h = r >>> 16,
	              b = l.__imul(d, n),
	              m = l.__imul(d, g),
	              c = l.__imul(h, n),
	              v = l.__imul(h, g),
	              f = a + (65535 & b),
	              y = s + o + (f >>> 16) + (b >>> 16) + (65535 & m) + (65535 & c);a = (m >>> 16) + (c >>> 16) + (65535 & v) + (y >>> 16), o = a >>> 16, a &= 65535, s = v >>> 16;this.__setDigit(u, 65535 & f | y << 16);
	        }if (0 !== o || 0 !== a || 0 !== s) throw new Error("implementation bug");
	      } }, { key: "__inplaceAdd", value: function value(e, t, _) {
	        for (var n, l = 0, g = 0; g < _; g++) {
	          n = this.__halfDigit(t + g) + e.__halfDigit(g) + l, l = n >>> 16, this.__setHalfDigit(t + g, n);
	        }return l;
	      } }, { key: "__inplaceSub", value: function value(e, t, _) {
	        var n = 0;if (1 & t) {
	          t >>= 1;for (var l = this.__digit(t), g = 65535 & l, o = 0; o < _ - 1 >>> 1; o++) {
	            var a = e.__digit(o),
	                s = (l >>> 16) - (65535 & a) - n;n = 1 & s >>> 16, this.__setDigit(t + o, s << 16 | 65535 & g), l = this.__digit(t + o + 1), g = (65535 & l) - (a >>> 16) - n, n = 1 & g >>> 16;
	          }var u = e.__digit(o),
	              r = (l >>> 16) - (65535 & u) - n;n = 1 & r >>> 16, this.__setDigit(t + o, r << 16 | 65535 & g);if (t + o + 1 >= this.length) throw new RangeError("out of bounds");0 == (1 & _) && (l = this.__digit(t + o + 1), g = (65535 & l) - (u >>> 16) - n, n = 1 & g >>> 16, this.__setDigit(t + e.length, 4294901760 & l | 65535 & g));
	        } else {
	          t >>= 1;for (var d = 0; d < e.length - 1; d++) {
	            var h = this.__digit(t + d),
	                b = e.__digit(d),
	                m = (65535 & h) - (65535 & b) - n;n = 1 & m >>> 16;var c = (h >>> 16) - (b >>> 16) - n;n = 1 & c >>> 16, this.__setDigit(t + d, c << 16 | 65535 & m);
	          }var v = this.__digit(t + d),
	              f = e.__digit(d),
	              y = (65535 & v) - (65535 & f) - n;n = 1 & y >>> 16;var k = 0;0 == (1 & _) && (k = (v >>> 16) - (f >>> 16) - n, n = 1 & k >>> 16), this.__setDigit(t + d, k << 16 | 65535 & y);
	        }return n;
	      } }, { key: "__inplaceRightShift", value: function value(e) {
	        if (0 !== e) {
	          for (var t, _ = this.__digit(0) >>> e, n = this.length - 1, l = 0; l < n; l++) {
	            t = this.__digit(l + 1), this.__setDigit(l, t << 32 - e | _), _ = t >>> e;
	          }this.__setDigit(n, _);
	        }
	      } }, { key: "__digit", value: function value(e) {
	        return this[e];
	      } }, { key: "__unsignedDigit", value: function value(e) {
	        return this[e] >>> 0;
	      } }, { key: "__setDigit", value: function value(e, t) {
	        this[e] = 0 | t;
	      } }, { key: "__setDigitGrow", value: function value(e, t) {
	        this[e] = 0 | t;
	      } }, { key: "__halfDigitLength", value: function value() {
	        var e = this.length;return 65535 >= this.__unsignedDigit(e - 1) ? 2 * e - 1 : 2 * e;
	      } }, { key: "__halfDigit", value: function value(e) {
	        return 65535 & this[e >>> 1] >>> ((1 & e) << 4);
	      } }, { key: "__setHalfDigit", value: function value(e, t) {
	        var i = e >>> 1,
	            _ = this.__digit(i),
	            n = 1 & e ? 65535 & _ | t << 16 : 4294901760 & _ | 65535 & t;this.__setDigit(i, n);
	      } }], [{ key: "BigInt", value: function value(t) {
	        var i = Math.floor,
	            _ = Number.isFinite;if ("number" == typeof t) {
	          if (0 === t) return l.__zero();if ((0 | t) === t) return 0 > t ? l.__oneDigit(-t, !0) : l.__oneDigit(t, !1);if (!_(t) || i(t) !== t) throw new RangeError("The number " + t + " cannot be converted to BigInt because it is not an integer");return l.__fromDouble(t);
	        }if ("string" == typeof t) {
	          var n = l.__fromString(t);if (null === n) throw new SyntaxError("Cannot convert " + t + " to a BigInt");return n;
	        }if ("boolean" == typeof t) return !0 === t ? l.__oneDigit(1, !1) : l.__zero();if ("object" === e(t)) {
	          if (t.constructor === l) return t;var g = l.__toPrimitive(t);return l.BigInt(g);
	        }throw new TypeError("Cannot convert " + t + " to a BigInt");
	      } }, { key: "toNumber", value: function value(e) {
	        var t = e.length;if (0 === t) return 0;if (1 === t) {
	          var i = e.__unsignedDigit(0);return e.sign ? -i : i;
	        }var _ = e.__digit(t - 1),
	            n = l.__clz32(_),
	            g = 32 * t - n;if (1024 < g) return e.sign ? -Infinity : 1 / 0;var o = g - 1,
	            a = _,
	            s = t - 1,
	            u = n + 1,
	            r = 32 === u ? 0 : a << u;r >>>= 12;var d = u - 12,
	            h = 12 <= u ? 0 : a << 20 + u,
	            b = 20 + u;0 < d && 0 < s && (s--, a = e.__digit(s), r |= a >>> 32 - d, h = a << d, b = d), 0 < b && 0 < s && (s--, a = e.__digit(s), h |= a >>> 32 - b, b -= 32);var m = l.__decideRounding(e, b, s, a);if ((1 === m || 0 === m && 1 == (1 & h)) && (h = h + 1 >>> 0, 0 === h && (r++, 0 != r >>> 20 && (r = 0, o++, 1023 < o)))) return e.sign ? -Infinity : 1 / 0;var c = e.sign ? -2147483648 : 0;return o = o + 1023 << 20, l.__kBitConversionInts[1] = c | o | r, l.__kBitConversionInts[0] = h, l.__kBitConversionDouble[0];
	      } }, { key: "unaryMinus", value: function value(e) {
	        if (0 === e.length) return e;var t = e.__copy();return t.sign = !e.sign, t;
	      } }, { key: "bitwiseNot", value: function value(e) {
	        return e.sign ? l.__absoluteSubOne(e).__trim() : l.__absoluteAddOne(e, !0);
	      } }, { key: "exponentiate", value: function value(e, t) {
	        if (t.sign) throw new RangeError("Exponent must be positive");if (0 === t.length) return l.__oneDigit(1, !1);if (0 === e.length) return e;if (1 === e.length && 1 === e.__digit(0)) return e.sign && 0 == (1 & t.__digit(0)) ? l.unaryMinus(e) : e;if (1 < t.length) throw new RangeError("BigInt too big");var i = t.__unsignedDigit(0);if (1 === i) return e;if (i >= l.__kMaxLengthBits) throw new RangeError("BigInt too big");if (1 === e.length && 2 === e.__digit(0)) {
	          var _ = 1 + (i >>> 5),
	              n = e.sign && 0 != (1 & i),
	              g = new l(_, n);g.__initializeDigits();var o = 1 << (31 & i);return g.__setDigit(_ - 1, o), g;
	        }var a = null,
	            s = e;for (0 != (1 & i) && (a = e), i >>= 1; 0 !== i; i >>= 1) {
	          s = l.multiply(s, s), 0 != (1 & i) && (null === a ? a = s : a = l.multiply(a, s));
	        }return a;
	      } }, { key: "multiply", value: function value(e, t) {
	        if (0 === e.length) return e;if (0 === t.length) return t;var _ = e.length + t.length;32 <= e.__clzmsd() + t.__clzmsd() && _--;var n = new l(_, e.sign !== t.sign);n.__initializeDigits();for (var g = 0; g < e.length; g++) {
	          l.__multiplyAccumulate(t, e.__digit(g), n, g);
	        }return n.__trim();
	      } }, { key: "divide", value: function value(e, t) {
	        if (0 === t.length) throw new RangeError("Division by zero");if (0 > l.__absoluteCompare(e, t)) return l.__zero();var i,
	            _ = e.sign !== t.sign,
	            n = t.__unsignedDigit(0);if (1 === t.length && 65535 >= n) {
	          if (1 === n) return _ === e.sign ? e : l.unaryMinus(e);i = l.__absoluteDivSmall(e, n, null);
	        } else i = l.__absoluteDivLarge(e, t, !0, !1);return i.sign = _, i.__trim();
	      } }, { key: "remainder", value: function e(t, i) {
	        if (0 === i.length) throw new RangeError("Division by zero");if (0 > l.__absoluteCompare(t, i)) return t;var _ = i.__unsignedDigit(0);if (1 === i.length && 65535 >= _) {
	          if (1 === _) return l.__zero();var n = l.__absoluteModSmall(t, _);return 0 === n ? l.__zero() : l.__oneDigit(n, t.sign);
	        }var e = l.__absoluteDivLarge(t, i, !1, !0);return e.sign = t.sign, e.__trim();
	      } }, { key: "add", value: function value(e, t) {
	        var i = e.sign;return i === t.sign ? l.__absoluteAdd(e, t, i) : 0 <= l.__absoluteCompare(e, t) ? l.__absoluteSub(e, t, i) : l.__absoluteSub(t, e, !i);
	      } }, { key: "subtract", value: function value(e, t) {
	        var i = e.sign;return i === t.sign ? 0 <= l.__absoluteCompare(e, t) ? l.__absoluteSub(e, t, i) : l.__absoluteSub(t, e, !i) : l.__absoluteAdd(e, t, i);
	      } }, { key: "leftShift", value: function value(e, t) {
	        return 0 === t.length || 0 === e.length ? e : t.sign ? l.__rightShiftByAbsolute(e, t) : l.__leftShiftByAbsolute(e, t);
	      } }, { key: "signedRightShift", value: function value(e, t) {
	        return 0 === t.length || 0 === e.length ? e : t.sign ? l.__leftShiftByAbsolute(e, t) : l.__rightShiftByAbsolute(e, t);
	      } }, { key: "unsignedRightShift", value: function value() {
	        throw new TypeError("BigInts have no unsigned right shift; use >> instead");
	      } }, { key: "lessThan", value: function value(e, t) {
	        return 0 > l.__compareToBigInt(e, t);
	      } }, { key: "lessThanOrEqual", value: function value(e, t) {
	        return 0 >= l.__compareToBigInt(e, t);
	      } }, { key: "greaterThan", value: function value(e, t) {
	        return 0 < l.__compareToBigInt(e, t);
	      } }, { key: "greaterThanOrEqual", value: function value(e, t) {
	        return 0 <= l.__compareToBigInt(e, t);
	      } }, { key: "equal", value: function value(e, t) {
	        if (e.sign !== t.sign) return !1;if (e.length !== t.length) return !1;for (var _ = 0; _ < e.length; _++) {
	          if (e.__digit(_) !== t.__digit(_)) return !1;
	        }return !0;
	      } }, { key: "notEqual", value: function value(e, t) {
	        return !l.equal(e, t);
	      } }, { key: "bitwiseAnd", value: function value(e, t) {
	        if (!e.sign && !t.sign) return l.__absoluteAnd(e, t).__trim();if (e.sign && t.sign) {
	          var i = o(e.length, t.length) + 1,
	              _ = l.__absoluteSubOne(e, i),
	              n = l.__absoluteSubOne(t);return _ = l.__absoluteOr(_, n, _), l.__absoluteAddOne(_, !0, _).__trim();
	        }if (e.sign) {
	          var g = [t, e];e = g[0], t = g[1];
	        }return l.__absoluteAndNot(e, l.__absoluteSubOne(t)).__trim();
	      } }, { key: "bitwiseXor", value: function value(e, t) {
	        if (!e.sign && !t.sign) return l.__absoluteXor(e, t).__trim();if (e.sign && t.sign) {
	          var i = o(e.length, t.length),
	              _ = l.__absoluteSubOne(e, i),
	              n = l.__absoluteSubOne(t);return l.__absoluteXor(_, n, _).__trim();
	        }var g = o(e.length, t.length) + 1;if (e.sign) {
	          var a = [t, e];e = a[0], t = a[1];
	        }var s = l.__absoluteSubOne(t, g);return s = l.__absoluteXor(s, e, s), l.__absoluteAddOne(s, !0, s).__trim();
	      } }, { key: "bitwiseOr", value: function value(e, t) {
	        var i = o(e.length, t.length);if (!e.sign && !t.sign) return l.__absoluteOr(e, t).__trim();if (e.sign && t.sign) {
	          var _ = l.__absoluteSubOne(e, i),
	              n = l.__absoluteSubOne(t);return _ = l.__absoluteAnd(_, n, _), l.__absoluteAddOne(_, !0, _).__trim();
	        }if (e.sign) {
	          var g = [t, e];e = g[0], t = g[1];
	        }var a = l.__absoluteSubOne(t, i);return a = l.__absoluteAndNot(a, e, a), l.__absoluteAddOne(a, !0, a).__trim();
	      } }, { key: "asIntN", value: function value(e, t) {
	        if (0 === t.length) return t;if (0 === e) return l.__zero();if (e >= l.__kMaxLengthBits) return t;var _ = e + 31 >>> 5;if (t.length < _) return t;var n = t.__unsignedDigit(_ - 1),
	            g = 1 << (31 & e - 1);if (t.length === _ && n < g) return t;if (!((n & g) === g)) return l.__truncateToNBits(e, t);if (!t.sign) return l.__truncateAndSubFromPowerOfTwo(e, t, !0);if (0 == (n & g - 1)) {
	          for (var o = _ - 2; 0 <= o; o--) {
	            if (0 !== t.__digit(o)) return l.__truncateAndSubFromPowerOfTwo(e, t, !1);
	          }return t.length === _ && n === g ? t : l.__truncateToNBits(e, t);
	        }return l.__truncateAndSubFromPowerOfTwo(e, t, !1);
	      } }, { key: "asUintN", value: function value(e, t) {
	        if (0 === t.length) return t;if (0 === e) return l.__zero();if (t.sign) {
	          if (e > l.__kMaxLengthBits) throw new RangeError("BigInt too big");return l.__truncateAndSubFromPowerOfTwo(e, t, !1);
	        }if (e >= l.__kMaxLengthBits) return t;var i = e + 31 >>> 5;if (t.length < i) return t;var _ = 31 & e;if (t.length == i) {
	          if (0 === _) return t;var n = t.__digit(i - 1);if (0 == n >>> _) return t;
	        }return l.__truncateToNBits(e, t);
	      } }, { key: "ADD", value: function value(e, t) {
	        if (e = l.__toPrimitive(e), t = l.__toPrimitive(t), "string" == typeof e) return "string" != typeof t && (t = t.toString()), e + t;if ("string" == typeof t) return e.toString() + t;if (e = l.__toNumeric(e), t = l.__toNumeric(t), l.__isBigInt(e) && l.__isBigInt(t)) return l.add(e, t);if ("number" == typeof e && "number" == typeof t) return e + t;throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
	      } }, { key: "LT", value: function value(e, t) {
	        return l.__compare(e, t, 0);
	      } }, { key: "LE", value: function value(e, t) {
	        return l.__compare(e, t, 1);
	      } }, { key: "GT", value: function value(e, t) {
	        return l.__compare(e, t, 2);
	      } }, { key: "GE", value: function value(e, t) {
	        return l.__compare(e, t, 3);
	      } }, { key: "EQ", value: function value(t, i) {
	        for (;;) {
	          if (l.__isBigInt(t)) return l.__isBigInt(i) ? l.equal(t, i) : l.EQ(i, t);if ("number" == typeof t) {
	            if (l.__isBigInt(i)) return l.__equalToNumber(i, t);if ("object" !== e(i)) return t == i;i = l.__toPrimitive(i);
	          } else if ("string" == typeof t) {
	            if (l.__isBigInt(i)) return t = l.__fromString(t), null !== t && l.equal(t, i);if ("object" !== e(i)) return t == i;i = l.__toPrimitive(i);
	          } else if ("boolean" == typeof t) {
	            if (l.__isBigInt(i)) return l.__equalToNumber(i, +t);if ("object" !== e(i)) return t == i;i = l.__toPrimitive(i);
	          } else if ("symbol" === e(t)) {
	            if (l.__isBigInt(i)) return !1;if ("object" !== e(i)) return t == i;i = l.__toPrimitive(i);
	          } else if ("object" === e(t)) {
	            if ("object" === e(i) && i.constructor !== l) return t == i;t = l.__toPrimitive(t);
	          } else return t == i;
	        }
	      } }, { key: "NE", value: function value(e, t) {
	        return !l.EQ(e, t);
	      } }, { key: "__zero", value: function value() {
	        return new l(0, !1);
	      } }, { key: "__oneDigit", value: function value(e, t) {
	        var i = new l(1, t);return i.__setDigit(0, e), i;
	      } }, { key: "__decideRounding", value: function value(e, t, i, _) {
	        if (0 < t) return -1;var n;if (0 > t) n = -t - 1;else {
	          if (0 === i) return -1;i--, _ = e.__digit(i), n = 31;
	        }var l = 1 << n;if (0 == (_ & l)) return -1;if (l -= 1, 0 != (_ & l)) return 1;for (; 0 < i;) {
	          if (i--, 0 !== e.__digit(i)) return 1;
	        }return 0;
	      } }, { key: "__fromDouble", value: function value(e) {
	        l.__kBitConversionDouble[0] = e;var t,
	            i = 2047 & l.__kBitConversionInts[1] >>> 20,
	            _ = i - 1023,
	            n = (_ >>> 5) + 1,
	            g = new l(n, 0 > e),
	            o = 1048575 & l.__kBitConversionInts[1] | 1048576,
	            a = l.__kBitConversionInts[0],
	            s = 20,
	            u = 31 & _,
	            r = 0;if (u < s) {
	          var d = s - u;r = d + 32, t = o >>> d, o = o << 32 - d | a >>> d, a <<= 32 - d;
	        } else if (u === s) r = 32, t = o, o = a;else {
	          var h = u - s;r = 32 - h, t = o << h | a >>> 32 - h, o = a << h;
	        }g.__setDigit(n - 1, t);for (var b = n - 2; 0 <= b; b--) {
	          0 < r ? (r -= 32, t = o, o = a) : t = 0, g.__setDigit(b, t);
	        }return g.__trim();
	      } }, { key: "__isWhitespace", value: function value(e) {
	        return !!(13 >= e && 9 <= e) || (159 >= e ? 32 == e : 131071 >= e ? 160 == e || 5760 == e : 196607 >= e ? (e &= 131071, 10 >= e || 40 == e || 41 == e || 47 == e || 95 == e || 4096 == e) : 65279 == e);
	      } }, { key: "__fromString", value: function value(e) {
	        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0,
	            i = 0,
	            _ = e.length,
	            n = 0;if (n === _) return l.__zero();for (var g = e.charCodeAt(n); l.__isWhitespace(g);) {
	          if (++n === _) return l.__zero();g = e.charCodeAt(n);
	        }if (43 === g) {
	          if (++n === _) return null;g = e.charCodeAt(n), i = 1;
	        } else if (45 === g) {
	          if (++n === _) return null;g = e.charCodeAt(n), i = -1;
	        }if (0 === t) {
	          if (t = 10, 48 === g) {
	            if (++n === _) return l.__zero();if (g = e.charCodeAt(n), 88 === g || 120 === g) {
	              if (t = 16, ++n === _) return null;g = e.charCodeAt(n);
	            } else if (79 === g || 111 === g) {
	              if (t = 8, ++n === _) return null;g = e.charCodeAt(n);
	            } else if (66 === g || 98 === g) {
	              if (t = 2, ++n === _) return null;g = e.charCodeAt(n);
	            }
	          }
	        } else if (16 === t && 48 === g) {
	          if (++n === _) return l.__zero();if (g = e.charCodeAt(n), 88 === g || 120 === g) {
	            if (++n === _) return null;g = e.charCodeAt(n);
	          }
	        }for (; 48 === g;) {
	          if (++n === _) return l.__zero();g = e.charCodeAt(n);
	        }var o = _ - n,
	            a = l.__kMaxBitsPerChar[t],
	            s = l.__kBitsPerCharTableMultiplier - 1;if (o > 1073741824 / a) return null;var u = a * o + s >>> l.__kBitsPerCharTableShift,
	            r = new l(u + 31 >>> 5, !1),
	            h = 10 > t ? t : 10,
	            b = 10 < t ? t - 10 : 0;if (0 == (t & t - 1)) {
	          a >>= l.__kBitsPerCharTableShift;var c = [],
	              v = [],
	              f = !1;do {
	            for (var y, k = 0, D = 0;;) {
	              if (y = void 0, g - 48 >>> 0 < h) y = g - 48;else if ((32 | g) - 97 >>> 0 < b) y = (32 | g) - 87;else {
	                f = !0;break;
	              }if (D += a, k = k << a | y, ++n === _) {
	                f = !0;break;
	              }if (g = e.charCodeAt(n), 32 < D + a) break;
	            }c.push(k), v.push(D);
	          } while (!f);l.__fillFromParts(r, c, v);
	        } else {
	          r.__initializeDigits();var p = !1,
	              B = 0;do {
	            for (var S, C = 0, A = 1;;) {
	              if (S = void 0, g - 48 >>> 0 < h) S = g - 48;else if ((32 | g) - 97 >>> 0 < b) S = (32 | g) - 87;else {
	                p = !0;break;
	              }var T = A * t;if (4294967295 < T) break;if (A = T, C = C * t + S, B++, ++n === _) {
	                p = !0;break;
	              }g = e.charCodeAt(n);
	            }s = 32 * l.__kBitsPerCharTableMultiplier - 1;var m = a * B + s >>> l.__kBitsPerCharTableShift + 5;r.__inplaceMultiplyAdd(A, C, m);
	          } while (!p);
	        }if (n !== _) {
	          if (!l.__isWhitespace(g)) return null;for (n++; n < _; n++) {
	            if (g = e.charCodeAt(n), !l.__isWhitespace(g)) return null;
	          }
	        }return 0 !== i && 10 !== t ? null : (r.sign = -1 === i, r.__trim());
	      } }, { key: "__fillFromParts", value: function value(e, t, _) {
	        for (var n = 0, l = 0, g = 0, o = t.length - 1; 0 <= o; o--) {
	          var a = t[o],
	              s = _[o];l |= a << g, g += s, 32 === g ? (e.__setDigit(n++, l), g = 0, l = 0) : 32 < g && (e.__setDigit(n++, l), g -= 32, l = a >>> s - g);
	        }if (0 !== l) {
	          if (n >= e.length) throw new Error("implementation bug");e.__setDigit(n++, l);
	        }for (; n < e.length; n++) {
	          e.__setDigit(n, 0);
	        }
	      } }, { key: "__toStringBasePowerOfTwo", value: function value(e, t) {
	        var _ = e.length,
	            n = t - 1;n = (85 & n >>> 1) + (85 & n), n = (51 & n >>> 2) + (51 & n), n = (15 & n >>> 4) + (15 & n);var g = n,
	            o = t - 1,
	            a = e.__digit(_ - 1),
	            s = l.__clz32(a),
	            u = 0 | (32 * _ - s + g - 1) / g;if (e.sign && u++, 268435456 < u) throw new Error("string too long");for (var r = Array(u), d = u - 1, h = 0, b = 0, m = 0; m < _ - 1; m++) {
	          var c = e.__digit(m),
	              v = (h | c << b) & o;r[d--] = l.__kConversionChars[v];var f = g - b;for (h = c >>> f, b = 32 - f; b >= g;) {
	            r[d--] = l.__kConversionChars[h & o], h >>>= g, b -= g;
	          }
	        }var y = (h | a << b) & o;for (r[d--] = l.__kConversionChars[y], h = a >>> g - b; 0 !== h;) {
	          r[d--] = l.__kConversionChars[h & o], h >>>= g;
	        }if (e.sign && (r[d--] = "-"), -1 !== d) throw new Error("implementation bug");return r.join("");
	      } }, { key: "__toStringGeneric", value: function value(e, t, _) {
	        var n = e.length;if (0 === n) return "";if (1 === n) {
	          var g = e.__unsignedDigit(0).toString(t);return !1 === _ && e.sign && (g = "-" + g), g;
	        }var o = 32 * n - l.__clz32(e.__digit(n - 1)),
	            a = l.__kMaxBitsPerChar[t],
	            s = a - 1,
	            u = o * l.__kBitsPerCharTableMultiplier;u += s - 1, u = 0 | u / s;var r,
	            d,
	            h = u + 1 >> 1,
	            b = l.exponentiate(l.__oneDigit(t, !1), l.__oneDigit(h, !1)),
	            m = b.__unsignedDigit(0);if (1 === b.length && 65535 >= m) {
	          r = new l(e.length, !1), r.__initializeDigits();for (var c, v = 0, f = 2 * e.length - 1; 0 <= f; f--) {
	            c = v << 16 | e.__halfDigit(f), r.__setHalfDigit(f, 0 | c / m), v = 0 | c % m;
	          }d = v.toString(t);
	        } else {
	          var y = l.__absoluteDivLarge(e, b, !0, !0);r = y.quotient;var k = y.remainder.__trim();d = l.__toStringGeneric(k, t, !0);
	        }r.__trim();for (var D = l.__toStringGeneric(r, t, !0); d.length < h;) {
	          d = "0" + d;
	        }return !1 === _ && e.sign && (D = "-" + D), D + d;
	      } }, { key: "__unequalSign", value: function value(e) {
	        return e ? -1 : 1;
	      } }, { key: "__absoluteGreater", value: function value(e) {
	        return e ? -1 : 1;
	      } }, { key: "__absoluteLess", value: function value(e) {
	        return e ? 1 : -1;
	      } }, { key: "__compareToBigInt", value: function value(e, t) {
	        var i = e.sign;if (i !== t.sign) return l.__unequalSign(i);var _ = l.__absoluteCompare(e, t);return 0 < _ ? l.__absoluteGreater(i) : 0 > _ ? l.__absoluteLess(i) : 0;
	      } }, { key: "__compareToNumber", value: function value(e, t) {
	        if (!0 | t) {
	          var i = e.sign,
	              _ = 0 > t;if (i !== _) return l.__unequalSign(i);if (0 === e.length) {
	            if (_) throw new Error("implementation bug");return 0 === t ? 0 : -1;
	          }if (1 < e.length) return l.__absoluteGreater(i);var n = g(t),
	              o = e.__unsignedDigit(0);return o > n ? l.__absoluteGreater(i) : o < n ? l.__absoluteLess(i) : 0;
	        }return l.__compareToDouble(e, t);
	      } }, { key: "__compareToDouble", value: function value(e, t) {
	        if (t !== t) return t;if (t === 1 / 0) return -1;if (t === -Infinity) return 1;var i = e.sign;if (i !== 0 > t) return l.__unequalSign(i);if (0 === t) throw new Error("implementation bug: should be handled elsewhere");if (0 === e.length) return -1;l.__kBitConversionDouble[0] = t;var _ = 2047 & l.__kBitConversionInts[1] >>> 20;if (2047 == _) throw new Error("implementation bug: handled elsewhere");var n = _ - 1023;if (0 > n) return l.__absoluteGreater(i);var g = e.length,
	            o = e.__digit(g - 1),
	            a = l.__clz32(o),
	            s = 32 * g - a,
	            u = n + 1;if (s < u) return l.__absoluteLess(i);if (s > u) return l.__absoluteGreater(i);var r = 1048576 | 1048575 & l.__kBitConversionInts[1],
	            d = l.__kBitConversionInts[0],
	            h = 20,
	            b = 31 - a;if (b !== (s - 1) % 31) throw new Error("implementation bug");var m,
	            c = 0;if (b < h) {
	          var v = h - b;c = v + 32, m = r >>> v, r = r << 32 - v | d >>> v, d <<= 32 - v;
	        } else if (b === h) c = 32, m = r, r = d;else {
	          var f = b - h;c = 32 - f, m = r << f | d >>> 32 - f, r = d << f;
	        }if (o >>>= 0, m >>>= 0, o > m) return l.__absoluteGreater(i);if (o < m) return l.__absoluteLess(i);for (var y = g - 2; 0 <= y; y--) {
	          0 < c ? (c -= 32, m = r >>> 0, r = d, d = 0) : m = 0;var k = e.__unsignedDigit(y);if (k > m) return l.__absoluteGreater(i);if (k < m) return l.__absoluteLess(i);
	        }if (0 !== r || 0 !== d) {
	          if (0 === c) throw new Error("implementation bug");return l.__absoluteLess(i);
	        }return 0;
	      } }, { key: "__equalToNumber", value: function value(e, t) {
	        return t | 0 === t ? 0 === t ? 0 === e.length : 1 === e.length && e.sign === 0 > t && e.__unsignedDigit(0) === g(t) : 0 === l.__compareToDouble(e, t);
	      } }, { key: "__comparisonResultToBool", value: function value(e, t) {
	        switch (t) {case 0:
	            return 0 > e;case 1:
	            return 0 >= e;case 2:
	            return 0 < e;case 3:
	            return 0 <= e;}throw new Error("unreachable");
	      } }, { key: "__compare", value: function value(e, t, i) {
	        if (e = l.__toPrimitive(e), t = l.__toPrimitive(t), "string" == typeof e && "string" == typeof t) switch (i) {case 0:
	            return e < t;case 1:
	            return e <= t;case 2:
	            return e > t;case 3:
	            return e >= t;}if (l.__isBigInt(e) && "string" == typeof t) return t = l.__fromString(t), null !== t && l.__comparisonResultToBool(l.__compareToBigInt(e, t), i);if ("string" == typeof e && l.__isBigInt(t)) return e = l.__fromString(e), null !== e && l.__comparisonResultToBool(l.__compareToBigInt(e, t), i);if (e = l.__toNumeric(e), t = l.__toNumeric(t), l.__isBigInt(e)) {
	          if (l.__isBigInt(t)) return l.__comparisonResultToBool(l.__compareToBigInt(e, t), i);if ("number" != typeof t) throw new Error("implementation bug");return l.__comparisonResultToBool(l.__compareToNumber(e, t), i);
	        }if ("number" != typeof e) throw new Error("implementation bug");if (l.__isBigInt(t)) return l.__comparisonResultToBool(l.__compareToNumber(t, e), 2 ^ i);if ("number" != typeof t) throw new Error("implementation bug");return 0 === i ? e < t : 1 === i ? e <= t : 2 === i ? e > t : 3 === i ? e >= t : void 0;
	      } }, { key: "__absoluteAdd", value: function value(e, t, _) {
	        if (e.length < t.length) return l.__absoluteAdd(t, e, _);if (0 === e.length) return e;if (0 === t.length) return e.sign === _ ? e : l.unaryMinus(e);var n = e.length;(0 === e.__clzmsd() || t.length === e.length && 0 === t.__clzmsd()) && n++;for (var g = new l(n, _), o = 0, a = 0; a < t.length; a++) {
	          var s = t.__digit(a),
	              u = e.__digit(a),
	              r = (65535 & u) + (65535 & s) + o,
	              d = (u >>> 16) + (s >>> 16) + (r >>> 16);o = d >>> 16, g.__setDigit(a, 65535 & r | d << 16);
	        }for (; a < e.length; a++) {
	          var h = e.__digit(a),
	              b = (65535 & h) + o,
	              m = (h >>> 16) + (b >>> 16);o = m >>> 16, g.__setDigit(a, 65535 & b | m << 16);
	        }return a < g.length && g.__setDigit(a, o), g.__trim();
	      } }, { key: "__absoluteSub", value: function value(e, t, _) {
	        if (0 === e.length) return e;if (0 === t.length) return e.sign === _ ? e : l.unaryMinus(e);for (var n = new l(e.length, _), g = 0, o = 0; o < t.length; o++) {
	          var a = e.__digit(o),
	              s = t.__digit(o),
	              u = (65535 & a) - (65535 & s) - g;g = 1 & u >>> 16;var r = (a >>> 16) - (s >>> 16) - g;g = 1 & r >>> 16, n.__setDigit(o, 65535 & u | r << 16);
	        }for (; o < e.length; o++) {
	          var d = e.__digit(o),
	              h = (65535 & d) - g;g = 1 & h >>> 16;var b = (d >>> 16) - g;g = 1 & b >>> 16, n.__setDigit(o, 65535 & h | b << 16);
	        }return n.__trim();
	      } }, { key: "__absoluteAddOne", value: function value(e, t) {
	        var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null,
	            n = e.length;null === _ ? _ = new l(n, t) : _.sign = t;for (var g, o = !0, a = 0; a < n; a++) {
	          if (g = e.__digit(a), o) {
	            var s = -1 === g;g = 0 | g + 1, o = s;
	          }_.__setDigit(a, g);
	        }return o && _.__setDigitGrow(n, 1), _;
	      } }, { key: "__absoluteSubOne", value: function value(e, t) {
	        var _ = e.length;t = t || _;for (var n, g = new l(t, !1), o = !0, a = 0; a < _; a++) {
	          if (n = e.__digit(a), o) {
	            var s = 0 === n;n = 0 | n - 1, o = s;
	          }g.__setDigit(a, n);
	        }if (o) throw new Error("implementation bug");for (var u = _; u < t; u++) {
	          g.__setDigit(u, 0);
	        }return g;
	      } }, { key: "__absoluteAnd", value: function value(e, t) {
	        var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null,
	            n = e.length,
	            g = t.length,
	            o = g;if (n < g) {
	          o = n;var a = e,
	              s = n;e = t, n = g, t = a, g = s;
	        }var u = o;null === _ ? _ = new l(u, !1) : u = _.length;for (var r = 0; r < o; r++) {
	          _.__setDigit(r, e.__digit(r) & t.__digit(r));
	        }for (; r < u; r++) {
	          _.__setDigit(r, 0);
	        }return _;
	      } }, { key: "__absoluteAndNot", value: function value(e, t) {
	        var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null,
	            n = e.length,
	            g = t.length,
	            o = g;n < g && (o = n);var a = n;null === _ ? _ = new l(a, !1) : a = _.length;for (var s = 0; s < o; s++) {
	          _.__setDigit(s, e.__digit(s) & ~t.__digit(s));
	        }for (; s < n; s++) {
	          _.__setDigit(s, e.__digit(s));
	        }for (; s < a; s++) {
	          _.__setDigit(s, 0);
	        }return _;
	      } }, { key: "__absoluteOr", value: function value(e, t) {
	        var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null,
	            n = e.length,
	            g = t.length,
	            o = g;if (n < g) {
	          o = n;var a = e,
	              s = n;e = t, n = g, t = a, g = s;
	        }var u = n;null === _ ? _ = new l(u, !1) : u = _.length;for (var r = 0; r < o; r++) {
	          _.__setDigit(r, e.__digit(r) | t.__digit(r));
	        }for (; r < n; r++) {
	          _.__setDigit(r, e.__digit(r));
	        }for (; r < u; r++) {
	          _.__setDigit(r, 0);
	        }return _;
	      } }, { key: "__absoluteXor", value: function value(e, t) {
	        var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null,
	            n = e.length,
	            g = t.length,
	            o = g;if (n < g) {
	          o = n;var a = e,
	              s = n;e = t, n = g, t = a, g = s;
	        }var u = n;null === _ ? _ = new l(u, !1) : u = _.length;for (var r = 0; r < o; r++) {
	          _.__setDigit(r, e.__digit(r) ^ t.__digit(r));
	        }for (; r < n; r++) {
	          _.__setDigit(r, e.__digit(r));
	        }for (; r < u; r++) {
	          _.__setDigit(r, 0);
	        }return _;
	      } }, { key: "__absoluteCompare", value: function value(e, t) {
	        var _ = e.length - t.length;if (0 != _) return _;for (var n = e.length - 1; 0 <= n && e.__digit(n) === t.__digit(n);) {
	          n--;
	        }return 0 > n ? 0 : e.__unsignedDigit(n) > t.__unsignedDigit(n) ? 1 : -1;
	      } }, { key: "__multiplyAccumulate", value: function value(e, t, _, n) {
	        if (0 !== t) {
	          for (var g = 65535 & t, o = t >>> 16, a = 0, s = 0, u = 0, r = 0; r < e.length; r++, n++) {
	            var d = _.__digit(n),
	                h = 65535 & d,
	                b = d >>> 16,
	                m = e.__digit(r),
	                c = 65535 & m,
	                v = m >>> 16,
	                f = l.__imul(c, g),
	                y = l.__imul(c, o),
	                k = l.__imul(v, g),
	                D = l.__imul(v, o);h += s + (65535 & f), b += u + a + (h >>> 16) + (f >>> 16) + (65535 & y) + (65535 & k), a = b >>> 16, s = (y >>> 16) + (k >>> 16) + (65535 & D) + a, a = s >>> 16, s &= 65535, u = D >>> 16, d = 65535 & h | b << 16, _.__setDigit(n, d);
	          }for (; 0 !== a || 0 !== s || 0 !== u; n++) {
	            var p = _.__digit(n),
	                B = (65535 & p) + s,
	                S = (p >>> 16) + (B >>> 16) + u + a;s = 0, u = 0, a = S >>> 16, p = 65535 & B | S << 16, _.__setDigit(n, p);
	          }
	        }
	      } }, { key: "__internalMultiplyAdd", value: function value(e, t, _, g, o) {
	        for (var a = _, s = 0, u = 0; u < g; u++) {
	          var r = e.__digit(u),
	              d = l.__imul(65535 & r, t),
	              h = (65535 & d) + s + a;a = h >>> 16;var b = l.__imul(r >>> 16, t),
	              m = (65535 & b) + (d >>> 16) + a;a = m >>> 16, s = b >>> 16, o.__setDigit(u, m << 16 | 65535 & h);
	        }if (o.length > g) for (o.__setDigit(g++, a + s); g < o.length;) {
	          o.__setDigit(g++, 0);
	        } else if (0 !== a + s) throw new Error("implementation bug");
	      } }, { key: "__absoluteDivSmall", value: function value(e, t, _) {
	        null === _ && (_ = new l(e.length, !1));for (var n = 0, g = 2 * e.length - 1; 0 <= g; g -= 2) {
	          var o = (n << 16 | e.__halfDigit(g)) >>> 0,
	              a = 0 | o / t;n = 0 | o % t, o = (n << 16 | e.__halfDigit(g - 1)) >>> 0;var s = 0 | o / t;n = 0 | o % t, _.__setDigit(g >>> 1, a << 16 | s);
	        }return _;
	      } }, { key: "__absoluteModSmall", value: function value(e, t) {
	        for (var _, n = 0, l = 2 * e.length - 1; 0 <= l; l--) {
	          _ = (n << 16 | e.__halfDigit(l)) >>> 0, n = 0 | _ % t;
	        }return n;
	      } }, { key: "__absoluteDivLarge", value: function value(e, t, i, _) {
	        var g = t.__halfDigitLength(),
	            n = t.length,
	            o = e.__halfDigitLength() - g,
	            a = null;i && (a = new l(o + 2 >>> 1, !1), a.__initializeDigits());var s = new l(g + 2 >>> 1, !1);s.__initializeDigits();var r = l.__clz16(t.__halfDigit(g - 1));0 < r && (t = l.__specialLeftShift(t, r, 0));for (var d = l.__specialLeftShift(e, r, 1), u = t.__halfDigit(g - 1), h = 0, b = o; 0 <= b; b--) {
	          var m = 65535,
	              v = d.__halfDigit(b + g);if (v !== u) {
	            var f = (v << 16 | d.__halfDigit(b + g - 1)) >>> 0;m = 0 | f / u;for (var y = 0 | f % u, k = t.__halfDigit(g - 2), D = d.__halfDigit(b + g - 2); l.__imul(m, k) >>> 0 > (y << 16 | D) >>> 0 && (m--, y += u, !(65535 < y));) {}
	          }l.__internalMultiplyAdd(t, m, 0, n, s);var p = d.__inplaceSub(s, b, g + 1);0 !== p && (p = d.__inplaceAdd(t, b, g), d.__setHalfDigit(b + g, d.__halfDigit(b + g) + p), m--), i && (1 & b ? h = m << 16 : a.__setDigit(b >>> 1, h | m));
	        }return _ ? (d.__inplaceRightShift(r), i ? { quotient: a, remainder: d } : d) : i ? a : void 0;
	      } }, { key: "__clz16", value: function value(e) {
	        return l.__clz32(e) - 16;
	      } }, { key: "__specialLeftShift", value: function value(e, t, _) {
	        var g = e.length,
	            n = new l(g + _, !1);if (0 === t) {
	          for (var o = 0; o < g; o++) {
	            n.__setDigit(o, e.__digit(o));
	          }return 0 < _ && n.__setDigit(g, 0), n;
	        }for (var a, s = 0, u = 0; u < g; u++) {
	          a = e.__digit(u), n.__setDigit(u, a << t | s), s = a >>> 32 - t;
	        }return 0 < _ && n.__setDigit(g, s), n;
	      } }, { key: "__leftShiftByAbsolute", value: function value(e, t) {
	        var _ = l.__toShiftAmount(t);if (0 > _) throw new RangeError("BigInt too big");var n = _ >>> 5,
	            g = 31 & _,
	            o = e.length,
	            a = 0 !== g && 0 != e.__digit(o - 1) >>> 32 - g,
	            s = o + n + (a ? 1 : 0),
	            u = new l(s, e.sign);if (0 === g) {
	          for (var r = 0; r < n; r++) {
	            u.__setDigit(r, 0);
	          }for (; r < s; r++) {
	            u.__setDigit(r, e.__digit(r - n));
	          }
	        } else {
	          for (var h = 0, b = 0; b < n; b++) {
	            u.__setDigit(b, 0);
	          }for (var m, c = 0; c < o; c++) {
	            m = e.__digit(c), u.__setDigit(c + n, m << g | h), h = m >>> 32 - g;
	          }if (a) u.__setDigit(o + n, h);else if (0 !== h) throw new Error("implementation bug");
	        }return u.__trim();
	      } }, { key: "__rightShiftByAbsolute", value: function value(e, t) {
	        var _ = e.length,
	            n = e.sign,
	            g = l.__toShiftAmount(t);if (0 > g) return l.__rightShiftByMaximum(n);var o = g >>> 5,
	            a = 31 & g,
	            s = _ - o;if (0 >= s) return l.__rightShiftByMaximum(n);var u = !1;if (n) {
	          if (0 != (e.__digit(o) & (1 << a) - 1)) u = !0;else for (var r = 0; r < o; r++) {
	            if (0 !== e.__digit(r)) {
	              u = !0;break;
	            }
	          }
	        }if (u && 0 === a) {
	          var h = e.__digit(_ - 1);0 == ~h && s++;
	        }var b = new l(s, n);if (0 === a) for (var m = o; m < _; m++) {
	          b.__setDigit(m - o, e.__digit(m));
	        } else {
	          for (var c, v = e.__digit(o) >>> a, f = _ - o - 1, y = 0; y < f; y++) {
	            c = e.__digit(y + o + 1), b.__setDigit(y, c << 32 - a | v), v = c >>> a;
	          }b.__setDigit(f, v);
	        }return u && (b = l.__absoluteAddOne(b, !0, b)), b.__trim();
	      } }, { key: "__rightShiftByMaximum", value: function value(e) {
	        return e ? l.__oneDigit(1, !0) : l.__zero();
	      } }, { key: "__toShiftAmount", value: function value(e) {
	        if (1 < e.length) return -1;var t = e.__unsignedDigit(0);return t > l.__kMaxLengthBits ? -1 : t;
	      } }, { key: "__toPrimitive", value: function value(t) {
	        var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "default";if ("object" !== e(t)) return t;if (t.constructor === l) return t;var _ = t[Symbol.toPrimitive];if (_) {
	          var n = _(i);if ("object" !== e(n)) return n;throw new TypeError("Cannot convert object to primitive value");
	        }var g = t.valueOf;if (g) {
	          var o = g.call(t);if ("object" !== e(o)) return o;
	        }var a = t.toString;if (a) {
	          var s = a.call(t);if ("object" !== e(s)) return s;
	        }throw new TypeError("Cannot convert object to primitive value");
	      } }, { key: "__toNumeric", value: function value(e) {
	        return l.__isBigInt(e) ? e : +e;
	      } }, { key: "__isBigInt", value: function value(t) {
	        return "object" === e(t) && t.constructor === l;
	      } }, { key: "__truncateToNBits", value: function value(e, t) {
	        for (var _ = e + 31 >>> 5, n = new l(_, t.sign), g = _ - 1, o = 0; o < g; o++) {
	          n.__setDigit(o, t.__digit(o));
	        }var a = t.__digit(g);if (0 != (31 & e)) {
	          var s = 32 - (31 & e);a = a << s >>> s;
	        }return n.__setDigit(g, a), n.__trim();
	      } }, { key: "__truncateAndSubFromPowerOfTwo", value: function value(e, t, _) {
	        for (var n = Math.min, g = e + 31 >>> 5, o = new l(g, _), a = 0, s = g - 1, u = 0, r = n(s, t.length); a < r; a++) {
	          var d = t.__digit(a),
	              h = 0 - (65535 & d) - u;u = 1 & h >>> 16;var b = 0 - (d >>> 16) - u;u = 1 & b >>> 16, o.__setDigit(a, 65535 & h | b << 16);
	        }for (; a < s; a++) {
	          o.__setDigit(a, 0 | -u);
	        }var m,
	            c = s < t.length ? t.__digit(s) : 0,
	            v = 31 & e;if (0 === v) {
	          var f = 0 - (65535 & c) - u;u = 1 & f >>> 16;var y = 0 - (c >>> 16) - u;m = 65535 & f | y << 16;
	        } else {
	          var k = 32 - v;c = c << k >>> k;var D = 1 << 32 - k,
	              p = (65535 & D) - (65535 & c) - u;u = 1 & p >>> 16;var B = (D >>> 16) - (c >>> 16) - u;m = 65535 & p | B << 16, m &= D - 1;
	        }return o.__setDigit(s, m), o.__trim();
	      } }, { key: "__digitPow", value: function value(e, t) {
	        for (var i = 1; 0 < t;) {
	          1 & t && (i *= e), t >>>= 1, e *= e;
	        }return i;
	      } }]), l;
	  }(u(Array));return y.__kMaxLength = 33554432, y.__kMaxLengthBits = y.__kMaxLength << 5, y.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], y.__kBitsPerCharTableShift = 5, y.__kBitsPerCharTableMultiplier = 1 << y.__kBitsPerCharTableShift, y.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], y.__kBitConversionBuffer = new ArrayBuffer(8), y.__kBitConversionDouble = new Float64Array(y.__kBitConversionBuffer), y.__kBitConversionInts = new Int32Array(y.__kBitConversionBuffer), y.__clz32 = f || function (e) {
	    var t = Math.LN2,
	        i = Math.log;return 0 === e ? 32 : 0 | 31 - (0 | i(e >>> 0) / t);
	  }, y.__imul = v || function (e, t) {
	    return 0 | e * t;
	  }, y;
	});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @file JSONRPC 2.0 request authentication with steem authorities.
	 * @author Johan Nordberg <johan@steemit.com>
	 */
	
	var __extends = undefined && undefined.__extends || function () {
	    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
	        d.__proto__ = b;
	    } || function (d, b) {
	        for (var p in b) {
	            if (b.hasOwnProperty(p)) d[p] = b[p];
	        }
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() {
	            this.constructor = d;
	        }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	}();
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = undefined && undefined.__generator || function (thisArg, body) {
	    var _ = { label: 0, sent: function sent() {
	            if (t[0] & 1) throw t[1];return t[1];
	        }, trys: [], ops: [] },
	        f,
	        y,
	        t,
	        g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
	        return this;
	    }), g;
	    function verb(n) {
	        return function (v) {
	            return step([n, v]);
	        };
	    }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) {
	            try {
	                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [0, t.value];
	                switch (op[0]) {
	                    case 0:case 1:
	                        t = op;break;
	                    case 4:
	                        _.label++;return { value: op[1], done: false };
	                    case 5:
	                        _.label++;y = op[1];op = [0];continue;
	                    case 7:
	                        op = _.ops.pop();_.trys.pop();continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
	                            _ = 0;continue;
	                        }
	                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
	                            _.label = op[1];break;
	                        }
	                        if (op[0] === 6 && _.label < t[1]) {
	                            _.label = t[1];t = op;break;
	                        }
	                        if (t && _.label < t[2]) {
	                            _.label = t[2];_.ops.push(op);break;
	                        }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop();continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) {
	                op = [6, e];y = 0;
	            } finally {
	                f = t = 0;
	            }
	        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var libcrypto_1 = __webpack_require__(208);
	var crypto_1 = __webpack_require__(209);
	/**
	 * Signing constant used to reserve opcode space and prevent cross-protocol attacks.
	 * Output of `sha256('steem_jsonrpc_auth')`.
	 */
	exports.K = Buffer.from('3b3b081e46ea808d5a96b08c4bc5003f5e15767090f344faab531ec57565136b', 'hex');
	/**
	 * Thrown when a request fails validation.
	 */
	var ValidationError = /** @class */function (_super) {
	    __extends(ValidationError, _super);
	    function ValidationError(message, cause) {
	        var _this = _super.call(this, message) || this;
	        _this.name = 'ValidationError';
	        if (cause) {
	            _this.cause = cause;
	            _this.message += " (" + cause.message + ")";
	        }
	        return _this;
	    }
	    return ValidationError;
	}(Error);
	/**
	 * Create request hash to be signed.
	 *
	 * @param timestamp  ISO8601 formatted date e.g. `2017-11-14T19:40:29.077Z`.
	 * @param account    Steem account name that is the signer.
	 * @param method     RPC request method.
	 * @param params     Base64 encoded JSON string containing request params.
	 * @param nonce      8 bytes of random data.
	 *
	 * @returns bytes to be signed or validated.
	 */
	function hashMessage(timestamp, account, method, params, nonce) {
	    var first = crypto_1.createHash('sha256');
	    first.update(timestamp);
	    first.update(account);
	    first.update(method);
	    first.update(params);
	    var second = crypto_1.createHash('sha256');
	    second.update(exports.K);
	    second.update(first.digest());
	    second.update(nonce);
	    return second.digest();
	}
	/**
	 * Sign a JSON RPC Request.
	 */
	function sign(request, account, keys) {
	    if (!request.params) {
	        throw new Error('Unable to sign a request without params');
	    }
	    var params = Buffer.from(JSON.stringify(request.params), 'utf8').toString('base64');
	    var nonceBytes = crypto_1.randomBytes(8);
	    var nonce = nonceBytes.toString('hex');
	    var timestamp = new Date().toISOString();
	    var message = hashMessage(timestamp, account, request.method, params, nonceBytes);
	    var signatures = [];
	    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
	        var key = keys_1[_i];
	        if (typeof key === 'string') {
	            key = libcrypto_1.PrivateKey.from(key);
	        }
	        var signature = libcrypto_1.hexify(key.sign(message.buffer));
	        signatures.push(signature);
	    }
	    return {
	        jsonrpc: '2.0',
	        method: request.method,
	        id: request.id,
	        params: {
	            __signed: {
	                account: account,
	                nonce: nonce,
	                params: params,
	                signatures: signatures,
	                timestamp: timestamp
	            }
	        }
	    };
	}
	exports.sign = sign;
	/**
	 * Validate a signed JSON RPC request.
	 * Throws a {@link ValidationError} if the request fails validation.
	 *
	 * @returns Resolved request params.
	 */
	function validate(request, verify) {
	    return __awaiter(this, void 0, void 0, function () {
	        var signed, params, jsonString, nonce, timestamp, message, cause_1;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (request.jsonrpc !== '2.0' || typeof request.method !== 'string') {
	                        throw new ValidationError('Invalid JSON RPC Request');
	                    }
	                    if (request.params == undefined || request.params.__signed == undefined) {
	                        throw new ValidationError('Signed payload missing');
	                    }
	                    if (Object.keys(request.params).length !== 1) {
	                        throw new ValidationError('Invalid request params');
	                    }
	                    signed = request.params.__signed;
	                    if (signed.account == undefined) {
	                        throw new ValidationError('Missing account');
	                    }
	                    try {
	                        jsonString = Buffer.from(signed.params, 'base64').toString('utf8');
	                        params = JSON.parse(jsonString);
	                    } catch (cause) {
	                        throw new ValidationError('Invalid encoded params', cause);
	                    }
	                    if (signed.nonce == undefined || typeof signed.nonce !== 'string') {
	                        throw new ValidationError('Invalid nonce');
	                    }
	                    nonce = Buffer.from(signed.nonce, 'hex');
	                    if (nonce.length !== 8) {
	                        throw new ValidationError('Invalid nonce');
	                    }
	                    timestamp = Date.parse(signed.timestamp);
	                    if (Number.isNaN(timestamp)) {
	                        throw new ValidationError('Invalid timestamp');
	                    }
	                    if (Date.now() - timestamp > 60 * 1000) {
	                        throw new ValidationError('Signature expired');
	                    }
	                    message = hashMessage(signed.timestamp, signed.account, request.method, signed.params, nonce);
	                    _a.label = 1;
	                case 1:
	                    _a.trys.push([1, 3,, 4]);
	                    return [4 /*yield*/, verify(message, signed.signatures, signed.account)];
	                case 2:
	                    _a.sent();
	                    return [3 /*break*/, 4];
	                case 3:
	                    cause_1 = _a.sent();
	                    throw new ValidationError('Verification failed', cause_1);
	                case 4:
	                    return [2 /*return*/, params];
	            }
	        });
	    });
	}
	exports.validate = validate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* global self */
	(function (root, factory) {
	  if (( false ? 'undefined' : _typeof(exports)) === 'object' && typeof exports.nodeName !== 'string') {
	    // CommonJS
	    factory(exports);
	  } else {
	    // Browser globals
	    root.steemit = root.steemit || {};
	    factory(root.steemit.crypto = {});
	  }
	})(typeof self !== 'undefined' ? self : undefined, function (exports) {
	  exports.PrivateKey = PrivateKey;
	  exports.PublicKey = PublicKey;
	  exports.generateKeys = generateKeys;
	  exports.keysFromPassword = keysFromPassword;
	  exports.sha256 = sha256;
	  exports.ripemd160 = ripemd160;
	  exports.hexify = hexify;
	
	  var sjcl = function () {
	    // SJCL is inserted here automatically by the build process.
	    /** @fileOverview Javascript cryptography implementation.
	    *
	    * Crush to remove comments, shorten variable names and
	    * generally reduce transmission size.
	    *
	    * @author Emily Stark
	    * @author Mike Hamburg
	    * @author Dan Boneh
	    */
	
	    "use strict";
	    /*jslint indent: 2, bitwise: false, nomen: false, plusplus: false, white: false, regexp: false */
	    /*global document, window, escape, unescape, module, require, Uint32Array */
	
	    /**
	     * The Stanford Javascript Crypto Library, top-level namespace.
	     * @namespace
	     */
	
	    var sjcl = {
	      /**
	       * Symmetric ciphers.
	       * @namespace
	       */
	      cipher: {},
	
	      /**
	       * Hash functions.  Right now only SHA256 is implemented.
	       * @namespace
	       */
	      hash: {},
	
	      /**
	       * Key exchange functions.  Right now only SRP is implemented.
	       * @namespace
	       */
	      keyexchange: {},
	
	      /**
	       * Cipher modes of operation.
	       * @namespace
	       */
	      mode: {},
	
	      /**
	       * Miscellaneous.  HMAC and PBKDF2.
	       * @namespace
	       */
	      misc: {},
	
	      /**
	       * Bit array encoders and decoders.
	       * @namespace
	       *
	       * @description
	       * The members of this namespace are functions which translate between
	       * SJCL's bitArrays and other objects (usually strings).  Because it
	       * isn't always clear which direction is encoding and which is decoding,
	       * the method names are "fromBits" and "toBits".
	       */
	      codec: {},
	
	      /**
	       * Exceptions.
	       * @namespace
	       */
	      exception: {
	        /**
	         * Ciphertext is corrupt.
	         * @constructor
	         */
	        corrupt: function corrupt(message) {
	          this.toString = function () {
	            return "CORRUPT: " + this.message;
	          };
	          this.message = message;
	        },
	
	        /**
	         * Invalid parameter.
	         * @constructor
	         */
	        invalid: function invalid(message) {
	          this.toString = function () {
	            return "INVALID: " + this.message;
	          };
	          this.message = message;
	        },
	
	        /**
	         * Bug or missing feature in SJCL.
	         * @constructor
	         */
	        bug: function bug(message) {
	          this.toString = function () {
	            return "BUG: " + this.message;
	          };
	          this.message = message;
	        },
	
	        /**
	         * Something isn't ready.
	         * @constructor
	         */
	        notReady: function notReady(message) {
	          this.toString = function () {
	            return "NOT READY: " + this.message;
	          };
	          this.message = message;
	        }
	      }
	    };
	    /** @fileOverview Arrays of bits, encoded as arrays of Numbers.
	     *
	     * @author Emily Stark
	     * @author Mike Hamburg
	     * @author Dan Boneh
	     */
	
	    /**
	     * Arrays of bits, encoded as arrays of Numbers.
	     * @namespace
	     * @description
	     * <p>
	     * These objects are the currency accepted by SJCL's crypto functions.
	     * </p>
	     *
	     * <p>
	     * Most of our crypto primitives operate on arrays of 4-byte words internally,
	     * but many of them can take arguments that are not a multiple of 4 bytes.
	     * This library encodes arrays of bits (whose size need not be a multiple of 8
	     * bits) as arrays of 32-bit words.  The bits are packed, big-endian, into an
	     * array of words, 32 bits at a time.  Since the words are double-precision
	     * floating point numbers, they fit some extra data.  We use this (in a private,
	     * possibly-changing manner) to encode the number of bits actually  present
	     * in the last word of the array.
	     * </p>
	     *
	     * <p>
	     * Because bitwise ops clear this out-of-band data, these arrays can be passed
	     * to ciphers like AES which want arrays of words.
	     * </p>
	     */
	    sjcl.bitArray = {
	      /**
	       * Array slices in units of bits.
	       * @param {bitArray} a The array to slice.
	       * @param {Number} bstart The offset to the start of the slice, in bits.
	       * @param {Number} bend The offset to the end of the slice, in bits.  If this is undefined,
	       * slice until the end of the array.
	       * @return {bitArray} The requested slice.
	       */
	      bitSlice: function bitSlice(a, bstart, bend) {
	        a = sjcl.bitArray._shiftRight(a.slice(bstart / 32), 32 - (bstart & 31)).slice(1);
	        return bend === undefined ? a : sjcl.bitArray.clamp(a, bend - bstart);
	      },
	
	      /**
	       * Extract a number packed into a bit array.
	       * @param {bitArray} a The array to slice.
	       * @param {Number} bstart The offset to the start of the slice, in bits.
	       * @param {Number} blength The length of the number to extract.
	       * @return {Number} The requested slice.
	       */
	      extract: function extract(a, bstart, blength) {
	        // FIXME: this Math.floor is not necessary at all, but for some reason
	        // seems to suppress a bug in the Chromium JIT.
	        var x,
	            sh = Math.floor(-bstart - blength & 31);
	        if ((bstart + blength - 1 ^ bstart) & -32) {
	          // it crosses a boundary
	          x = a[bstart / 32 | 0] << 32 - sh ^ a[bstart / 32 + 1 | 0] >>> sh;
	        } else {
	          // within a single word
	          x = a[bstart / 32 | 0] >>> sh;
	        }
	        return x & (1 << blength) - 1;
	      },
	
	      /**
	       * Concatenate two bit arrays.
	       * @param {bitArray} a1 The first array.
	       * @param {bitArray} a2 The second array.
	       * @return {bitArray} The concatenation of a1 and a2.
	       */
	      concat: function concat(a1, a2) {
	        if (a1.length === 0 || a2.length === 0) {
	          return a1.concat(a2);
	        }
	
	        var last = a1[a1.length - 1],
	            shift = sjcl.bitArray.getPartial(last);
	        if (shift === 32) {
	          return a1.concat(a2);
	        } else {
	          return sjcl.bitArray._shiftRight(a2, shift, last | 0, a1.slice(0, a1.length - 1));
	        }
	      },
	
	      /**
	       * Find the length of an array of bits.
	       * @param {bitArray} a The array.
	       * @return {Number} The length of a, in bits.
	       */
	      bitLength: function bitLength(a) {
	        var l = a.length,
	            x;
	        if (l === 0) {
	          return 0;
	        }
	        x = a[l - 1];
	        return (l - 1) * 32 + sjcl.bitArray.getPartial(x);
	      },
	
	      /**
	       * Truncate an array.
	       * @param {bitArray} a The array.
	       * @param {Number} len The length to truncate to, in bits.
	       * @return {bitArray} A new array, truncated to len bits.
	       */
	      clamp: function clamp(a, len) {
	        if (a.length * 32 < len) {
	          return a;
	        }
	        a = a.slice(0, Math.ceil(len / 32));
	        var l = a.length;
	        len = len & 31;
	        if (l > 0 && len) {
	          a[l - 1] = sjcl.bitArray.partial(len, a[l - 1] & 0x80000000 >> len - 1, 1);
	        }
	        return a;
	      },
	
	      /**
	       * Make a partial word for a bit array.
	       * @param {Number} len The number of bits in the word.
	       * @param {Number} x The bits.
	       * @param {Number} [_end=0] Pass 1 if x has already been shifted to the high side.
	       * @return {Number} The partial word.
	       */
	      partial: function partial(len, x, _end) {
	        if (len === 32) {
	          return x;
	        }
	        return (_end ? x | 0 : x << 32 - len) + len * 0x10000000000;
	      },
	
	      /**
	       * Get the number of bits used by a partial word.
	       * @param {Number} x The partial word.
	       * @return {Number} The number of bits used by the partial word.
	       */
	      getPartial: function getPartial(x) {
	        return Math.round(x / 0x10000000000) || 32;
	      },
	
	      /**
	       * Compare two arrays for equality in a predictable amount of time.
	       * @param {bitArray} a The first array.
	       * @param {bitArray} b The second array.
	       * @return {boolean} true if a == b; false otherwise.
	       */
	      equal: function equal(a, b) {
	        if (sjcl.bitArray.bitLength(a) !== sjcl.bitArray.bitLength(b)) {
	          return false;
	        }
	        var x = 0,
	            i;
	        for (i = 0; i < a.length; i++) {
	          x |= a[i] ^ b[i];
	        }
	        return x === 0;
	      },
	
	      /** Shift an array right.
	       * @param {bitArray} a The array to shift.
	       * @param {Number} shift The number of bits to shift.
	       * @param {Number} [carry=0] A byte to carry in
	       * @param {bitArray} [out=[]] An array to prepend to the output.
	       * @private
	       */
	      _shiftRight: function _shiftRight(a, shift, carry, out) {
	        var i,
	            last2 = 0,
	            shift2;
	        if (out === undefined) {
	          out = [];
	        }
	
	        for (; shift >= 32; shift -= 32) {
	          out.push(carry);
	          carry = 0;
	        }
	        if (shift === 0) {
	          return out.concat(a);
	        }
	
	        for (i = 0; i < a.length; i++) {
	          out.push(carry | a[i] >>> shift);
	          carry = a[i] << 32 - shift;
	        }
	        last2 = a.length ? a[a.length - 1] : 0;
	        shift2 = sjcl.bitArray.getPartial(last2);
	        out.push(sjcl.bitArray.partial(shift + shift2 & 31, shift + shift2 > 32 ? carry : out.pop(), 1));
	        return out;
	      },
	
	      /** xor a block of 4 words together.
	       * @private
	       */
	      _xor4: function _xor4(x, y) {
	        return [x[0] ^ y[0], x[1] ^ y[1], x[2] ^ y[2], x[3] ^ y[3]];
	      },
	
	      /** byteswap a word array inplace.
	       * (does not handle partial words)
	       * @param {sjcl.bitArray} a word array
	       * @return {sjcl.bitArray} byteswapped array
	       */
	      byteswapM: function byteswapM(a) {
	        var i,
	            v,
	            m = 0xff00;
	        for (i = 0; i < a.length; ++i) {
	          v = a[i];
	          a[i] = v >>> 24 | v >>> 8 & m | (v & m) << 8 | v << 24;
	        }
	        return a;
	      }
	    };
	    /** @fileOverview Low-level AES implementation.
	     *
	     * This file contains a low-level implementation of AES, optimized for
	     * size and for efficiency on several browsers.  It is based on
	     * OpenSSL's aes_core.c, a public-domain implementation by Vincent
	     * Rijmen, Antoon Bosselaers and Paulo Barreto.
	     *
	     * An older version of this implementation is available in the public
	     * domain, but this one is (c) Emily Stark, Mike Hamburg, Dan Boneh,
	     * Stanford University 2008-2010 and BSD-licensed for liability
	     * reasons.
	     *
	     * @author Emily Stark
	     * @author Mike Hamburg
	     * @author Dan Boneh
	     */
	
	    /**
	     * Schedule out an AES key for both encryption and decryption.  This
	     * is a low-level class.  Use a cipher mode to do bulk encryption.
	     *
	     * @constructor
	     * @param {Array} key The key as an array of 4, 6 or 8 words.
	     */
	    sjcl.cipher.aes = function (key) {
	      if (!this._tables[0][0][0]) {
	        this._precompute();
	      }
	
	      var i,
	          j,
	          tmp,
	          encKey,
	          decKey,
	          sbox = this._tables[0][4],
	          decTable = this._tables[1],
	          keyLen = key.length,
	          rcon = 1;
	
	      if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	        throw new sjcl.exception.invalid("invalid aes key size");
	      }
	
	      this._key = [encKey = key.slice(0), decKey = []];
	
	      // schedule encryption keys
	      for (i = keyLen; i < 4 * keyLen + 28; i++) {
	        tmp = encKey[i - 1];
	
	        // apply sbox
	        if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	          tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];
	
	          // shift rows and add rcon
	          if (i % keyLen === 0) {
	            tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	            rcon = rcon << 1 ^ (rcon >> 7) * 283;
	          }
	        }
	
	        encKey[i] = encKey[i - keyLen] ^ tmp;
	      }
	
	      // schedule decryption keys
	      for (j = 0; i; j++, i--) {
	        tmp = encKey[j & 3 ? i : i - 4];
	        if (i <= 4 || j < 4) {
	          decKey[j] = tmp;
	        } else {
	          decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	        }
	      }
	    };
	
	    sjcl.cipher.aes.prototype = {
	      // public
	      /* Something like this might appear here eventually
	      name: "AES",
	      blockSize: 4,
	      keySizes: [4,6,8],
	      */
	
	      /**
	       * Encrypt an array of 4 big-endian words.
	       * @param {Array} data The plaintext.
	       * @return {Array} The ciphertext.
	       */
	      encrypt: function encrypt(data) {
	        return this._crypt(data, 0);
	      },
	
	      /**
	       * Decrypt an array of 4 big-endian words.
	       * @param {Array} data The ciphertext.
	       * @return {Array} The plaintext.
	       */
	      decrypt: function decrypt(data) {
	        return this._crypt(data, 1);
	      },
	
	      /**
	       * The expanded S-box and inverse S-box tables.  These will be computed
	       * on the client so that we don't have to send them down the wire.
	       *
	       * There are two tables, _tables[0] is for encryption and
	       * _tables[1] is for decryption.
	       *
	       * The first 4 sub-tables are the expanded S-box with MixColumns.  The
	       * last (_tables[01][4]) is the S-box itself.
	       *
	       * @private
	       */
	      _tables: [[[], [], [], [], []], [[], [], [], [], []]],
	
	      /**
	       * Expand the S-box tables.
	       *
	       * @private
	       */
	      _precompute: function _precompute() {
	        var encTable = this._tables[0],
	            decTable = this._tables[1],
	            sbox = encTable[4],
	            sboxInv = decTable[4],
	            i,
	            x,
	            xInv,
	            d = [],
	            th = [],
	            x2,
	            x4,
	            x8,
	            s,
	            tEnc,
	            tDec;
	
	        // Compute double and third tables
	        for (i = 0; i < 256; i++) {
	          th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	        }
	
	        for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	          // Compute sbox
	          s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	          s = s >> 8 ^ s & 255 ^ 99;
	          sbox[x] = s;
	          sboxInv[s] = x;
	
	          // Compute MixColumns
	          x8 = d[x4 = d[x2 = d[x]]];
	          tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	          tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	          for (i = 0; i < 4; i++) {
	            encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	            decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	          }
	        }
	
	        // Compactify.  Considerable speedup on Firefox.
	        for (i = 0; i < 5; i++) {
	          encTable[i] = encTable[i].slice(0);
	          decTable[i] = decTable[i].slice(0);
	        }
	      },
	
	      /**
	       * Encryption and decryption core.
	       * @param {Array} input Four words to be encrypted or decrypted.
	       * @param dir The direction, 0 for encrypt and 1 for decrypt.
	       * @return {Array} The four encrypted or decrypted words.
	       * @private
	       */
	      _crypt: function _crypt(input, dir) {
	        if (input.length !== 4) {
	          throw new sjcl.exception.invalid("invalid aes block size");
	        }
	
	        var key = this._key[dir],
	
	        // state variables a,b,c,d are loaded with pre-whitened data
	        a = input[0] ^ key[0],
	            b = input[dir ? 3 : 1] ^ key[1],
	            c = input[2] ^ key[2],
	            d = input[dir ? 1 : 3] ^ key[3],
	            a2,
	            b2,
	            c2,
	            nInnerRounds = key.length / 4 - 2,
	            i,
	            kIndex = 4,
	            out = [0, 0, 0, 0],
	            table = this._tables[dir],
	
	
	        // load up the tables
	        t0 = table[0],
	            t1 = table[1],
	            t2 = table[2],
	            t3 = table[3],
	            sbox = table[4];
	
	        // Inner rounds.  Cribbed from OpenSSL.
	        for (i = 0; i < nInnerRounds; i++) {
	          a2 = t0[a >>> 24] ^ t1[b >> 16 & 255] ^ t2[c >> 8 & 255] ^ t3[d & 255] ^ key[kIndex];
	          b2 = t0[b >>> 24] ^ t1[c >> 16 & 255] ^ t2[d >> 8 & 255] ^ t3[a & 255] ^ key[kIndex + 1];
	          c2 = t0[c >>> 24] ^ t1[d >> 16 & 255] ^ t2[a >> 8 & 255] ^ t3[b & 255] ^ key[kIndex + 2];
	          d = t0[d >>> 24] ^ t1[a >> 16 & 255] ^ t2[b >> 8 & 255] ^ t3[c & 255] ^ key[kIndex + 3];
	          kIndex += 4;
	          a = a2;b = b2;c = c2;
	        }
	
	        // Last round.
	        for (i = 0; i < 4; i++) {
	          out[dir ? 3 & -i : i] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	          a2 = a;a = b;b = c;c = d;d = a2;
	        }
	
	        return out;
	      }
	    };
	
	    /**
	     * Constructs a new bignum from another bignum, a number or a hex string.
	     * @constructor
	     */
	    sjcl.bn = function (it) {
	      this.initWith(it);
	    };
	
	    sjcl.bn.prototype = {
	      radix: 24,
	      maxMul: 8,
	      _class: sjcl.bn,
	
	      copy: function copy() {
	        return new this._class(this);
	      },
	
	      /**
	       * Initializes this with it, either as a bn, a number, or a hex string.
	       */
	      initWith: function initWith(it) {
	        var i = 0,
	            k;
	        switch (typeof it === 'undefined' ? 'undefined' : _typeof(it)) {
	          case "object":
	            this.limbs = it.limbs.slice(0);
	            break;
	
	          case "number":
	            this.limbs = [it];
	            this.normalize();
	            break;
	
	          case "string":
	            it = it.replace(/^0x/, '');
	            this.limbs = [];
	            // hack
	            k = this.radix / 4;
	            for (i = 0; i < it.length; i += k) {
	              this.limbs.push(parseInt(it.substring(Math.max(it.length - i - k, 0), it.length - i), 16));
	            }
	            break;
	
	          default:
	            this.limbs = [0];
	        }
	        return this;
	      },
	
	      /**
	       * Returns true if "this" and "that" are equal.  Calls fullReduce().
	       * Equality test is in constant time.
	       */
	      equals: function equals(that) {
	        if (typeof that === "number") {
	          that = new this._class(that);
	        }
	        var difference = 0,
	            i;
	        this.fullReduce();
	        that.fullReduce();
	        for (i = 0; i < this.limbs.length || i < that.limbs.length; i++) {
	          difference |= this.getLimb(i) ^ that.getLimb(i);
	        }
	        return difference === 0;
	      },
	
	      /**
	       * Get the i'th limb of this, zero if i is too large.
	       */
	      getLimb: function getLimb(i) {
	        return i >= this.limbs.length ? 0 : this.limbs[i];
	      },
	
	      /**
	       * Constant time comparison function.
	       * Returns 1 if this >= that, or zero otherwise.
	       */
	      greaterEquals: function greaterEquals(that) {
	        if (typeof that === "number") {
	          that = new this._class(that);
	        }
	        var less = 0,
	            greater = 0,
	            i,
	            a,
	            b;
	        i = Math.max(this.limbs.length, that.limbs.length) - 1;
	        for (; i >= 0; i--) {
	          a = this.getLimb(i);
	          b = that.getLimb(i);
	          greater |= b - a & ~less;
	          less |= a - b & ~greater;
	        }
	        return (greater | ~less) >>> 31;
	      },
	
	      /**
	       * Convert to a hex string.
	       */
	      toString: function toString() {
	        this.fullReduce();
	        var out = "",
	            i,
	            s,
	            l = this.limbs;
	        for (i = 0; i < this.limbs.length; i++) {
	          s = l[i].toString(16);
	          while (i < this.limbs.length - 1 && s.length < 6) {
	            s = "0" + s;
	          }
	          out = s + out;
	        }
	        return "0x" + out;
	      },
	
	      /** this += that.  Does not normalize. */
	      addM: function addM(that) {
	        if ((typeof that === 'undefined' ? 'undefined' : _typeof(that)) !== "object") {
	          that = new this._class(that);
	        }
	        var i,
	            l = this.limbs,
	            ll = that.limbs;
	        for (i = l.length; i < ll.length; i++) {
	          l[i] = 0;
	        }
	        for (i = 0; i < ll.length; i++) {
	          l[i] += ll[i];
	        }
	        return this;
	      },
	
	      /** this *= 2.  Requires normalized; ends up normalized. */
	      doubleM: function doubleM() {
	        var i,
	            carry = 0,
	            tmp,
	            r = this.radix,
	            m = this.radixMask,
	            l = this.limbs;
	        for (i = 0; i < l.length; i++) {
	          tmp = l[i];
	          tmp = tmp + tmp + carry;
	          l[i] = tmp & m;
	          carry = tmp >> r;
	        }
	        if (carry) {
	          l.push(carry);
	        }
	        return this;
	      },
	
	      /** this /= 2, rounded down.  Requires normalized; ends up normalized. */
	      halveM: function halveM() {
	        var i,
	            carry = 0,
	            tmp,
	            r = this.radix,
	            l = this.limbs;
	        for (i = l.length - 1; i >= 0; i--) {
	          tmp = l[i];
	          l[i] = tmp + carry >> 1;
	          carry = (tmp & 1) << r;
	        }
	        if (!l[l.length - 1]) {
	          l.pop();
	        }
	        return this;
	      },
	
	      /** this -= that.  Does not normalize. */
	      subM: function subM(that) {
	        if ((typeof that === 'undefined' ? 'undefined' : _typeof(that)) !== "object") {
	          that = new this._class(that);
	        }
	        var i,
	            l = this.limbs,
	            ll = that.limbs;
	        for (i = l.length; i < ll.length; i++) {
	          l[i] = 0;
	        }
	        for (i = 0; i < ll.length; i++) {
	          l[i] -= ll[i];
	        }
	        return this;
	      },
	
	      mod: function mod(that) {
	        var neg = !this.greaterEquals(new sjcl.bn(0));
	
	        that = new sjcl.bn(that).normalize(); // copy before we begin
	        var out = new sjcl.bn(this).normalize(),
	            ci = 0;
	
	        if (neg) out = new sjcl.bn(0).subM(out).normalize();
	
	        for (; out.greaterEquals(that); ci++) {
	          that.doubleM();
	        }
	
	        if (neg) out = that.sub(out).normalize();
	
	        for (; ci > 0; ci--) {
	          that.halveM();
	          if (out.greaterEquals(that)) {
	            out.subM(that).normalize();
	          }
	        }
	        return out.trim();
	      },
	
	      /** return inverse mod prime p.  p must be odd. Binary extended Euclidean algorithm mod p. */
	      inverseMod: function inverseMod(p) {
	        var a = new sjcl.bn(1),
	            b = new sjcl.bn(0),
	            x = new sjcl.bn(this),
	            y = new sjcl.bn(p),
	            tmp,
	            i,
	            nz = 1;
	
	        if (!(p.limbs[0] & 1)) {
	          throw new sjcl.exception.invalid("inverseMod: p must be odd");
	        }
	
	        // invariant: y is odd
	        do {
	          if (x.limbs[0] & 1) {
	            if (!x.greaterEquals(y)) {
	              // x < y; swap everything
	              tmp = x;x = y;y = tmp;
	              tmp = a;a = b;b = tmp;
	            }
	            x.subM(y);
	            x.normalize();
	
	            if (!a.greaterEquals(b)) {
	              a.addM(p);
	            }
	            a.subM(b);
	          }
	
	          // cut everything in half
	          x.halveM();
	          if (a.limbs[0] & 1) {
	            a.addM(p);
	          }
	          a.normalize();
	          a.halveM();
	
	          // check for termination: x ?= 0
	          for (i = nz = 0; i < x.limbs.length; i++) {
	            nz |= x.limbs[i];
	          }
	        } while (nz);
	
	        if (!y.equals(1)) {
	          throw new sjcl.exception.invalid("inverseMod: p and x must be relatively prime");
	        }
	
	        return b;
	      },
	
	      /** this + that.  Does not normalize. */
	      add: function add(that) {
	        return this.copy().addM(that);
	      },
	
	      /** this - that.  Does not normalize. */
	      sub: function sub(that) {
	        return this.copy().subM(that);
	      },
	
	      /** this * that.  Normalizes and reduces. */
	      mul: function mul(that) {
	        if (typeof that === "number") {
	          that = new this._class(that);
	        }
	        var i,
	            j,
	            a = this.limbs,
	            b = that.limbs,
	            al = a.length,
	            bl = b.length,
	            out = new this._class(),
	            c = out.limbs,
	            ai,
	            ii = this.maxMul;
	
	        for (i = 0; i < this.limbs.length + that.limbs.length + 1; i++) {
	          c[i] = 0;
	        }
	        for (i = 0; i < al; i++) {
	          ai = a[i];
	          for (j = 0; j < bl; j++) {
	            c[i + j] += ai * b[j];
	          }
	
	          if (! --ii) {
	            ii = this.maxMul;
	            out.cnormalize();
	          }
	        }
	        return out.cnormalize().reduce();
	      },
	
	      /** this ^ 2.  Normalizes and reduces. */
	      square: function square() {
	        return this.mul(this);
	      },
	
	      /** this ^ n.  Uses square-and-multiply.  Normalizes and reduces. */
	      power: function power(l) {
	        l = new sjcl.bn(l).normalize().trim().limbs;
	        var i,
	            j,
	            out = new this._class(1),
	            pow = this;
	
	        for (i = 0; i < l.length; i++) {
	          for (j = 0; j < this.radix; j++) {
	            if (l[i] & 1 << j) {
	              out = out.mul(pow);
	            }
	            if (i == l.length - 1 && l[i] >> j + 1 == 0) {
	              break;
	            }
	
	            pow = pow.square();
	          }
	        }
	
	        return out;
	      },
	
	      /** this * that mod N */
	      mulmod: function mulmod(that, N) {
	        return this.mod(N).mul(that.mod(N)).mod(N);
	      },
	
	      /** this ^ x mod N */
	      powermod: function powermod(x, N) {
	        x = new sjcl.bn(x);
	        N = new sjcl.bn(N);
	
	        // Jump to montpowermod if possible.
	        if ((N.limbs[0] & 1) == 1) {
	          var montOut = this.montpowermod(x, N);
	
	          if (montOut != false) {
	            return montOut;
	          } // else go to slow powermod
	        }
	
	        var i,
	            j,
	            l = x.normalize().trim().limbs,
	            out = new this._class(1),
	            pow = this;
	
	        for (i = 0; i < l.length; i++) {
	          for (j = 0; j < this.radix; j++) {
	            if (l[i] & 1 << j) {
	              out = out.mulmod(pow, N);
	            }
	            if (i == l.length - 1 && l[i] >> j + 1 == 0) {
	              break;
	            }
	
	            pow = pow.mulmod(pow, N);
	          }
	        }
	
	        return out;
	      },
	
	      /** this ^ x mod N with Montomery reduction */
	      montpowermod: function montpowermod(x, N) {
	        x = new sjcl.bn(x).normalize().trim();
	        N = new sjcl.bn(N);
	
	        var i,
	            j,
	            radix = this.radix,
	            out = new this._class(1),
	            pow = this.copy();
	
	        // Generate R as a cap of N.
	        var R,
	            s,
	            wind,
	            bitsize = x.bitLength();
	
	        R = new sjcl.bn({
	          limbs: N.copy().normalize().trim().limbs.map(function () {
	            return 0;
	          })
	        });
	
	        for (s = this.radix; s > 0; s--) {
	          if ((N.limbs[N.limbs.length - 1] >> s & 1) == 1) {
	            R.limbs[R.limbs.length - 1] = 1 << s;
	            break;
	          }
	        }
	
	        // Calculate window size as a function of the exponent's size.
	        if (bitsize == 0) {
	          return this;
	        } else if (bitsize < 18) {
	          wind = 1;
	        } else if (bitsize < 48) {
	          wind = 3;
	        } else if (bitsize < 144) {
	          wind = 4;
	        } else if (bitsize < 768) {
	          wind = 5;
	        } else {
	          wind = 6;
	        }
	
	        // Find R' and N' such that R * R' - N * N' = 1.
	        var RR = R.copy(),
	            NN = N.copy(),
	            RP = new sjcl.bn(1),
	            NP = new sjcl.bn(0),
	            RT = R.copy();
	
	        while (RT.greaterEquals(1)) {
	          RT.halveM();
	
	          if ((RP.limbs[0] & 1) == 0) {
	            RP.halveM();
	            NP.halveM();
	          } else {
	            RP.addM(NN);
	            RP.halveM();
	
	            NP.halveM();
	            NP.addM(RR);
	          }
	        }
	
	        RP = RP.normalize();
	        NP = NP.normalize();
	
	        RR.doubleM();
	        var R2 = RR.mulmod(RR, N);
	
	        // Check whether the invariant holds.
	        // If it doesn't, we can't use Montgomery reduction on this modulus.
	        if (!RR.mul(RP).sub(N.mul(NP)).equals(1)) {
	          return false;
	        }
	
	        var montIn = function montIn(c) {
	          return montMul(c, R2);
	        },
	            montMul = function montMul(a, b) {
	          // Standard Montgomery reduction
	          var k,
	              carry,
	              ab,
	              right,
	              abBar,
	              mask = (1 << s + 1) - 1;
	
	          ab = a.mul(b);
	
	          right = ab.mul(NP);
	          right.limbs = right.limbs.slice(0, R.limbs.length);
	
	          if (right.limbs.length == R.limbs.length) {
	            right.limbs[R.limbs.length - 1] &= mask;
	          }
	
	          right = right.mul(N);
	
	          abBar = ab.add(right).normalize().trim();
	          abBar.limbs = abBar.limbs.slice(R.limbs.length - 1);
	
	          // Division.  Equivelent to calling *.halveM() s times.
	          for (k = 0; k < abBar.limbs.length; k++) {
	            if (k > 0) {
	              abBar.limbs[k - 1] |= (abBar.limbs[k] & mask) << radix - s - 1;
	            }
	
	            abBar.limbs[k] = abBar.limbs[k] >> s + 1;
	          }
	
	          if (abBar.greaterEquals(N)) {
	            abBar.subM(N);
	          }
	
	          return abBar;
	        },
	            montOut = function montOut(c) {
	          return montMul(c, 1);
	        };
	
	        pow = montIn(pow);
	        out = montIn(out);
	
	        // Sliding-Window Exponentiation (HAC 14.85)
	        var h,
	            precomp = {},
	            cap = (1 << wind - 1) - 1;
	
	        precomp[1] = pow.copy();
	        precomp[2] = montMul(pow, pow);
	
	        for (h = 1; h <= cap; h++) {
	          precomp[2 * h + 1] = montMul(precomp[2 * h - 1], precomp[2]);
	        }
	
	        var getBit = function getBit(exp, i) {
	          // Gets ith bit of exp.
	          var off = i % exp.radix;
	
	          return (exp.limbs[Math.floor(i / exp.radix)] & 1 << off) >> off;
	        };
	
	        for (i = x.bitLength() - 1; i >= 0;) {
	          if (getBit(x, i) == 0) {
	            // If the next bit is zero:
	            //   Square, move forward one bit.
	            out = montMul(out, out);
	            i = i - 1;
	          } else {
	            // If the next bit is one:
	            //   Find the longest sequence of bits after this one, less than `wind`
	            //   bits long, that ends with a 1.  Convert the sequence into an
	            //   integer and look up the pre-computed value to add.
	            var l = i - wind + 1;
	
	            while (getBit(x, l) == 0) {
	              l++;
	            }
	
	            var indx = 0;
	            for (j = l; j <= i; j++) {
	              indx += getBit(x, j) << j - l;
	              out = montMul(out, out);
	            }
	
	            out = montMul(out, precomp[indx]);
	
	            i = l - 1;
	          }
	        }
	
	        return montOut(out);
	      },
	
	      trim: function trim() {
	        var l = this.limbs,
	            p;
	        do {
	          p = l.pop();
	        } while (l.length && p === 0);
	        l.push(p);
	        return this;
	      },
	
	      /** Reduce mod a modulus.  Stubbed for subclassing. */
	      reduce: function reduce() {
	        return this;
	      },
	
	      /** Reduce and normalize. */
	      fullReduce: function fullReduce() {
	        return this.normalize();
	      },
	
	      /** Propagate carries. */
	      normalize: function normalize() {
	        var carry = 0,
	            i,
	            pv = this.placeVal,
	            ipv = this.ipv,
	            l,
	            m,
	            limbs = this.limbs,
	            ll = limbs.length,
	            mask = this.radixMask;
	        for (i = 0; i < ll || carry !== 0 && carry !== -1; i++) {
	          l = (limbs[i] || 0) + carry;
	          m = limbs[i] = l & mask;
	          carry = (l - m) * ipv;
	        }
	        if (carry === -1) {
	          limbs[i - 1] -= pv;
	        }
	        this.trim();
	        return this;
	      },
	
	      /** Constant-time normalize. Does not allocate additional space. */
	      cnormalize: function cnormalize() {
	        var carry = 0,
	            i,
	            ipv = this.ipv,
	            l,
	            m,
	            limbs = this.limbs,
	            ll = limbs.length,
	            mask = this.radixMask;
	        for (i = 0; i < ll - 1; i++) {
	          l = limbs[i] + carry;
	          m = limbs[i] = l & mask;
	          carry = (l - m) * ipv;
	        }
	        limbs[i] += carry;
	        return this;
	      },
	
	      /** Serialize to a bit array */
	      toBits: function toBits(len) {
	        this.fullReduce();
	        len = len || this.exponent || this.bitLength();
	        var i = Math.floor((len - 1) / 24),
	            w = sjcl.bitArray,
	            e = (len + 7 & -8) % this.radix || this.radix,
	            out = [w.partial(e, this.getLimb(i))];
	        for (i--; i >= 0; i--) {
	          out = w.concat(out, [w.partial(Math.min(this.radix, len), this.getLimb(i))]);
	          len -= this.radix;
	        }
	        return out;
	      },
	
	      /** Return the length in bits, rounded up to the nearest byte. */
	      bitLength: function bitLength() {
	        this.fullReduce();
	        var out = this.radix * (this.limbs.length - 1),
	            b = this.limbs[this.limbs.length - 1];
	        for (; b; b >>>= 1) {
	          out++;
	        }
	        return out + 7 & -8;
	      }
	    };
	
	    /** @memberOf sjcl.bn
	    * @this { sjcl.bn }
	    */
	    sjcl.bn.fromBits = function (bits) {
	      var Class = this,
	          out = new Class(),
	          words = [],
	          w = sjcl.bitArray,
	          t = this.prototype,
	          l = Math.min(this.bitLength || 0x100000000, w.bitLength(bits)),
	          e = l % t.radix || t.radix;
	
	      words[0] = w.extract(bits, 0, e);
	      for (; e < l; e += t.radix) {
	        words.unshift(w.extract(bits, e, t.radix));
	      }
	
	      out.limbs = words;
	      return out;
	    };
	
	    sjcl.bn.prototype.ipv = 1 / (sjcl.bn.prototype.placeVal = Math.pow(2, sjcl.bn.prototype.radix));
	    sjcl.bn.prototype.radixMask = (1 << sjcl.bn.prototype.radix) - 1;
	
	    /**
	     * Creates a new subclass of bn, based on reduction modulo a pseudo-Mersenne prime,
	     * i.e. a prime of the form 2^e + sum(a * 2^b),where the sum is negative and sparse.
	     */
	    sjcl.bn.pseudoMersennePrime = function (exponent, coeff) {
	      /** @constructor
	      * @private
	      */
	      function p(it) {
	        this.initWith(it);
	        /*if (this.limbs[this.modOffset]) {
	          this.reduce();
	        }*/
	      }
	
	      var ppr = p.prototype = new sjcl.bn(),
	          i,
	          tmp,
	          mo;
	      mo = ppr.modOffset = Math.ceil(tmp = exponent / ppr.radix);
	      ppr.exponent = exponent;
	      ppr.offset = [];
	      ppr.factor = [];
	      ppr.minOffset = mo;
	      ppr.fullMask = 0;
	      ppr.fullOffset = [];
	      ppr.fullFactor = [];
	      ppr.modulus = p.modulus = new sjcl.bn(Math.pow(2, exponent));
	
	      ppr.fullMask = 0 | -Math.pow(2, exponent % ppr.radix);
	
	      for (i = 0; i < coeff.length; i++) {
	        ppr.offset[i] = Math.floor(coeff[i][0] / ppr.radix - tmp);
	        ppr.fullOffset[i] = Math.ceil(coeff[i][0] / ppr.radix - tmp);
	        ppr.factor[i] = coeff[i][1] * Math.pow(1 / 2, exponent - coeff[i][0] + ppr.offset[i] * ppr.radix);
	        ppr.fullFactor[i] = coeff[i][1] * Math.pow(1 / 2, exponent - coeff[i][0] + ppr.fullOffset[i] * ppr.radix);
	        ppr.modulus.addM(new sjcl.bn(Math.pow(2, coeff[i][0]) * coeff[i][1]));
	        ppr.minOffset = Math.min(ppr.minOffset, -ppr.offset[i]); // conservative
	      }
	      ppr._class = p;
	      ppr.modulus.cnormalize();
	
	      /** Approximate reduction mod p.  May leave a number which is negative or slightly larger than p.
	       * @memberof sjcl.bn
	       * @this { sjcl.bn }
	       */
	      ppr.reduce = function () {
	        var i,
	            k,
	            l,
	            mo = this.modOffset,
	            limbs = this.limbs,
	            off = this.offset,
	            ol = this.offset.length,
	            fac = this.factor,
	            ll;
	
	        i = this.minOffset;
	        while (limbs.length > mo) {
	          l = limbs.pop();
	          ll = limbs.length;
	          for (k = 0; k < ol; k++) {
	            limbs[ll + off[k]] -= fac[k] * l;
	          }
	
	          i--;
	          if (!i) {
	            limbs.push(0);
	            this.cnormalize();
	            i = this.minOffset;
	          }
	        }
	        this.cnormalize();
	
	        return this;
	      };
	
	      /** @memberof sjcl.bn
	      * @this { sjcl.bn }
	      */
	      ppr._strongReduce = ppr.fullMask === -1 ? ppr.reduce : function () {
	        var limbs = this.limbs,
	            i = limbs.length - 1,
	            k,
	            l;
	        this.reduce();
	        if (i === this.modOffset - 1) {
	          l = limbs[i] & this.fullMask;
	          limbs[i] -= l;
	          for (k = 0; k < this.fullOffset.length; k++) {
	            limbs[i + this.fullOffset[k]] -= this.fullFactor[k] * l;
	          }
	          this.normalize();
	        }
	      };
	
	      /** mostly constant-time, very expensive full reduction.
	       * @memberof sjcl.bn
	       * @this { sjcl.bn }
	       */
	      ppr.fullReduce = function () {
	        var greater, i;
	        // massively above the modulus, may be negative
	
	        this._strongReduce();
	        // less than twice the modulus, may be negative
	
	        this.addM(this.modulus);
	        this.addM(this.modulus);
	        this.normalize();
	        // probably 2-3x the modulus
	
	        this._strongReduce();
	        // less than the power of 2.  still may be more than
	        // the modulus
	
	        // HACK: pad out to this length
	        for (i = this.limbs.length; i < this.modOffset; i++) {
	          this.limbs[i] = 0;
	        }
	
	        // constant-time subtract modulus
	        greater = this.greaterEquals(this.modulus);
	        for (i = 0; i < this.limbs.length; i++) {
	          this.limbs[i] -= this.modulus.limbs[i] * greater;
	        }
	        this.cnormalize();
	
	        return this;
	      };
	
	      /** @memberof sjcl.bn
	      * @this { sjcl.bn }
	      */
	      ppr.inverse = function () {
	        return this.power(this.modulus.sub(2));
	      };
	
	      p.fromBits = sjcl.bn.fromBits;
	
	      return p;
	    };
	
	    // a small Mersenne prime
	    var sbp = sjcl.bn.pseudoMersennePrime;
	    sjcl.bn.prime = {
	      p127: sbp(127, [[0, -1]]),
	
	      // Bernstein's prime for Curve25519
	      p25519: sbp(255, [[0, -19]]),
	
	      // Koblitz primes
	      p192k: sbp(192, [[32, -1], [12, -1], [8, -1], [7, -1], [6, -1], [3, -1], [0, -1]]),
	      p224k: sbp(224, [[32, -1], [12, -1], [11, -1], [9, -1], [7, -1], [4, -1], [1, -1], [0, -1]]),
	      p256k: sbp(256, [[32, -1], [9, -1], [8, -1], [7, -1], [6, -1], [4, -1], [0, -1]]),
	
	      // NIST primes
	      p192: sbp(192, [[0, -1], [64, -1]]),
	      p224: sbp(224, [[0, 1], [96, -1]]),
	      p256: sbp(256, [[0, -1], [96, 1], [192, 1], [224, -1]]),
	      p384: sbp(384, [[0, -1], [32, 1], [96, -1], [128, -1]]),
	      p521: sbp(521, [[0, -1]])
	    };
	
	    sjcl.bn.random = function (modulus, paranoia) {
	      if ((typeof modulus === 'undefined' ? 'undefined' : _typeof(modulus)) !== "object") {
	        modulus = new sjcl.bn(modulus);
	      }
	      var words,
	          i,
	          l = modulus.limbs.length,
	          m = modulus.limbs[l - 1] + 1,
	          out = new sjcl.bn();
	      while (true) {
	        // get a sequence whose first digits make sense
	        do {
	          words = sjcl.random.randomWords(l, paranoia);
	          if (words[l - 1] < 0) {
	            words[l - 1] += 0x100000000;
	          }
	        } while (Math.floor(words[l - 1] / m) === Math.floor(0x100000000 / m));
	        words[l - 1] %= m;
	
	        // mask off all the limbs
	        for (i = 0; i < l - 1; i++) {
	          words[i] &= modulus.radixMask;
	        }
	
	        // check the rest of the digitssj
	        out.limbs = words;
	        if (!out.greaterEquals(modulus)) {
	          return out;
	        }
	      }
	    };
	    /** @fileOverview Bit array codec implementations.
	     *
	     * @author Marco Munizaga
	     */
	
	    //patch arraybuffers if they don't exist
	    if (typeof ArrayBuffer === 'undefined') {
	      (function (globals) {
	        "use strict";
	
	        globals.ArrayBuffer = function () {};
	        globals.DataView = function () {};
	      })(this);
	    }
	
	    /**
	     * ArrayBuffer
	     * @namespace
	     */
	    sjcl.codec.arrayBuffer = {
	      /** Convert from a bitArray to an ArrayBuffer. 
	       * Will default to 8byte padding if padding is undefined*/
	      fromBits: function fromBits(arr, padding, padding_count) {
	        var out, i, ol, tmp, smallest;
	        padding = padding == undefined ? true : padding;
	        padding_count = padding_count || 8;
	
	        if (arr.length === 0) {
	          return new ArrayBuffer(0);
	        }
	
	        ol = sjcl.bitArray.bitLength(arr) / 8;
	
	        //check to make sure the bitLength is divisible by 8, if it isn't 
	        //we can't do anything since arraybuffers work with bytes, not bits
	        if (sjcl.bitArray.bitLength(arr) % 8 !== 0) {
	          throw new sjcl.exception.invalid("Invalid bit size, must be divisble by 8 to fit in an arraybuffer correctly");
	        }
	
	        if (padding && ol % padding_count !== 0) {
	          ol += padding_count - ol % padding_count;
	        }
	
	        //padded temp for easy copying
	        tmp = new DataView(new ArrayBuffer(arr.length * 4));
	        for (i = 0; i < arr.length; i++) {
	          tmp.setUint32(i * 4, arr[i] << 32); //get rid of the higher bits
	        }
	
	        //now copy the final message if we are not going to 0 pad
	        out = new DataView(new ArrayBuffer(ol));
	
	        //save a step when the tmp and out bytelength are ===
	        if (out.byteLength === tmp.byteLength) {
	          return tmp.buffer;
	        }
	
	        smallest = tmp.byteLength < out.byteLength ? tmp.byteLength : out.byteLength;
	        for (i = 0; i < smallest; i++) {
	          out.setUint8(i, tmp.getUint8(i));
	        }
	
	        return out.buffer;
	      },
	
	      toBits: function toBits(buffer) {
	        var i,
	            out = [],
	            len,
	            inView,
	            tmp;
	
	        if (buffer.byteLength === 0) {
	          return [];
	        }
	
	        inView = new DataView(buffer);
	        len = inView.byteLength - inView.byteLength % 4;
	
	        for (var i = 0; i < len; i += 4) {
	          out.push(inView.getUint32(i));
	        }
	
	        if (inView.byteLength % 4 != 0) {
	          tmp = new DataView(new ArrayBuffer(4));
	          for (var i = 0, l = inView.byteLength % 4; i < l; i++) {
	            //we want the data to the right, because partial slices off the starting bits
	            tmp.setUint8(i + 4 - l, inView.getUint8(len + i)); // big-endian, 
	          }
	          out.push(sjcl.bitArray.partial(inView.byteLength % 4 * 8, tmp.getUint32(0)));
	        }
	        return out;
	      },
	
	      /** Prints a hex output of the buffer contents, akin to hexdump **/
	      hexDumpBuffer: function hexDumpBuffer(buffer) {
	        var stringBufferView = new DataView(buffer);
	        var string = '';
	        var pad = function pad(n, width) {
	          n = n + '';
	          return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
	        };
	
	        for (var i = 0; i < stringBufferView.byteLength; i += 2) {
	          if (i % 16 == 0) string += '\n' + i.toString(16) + '\t';
	          string += pad(stringBufferView.getUint16(i).toString(16), 4) + ' ';
	        }
	
	        if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) === undefined) {
	          console = console || { log: function log() {} }; //fix for IE
	        }
	        console.log(string.toUpperCase());
	      }
	    };
	
	    /** @fileOverview Bit array codec implementations.
	     *
	     * @author Emily Stark
	     * @author Mike Hamburg
	     * @author Dan Boneh
	     */
	
	    /**
	     * UTF-8 strings
	     * @namespace
	     */
	    sjcl.codec.utf8String = {
	      /** Convert from a bitArray to a UTF-8 string. */
	      fromBits: function fromBits(arr) {
	        var out = "",
	            bl = sjcl.bitArray.bitLength(arr),
	            i,
	            tmp;
	        for (i = 0; i < bl / 8; i++) {
	          if ((i & 3) === 0) {
	            tmp = arr[i / 4];
	          }
	          out += String.fromCharCode(tmp >>> 8 >>> 8 >>> 8);
	          tmp <<= 8;
	        }
	        return decodeURIComponent(escape(out));
	      },
	
	      /** Convert from a UTF-8 string to a bitArray. */
	      toBits: function toBits(str) {
	        str = unescape(encodeURIComponent(str));
	        var out = [],
	            i,
	            tmp = 0;
	        for (i = 0; i < str.length; i++) {
	          tmp = tmp << 8 | str.charCodeAt(i);
	          if ((i & 3) === 3) {
	            out.push(tmp);
	            tmp = 0;
	          }
	        }
	        if (i & 3) {
	          out.push(sjcl.bitArray.partial(8 * (i & 3), tmp));
	        }
	        return out;
	      }
	    };
	    /**
	     * base class for all ecc operations.
	     * @namespace
	     */
	    sjcl.ecc = {};
	
	    /**
	     * Represents a point on a curve in affine coordinates.
	     * @constructor
	     * @param {sjcl.ecc.curve} curve The curve that this point lies on.
	     * @param {bigInt} x The x coordinate.
	     * @param {bigInt} y The y coordinate.
	     */
	    sjcl.ecc.point = function (curve, x, y) {
	      if (x === undefined) {
	        this.isIdentity = true;
	      } else {
	        if (x instanceof sjcl.bn) {
	          x = new curve.field(x);
	        }
	        if (y instanceof sjcl.bn) {
	          y = new curve.field(y);
	        }
	
	        this.x = x;
	        this.y = y;
	
	        this.isIdentity = false;
	      }
	      this.curve = curve;
	    };
	
	    sjcl.ecc.point.prototype = {
	      toJac: function toJac() {
	        return new sjcl.ecc.pointJac(this.curve, this.x, this.y, new this.curve.field(1));
	      },
	
	      mult: function mult(k) {
	        return this.toJac().mult(k, this).toAffine();
	      },
	
	      /**
	       * Multiply this point by k, added to affine2*k2, and return the answer in Jacobian coordinates.
	       * @param {bigInt} k The coefficient to multiply this by.
	       * @param {bigInt} k2 The coefficient to multiply affine2 this by.
	       * @param {sjcl.ecc.point} affine The other point in affine coordinates.
	       * @return {sjcl.ecc.pointJac} The result of the multiplication and addition, in Jacobian coordinates.
	       */
	      mult2: function mult2(k, k2, affine2) {
	        return this.toJac().mult2(k, this, k2, affine2).toAffine();
	      },
	
	      multiples: function multiples() {
	        var m, i, j;
	        if (this._multiples === undefined) {
	          j = this.toJac().doubl();
	          m = this._multiples = [new sjcl.ecc.point(this.curve), this, j.toAffine()];
	          for (i = 3; i < 16; i++) {
	            j = j.add(this);
	            m.push(j.toAffine());
	          }
	        }
	        return this._multiples;
	      },
	
	      negate: function negate() {
	        var newY = new this.curve.field(0).sub(this.y).normalize().reduce();
	        return new sjcl.ecc.point(this.curve, this.x, newY);
	      },
	
	      isValid: function isValid() {
	        return this.y.square().equals(this.curve.b.add(this.x.mul(this.curve.a.add(this.x.square()))));
	      },
	
	      toBits: function toBits() {
	        return sjcl.bitArray.concat(this.x.toBits(), this.y.toBits());
	      }
	    };
	
	    /**
	     * Represents a point on a curve in Jacobian coordinates. Coordinates can be specified as bigInts or strings (which
	     * will be converted to bigInts).
	     *
	     * @constructor
	     * @param {bigInt/string} x The x coordinate.
	     * @param {bigInt/string} y The y coordinate.
	     * @param {bigInt/string} z The z coordinate.
	     * @param {sjcl.ecc.curve} curve The curve that this point lies on.
	     */
	    sjcl.ecc.pointJac = function (curve, x, y, z) {
	      if (x === undefined) {
	        this.isIdentity = true;
	      } else {
	        this.x = x;
	        this.y = y;
	        this.z = z;
	        this.isIdentity = false;
	      }
	      this.curve = curve;
	    };
	
	    sjcl.ecc.pointJac.prototype = {
	      /**
	       * Adds S and T and returns the result in Jacobian coordinates. Note that S must be in Jacobian coordinates and T must be in affine coordinates.
	       * @param {sjcl.ecc.pointJac} S One of the points to add, in Jacobian coordinates.
	       * @param {sjcl.ecc.point} T The other point to add, in affine coordinates.
	       * @return {sjcl.ecc.pointJac} The sum of the two points, in Jacobian coordinates.
	       */
	      add: function add(T) {
	        var S = this,
	            sz2,
	            c,
	            d,
	            c2,
	            x1,
	            x2,
	            x,
	            y1,
	            y2,
	            y,
	            z;
	        if (S.curve !== T.curve) {
	          throw new sjcl.exception.invalid("sjcl.ecc.add(): Points must be on the same curve to add them!");
	        }
	
	        if (S.isIdentity) {
	          return T.toJac();
	        } else if (T.isIdentity) {
	          return S;
	        }
	
	        sz2 = S.z.square();
	        c = T.x.mul(sz2).subM(S.x);
	
	        if (c.equals(0)) {
	          if (S.y.equals(T.y.mul(sz2.mul(S.z)))) {
	            // same point
	            return S.doubl();
	          } else {
	            // inverses
	            return new sjcl.ecc.pointJac(S.curve);
	          }
	        }
	
	        d = T.y.mul(sz2.mul(S.z)).subM(S.y);
	        c2 = c.square();
	
	        x1 = d.square();
	        x2 = c.square().mul(c).addM(S.x.add(S.x).mul(c2));
	        x = x1.subM(x2);
	
	        y1 = S.x.mul(c2).subM(x).mul(d);
	        y2 = S.y.mul(c.square().mul(c));
	        y = y1.subM(y2);
	
	        z = S.z.mul(c);
	
	        return new sjcl.ecc.pointJac(this.curve, x, y, z);
	      },
	
	      /**
	       * doubles this point.
	       * @return {sjcl.ecc.pointJac} The doubled point.
	       */
	      doubl: function doubl() {
	        if (this.isIdentity) {
	          return this;
	        }
	
	        var y2 = this.y.square(),
	            a = y2.mul(this.x.mul(4)),
	            b = y2.square().mul(8),
	            z2 = this.z.square(),
	            c = this.curve.a.toString() == new sjcl.bn(-3).toString() ? this.x.sub(z2).mul(3).mul(this.x.add(z2)) : this.x.square().mul(3).add(z2.square().mul(this.curve.a)),
	            x = c.square().subM(a).subM(a),
	            y = a.sub(x).mul(c).subM(b),
	            z = this.y.add(this.y).mul(this.z);
	        return new sjcl.ecc.pointJac(this.curve, x, y, z);
	      },
	
	      /**
	       * Returns a copy of this point converted to affine coordinates.
	       * @return {sjcl.ecc.point} The converted point.
	       */
	      toAffine: function toAffine() {
	        if (this.isIdentity || this.z.equals(0)) {
	          return new sjcl.ecc.point(this.curve);
	        }
	        var zi = this.z.inverse(),
	            zi2 = zi.square();
	        return new sjcl.ecc.point(this.curve, this.x.mul(zi2).fullReduce(), this.y.mul(zi2.mul(zi)).fullReduce());
	      },
	
	      /**
	       * Multiply this point by k and return the answer in Jacobian coordinates.
	       * @param {bigInt} k The coefficient to multiply by.
	       * @param {sjcl.ecc.point} affine This point in affine coordinates.
	       * @return {sjcl.ecc.pointJac} The result of the multiplication, in Jacobian coordinates.
	       */
	      mult: function mult(k, affine) {
	        if (typeof k === "number") {
	          k = [k];
	        } else if (k.limbs !== undefined) {
	          k = k.normalize().limbs;
	        }
	
	        var i,
	            j,
	            out = new sjcl.ecc.point(this.curve).toJac(),
	            multiples = affine.multiples();
	
	        for (i = k.length - 1; i >= 0; i--) {
	          for (j = sjcl.bn.prototype.radix - 4; j >= 0; j -= 4) {
	            out = out.doubl().doubl().doubl().doubl().add(multiples[k[i] >> j & 0xF]);
	          }
	        }
	
	        return out;
	      },
	
	      /**
	       * Multiply this point by k, added to affine2*k2, and return the answer in Jacobian coordinates.
	       * @param {bigInt} k The coefficient to multiply this by.
	       * @param {sjcl.ecc.point} affine This point in affine coordinates.
	       * @param {bigInt} k2 The coefficient to multiply affine2 this by.
	       * @param {sjcl.ecc.point} affine The other point in affine coordinates.
	       * @return {sjcl.ecc.pointJac} The result of the multiplication and addition, in Jacobian coordinates.
	       */
	      mult2: function mult2(k1, affine, k2, affine2) {
	        if (typeof k1 === "number") {
	          k1 = [k1];
	        } else if (k1.limbs !== undefined) {
	          k1 = k1.normalize().limbs;
	        }
	
	        if (typeof k2 === "number") {
	          k2 = [k2];
	        } else if (k2.limbs !== undefined) {
	          k2 = k2.normalize().limbs;
	        }
	
	        var i,
	            j,
	            out = new sjcl.ecc.point(this.curve).toJac(),
	            m1 = affine.multiples(),
	            m2 = affine2.multiples(),
	            l1,
	            l2;
	
	        for (i = Math.max(k1.length, k2.length) - 1; i >= 0; i--) {
	          l1 = k1[i] | 0;
	          l2 = k2[i] | 0;
	          for (j = sjcl.bn.prototype.radix - 4; j >= 0; j -= 4) {
	            out = out.doubl().doubl().doubl().doubl().add(m1[l1 >> j & 0xF]).add(m2[l2 >> j & 0xF]);
	          }
	        }
	
	        return out;
	      },
	
	      negate: function negate() {
	        return this.toAffine().negate().toJac();
	      },
	
	      isValid: function isValid() {
	        var z2 = this.z.square(),
	            z4 = z2.square(),
	            z6 = z4.mul(z2);
	        return this.y.square().equals(this.curve.b.mul(z6).add(this.x.mul(this.curve.a.mul(z4).add(this.x.square()))));
	      }
	    };
	
	    /**
	     * Construct an elliptic curve. Most users will not use this and instead start with one of the NIST curves defined below.
	     *
	     * @constructor
	     * @param {bigInt} p The prime modulus.
	     * @param {bigInt} r The prime order of the curve.
	     * @param {bigInt} a The constant a in the equation of the curve y^2 = x^3 + ax + b (for NIST curves, a is always -3).
	     * @param {bigInt} x The x coordinate of a base point of the curve.
	     * @param {bigInt} y The y coordinate of a base point of the curve.
	     */
	    sjcl.ecc.curve = function (Field, r, a, b, x, y) {
	      this.field = Field;
	      this.r = new sjcl.bn(r);
	      this.a = new Field(a);
	      this.b = new Field(b);
	      this.G = new sjcl.ecc.point(this, new Field(x), new Field(y));
	    };
	
	    sjcl.ecc.curve.prototype.fromBits = function (bits) {
	      var w = sjcl.bitArray,
	          l = this.field.prototype.exponent + 7 & -8,
	          p = new sjcl.ecc.point(this, this.field.fromBits(w.bitSlice(bits, 0, l)), this.field.fromBits(w.bitSlice(bits, l, 2 * l)));
	      if (!p.isValid()) {
	        throw new sjcl.exception.corrupt("not on the curve!");
	      }
	      return p;
	    };
	
	    sjcl.ecc.curves = {
	      c192: new sjcl.ecc.curve(sjcl.bn.prime.p192, "0xffffffffffffffffffffffff99def836146bc9b1b4d22831", -3, "0x64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1", "0x188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012", "0x07192b95ffc8da78631011ed6b24cdd573f977a11e794811"),
	
	      c224: new sjcl.ecc.curve(sjcl.bn.prime.p224, "0xffffffffffffffffffffffffffff16a2e0b8f03e13dd29455c5c2a3d", -3, "0xb4050a850c04b3abf54132565044b0b7d7bfd8ba270b39432355ffb4", "0xb70e0cbd6bb4bf7f321390b94a03c1d356c21122343280d6115c1d21", "0xbd376388b5f723fb4c22dfe6cd4375a05a07476444d5819985007e34"),
	
	      c256: new sjcl.ecc.curve(sjcl.bn.prime.p256, "0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551", -3, "0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b", "0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296", "0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
	
	      c384: new sjcl.ecc.curve(sjcl.bn.prime.p384, "0xffffffffffffffffffffffffffffffffffffffffffffffffc7634d81f4372ddf581a0db248b0a77aecec196accc52973", -3, "0xb3312fa7e23ee7e4988e056be3f82d19181d9c6efe8141120314088f5013875ac656398d8a2ed19d2a85c8edd3ec2aef", "0xaa87ca22be8b05378eb1c71ef320ad746e1d3b628ba79b9859f741e082542a385502f25dbf55296c3a545e3872760ab7", "0x3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f"),
	
	      c521: new sjcl.ecc.curve(sjcl.bn.prime.p521, "0x1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", -3, "0x051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "0xC6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "0x11839296A789A3BC0045C8A5FB42C7D1BD998F54449579B446817AFBD17273E662C97EE72995EF42640C550B9013FAD0761353C7086A272C24088BE94769FD16650"),
	
	      k192: new sjcl.ecc.curve(sjcl.bn.prime.p192k, "0xfffffffffffffffffffffffe26f2fc170f69466a74defd8d", 0, 3, "0xdb4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d", "0x9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"),
	
	      k224: new sjcl.ecc.curve(sjcl.bn.prime.p224k, "0x010000000000000000000000000001dce8d2ec6184caf0a971769fb1f7", 0, 5, "0xa1455b334df099df30fc28a169a467e9e47075a90f7e650eb6b7a45c", "0x7e089fed7fba344282cafbd6f7e319f7c0b0bd59e2ca4bdb556d61a5"),
	
	      k256: new sjcl.ecc.curve(sjcl.bn.prime.p256k, "0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 0, 7, "0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
	
	    };
	
	    sjcl.ecc.curveName = function (curve) {
	      var curcurve;
	      for (curcurve in sjcl.ecc.curves) {
	        if (sjcl.ecc.curves.hasOwnProperty(curcurve)) {
	          if (sjcl.ecc.curves[curcurve] === curve) {
	            return curcurve;
	          }
	        }
	      }
	
	      throw new sjcl.exception.invalid("no such curve");
	    };
	
	    sjcl.ecc.deserialize = function (key) {
	      var types = ["elGamal", "ecdsa"];
	
	      if (!key || !key.curve || !sjcl.ecc.curves[key.curve]) {
	        throw new sjcl.exception.invalid("invalid serialization");
	      }
	      if (types.indexOf(key.type) === -1) {
	        throw new sjcl.exception.invalid("invalid type");
	      }
	
	      var curve = sjcl.ecc.curves[key.curve];
	
	      if (key.secretKey) {
	        if (!key.exponent) {
	          throw new sjcl.exception.invalid("invalid exponent");
	        }
	        var exponent = new sjcl.bn(key.exponent);
	        return new sjcl.ecc[key.type].secretKey(curve, exponent);
	      } else {
	        if (!key.point) {
	          throw new sjcl.exception.invalid("invalid point");
	        }
	
	        var point = curve.fromBits(sjcl.codec.hex.toBits(key.point));
	        return new sjcl.ecc[key.type].publicKey(curve, point);
	      }
	    };
	
	    /** our basicKey classes
	    */
	    sjcl.ecc.basicKey = {
	      /** ecc publicKey.
	      * @constructor
	      * @param {curve} curve the elliptic curve
	      * @param {point} point the point on the curve
	      */
	      publicKey: function publicKey(curve, point) {
	        this._curve = curve;
	        this._curveBitLength = curve.r.bitLength();
	        if (point instanceof Array) {
	          this._point = curve.fromBits(point);
	        } else {
	          this._point = point;
	        }
	
	        this.serialize = function () {
	          var curveName = sjcl.ecc.curveName(curve);
	          return {
	            type: this.getType(),
	            secretKey: false,
	            point: sjcl.codec.hex.fromBits(this._point.toBits()),
	            curve: curveName
	          };
	        };
	
	        /** get this keys point data
	        * @return x and y as bitArrays
	        */
	        this.get = function () {
	          var pointbits = this._point.toBits();
	          var len = sjcl.bitArray.bitLength(pointbits);
	          var x = sjcl.bitArray.bitSlice(pointbits, 0, len / 2);
	          var y = sjcl.bitArray.bitSlice(pointbits, len / 2);
	          return { x: x, y: y };
	        };
	      },
	
	      /** ecc secretKey
	      * @constructor
	      * @param {curve} curve the elliptic curve
	      * @param exponent
	      */
	      secretKey: function secretKey(curve, exponent) {
	        this._curve = curve;
	        this._curveBitLength = curve.r.bitLength();
	        this._exponent = exponent;
	
	        this.serialize = function () {
	          var exponent = this.get();
	          var curveName = sjcl.ecc.curveName(curve);
	          return {
	            type: this.getType(),
	            secretKey: true,
	            exponent: sjcl.codec.hex.fromBits(exponent),
	            curve: curveName
	          };
	        };
	
	        /** get this keys exponent data
	        * @return {bitArray} exponent
	        */
	        this.get = function () {
	          return this._exponent.toBits();
	        };
	      }
	    };
	
	    /** @private */
	    sjcl.ecc.basicKey.generateKeys = function (cn) {
	      return function generateKeys(curve, paranoia, sec) {
	        curve = curve || 256;
	
	        if (typeof curve === "number") {
	          curve = sjcl.ecc.curves['c' + curve];
	          if (curve === undefined) {
	            throw new sjcl.exception.invalid("no such curve");
	          }
	        }
	        sec = sec || sjcl.bn.random(curve.r, paranoia);
	
	        var pub = curve.G.mult(sec);
	        return { pub: new sjcl.ecc[cn].publicKey(curve, pub),
	          sec: new sjcl.ecc[cn].secretKey(curve, sec) };
	      };
	    };
	
	    /** elGamal keys */
	    sjcl.ecc.elGamal = {
	      /** generate keys
	      * @function
	      * @param curve
	      * @param {int} paranoia Paranoia for generation (default 6)
	      * @param {secretKey} sec secret Key to use. used to get the publicKey for ones secretKey
	      */
	      generateKeys: sjcl.ecc.basicKey.generateKeys("elGamal"),
	      /** elGamal publicKey.
	      * @constructor
	      * @augments sjcl.ecc.basicKey.publicKey
	      */
	      publicKey: function publicKey(curve, point) {
	        sjcl.ecc.basicKey.publicKey.apply(this, arguments);
	      },
	      /** elGamal secretKey
	      * @constructor
	      * @augments sjcl.ecc.basicKey.secretKey
	      */
	      secretKey: function secretKey(curve, exponent) {
	        sjcl.ecc.basicKey.secretKey.apply(this, arguments);
	      }
	    };
	
	    sjcl.ecc.elGamal.publicKey.prototype = {
	      /** Kem function of elGamal Public Key
	      * @param paranoia paranoia to use for randomization.
	      * @return {object} key and tag. unkem(tag) with the corresponding secret key results in the key returned.
	      */
	      kem: function kem(paranoia) {
	        var sec = sjcl.bn.random(this._curve.r, paranoia),
	            tag = this._curve.G.mult(sec).toBits(),
	            key = sjcl.hash.sha256.hash(this._point.mult(sec).toBits());
	        return { key: key, tag: tag };
	      },
	
	      getType: function getType() {
	        return "elGamal";
	      }
	    };
	
	    sjcl.ecc.elGamal.secretKey.prototype = {
	      /** UnKem function of elGamal Secret Key
	      * @param {bitArray} tag The Tag to decrypt.
	      * @return {bitArray} decrypted key.
	      */
	      unkem: function unkem(tag) {
	        return sjcl.hash.sha256.hash(this._curve.fromBits(tag).mult(this._exponent).toBits());
	      },
	
	      /** Diffie-Hellmann function
	      * @param {elGamal.publicKey} pk The Public Key to do Diffie-Hellmann with
	      * @return {bitArray} diffie-hellmann result for this key combination.
	      */
	      dh: function dh(pk) {
	        return sjcl.hash.sha256.hash(pk._point.mult(this._exponent).toBits());
	      },
	
	      /** Diffie-Hellmann function, compatible with Java generateSecret
	      * @param {elGamal.publicKey} pk The Public Key to do Diffie-Hellmann with
	      * @return {bitArray} undigested X value, diffie-hellmann result for this key combination,
	      * compatible with Java generateSecret().
	      */
	      dhJavaEc: function dhJavaEc(pk) {
	        return pk._point.mult(this._exponent).x.toBits();
	      },
	
	      getType: function getType() {
	        return "elGamal";
	      }
	    };
	
	    /** ecdsa keys */
	    sjcl.ecc.ecdsa = {
	      /** generate keys
	      * @function
	      * @param curve
	      * @param {int} paranoia Paranoia for generation (default 6)
	      * @param {secretKey} sec secret Key to use. used to get the publicKey for ones secretKey
	      */
	      generateKeys: sjcl.ecc.basicKey.generateKeys("ecdsa")
	    };
	
	    /** ecdsa publicKey.
	    * @constructor
	    * @augments sjcl.ecc.basicKey.publicKey
	    */
	    sjcl.ecc.ecdsa.publicKey = function (curve, point) {
	      sjcl.ecc.basicKey.publicKey.apply(this, arguments);
	    };
	
	    /** specific functions for ecdsa publicKey. */
	    sjcl.ecc.ecdsa.publicKey.prototype = {
	      /** Diffie-Hellmann function
	      * @param {bitArray} hash hash to verify.
	      * @param {bitArray} rs signature bitArray.
	      * @param {boolean}  fakeLegacyVersion use old legacy version
	      */
	      verify: function verify(hash, rs, fakeLegacyVersion) {
	        if (sjcl.bitArray.bitLength(hash) > this._curveBitLength) {
	          hash = sjcl.bitArray.clamp(hash, this._curveBitLength);
	        }
	        var w = sjcl.bitArray,
	            R = this._curve.r,
	            l = this._curveBitLength,
	            r = sjcl.bn.fromBits(w.bitSlice(rs, 0, l)),
	            ss = sjcl.bn.fromBits(w.bitSlice(rs, l, 2 * l)),
	            s = fakeLegacyVersion ? ss : ss.inverseMod(R),
	            hG = sjcl.bn.fromBits(hash).mul(s).mod(R),
	            hA = r.mul(s).mod(R),
	            r2 = this._curve.G.mult2(hG, hA, this._point).x;
	        if (r.equals(0) || ss.equals(0) || r.greaterEquals(R) || ss.greaterEquals(R) || !r2.equals(r)) {
	          if (fakeLegacyVersion === undefined) {
	            return this.verify(hash, rs, true);
	          } else {
	            throw new sjcl.exception.corrupt("signature didn't check out");
	          }
	        }
	        return true;
	      },
	
	      getType: function getType() {
	        return "ecdsa";
	      }
	    };
	
	    /** ecdsa secretKey
	    * @constructor
	    * @augments sjcl.ecc.basicKey.publicKey
	    */
	    sjcl.ecc.ecdsa.secretKey = function (curve, exponent) {
	      sjcl.ecc.basicKey.secretKey.apply(this, arguments);
	    };
	
	    /** specific functions for ecdsa secretKey. */
	    sjcl.ecc.ecdsa.secretKey.prototype = {
	      /** Diffie-Hellmann function
	      * @param {bitArray} hash hash to sign.
	      * @param {int} paranoia paranoia for random number generation
	      * @param {boolean} fakeLegacyVersion use old legacy version
	      */
	      sign: function sign(hash, paranoia, fakeLegacyVersion, fixedKForTesting) {
	        if (sjcl.bitArray.bitLength(hash) > this._curveBitLength) {
	          hash = sjcl.bitArray.clamp(hash, this._curveBitLength);
	        }
	        var R = this._curve.r,
	            l = R.bitLength(),
	            k = fixedKForTesting || sjcl.bn.random(R.sub(1), paranoia).add(1),
	            r = this._curve.G.mult(k).x.mod(R),
	            ss = sjcl.bn.fromBits(hash).add(r.mul(this._exponent)),
	            s = fakeLegacyVersion ? ss.inverseMod(R).mul(k).mod(R) : ss.mul(k.inverseMod(R)).mod(R);
	        return sjcl.bitArray.concat(r.toBits(l), s.toBits(l));
	      },
	
	      getType: function getType() {
	        return "ecdsa";
	      }
	    };
	    /** @fileOverview Javascript RIPEMD-160 implementation.
	     *
	     * @author Artem S Vybornov <vybornov@gmail.com>
	     */
	    (function () {
	
	      /**
	       * Context for a RIPEMD-160 operation in progress.
	       * @constructor
	       */
	      sjcl.hash.ripemd160 = function (hash) {
	        if (hash) {
	          this._h = hash._h.slice(0);
	          this._buffer = hash._buffer.slice(0);
	          this._length = hash._length;
	        } else {
	          this.reset();
	        }
	      };
	
	      /**
	       * Hash a string or an array of words.
	       * @static
	       * @param {bitArray|String} data the data to hash.
	       * @return {bitArray} The hash value, an array of 5 big-endian words.
	       */
	      sjcl.hash.ripemd160.hash = function (data) {
	        return new sjcl.hash.ripemd160().update(data).finalize();
	      };
	
	      sjcl.hash.ripemd160.prototype = {
	        /**
	         * Reset the hash state.
	         * @return this
	         */
	        reset: function reset() {
	          this._h = _h0.slice(0);
	          this._buffer = [];
	          this._length = 0;
	          return this;
	        },
	
	        /**
	         * Reset the hash state.
	         * @param {bitArray|String} data the data to hash.
	         * @return this
	         */
	        update: function update(data) {
	          if (typeof data === "string") data = sjcl.codec.utf8String.toBits(data);
	
	          var i,
	              b = this._buffer = sjcl.bitArray.concat(this._buffer, data),
	              ol = this._length,
	              nl = this._length = ol + sjcl.bitArray.bitLength(data);
	          if (nl > 9007199254740991) {
	            throw new sjcl.exception.invalid("Cannot hash more than 2^53 - 1 bits");
	          }
	          for (i = 512 + ol - (512 + ol & 511); i <= nl; i += 512) {
	            var words = b.splice(0, 16);
	            for (var w = 0; w < 16; ++w) {
	              words[w] = _cvt(words[w]);
	            }_block.call(this, words);
	          }
	
	          return this;
	        },
	
	        /**
	         * Complete hashing and output the hash value.
	         * @return {bitArray} The hash value, an array of 5 big-endian words.
	         */
	        finalize: function finalize() {
	          var b = sjcl.bitArray.concat(this._buffer, [sjcl.bitArray.partial(1, 1)]),
	              l = (this._length + 1) % 512,
	              z = (l > 448 ? 512 : 448) - l % 448,
	              zp = z % 32;
	
	          if (zp > 0) b = sjcl.bitArray.concat(b, [sjcl.bitArray.partial(zp, 0)]);
	          for (; z >= 32; z -= 32) {
	            b.push(0);
	          }b.push(_cvt(this._length | 0));
	          b.push(_cvt(Math.floor(this._length / 0x100000000)));
	
	          while (b.length) {
	            var words = b.splice(0, 16);
	            for (var w = 0; w < 16; ++w) {
	              words[w] = _cvt(words[w]);
	            }_block.call(this, words);
	          }
	
	          var h = this._h;
	          this.reset();
	
	          for (var w = 0; w < 5; ++w) {
	            h[w] = _cvt(h[w]);
	          }return h;
	        }
	      };
	
	      var _h0 = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	      var _k1 = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
	      var _k2 = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];
	      for (var i = 4; i >= 0; --i) {
	        for (var j = 1; j < 16; ++j) {
	          _k1.splice(i, 0, _k1[i]);
	          _k2.splice(i, 0, _k2[i]);
	        }
	      }
	
	      var _r1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
	      var _r2 = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
	
	      var _s1 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
	      var _s2 = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
	
	      function _f0(x, y, z) {
	        return x ^ y ^ z;
	      }
	
	      function _f1(x, y, z) {
	        return x & y | ~x & z;
	      }
	
	      function _f2(x, y, z) {
	        return (x | ~y) ^ z;
	      }
	
	      function _f3(x, y, z) {
	        return x & z | y & ~z;
	      }
	
	      function _f4(x, y, z) {
	        return x ^ (y | ~z);
	      }
	
	      function _rol(n, l) {
	        return n << l | n >>> 32 - l;
	      }
	
	      function _cvt(n) {
	        return (n & 0xff << 0) << 24 | (n & 0xff << 8) << 8 | (n & 0xff << 16) >>> 8 | (n & 0xff << 24) >>> 24;
	      }
	
	      function _block(X) {
	        var A1 = this._h[0],
	            B1 = this._h[1],
	            C1 = this._h[2],
	            D1 = this._h[3],
	            E1 = this._h[4],
	            A2 = this._h[0],
	            B2 = this._h[1],
	            C2 = this._h[2],
	            D2 = this._h[3],
	            E2 = this._h[4];
	
	        var j = 0,
	            T;
	
	        for (; j < 16; ++j) {
	          T = _rol(A1 + _f0(B1, C1, D1) + X[_r1[j]] + _k1[j], _s1[j]) + E1;
	          A1 = E1;E1 = D1;D1 = _rol(C1, 10);C1 = B1;B1 = T;
	          T = _rol(A2 + _f4(B2, C2, D2) + X[_r2[j]] + _k2[j], _s2[j]) + E2;
	          A2 = E2;E2 = D2;D2 = _rol(C2, 10);C2 = B2;B2 = T;
	        }
	        for (; j < 32; ++j) {
	          T = _rol(A1 + _f1(B1, C1, D1) + X[_r1[j]] + _k1[j], _s1[j]) + E1;
	          A1 = E1;E1 = D1;D1 = _rol(C1, 10);C1 = B1;B1 = T;
	          T = _rol(A2 + _f3(B2, C2, D2) + X[_r2[j]] + _k2[j], _s2[j]) + E2;
	          A2 = E2;E2 = D2;D2 = _rol(C2, 10);C2 = B2;B2 = T;
	        }
	        for (; j < 48; ++j) {
	          T = _rol(A1 + _f2(B1, C1, D1) + X[_r1[j]] + _k1[j], _s1[j]) + E1;
	          A1 = E1;E1 = D1;D1 = _rol(C1, 10);C1 = B1;B1 = T;
	          T = _rol(A2 + _f2(B2, C2, D2) + X[_r2[j]] + _k2[j], _s2[j]) + E2;
	          A2 = E2;E2 = D2;D2 = _rol(C2, 10);C2 = B2;B2 = T;
	        }
	        for (; j < 64; ++j) {
	          T = _rol(A1 + _f3(B1, C1, D1) + X[_r1[j]] + _k1[j], _s1[j]) + E1;
	          A1 = E1;E1 = D1;D1 = _rol(C1, 10);C1 = B1;B1 = T;
	          T = _rol(A2 + _f1(B2, C2, D2) + X[_r2[j]] + _k2[j], _s2[j]) + E2;
	          A2 = E2;E2 = D2;D2 = _rol(C2, 10);C2 = B2;B2 = T;
	        }
	        for (; j < 80; ++j) {
	          T = _rol(A1 + _f4(B1, C1, D1) + X[_r1[j]] + _k1[j], _s1[j]) + E1;
	          A1 = E1;E1 = D1;D1 = _rol(C1, 10);C1 = B1;B1 = T;
	          T = _rol(A2 + _f0(B2, C2, D2) + X[_r2[j]] + _k2[j], _s2[j]) + E2;
	          A2 = E2;E2 = D2;D2 = _rol(C2, 10);C2 = B2;B2 = T;
	        }
	
	        T = this._h[1] + C1 + D2;
	        this._h[1] = this._h[2] + D1 + E2;
	        this._h[2] = this._h[3] + E1 + A2;
	        this._h[3] = this._h[4] + A1 + B2;
	        this._h[4] = this._h[0] + B1 + C2;
	        this._h[0] = T;
	      }
	    })();
	    /** @fileOverview Javascript SHA-256 implementation.
	     *
	     * An older version of this implementation is available in the public
	     * domain, but this one is (c) Emily Stark, Mike Hamburg, Dan Boneh,
	     * Stanford University 2008-2010 and BSD-licensed for liability
	     * reasons.
	     *
	     * Special thanks to Aldo Cortesi for pointing out several bugs in
	     * this code.
	     *
	     * @author Emily Stark
	     * @author Mike Hamburg
	     * @author Dan Boneh
	     */
	
	    /**
	     * Context for a SHA-256 operation in progress.
	     * @constructor
	     */
	    sjcl.hash.sha256 = function (hash) {
	      if (!this._key[0]) {
	        this._precompute();
	      }
	      if (hash) {
	        this._h = hash._h.slice(0);
	        this._buffer = hash._buffer.slice(0);
	        this._length = hash._length;
	      } else {
	        this.reset();
	      }
	    };
	
	    /**
	     * Hash a string or an array of words.
	     * @static
	     * @param {bitArray|String} data the data to hash.
	     * @return {bitArray} The hash value, an array of 16 big-endian words.
	     */
	    sjcl.hash.sha256.hash = function (data) {
	      return new sjcl.hash.sha256().update(data).finalize();
	    };
	
	    sjcl.hash.sha256.prototype = {
	      /**
	       * The hash's block size, in bits.
	       * @constant
	       */
	      blockSize: 512,
	
	      /**
	       * Reset the hash state.
	       * @return this
	       */
	      reset: function reset() {
	        this._h = this._init.slice(0);
	        this._buffer = [];
	        this._length = 0;
	        return this;
	      },
	
	      /**
	       * Input several words to the hash.
	       * @param {bitArray|String} data the data to hash.
	       * @return this
	       */
	      update: function update(data) {
	        if (typeof data === "string") {
	          data = sjcl.codec.utf8String.toBits(data);
	        }
	        var i,
	            b = this._buffer = sjcl.bitArray.concat(this._buffer, data),
	            ol = this._length,
	            nl = this._length = ol + sjcl.bitArray.bitLength(data);
	        if (nl > 9007199254740991) {
	          throw new sjcl.exception.invalid("Cannot hash more than 2^53 - 1 bits");
	        }
	
	        if (typeof Uint32Array !== 'undefined') {
	          var c = new Uint32Array(b);
	          var j = 0;
	          for (i = 512 + ol - (512 + ol & 511); i <= nl; i += 512) {
	            this._block(c.subarray(16 * j, 16 * (j + 1)));
	            j += 1;
	          }
	          b.splice(0, 16 * j);
	        } else {
	          for (i = 512 + ol - (512 + ol & 511); i <= nl; i += 512) {
	            this._block(b.splice(0, 16));
	          }
	        }
	        return this;
	      },
	
	      /**
	       * Complete hashing and output the hash value.
	       * @return {bitArray} The hash value, an array of 8 big-endian words.
	       */
	      finalize: function finalize() {
	        var i,
	            b = this._buffer,
	            h = this._h;
	
	        // Round out and push the buffer
	        b = sjcl.bitArray.concat(b, [sjcl.bitArray.partial(1, 1)]);
	
	        // Round out the buffer to a multiple of 16 words, less the 2 length words.
	        for (i = b.length + 2; i & 15; i++) {
	          b.push(0);
	        }
	
	        // append the length
	        b.push(Math.floor(this._length / 0x100000000));
	        b.push(this._length | 0);
	
	        while (b.length) {
	          this._block(b.splice(0, 16));
	        }
	
	        this.reset();
	        return h;
	      },
	
	      /**
	       * The SHA-256 initialization vector, to be precomputed.
	       * @private
	       */
	      _init: [],
	      /*
	      _init:[0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19],
	      */
	
	      /**
	       * The SHA-256 hash key, to be precomputed.
	       * @private
	       */
	      _key: [],
	      /*
	      _key:
	        [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	         0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	         0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	         0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	         0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	         0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	         0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	         0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2],
	      */
	
	      /**
	       * Function to precompute _init and _key.
	       * @private
	       */
	      _precompute: function _precompute() {
	        var i = 0,
	            prime = 2,
	            factor,
	            isPrime;
	
	        function frac(x) {
	          return (x - Math.floor(x)) * 0x100000000 | 0;
	        }
	
	        for (; i < 64; prime++) {
	          isPrime = true;
	          for (factor = 2; factor * factor <= prime; factor++) {
	            if (prime % factor === 0) {
	              isPrime = false;
	              break;
	            }
	          }
	          if (isPrime) {
	            if (i < 8) {
	              this._init[i] = frac(Math.pow(prime, 1 / 2));
	            }
	            this._key[i] = frac(Math.pow(prime, 1 / 3));
	            i++;
	          }
	        }
	      },
	
	      /**
	       * Perform one cycle of SHA-256.
	       * @param {Uint32Array|bitArray} w one block of words.
	       * @private
	       */
	      _block: function _block(w) {
	        var i,
	            tmp,
	            a,
	            b,
	            h = this._h,
	            k = this._key,
	            h0 = h[0],
	            h1 = h[1],
	            h2 = h[2],
	            h3 = h[3],
	            h4 = h[4],
	            h5 = h[5],
	            h6 = h[6],
	            h7 = h[7];
	
	        /* Rationale for placement of |0 :
	         * If a value can overflow is original 32 bits by a factor of more than a few
	         * million (2^23 ish), there is a possibility that it might overflow the
	         * 53-bit mantissa and lose precision.
	         *
	         * To avoid this, we clamp back to 32 bits by |'ing with 0 on any value that
	         * propagates around the loop, and on the hash state h[].  I don't believe
	         * that the clamps on h4 and on h0 are strictly necessary, but it's close
	         * (for h4 anyway), and better safe than sorry.
	         *
	         * The clamps on h[] are necessary for the output to be correct even in the
	         * common case and for short inputs.
	         */
	        for (i = 0; i < 64; i++) {
	          // load up the input word for this round
	          if (i < 16) {
	            tmp = w[i];
	          } else {
	            a = w[i + 1 & 15];
	            b = w[i + 14 & 15];
	            tmp = w[i & 15] = (a >>> 7 ^ a >>> 18 ^ a >>> 3 ^ a << 25 ^ a << 14) + (b >>> 17 ^ b >>> 19 ^ b >>> 10 ^ b << 15 ^ b << 13) + w[i & 15] + w[i + 9 & 15] | 0;
	          }
	
	          tmp = tmp + h7 + (h4 >>> 6 ^ h4 >>> 11 ^ h4 >>> 25 ^ h4 << 26 ^ h4 << 21 ^ h4 << 7) + (h6 ^ h4 & (h5 ^ h6)) + k[i]; // | 0;
	
	          // shift register
	          h7 = h6;h6 = h5;h5 = h4;
	          h4 = h3 + tmp | 0;
	          h3 = h2;h2 = h1;h1 = h0;
	
	          h0 = tmp + (h1 & h2 ^ h3 & (h1 ^ h2)) + (h1 >>> 2 ^ h1 >>> 13 ^ h1 >>> 22 ^ h1 << 30 ^ h1 << 19 ^ h1 << 10) | 0;
	        }
	
	        h[0] = h[0] + h0 | 0;
	        h[1] = h[1] + h1 | 0;
	        h[2] = h[2] + h2 | 0;
	        h[3] = h[3] + h3 | 0;
	        h[4] = h[4] + h4 | 0;
	        h[5] = h[5] + h5 | 0;
	        h[6] = h[6] + h6 | 0;
	        h[7] = h[7] + h7 | 0;
	      }
	    };
	
	    /** @fileOverview Random number generator.
	     *
	     * @author Emily Stark
	     * @author Mike Hamburg
	     * @author Dan Boneh
	     * @author Michael Brooks
	     * @author Steve Thomas
	     */
	
	    /** 
	     * @class Random number generator
	     * @description
	     * <b>Use sjcl.random as a singleton for this class!</b>
	     * <p>
	     * This random number generator is a derivative of Ferguson and Schneier's
	     * generator Fortuna.  It collects entropy from various events into several
	     * pools, implemented by streaming SHA-256 instances.  It differs from
	     * ordinary Fortuna in a few ways, though.
	     * </p>
	     *
	     * <p>
	     * Most importantly, it has an entropy estimator.  This is present because
	     * there is a strong conflict here between making the generator available
	     * as soon as possible, and making sure that it doesn't "run on empty".
	     * In Fortuna, there is a saved state file, and the system is likely to have
	     * time to warm up.
	     * </p>
	     *
	     * <p>
	     * Second, because users are unlikely to stay on the page for very long,
	     * and to speed startup time, the number of pools increases logarithmically:
	     * a new pool is created when the previous one is actually used for a reseed.
	     * This gives the same asymptotic guarantees as Fortuna, but gives more
	     * entropy to early reseeds.
	     * </p>
	     *
	     * <p>
	     * The entire mechanism here feels pretty klunky.  Furthermore, there are
	     * several improvements that should be made, including support for
	     * dedicated cryptographic functions that may be present in some browsers;
	     * state files in local storage; cookies containing randomness; etc.  So
	     * look for improvements in future versions.
	     * </p>
	     * @constructor
	     */
	    sjcl.prng = function (defaultParanoia) {
	
	      /* private */
	      this._pools = [new sjcl.hash.sha256()];
	      this._poolEntropy = [0];
	      this._reseedCount = 0;
	      this._robins = {};
	      this._eventId = 0;
	
	      this._collectorIds = {};
	      this._collectorIdNext = 0;
	
	      this._strength = 0;
	      this._poolStrength = 0;
	      this._nextReseed = 0;
	      this._key = [0, 0, 0, 0, 0, 0, 0, 0];
	      this._counter = [0, 0, 0, 0];
	      this._cipher = undefined;
	      this._defaultParanoia = defaultParanoia;
	
	      /* event listener stuff */
	      this._collectorsStarted = false;
	      this._callbacks = { progress: {}, seeded: {} };
	      this._callbackI = 0;
	
	      /* constants */
	      this._NOT_READY = 0;
	      this._READY = 1;
	      this._REQUIRES_RESEED = 2;
	
	      this._MAX_WORDS_PER_BURST = 65536;
	      this._PARANOIA_LEVELS = [0, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024];
	      this._MILLISECONDS_PER_RESEED = 30000;
	      this._BITS_PER_RESEED = 80;
	    };
	
	    sjcl.prng.prototype = {
	      /** Generate several random words, and return them in an array.
	       * A word consists of 32 bits (4 bytes)
	       * @param {Number} nwords The number of words to generate.
	       */
	      randomWords: function randomWords(nwords, paranoia) {
	        var out = [],
	            i,
	            readiness = this.isReady(paranoia),
	            g;
	
	        if (readiness === this._NOT_READY) {
	          throw new sjcl.exception.notReady("generator isn't seeded");
	        } else if (readiness & this._REQUIRES_RESEED) {
	          this._reseedFromPools(!(readiness & this._READY));
	        }
	
	        for (i = 0; i < nwords; i += 4) {
	          if ((i + 1) % this._MAX_WORDS_PER_BURST === 0) {
	            this._gate();
	          }
	
	          g = this._gen4words();
	          out.push(g[0], g[1], g[2], g[3]);
	        }
	        this._gate();
	
	        return out.slice(0, nwords);
	      },
	
	      setDefaultParanoia: function setDefaultParanoia(paranoia, allowZeroParanoia) {
	        if (paranoia === 0 && allowZeroParanoia !== "Setting paranoia=0 will ruin your security; use it only for testing") {
	          throw new sjcl.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");
	        }
	
	        this._defaultParanoia = paranoia;
	      },
	
	      /**
	       * Add entropy to the pools.
	       * @param data The entropic value.  Should be a 32-bit integer, array of 32-bit integers, or string
	       * @param {Number} estimatedEntropy The estimated entropy of data, in bits
	       * @param {String} source The source of the entropy, eg "mouse"
	       */
	      addEntropy: function addEntropy(data, estimatedEntropy, source) {
	        source = source || "user";
	
	        var id,
	            i,
	            tmp,
	            t = new Date().valueOf(),
	            robin = this._robins[source],
	            oldReady = this.isReady(),
	            err = 0,
	            objName;
	
	        id = this._collectorIds[source];
	        if (id === undefined) {
	          id = this._collectorIds[source] = this._collectorIdNext++;
	        }
	
	        if (robin === undefined) {
	          robin = this._robins[source] = 0;
	        }
	        this._robins[source] = (this._robins[source] + 1) % this._pools.length;
	
	        switch (typeof data === 'undefined' ? 'undefined' : _typeof(data)) {
	
	          case "number":
	            if (estimatedEntropy === undefined) {
	              estimatedEntropy = 1;
	            }
	            this._pools[robin].update([id, this._eventId++, 1, estimatedEntropy, t, 1, data | 0]);
	            break;
	
	          case "object":
	            objName = Object.prototype.toString.call(data);
	            if (objName === "[object Uint32Array]") {
	              tmp = [];
	              for (i = 0; i < data.length; i++) {
	                tmp.push(data[i]);
	              }
	              data = tmp;
	            } else {
	              if (objName !== "[object Array]") {
	                err = 1;
	              }
	              for (i = 0; i < data.length && !err; i++) {
	                if (typeof data[i] !== "number") {
	                  err = 1;
	                }
	              }
	            }
	            if (!err) {
	              if (estimatedEntropy === undefined) {
	                /* horrible entropy estimator */
	                estimatedEntropy = 0;
	                for (i = 0; i < data.length; i++) {
	                  tmp = data[i];
	                  while (tmp > 0) {
	                    estimatedEntropy++;
	                    tmp = tmp >>> 1;
	                  }
	                }
	              }
	              this._pools[robin].update([id, this._eventId++, 2, estimatedEntropy, t, data.length].concat(data));
	            }
	            break;
	
	          case "string":
	            if (estimatedEntropy === undefined) {
	              /* English text has just over 1 bit per character of entropy.
	               * But this might be HTML or something, and have far less
	               * entropy than English...  Oh well, let's just say one bit.
	               */
	              estimatedEntropy = data.length;
	            }
	            this._pools[robin].update([id, this._eventId++, 3, estimatedEntropy, t, data.length]);
	            this._pools[robin].update(data);
	            break;
	
	          default:
	            err = 1;
	        }
	        if (err) {
	          throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");
	        }
	
	        /* record the new strength */
	        this._poolEntropy[robin] += estimatedEntropy;
	        this._poolStrength += estimatedEntropy;
	
	        /* fire off events */
	        if (oldReady === this._NOT_READY) {
	          if (this.isReady() !== this._NOT_READY) {
	            this._fireEvent("seeded", Math.max(this._strength, this._poolStrength));
	          }
	          this._fireEvent("progress", this.getProgress());
	        }
	      },
	
	      /** Is the generator ready? */
	      isReady: function isReady(paranoia) {
	        var entropyRequired = this._PARANOIA_LEVELS[paranoia !== undefined ? paranoia : this._defaultParanoia];
	
	        if (this._strength && this._strength >= entropyRequired) {
	          return this._poolEntropy[0] > this._BITS_PER_RESEED && new Date().valueOf() > this._nextReseed ? this._REQUIRES_RESEED | this._READY : this._READY;
	        } else {
	          return this._poolStrength >= entropyRequired ? this._REQUIRES_RESEED | this._NOT_READY : this._NOT_READY;
	        }
	      },
	
	      /** Get the generator's progress toward readiness, as a fraction */
	      getProgress: function getProgress(paranoia) {
	        var entropyRequired = this._PARANOIA_LEVELS[paranoia ? paranoia : this._defaultParanoia];
	
	        if (this._strength >= entropyRequired) {
	          return 1.0;
	        } else {
	          return this._poolStrength > entropyRequired ? 1.0 : this._poolStrength / entropyRequired;
	        }
	      },
	
	      /** start the built-in entropy collectors */
	      startCollectors: function startCollectors() {
	        if (this._collectorsStarted) {
	          return;
	        }
	
	        this._eventListener = {
	          loadTimeCollector: this._bind(this._loadTimeCollector),
	          mouseCollector: this._bind(this._mouseCollector),
	          keyboardCollector: this._bind(this._keyboardCollector),
	          accelerometerCollector: this._bind(this._accelerometerCollector),
	          touchCollector: this._bind(this._touchCollector)
	        };
	
	        if (window.addEventListener) {
	          window.addEventListener("load", this._eventListener.loadTimeCollector, false);
	          window.addEventListener("mousemove", this._eventListener.mouseCollector, false);
	          window.addEventListener("keypress", this._eventListener.keyboardCollector, false);
	          window.addEventListener("devicemotion", this._eventListener.accelerometerCollector, false);
	          window.addEventListener("touchmove", this._eventListener.touchCollector, false);
	        } else if (document.attachEvent) {
	          document.attachEvent("onload", this._eventListener.loadTimeCollector);
	          document.attachEvent("onmousemove", this._eventListener.mouseCollector);
	          document.attachEvent("keypress", this._eventListener.keyboardCollector);
	        } else {
	          throw new sjcl.exception.bug("can't attach event");
	        }
	
	        this._collectorsStarted = true;
	      },
	
	      /** stop the built-in entropy collectors */
	      stopCollectors: function stopCollectors() {
	        if (!this._collectorsStarted) {
	          return;
	        }
	
	        if (window.removeEventListener) {
	          window.removeEventListener("load", this._eventListener.loadTimeCollector, false);
	          window.removeEventListener("mousemove", this._eventListener.mouseCollector, false);
	          window.removeEventListener("keypress", this._eventListener.keyboardCollector, false);
	          window.removeEventListener("devicemotion", this._eventListener.accelerometerCollector, false);
	          window.removeEventListener("touchmove", this._eventListener.touchCollector, false);
	        } else if (document.detachEvent) {
	          document.detachEvent("onload", this._eventListener.loadTimeCollector);
	          document.detachEvent("onmousemove", this._eventListener.mouseCollector);
	          document.detachEvent("keypress", this._eventListener.keyboardCollector);
	        }
	
	        this._collectorsStarted = false;
	      },
	
	      /* use a cookie to store entropy.
	      useCookie: function (all_cookies) {
	          throw new sjcl.exception.bug("random: useCookie is unimplemented");
	      },*/
	
	      /** add an event listener for progress or seeded-ness. */
	      addEventListener: function addEventListener(name, callback) {
	        this._callbacks[name][this._callbackI++] = callback;
	      },
	
	      /** remove an event listener for progress or seeded-ness */
	      removeEventListener: function removeEventListener(name, cb) {
	        var i,
	            j,
	            cbs = this._callbacks[name],
	            jsTemp = [];
	
	        /* I'm not sure if this is necessary; in C++, iterating over a
	         * collection and modifying it at the same time is a no-no.
	         */
	
	        for (j in cbs) {
	          if (cbs.hasOwnProperty(j) && cbs[j] === cb) {
	            jsTemp.push(j);
	          }
	        }
	
	        for (i = 0; i < jsTemp.length; i++) {
	          j = jsTemp[i];
	          delete cbs[j];
	        }
	      },
	
	      _bind: function _bind(func) {
	        var that = this;
	        return function () {
	          func.apply(that, arguments);
	        };
	      },
	
	      /** Generate 4 random words, no reseed, no gate.
	       * @private
	       */
	      _gen4words: function _gen4words() {
	        for (var i = 0; i < 4; i++) {
	          this._counter[i] = this._counter[i] + 1 | 0;
	          if (this._counter[i]) {
	            break;
	          }
	        }
	        return this._cipher.encrypt(this._counter);
	      },
	
	      /* Rekey the AES instance with itself after a request, or every _MAX_WORDS_PER_BURST words.
	       * @private
	       */
	      _gate: function _gate() {
	        this._key = this._gen4words().concat(this._gen4words());
	        this._cipher = new sjcl.cipher.aes(this._key);
	      },
	
	      /** Reseed the generator with the given words
	       * @private
	       */
	      _reseed: function _reseed(seedWords) {
	        this._key = sjcl.hash.sha256.hash(this._key.concat(seedWords));
	        this._cipher = new sjcl.cipher.aes(this._key);
	        for (var i = 0; i < 4; i++) {
	          this._counter[i] = this._counter[i] + 1 | 0;
	          if (this._counter[i]) {
	            break;
	          }
	        }
	      },
	
	      /** reseed the data from the entropy pools
	       * @param full If set, use all the entropy pools in the reseed.
	       */
	      _reseedFromPools: function _reseedFromPools(full) {
	        var reseedData = [],
	            strength = 0,
	            i;
	
	        this._nextReseed = reseedData[0] = new Date().valueOf() + this._MILLISECONDS_PER_RESEED;
	
	        for (i = 0; i < 16; i++) {
	          /* On some browsers, this is cryptographically random.  So we might
	           * as well toss it in the pot and stir...
	           */
	          reseedData.push(Math.random() * 0x100000000 | 0);
	        }
	
	        for (i = 0; i < this._pools.length; i++) {
	          reseedData = reseedData.concat(this._pools[i].finalize());
	          strength += this._poolEntropy[i];
	          this._poolEntropy[i] = 0;
	
	          if (!full && this._reseedCount & 1 << i) {
	            break;
	          }
	        }
	
	        /* if we used the last pool, push a new one onto the stack */
	        if (this._reseedCount >= 1 << this._pools.length) {
	          this._pools.push(new sjcl.hash.sha256());
	          this._poolEntropy.push(0);
	        }
	
	        /* how strong was this reseed? */
	        this._poolStrength -= strength;
	        if (strength > this._strength) {
	          this._strength = strength;
	        }
	
	        this._reseedCount++;
	        this._reseed(reseedData);
	      },
	
	      _keyboardCollector: function _keyboardCollector() {
	        this._addCurrentTimeToEntropy(1);
	      },
	
	      _mouseCollector: function _mouseCollector(ev) {
	        var x, y;
	
	        try {
	          x = ev.x || ev.clientX || ev.offsetX || 0;
	          y = ev.y || ev.clientY || ev.offsetY || 0;
	        } catch (err) {
	          // Event originated from a secure element. No mouse position available.
	          x = 0;
	          y = 0;
	        }
	
	        if (x != 0 && y != 0) {
	          this.addEntropy([x, y], 2, "mouse");
	        }
	
	        this._addCurrentTimeToEntropy(0);
	      },
	
	      _touchCollector: function _touchCollector(ev) {
	        var touch = ev.touches[0] || ev.changedTouches[0];
	        var x = touch.pageX || touch.clientX,
	            y = touch.pageY || touch.clientY;
	
	        this.addEntropy([x, y], 1, "touch");
	
	        this._addCurrentTimeToEntropy(0);
	      },
	
	      _loadTimeCollector: function _loadTimeCollector() {
	        this._addCurrentTimeToEntropy(2);
	      },
	
	      _addCurrentTimeToEntropy: function _addCurrentTimeToEntropy(estimatedEntropy) {
	        if (typeof window !== 'undefined' && window.performance && typeof window.performance.now === "function") {
	          //how much entropy do we want to add here?
	          this.addEntropy(window.performance.now(), estimatedEntropy, "loadtime");
	        } else {
	          this.addEntropy(new Date().valueOf(), estimatedEntropy, "loadtime");
	        }
	      },
	      _accelerometerCollector: function _accelerometerCollector(ev) {
	        var ac = ev.accelerationIncludingGravity.x || ev.accelerationIncludingGravity.y || ev.accelerationIncludingGravity.z;
	        if (window.orientation) {
	          var or = window.orientation;
	          if (typeof or === "number") {
	            this.addEntropy(or, 1, "accelerometer");
	          }
	        }
	        if (ac) {
	          this.addEntropy(ac, 2, "accelerometer");
	        }
	        this._addCurrentTimeToEntropy(0);
	      },
	
	      _fireEvent: function _fireEvent(name, arg) {
	        var j,
	            cbs = sjcl.random._callbacks[name],
	            cbsTemp = [];
	        /* TODO: there is a race condition between removing collectors and firing them */
	
	        /* I'm not sure if this is necessary; in C++, iterating over a
	         * collection and modifying it at the same time is a no-no.
	         */
	
	        for (j in cbs) {
	          if (cbs.hasOwnProperty(j)) {
	            cbsTemp.push(cbs[j]);
	          }
	        }
	
	        for (j = 0; j < cbsTemp.length; j++) {
	          cbsTemp[j](arg);
	        }
	      }
	    };
	
	    /** an instance for the prng.
	    * @see sjcl.prng
	    */
	    sjcl.random = new sjcl.prng(6);
	
	    (function () {
	      // function for getting nodejs crypto module. catches and ignores errors.
	      function getCryptoModule() {
	        try {
	          return __webpack_require__(209);
	        } catch (e) {
	          return null;
	        }
	      }
	
	      try {
	        var buf, crypt, ab;
	
	        // get cryptographically strong entropy depending on runtime environment
	        if (typeof module !== 'undefined' && module.exports && (crypt = getCryptoModule()) && crypt.randomBytes) {
	          buf = crypt.randomBytes(1024 / 8);
	          buf = new Uint32Array(new Uint8Array(buf).buffer);
	          sjcl.random.addEntropy(buf, 1024, "crypto.randomBytes");
	        } else if (typeof window !== 'undefined' && typeof Uint32Array !== 'undefined') {
	          ab = new Uint32Array(32);
	          if (window.crypto && window.crypto.getRandomValues) {
	            window.crypto.getRandomValues(ab);
	          } else if (window.msCrypto && window.msCrypto.getRandomValues) {
	            window.msCrypto.getRandomValues(ab);
	          } else {
	            return;
	          }
	
	          // get cryptographically strong entropy in Webkit
	          sjcl.random.addEntropy(ab, 1024, "crypto.getRandomValues");
	        } else {
	          // no getRandomValues :-(
	        }
	      } catch (e) {
	        if (typeof window !== 'undefined' && window.console) {
	          console.log("There was an error collecting entropy from the browser:");
	          console.log(e);
	          //we do not want the library to fail due to randomness not being maintained.
	        }
	      }
	    })();
	    /* global sjcl */
	    sjcl.codec.base58 = {
	      alpha: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
	      lookup: {
	        '1': 0,
	        '2': 1,
	        '3': 2,
	        '4': 3,
	        '5': 4,
	        '6': 5,
	        '7': 6,
	        '8': 7,
	        '9': 8,
	        A: 9,
	        B: 10,
	        C: 11,
	        D: 12,
	        E: 13,
	        F: 14,
	        G: 15,
	        H: 16,
	        J: 17,
	        K: 18,
	        L: 19,
	        M: 20,
	        N: 21,
	        P: 22,
	        Q: 23,
	        R: 24,
	        S: 25,
	        T: 26,
	        U: 27,
	        V: 28,
	        W: 29,
	        X: 30,
	        Y: 31,
	        Z: 32,
	        a: 33,
	        b: 34,
	        c: 35,
	        d: 36,
	        e: 37,
	        f: 38,
	        g: 39,
	        h: 40,
	        i: 41,
	        j: 42,
	        k: 43,
	        m: 44,
	        n: 45,
	        o: 46,
	        p: 47,
	        q: 48,
	        r: 49,
	        s: 50,
	        t: 51,
	        u: 52,
	        v: 53,
	        w: 54,
	        x: 55,
	        y: 56,
	        z: 57
	      },
	
	      toBits: function toBits(fromDigits) {
	        var work = new sjcl.bn();
	        var fb = new sjcl.bn(58);
	
	        for (var i = 0; i < fromDigits.length; i++) {
	          var digit = new sjcl.bn(sjcl.codec.base58.lookup[fromDigits[i]]);
	          work.addM(digit.mul(fb.power(fromDigits.length - i - 1)));
	        }
	
	        work.fullReduce();
	        return work.toBits();
	      },
	
	      fromBits: function fromBits(bits) {
	        var num = sjcl.bn.fromBits(bits);
	        var bitlen = sjcl.bitArray.bitLength(bits);
	        var len = Math.ceil(bitlen * (Math.log(2) / Math.log(58)));
	        var base = new sjcl.bn(58);
	        var str = '';
	
	        for (var i = len - 1; i >= 0; i--) {
	          var iBig = new sjcl.bn(i);
	          var exp = base.power(iBig);
	
	          var pos = 0;
	          while (num.greaterEquals(exp)) {
	            num.subM(exp);
	            num.normalize();
	            pos++;
	          }
	          if (!(i === len - 1 && pos === 0)) {
	            str += sjcl.codec.base58.alpha[pos];
	          }
	        }
	        return str;
	      }
	    };
	    /* global sjcl */
	
	    sjcl.codec.base58Check = {
	      defaultChecksumFn: function defaultChecksumFn(bits) {
	        return sjcl.bitArray.bitSlice(sjcl.hash.sha256.hash(sjcl.hash.sha256.hash(bits)), 0, 32);
	      },
	
	      fromBits: function fromBits(version, bits, checksumFn) {
	        checksumFn = checksumFn || sjcl.codec.base58Check.defaultChecksumFn;
	
	        var bitsWithHeader = sjcl.bitArray.concat([sjcl.bitArray.partial(8, version)], bits);
	        var checksum = checksumFn(bitsWithHeader);
	        var headerPayloadAndChecksum = sjcl.bitArray.concat(bitsWithHeader, checksum);
	        var base58str = sjcl.codec.base58.fromBits(headerPayloadAndChecksum);
	
	        var leadingZeroBits = 0;
	        while (sjcl.bitArray.extract(headerPayloadAndChecksum, leadingZeroBits, 8) == 0) {
	          base58str = '1' + base58str;
	          leadingZeroBits += 8;
	        }
	
	        return base58str;
	      },
	      toBits: function toBits(str, checksumFn) {
	        checksumFn = checksumFn || sjcl.codec.base58Check.defaultChecksumFn;
	
	        var bits = sjcl.codec.base58.toBits(str);
	        var bitlen = sjcl.bitArray.bitLength(bits);
	        //    var headerByte = sjcl.bitArray.extract(bits, 0, 8);
	        var payload = sjcl.bitArray.bitSlice(bits, 0, bitlen - 32);
	
	        var transmittedChecksum = sjcl.bitArray.bitSlice(bits, bitlen - 32);
	        var computedChecksum = checksumFn(payload);
	        if (!sjcl.bitArray.equal(computedChecksum, transmittedChecksum)) {
	          throw new Error('Checksums do not match');
	        }
	
	        return payload;
	      }
	    };
	    /* global sjcl */
	    sjcl.codec.steemit = {
	      ROLES: ['owner', 'memo', 'active', 'posting'],
	      MAINNET: {
	        pubHeader: 0x0,
	        privHeader: 0x80,
	        pubPrefix: 'STM'
	      },
	      TESTNET: {
	        pubHeader: 0x0,
	        privHeader: 0x80,
	        pubPrefix: 'TST'
	      },
	      keyChecksum: function keyChecksum(bits) {
	        return sjcl.bitArray.bitSlice(sjcl.hash.ripemd160.hash(bits), 0, 32);
	      },
	
	      keysFromPassword: function keysFromPassword(account, password) {
	        var keyPairs = {};
	        var CURVE = sjcl.ecc.curves.k256;
	        for (var i = 0; i < sjcl.codec.steemit.ROLES.length; i++) {
	          var role = sjcl.codec.steemit.ROLES[i];
	          var seed = account + role + password;
	          var secret = sjcl.bn.fromBits(sjcl.hash.sha256.hash(sjcl.codec.utf8String.toBits(seed)));
	          keyPairs[role] = sjcl.ecc.ecdsa.generateKeys(CURVE, 0, secret);
	        }
	        return keyPairs;
	      },
	
	      signRecoverably: function signRecoverably(sec, hash, paranoia, fixedKForTesting) {
	        /*
	         * an explanation of the format of the recovery parameter.
	         * given any ECDSA signature (r, s), there are 4 possible public keys that could have
	         * generated the signature over the hash. Two have odd Y-coordinates and two have
	         * even Y-coordinates. the recovery parameter deterministically identifies the public key
	         * that _did_ generate the signature.
	         *
	         * to get the public key given the recovery parameter, do the following:
	         * a. if the recovery parameter is between 27 and 31, subtract 27 and remember that the public
	         * key that produced the signature is canonically an "uncompressed" public key (i.e. known by
	         * its X and Y coordinates)
	         * b. If the recovery parameter is between 31 and 34, subtract 31 and remember that the public
	         * key that produced the signature is canonically a "compressed" public key (i.e. known by only
	         * its X coordinate).
	         *
	         * note that in the Steem blockchain, all public keys are canonically compressed and therefore the
	         * recovery parameter will always be between 31 and 34. therefore only case "b" applies here.
	         *
	         * after the subtraction, you will get a number between 0 and 4. this number, i, encodes the parity
	         * and "overflow" of the candidate public key among the four options.
	         *
	         * the lowest bit of i in binary notation indicates the parity of the candidate public key.
	         * if the lowest bit is set, the candidate public key's Y coordinate is odd. If it is cleared, the
	         * Y coordinate is even.
	         *
	         * The next-lowest bit of i, if set, indicates that the candidate public key's x was greater than
	         * the order of k. This is true of approximately 1 in 1^127 points on the secp256k1 curve.
	         * considering the rarity of this condition, it's much much simpler to just brute-force this
	         * condition when it occurs, following §4.1.6.
	         */
	
	        if (sjcl.bitArray.bitLength(hash) > this._curveBitLength) {
	          hash = sjcl.bitArray.clamp(hash, this._curveBitLength);
	        }
	
	        while (true) {
	
	          var CURVE = sjcl.ecc.curves.k256,
	              n = CURVE.r,
	              l = n.bitLength(),
	              k = fixedKForTesting || sjcl.bn.random(n.sub(1), paranoia).add(1),
	              R = CURVE.G.mult(k);
	
	          if (fixedKForTesting) {
	            fixedKForTesting = fixedKForTesting.add(1);
	          }
	
	          if (R.isIdentity) {
	            continue;
	          }
	
	          var r = R.x.mod(n),
	              ss = sjcl.bn.fromBits(hash).add(r.mul(sec._exponent)),
	              s = ss.mul(k.inverseMod(n)).mod(n),
	              isOdd = R.y.limbs[0] & 0x1 == 1,
	              recoveryParam = 31;
	
	          if (isOdd) {
	            recoveryParam++;
	          }
	
	          var rBitArray = r.toBits(l);
	          var sBitArray = s.toBits(l);
	
	          var r0 = sjcl.bitArray.extract(rBitArray, 0, 8);
	          var r1 = sjcl.bitArray.extract(rBitArray, 8, 8);
	          var s0 = sjcl.bitArray.extract(sBitArray, 0, 8);
	          var s1 = sjcl.bitArray.extract(sBitArray, 8, 8);
	
	          if (!(r0 & 0x80) && !(r0 == 0 && !(r1 & 0x80)) && !(s0 & 0x80) && !(s0 == 0 && !(s1 & 0x80))) {
	            var rawSig = sjcl.bitArray.concat(r.toBits(l), s.toBits(l));
	
	            return sjcl.bitArray.concat([sjcl.bitArray.partial(8, recoveryParam)], rawSig);
	          }
	        }
	      },
	
	      recoverPublicKey: function recoverPublicKey(hash, sig) {
	        var CURVE = sjcl.ecc.curves.k256;
	        var n = CURVE.r;
	        var G = CURVE.G;
	
	        var recoveryParameter = sjcl.bitArray.extract(sig, 0, 8) - 31;
	        var e = sjcl.bn.fromBits(hash);
	        var r = sjcl.bn.fromBits(sjcl.bitArray.bitSlice(sig, 8, 264));
	        var s = sjcl.bn.fromBits(sjcl.bitArray.bitSlice(sig, 264));
	
	        if (recoveryParameter < 0 || recoveryParameter > 4) {
	          throw new Error('Corrupt signature: recovery parameter is wrong');
	        }
	
	        var hasOddParity = (recoveryParameter & 0x1) === 1;
	
	        for (var j = 0; j <= 1; j++) {
	          var x = r.add(n.mul(j));
	
	          var y = sjcl.codec.steemit._yFromX(x, hasOddParity);
	          var p = new sjcl.ecc.point(CURVE, x, y);
	
	          var rInv = r.inverseMod(n);
	          var eNeg = new sjcl.bn(0).sub(e).mod(n);
	          var keyPoint = G.mult2(eNeg, s, p).mult(rInv);
	          var key = new sjcl.ecc.ecdsa.publicKey(CURVE, keyPoint);
	          try {
	            key.verify(hash, sjcl.bitArray.bitSlice(sig, 8));
	            return key;
	          } catch (_) {
	            // do nothing, wait for next j
	          }
	        }
	        throw new Error('public key was unrecoverable');
	      },
	
	      serializePublicKey: function serializePublicKey(key, net) {
	        net = net || sjcl.codec.steemit.MAINNET;
	
	        var point = key.get();
	        var header = net.pubHeader;
	
	        // the public key header sets 0x3 if X is odd, 0x2 if even
	        if (sjcl.bn.fromBits(point.y).limbs[0] & 0x1) {
	          header |= 0x3;
	        } else {
	          header |= 0x2;
	        }
	        return net.pubPrefix + sjcl.codec.base58Check.fromBits(header, point.x, sjcl.codec.steemit.keyChecksum);
	      },
	
	      deserializePublicKey: function deserializePublicKey(pubKey, net) {
	        net = net || sjcl.codec.steemit.MAINNET;
	        var CURVE = sjcl.ecc.curves.k256;
	
	        if (pubKey.indexOf(net.pubPrefix) !== 0) {
	          throw new Error('Public key is not in correct format, it should begin with "' + net.pubPrefix + '"');
	        }
	
	        var payload = sjcl.codec.base58Check.toBits(pubKey.slice(3), sjcl.codec.steemit.keyChecksum);
	        var headerByte = sjcl.bitArray.extract(payload, 0, 8);
	        var isOdd = headerByte == 0x3;
	        if ((headerByte & net.pubHeader) !== net.pubHeader) {
	          throw new Error('public key has invalid header');
	        } else if ((headerByte & 0x3) === 0 && (headerByte & 0x2) === 0) {
	          throw new Error('public key has invalid header: should set 0x2 or 0x3, but got 0x' + headerByte.toString(16));
	        }
	
	        var xBits = sjcl.bitArray.bitSlice(payload, 8);
	        var x = sjcl.bn.fromBits(xBits);
	        var y = sjcl.codec.steemit._yFromX(x, isOdd);
	
	        return new sjcl.ecc.ecdsa.publicKey(CURVE, new sjcl.ecc.point(CURVE, x, y));
	      },
	
	      serializePrivateKey: function serializePrivateKey(key, net) {
	        net = net || sjcl.codec.steemit.MAINNET;
	        return sjcl.codec.base58Check.fromBits(net.privHeader, key.get());
	      },
	
	      deserializePrivateKey: function deserializePrivateKey(wif, header) {
	        header = header || sjcl.codec.steemit.MAINNET.privHeader;
	        var curve = sjcl.ecc.curves.k256;
	        var payload = sjcl.codec.base58Check.toBits(wif);
	        var headerByte = sjcl.bitArray.extract(payload, 0, 8);
	        if (headerByte !== header) {
	          throw new Error('private key has invalid header: wanted 0x' + header.toString(16) + ', got 0x' + headerByte.toString(16));
	        }
	
	        var keyBits = sjcl.bitArray.bitSlice(payload, 8);
	        return new sjcl.ecc.ecdsa.secretKey(curve, sjcl.bn.fromBits(keyBits));
	      },
	
	      _yFromX: function _yFromX(x, shouldBeOdd) {
	        var CURVE = sjcl.ecc.curves.k256;
	        var PIDENT = sjcl.codec.steemit._getPident();
	
	        var alpha = x.powermod(3, CURVE.field.modulus).add(x.mulmod(CURVE.a, CURVE.field.modulus)).add(CURVE.b).mod(CURVE.field.modulus);
	
	        var y = alpha.powermod(PIDENT, CURVE.field.modulus);
	        var yIsOdd = y.mod(2).equals(1);
	
	        if (yIsOdd && shouldBeOdd || !yIsOdd && !shouldBeOdd) {
	          return y;
	        } else {
	          return CURVE.field.modulus.sub(y).normalize();
	        }
	      },
	
	      _getPident: function _getPident() {
	        if (!sjcl.codec.steemit.PIDENT) {
	          sjcl.codec.steemit.PIDENT = sjcl.ecc.curves.k256.field.modulus.add(1).normalize().halveM().halveM().normalize();
	        }
	        return sjcl.codec.steemit.PIDENT;
	      }
	    };
	
	    return sjcl;
	  }();
	
	  exports.sjcl = sjcl;
	
	  function PrivateKey(priv, pub) {
	    // we deliberately avoid exposing private key material on the instance.
	    // this is paranoid and probably doesn't protect against a determined
	    // attack, but why make things easy?
	    this.getPublicKey = function () {
	      if (!pub) {
	        pub = sjcl.ecc.ecdsa.generateKeys(sjcl.ecc.curves.k256, undefined, sjcl.bn.fromBits(priv.get())).pub;
	      }
	      return new PublicKey(pub);
	    };
	
	    this.sign = function (hash) {
	      return fromBits(sjcl.codec.steemit.signRecoverably(priv, toBits(hash)));
	    };
	  }
	
	  PrivateKey.from = function (wif, header) {
	    return new PrivateKey(sjcl.codec.steemit.deserializePrivateKey(wif, header));
	  };
	
	  function PublicKey(pub) {
	    this._p = pub;
	  }
	
	  PublicKey.from = function (str) {
	    return new PublicKey(sjcl.codec.steemit.deserializePublicKey(str));
	  };
	
	  PublicKey.recover = function (hash, sig) {
	    return new PublicKey(sjcl.codec.steemit.recoverPublicKey(toBits(hash), toBits(sig)));
	  };
	
	  PublicKey.prototype = {
	    toString: function toString() {
	      return sjcl.codec.steemit.serializePublicKey(this._p);
	    },
	    verify: function verify(hash, signature) {
	      try {
	        var rawSig = sjcl.bitArray.bitSlice(toBits(signature), 8);
	        this._p.verify(toBits(hash), rawSig);
	        return true;
	      } catch (_) {
	        return false;
	      }
	    }
	  };
	
	  function generateKeys() {
	    var k = sjcl.ecc.ecdsa.generateKeys(sjcl.ecc.curves.k256);
	    return serializePair(k);
	  }
	
	  function keysFromPassword(accountName, accountPassword) {
	    var keys = sjcl.codec.steemit.keysFromPassword(accountName, accountPassword);
	    return {
	      owner: serializePair(keys.owner),
	      memo: serializePair(keys.memo),
	      posting: serializePair(keys.posting),
	      active: serializePair(keys.active)
	    };
	  }
	
	  function sha256(data) {
	    return fromBits(sjcl.hash.sha256.hash(toBits(data)));
	  }
	
	  function ripemd160(data) {
	    return fromBits(sjcl.hash.ripemd160.hash(toBits(data)));
	  }
	
	  function hexify(data) {
	    var result = '';
	    var view = new Uint8Array(data);
	    for (var i = 0; i < view.byteLength; i++) {
	      if (view[i] < 16) {
	        result += '0';
	      }
	      result += view[i].toString(16);
	    }
	    return result;
	  }
	
	  function serializePair(k) {
	    return {
	      private: sjcl.codec.steemit.serializePrivateKey(k.sec),
	      public: sjcl.codec.steemit.serializePublicKey(k.pub)
	    };
	  }
	
	  function toBits(a) {
	    if (a instanceof ArrayBuffer) {
	      return sjcl.codec.arrayBuffer.toBits(a);
	    } else {
	      throw new Error('You must supply an ArrayBuffer');
	    }
	  }
	
	  function fromBits(a) {
	    return sjcl.codec.arrayBuffer.fromBits(a, 0, 0);
	  }
	});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var rng = __webpack_require__(210);
	
	function error() {
	  var m = [].slice.call(arguments).join(' ');
	  throw new Error([m, 'we accept pull requests', 'http://github.com/dominictarr/crypto-browserify'].join('\n'));
	}
	
	exports.createHash = __webpack_require__(212);
	
	exports.createHmac = __webpack_require__(221);
	
	exports.randomBytes = function (size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)));
	    } catch (err) {
	      callback(err);
	    }
	  } else {
	    return new Buffer(rng(size));
	  }
	};
	
	function each(a, f) {
	  for (var i in a) {
	    f(a[i], i);
	  }
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160'];
	};
	
	var p = __webpack_require__(222)(exports);
	exports.pbkdf2 = p.pbkdf2;
	exports.pbkdf2Sync = p.pbkdf2Sync;
	__webpack_require__(224)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials', 'createSign', 'createVerify', 'createDiffieHellman'], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet');
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {'use strict';
	
	(function () {
	  var g = ('undefined' === typeof window ? global : window) || {};
	  _crypto = g.crypto || g.msCrypto || __webpack_require__(211);
	  module.exports = function (size) {
	    // Modern Browsers
	    if (_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    } else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size);
	    } else throw new Error('secure random number generation not supported by this browser\n' + 'use chrome, FireFox or Internet Explorer 11');
	  };
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99).Buffer))

/***/ }),
/* 211 */
96,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var createHash = __webpack_require__(213);
	
	var md5 = toConstructor(__webpack_require__(218));
	var rmd160 = toConstructor(__webpack_require__(220));
	
	function toConstructor(fn) {
	  return function () {
	    var buffers = [];
	    var m = {
	      update: function update(data, enc) {
	        if (!Buffer.isBuffer(data)) data = new Buffer(data, enc);
	        buffers.push(data);
	        return this;
	      },
	      digest: function digest(enc) {
	        var buf = Buffer.concat(buffers);
	        var r = fn(buf);
	        buffers = null;
	        return enc ? r.toString(enc) : r;
	      }
	    };
	    return m;
	  };
	}
	
	module.exports = function (alg) {
	  if ('md5' === alg) return new md5();
	  if ('rmd160' === alg) return new rmd160();
	  return createHash(alg);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _exports = module.exports = function (alg) {
	  var Alg = _exports[alg];
	  if (!Alg) throw new Error(alg + ' is not supported (we accept pull requests)');
	  return new Alg();
	};
	
	var Buffer = __webpack_require__(122).Buffer;
	var Hash = __webpack_require__(214)(Buffer);
	
	_exports.sha1 = __webpack_require__(215)(Buffer, Hash);
	_exports.sha256 = __webpack_require__(216)(Buffer, Hash);
	_exports.sha512 = __webpack_require__(217)(Buffer, Hash);

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash(blockSize, finalSize) {
	    this._block = new Buffer(blockSize); //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize;
	    this._blockSize = blockSize;
	    this._len = 0;
	    this._s = 0;
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0;
	    this._len = 0;
	  };
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8";
	      data = new Buffer(data, enc);
	    }
	
	    var l = this._len += data.length;
	    var s = this._s = this._s || 0;
	    var f = 0;
	    var buffer = this._block;
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - s % this._blockSize);
	      var ch = t - f;
	
	      for (var i = 0; i < ch; i++) {
	        buffer[s % this._blockSize + i] = data[i + f];
	      }
	
	      s += ch;
	      f += ch;
	
	      if (s % this._blockSize === 0) {
	        this._update(buffer);
	      }
	    }
	    this._s = s;
	
	    return this;
	  };
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8;
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80;
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1);
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block);
	      this._block.fill(0);
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4);
	
	    var hash = this._update(this._block) || this._hash();
	
	    return enc ? hash.toString(enc) : hash;
	  };
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass');
	  };
	
	  return Hash;
	};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(106).inherits;
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0 | 0;
	  var B = 4 | 0;
	  var C = 8 | 0;
	  var D = 12 | 0;
	  var E = 16 | 0;
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80);
	
	  var POOL = [];
	
	  function Sha1() {
	    if (POOL.length) return POOL.pop().init();
	
	    if (!(this instanceof Sha1)) return new Sha1();
	    this._w = W;
	    Hash.call(this, 16 * 4, 14 * 4);
	
	    this._h = null;
	    this.init();
	  }
	
	  inherits(Sha1, Hash);
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301;
	    this._b = 0xefcdab89;
	    this._c = 0x98badcfe;
	    this._d = 0x10325476;
	    this._e = 0xc3d2e1f0;
	
	    Hash.prototype.init.call(this);
	    return this;
	  };
	
	  Sha1.prototype._POOL = POOL;
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e;
	
	    a = _a = this._a;
	    b = _b = this._b;
	    c = _c = this._c;
	    d = _d = this._d;
	    e = _e = this._e;
	
	    var w = this._w;
	
	    for (var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j * 4) : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
	
	      var t = add(add(rol(a, 5), sha1_ft(j, b, c, d)), add(add(e, W), sha1_kt(j)));
	
	      e = d;
	      d = c;
	      c = rol(b, 30);
	      b = a;
	      a = t;
	    }
	
	    this._a = add(a, _a);
	    this._b = add(b, _b);
	    this._c = add(c, _c);
	    this._d = add(d, _d);
	    this._e = add(e, _e);
	  };
	
	  Sha1.prototype._hash = function () {
	    if (POOL.length < 100) POOL.push(this);
	    var H = new Buffer(20);
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a | 0, A);
	    H.writeInt32BE(this._b | 0, B);
	    H.writeInt32BE(this._c | 0, C);
	    H.writeInt32BE(this._d | 0, D);
	    H.writeInt32BE(this._e | 0, E);
	    return H;
	  };
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if (t < 20) return b & c | ~b & d;
	    if (t < 40) return b ^ c ^ d;
	    if (t < 60) return b & c | b & d | c & d;
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return x + y | 0;
	    //lets see how this goes on testling.
	    //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	    //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	    //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return num << cnt | num >>> 32 - cnt;
	  }
	
	  return Sha1;
	};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(106).inherits;
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];
	
	  var W = new Array(64);
	
	  function Sha256() {
	    this.init();
	
	    this._w = W; //new Array(64)
	
	    Hash.call(this, 16 * 4, 14 * 4);
	  }
	
	  inherits(Sha256, Hash);
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667 | 0;
	    this._b = 0xbb67ae85 | 0;
	    this._c = 0x3c6ef372 | 0;
	    this._d = 0xa54ff53a | 0;
	    this._e = 0x510e527f | 0;
	    this._f = 0x9b05688c | 0;
	    this._g = 0x1f83d9ab | 0;
	    this._h = 0x5be0cd19 | 0;
	
	    this._len = this._s = 0;
	
	    return this;
	  };
	
	  function S(X, n) {
	    return X >>> n | X << 32 - n;
	  }
	
	  function R(X, n) {
	    return X >>> n;
	  }
	
	  function Ch(x, y, z) {
	    return x & y ^ ~x & z;
	  }
	
	  function Maj(x, y, z) {
	    return x & y ^ x & z ^ y & z;
	  }
	
	  function Sigma0256(x) {
	    return S(x, 2) ^ S(x, 13) ^ S(x, 22);
	  }
	
	  function Sigma1256(x) {
	    return S(x, 6) ^ S(x, 11) ^ S(x, 25);
	  }
	
	  function Gamma0256(x) {
	    return S(x, 7) ^ S(x, 18) ^ R(x, 3);
	  }
	
	  function Gamma1256(x) {
	    return S(x, 17) ^ S(x, 19) ^ R(x, 10);
	  }
	
	  Sha256.prototype._update = function (M) {
	
	    var W = this._w;
	    var a, b, c, d, e, f, g, h;
	    var T1, T2;
	
	    a = this._a | 0;
	    b = this._b | 0;
	    c = this._c | 0;
	    d = this._d | 0;
	    e = this._e | 0;
	    f = this._f | 0;
	    g = this._g | 0;
	    h = this._h | 0;
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16 ? M.readInt32BE(j * 4) : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16];
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w;
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g;g = f;f = e;e = d + T1;d = c;c = b;b = a;a = T1 + T2;
	    }
	
	    this._a = a + this._a | 0;
	    this._b = b + this._b | 0;
	    this._c = c + this._c | 0;
	    this._d = d + this._d | 0;
	    this._e = e + this._e | 0;
	    this._f = f + this._f | 0;
	    this._g = g + this._g | 0;
	    this._h = h + this._h | 0;
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32);
	
	    H.writeInt32BE(this._a, 0);
	    H.writeInt32BE(this._b, 4);
	    H.writeInt32BE(this._c, 8);
	    H.writeInt32BE(this._d, 12);
	    H.writeInt32BE(this._e, 16);
	    H.writeInt32BE(this._f, 20);
	    H.writeInt32BE(this._g, 24);
	    H.writeInt32BE(this._h, 28);
	
	    return H;
	  };
	
	  return Sha256;
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(106).inherits;
	
	module.exports = function (Buffer, Hash) {
	  var K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
	
	  var W = new Array(160);
	
	  function Sha512() {
	    this.init();
	    this._w = W;
	
	    Hash.call(this, 128, 112);
	  }
	
	  inherits(Sha512, Hash);
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667 | 0;
	    this._b = 0xbb67ae85 | 0;
	    this._c = 0x3c6ef372 | 0;
	    this._d = 0xa54ff53a | 0;
	    this._e = 0x510e527f | 0;
	    this._f = 0x9b05688c | 0;
	    this._g = 0x1f83d9ab | 0;
	    this._h = 0x5be0cd19 | 0;
	
	    this._al = 0xf3bcc908 | 0;
	    this._bl = 0x84caa73b | 0;
	    this._cl = 0xfe94f82b | 0;
	    this._dl = 0x5f1d36f1 | 0;
	    this._el = 0xade682d1 | 0;
	    this._fl = 0x2b3e6c1f | 0;
	    this._gl = 0xfb41bd6b | 0;
	    this._hl = 0x137e2179 | 0;
	
	    this._len = this._s = 0;
	
	    return this;
	  };
	
	  function S(X, Xl, n) {
	    return X >>> n | Xl << 32 - n;
	  }
	
	  function Ch(x, y, z) {
	    return x & y ^ ~x & z;
	  }
	
	  function Maj(x, y, z) {
	    return x & y ^ x & z ^ y & z;
	  }
	
	  Sha512.prototype._update = function (M) {
	
	    var W = this._w;
	    var a, b, c, d, e, f, g, h;
	    var al, bl, cl, dl, el, fl, gl, hl;
	
	    a = this._a | 0;
	    b = this._b | 0;
	    c = this._c | 0;
	    d = this._d | 0;
	    e = this._e | 0;
	    f = this._f | 0;
	    g = this._g | 0;
	    h = this._h | 0;
	
	    al = this._al | 0;
	    bl = this._bl | 0;
	    cl = this._cl | 0;
	    dl = this._dl | 0;
	    el = this._el | 0;
	    fl = this._fl | 0;
	    gl = this._gl | 0;
	    hl = this._hl | 0;
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2;
	
	      var Wi, Wil;
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4);
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4);
	      } else {
	        var x = W[j - 15 * 2];
	        var xl = W[j - 15 * 2 + 1];
	        var gamma0 = S(x, xl, 1) ^ S(x, xl, 8) ^ x >>> 7;
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7);
	
	        x = W[j - 2 * 2];
	        xl = W[j - 2 * 2 + 1];
	        var gamma1 = S(x, xl, 19) ^ S(xl, x, 29) ^ x >>> 6;
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6);
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7 = W[j - 7 * 2];
	        var Wi7l = W[j - 7 * 2 + 1];
	
	        var Wi16 = W[j - 16 * 2];
	        var Wi16l = W[j - 16 * 2 + 1];
	
	        Wil = gamma0l + Wi7l;
	        Wi = gamma0 + Wi7 + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
	        Wil = Wil + gamma1l;
	        Wi = Wi + gamma1 + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
	        Wil = Wil + Wi16l;
	        Wi = Wi + Wi16 + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
	
	        W[j] = Wi;
	        W[j + 1] = Wil;
	      }
	
	      var maj = Maj(a, b, c);
	      var majl = Maj(al, bl, cl);
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7);
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7);
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9);
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9);
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j];
	      var Kil = K[j + 1];
	
	      var ch = Ch(e, f, g);
	      var chl = Ch(el, fl, gl);
	
	      var t1l = hl + sigma1l;
	      var t1 = h + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
	      t1l = t1l + chl;
	      t1 = t1 + ch + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
	      t1l = t1l + Kil;
	      t1 = t1 + Ki + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
	      t1l = t1l + Wil;
	      t1 = t1 + Wi + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl;
	      var t2 = sigma0h + maj + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
	
	      h = g;
	      hl = gl;
	      g = f;
	      gl = fl;
	      f = e;
	      fl = el;
	      el = dl + t1l | 0;
	      e = d + t1 + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
	      d = c;
	      dl = cl;
	      c = b;
	      cl = bl;
	      b = a;
	      bl = al;
	      al = t1l + t2l | 0;
	      a = t1 + t2 + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
	    }
	
	    this._al = this._al + al | 0;
	    this._bl = this._bl + bl | 0;
	    this._cl = this._cl + cl | 0;
	    this._dl = this._dl + dl | 0;
	    this._el = this._el + el | 0;
	    this._fl = this._fl + fl | 0;
	    this._gl = this._gl + gl | 0;
	    this._hl = this._hl + hl | 0;
	
	    this._a = this._a + a + (this._al >>> 0 < al >>> 0 ? 1 : 0) | 0;
	    this._b = this._b + b + (this._bl >>> 0 < bl >>> 0 ? 1 : 0) | 0;
	    this._c = this._c + c + (this._cl >>> 0 < cl >>> 0 ? 1 : 0) | 0;
	    this._d = this._d + d + (this._dl >>> 0 < dl >>> 0 ? 1 : 0) | 0;
	    this._e = this._e + e + (this._el >>> 0 < el >>> 0 ? 1 : 0) | 0;
	    this._f = this._f + f + (this._fl >>> 0 < fl >>> 0 ? 1 : 0) | 0;
	    this._g = this._g + g + (this._gl >>> 0 < gl >>> 0 ? 1 : 0) | 0;
	    this._h = this._h + h + (this._hl >>> 0 < hl >>> 0 ? 1 : 0) | 0;
	  };
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64);
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset);
	      H.writeInt32BE(l, offset + 4);
	    }
	
	    writeInt64BE(this._a, this._al, 0);
	    writeInt64BE(this._b, this._bl, 8);
	    writeInt64BE(this._c, this._cl, 16);
	    writeInt64BE(this._d, this._dl, 24);
	    writeInt64BE(this._e, this._el, 32);
	    writeInt64BE(this._f, this._fl, 40);
	    writeInt64BE(this._g, this._gl, 48);
	    writeInt64BE(this._h, this._hl, 56);
	
	    return H;
	  };
	
	  return Sha512;
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(219);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (var i = 0; i < x.length; i += 16) {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
	    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
	    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t) {
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	}
	function md5_ff(a, b, c, d, x, s, t) {
	  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t) {
	  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t) {
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t) {
	  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y) {
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xFFFF;
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var intSize = 4;
	var zeroBuffer = new Buffer(intSize);zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if (buf.length % intSize !== 0) {
	    var len = buf.length + (intSize - buf.length % intSize);
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = ripemd160;
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
	var zr = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
	var sl = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
	var sr = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
	
	var hl = [0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr = [0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function bytesToWords(bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << 24 - b % 32;
	  }
	  return words;
	};
	
	var wordsToBytes = function wordsToBytes(words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function processBlock(H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = al + M[offset + zl[i]] | 0;
	    if (i < 16) {
	      t += f1(bl, cl, dl) + hl[0];
	    } else if (i < 32) {
	      t += f2(bl, cl, dl) + hl[1];
	    } else if (i < 48) {
	      t += f3(bl, cl, dl) + hl[2];
	    } else if (i < 64) {
	      t += f4(bl, cl, dl) + hl[3];
	    } else {
	      // if (i<80) {
	      t += f5(bl, cl, dl) + hl[4];
	    }
	    t = t | 0;
	    t = rotl(t, sl[i]);
	    t = t + el | 0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = ar + M[offset + zr[i]] | 0;
	    if (i < 16) {
	      t += f5(br, cr, dr) + hr[0];
	    } else if (i < 32) {
	      t += f4(br, cr, dr) + hr[1];
	    } else if (i < 48) {
	      t += f3(br, cr, dr) + hr[2];
	    } else if (i < 64) {
	      t += f2(br, cr, dr) + hr[3];
	    } else {
	      // if (i<80) {
	      t += f1(br, cr, dr) + hr[4];
	    }
	    t = t | 0;
	    t = rotl(t, sr[i]);
	    t = t + er | 0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t = H[1] + cl + dr | 0;
	  H[1] = H[2] + dl + er | 0;
	  H[2] = H[3] + el + ar | 0;
	  H[3] = H[4] + al + br | 0;
	  H[4] = H[0] + bl + cr | 0;
	  H[0] = t;
	};
	
	function f1(x, y, z) {
	  return x ^ y ^ z;
	}
	
	function f2(x, y, z) {
	  return x & y | ~x & z;
	}
	
	function f3(x, y, z) {
	  return (x | ~y) ^ z;
	}
	
	function f4(x, y, z) {
	  return x & z | y & ~z;
	}
	
	function f5(x, y, z) {
	  return x ^ (y | ~z);
	}
	
	function rotl(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string') message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
	  m[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
	
	  for (var i = 0; i < m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	    // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var createHash = __webpack_require__(212);
	
	var zeroBuffer = new Buffer(128);
	zeroBuffer.fill(0);
	
	module.exports = Hmac;
	
	function Hmac(alg, key) {
	  if (!(this instanceof Hmac)) return new Hmac(alg, key);
	  this._opad = opad;
	  this._alg = alg;
	
	  var blocksize = alg === 'sha512' ? 128 : 64;
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key;
	
	  if (key.length > blocksize) {
	    key = createHash(alg).update(key).digest();
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize);
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize);
	  var opad = this._opad = new Buffer(blocksize);
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36;
	    opad[i] = key[i] ^ 0x5C;
	  }
	
	  this._hash = createHash(alg).update(ipad);
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc);
	  return this;
	};
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest();
	  return createHash(this._alg).update(this._opad).update(h).digest(enc);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pbkdf2Export = __webpack_require__(223);
	
	module.exports = function (crypto, exports) {
	  exports = exports || {};
	
	  var exported = pbkdf2Export(crypto);
	
	  exports.pbkdf2 = exported.pbkdf2;
	  exports.pbkdf2Sync = exported.pbkdf2Sync;
	
	  return exports;
	};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = function (crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest;
	      digest = undefined;
	    }
	
	    if ('function' !== typeof callback) throw new Error('No callback provided to pbkdf2');
	
	    setTimeout(function () {
	      var result;
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest);
	      } catch (e) {
	        return callback(e);
	      }
	
	      callback(undefined, result);
	    });
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations) throw new TypeError('Iterations not a number');
	
	    if (iterations < 0) throw new TypeError('Bad iterations');
	
	    if ('number' !== typeof keylen) throw new TypeError('Key length not a number');
	
	    if (keylen < 0) throw new TypeError('Bad key length');
	
	    digest = digest || 'sha1';
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password);
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt);
	
	    var hLen,
	        l = 1,
	        r,
	        T;
	    var DK = new Buffer(keylen);
	    var block1 = new Buffer(salt.length + 4);
	    salt.copy(block1, 0, 0, salt.length);
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length);
	
	      var U = crypto.createHmac(digest, password).update(block1).digest();
	
	      if (!hLen) {
	        hLen = U.length;
	        T = new Buffer(hLen);
	        l = Math.ceil(keylen / hLen);
	        r = keylen - (l - 1) * hLen;
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen) throw new TypeError('keylen exceeds maximum length');
	      }
	
	      U.copy(T, 0, 0, hLen);
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest();
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k];
	        }
	      }
	
	      var destPos = (i - 1) * hLen;
	      var len = i == l ? r : hLen;
	      T.copy(DK, destPos, 0, len);
	    }
	
	    return DK;
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(225)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(237)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(228);
	  function listCiphers() {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var aes = __webpack_require__(226);
	var Transform = __webpack_require__(227);
	var inherits = __webpack_require__(111);
	var modes = __webpack_require__(228);
	var ebtk = __webpack_require__(229);
	var StreamCipher = __webpack_require__(230);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while (chunk = this._cache.get()) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	function Splitter() {
	  if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(231),
	  CBC: __webpack_require__(232),
	  CFB: __webpack_require__(234),
	  OFB: __webpack_require__(235),
	  CTR: __webpack_require__(236)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key / 8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher(suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	  var ret, x_pos;
	  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	  return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = function () {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  }();
	  this.INV_SUB_MIX = function () {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  }();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function () {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = function () {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push(i << 1 ^ 0x11b);
	      }
	    }
	    return _results;
	  }();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
	    sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = d[sx] * 0x101 ^ sx * 0x1010100;
	    this.SUB_MIX[0][x] = t << 24 | t >>> 8;
	    this.SUB_MIX[1][x] = t << 16 | t >>> 16;
	    this.SUB_MIX[2][x] = t << 8 | t >>> 24;
	    this.SUB_MIX[3][x] = t;
	    t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	    this.INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
	    this.INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
	    this.INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	function bufferToArray(buf) {
	  var len = buf.length / 4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	}
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function () {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], ksRow % keySize === 0 ? (t = t << 8 | t >>> 24, t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff], t ^= G.RCON[ksRow / keySize | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[t >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[t >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function (M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function (M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function () {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function (M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][s1 >>> 16 & 0xff] ^ SUB_MIX[2][s2 >>> 8 & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][s2 >>> 16 & 0xff] ^ SUB_MIX[2][s3 >>> 8 & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][s3 >>> 16 & 0xff] ^ SUB_MIX[2][s0 >>> 8 & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][s0 >>> 16 & 0xff] ^ SUB_MIX[2][s1 >>> 8 & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [fixup_uint32(t0), fixup_uint32(t1), fixup_uint32(t2), fixup_uint32(t3)];
	};
	
	exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var Transform = __webpack_require__(116).Transform;
	var inherits = __webpack_require__(111);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while (chunk = this.read()) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while (chunk = this.read()) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen / 8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if (addmd++ > 0) {
	      md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if (keyLen > 0) {
	      while (true) {
	        if (keyLen === 0) {
	          break;
	        }
	        if (i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	      }
	    }
	    if (ivLen > 0 && i !== md_buf.length) {
	      while (true) {
	        if (ivLen === 0) {
	          break;
	        }
	        if (i === md_buf.length) {
	          break;
	        }
	        iv[ii++] = md_buf[i];
	        ivLen--;
	        i++;
	      }
	    }
	    if (keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for (i = 0; i < md_buf.length; i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var aes = __webpack_require__(226);
	var Transform = __webpack_require__(227);
	var inherits = __webpack_require__(111);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xor = __webpack_require__(233);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var xor = __webpack_require__(233);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt ? data : out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var xor = __webpack_require__(233);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var xor = __webpack_require__(233);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var aes = __webpack_require__(226);
	var Transform = __webpack_require__(227);
	var inherits = __webpack_require__(111);
	var modes = __webpack_require__(228);
	var StreamCipher = __webpack_require__(230);
	var ebtk = __webpack_require__(229);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while (chunk = this._cache.get()) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	  if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(231),
	  CBC: __webpack_require__(232),
	  CFB: __webpack_require__(234),
	  OFB: __webpack_require__(235),
	  CTR: __webpack_require__(236)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key / 8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher(suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var bigi = __webpack_require__(179),
	    bs58 = __webpack_require__(149),
	    ecurve = __webpack_require__(183),
	    Point = ecurve.Point,
	    secp256k1 = ecurve.getCurveByName('secp256k1'),
	    config = __webpack_require__(42),
	    operations = __webpack_require__(203),
	    Signature = __webpack_require__(189),
	    KeyPrivate = __webpack_require__(188),
	    PublicKey = __webpack_require__(178),
	    hash = __webpack_require__(109);
	
	var Auth = {};
	var transaction = operations.transaction;
	var signed_transaction = operations.signed_transaction;
	
	Auth.verify = function (name, password, auths) {
		var hasKey = false;
		var roles = [];
		for (var role in auths) {
			roles.push(role);
		}
		var pubKeys = this.generateKeys(name, password, roles);
		roles.forEach(function (role) {
			if (auths[role][0][0] === pubKeys[role]) {
				hasKey = true;
			}
		});
		return hasKey;
	};
	
	Auth.generateKeys = function (name, password, roles) {
		var pubKeys = {};
		roles.forEach(function (role) {
			var seed = name + role + password;
			var brainKey = seed.trim().split(/[\t\n\v\f\r ]+/).join(' ');
			var hashSha256 = hash.sha256(brainKey);
			var bigInt = bigi.fromBuffer(hashSha256);
			var toPubKey = secp256k1.G.multiply(bigInt);
			var point = new Point(toPubKey.curve, toPubKey.x, toPubKey.y, toPubKey.z);
			var pubBuf = point.getEncoded(toPubKey.compressed);
			var checksum = hash.ripemd160(pubBuf);
			var addy = Buffer.concat([pubBuf, checksum.slice(0, 4)]);
			pubKeys[role] = config.get('address_prefix') + bs58.encode(addy);
		});
		return pubKeys;
	};
	
	/**
		@arg {string} name - blockchain account name
		@arg {string} password - very strong password typically no shorter than a private key
		@arg {array} roles - defaults to standard Hive blockchain-level roles
	*/
	Auth.getPrivateKeys = function (name, password) {
		var roles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['owner', 'active', 'posting', 'memo'];
	
		var privKeys = {};
		roles.forEach(function (role) {
			privKeys[role] = this.toWif(name, password, role);
			privKeys[role + 'Pubkey'] = this.wifToPublic(privKeys[role]);
		}.bind(this));
		return privKeys;
	};
	
	Auth.isWif = function (privWif) {
		var isWif = false;
		try {
			var bufWif = new Buffer(bs58.decode(privWif));
			var privKey = bufWif.slice(0, -4);
			var checksum = bufWif.slice(-4);
			var newChecksum = hash.sha256(privKey);
			newChecksum = hash.sha256(newChecksum);
			newChecksum = newChecksum.slice(0, 4);
			if (checksum.toString() == newChecksum.toString()) {
				isWif = true;
			}
		} catch (e) {}
		return isWif;
	};
	
	Auth.toWif = function (name, password, role) {
		var seed = name + role + password;
		var brainKey = seed.trim().split(/[\t\n\v\f\r ]+/).join(' ');
		var hashSha256 = hash.sha256(brainKey);
		var privKey = Buffer.concat([new Buffer([0x80]), hashSha256]);
		var checksum = hash.sha256(privKey);
		checksum = hash.sha256(checksum);
		checksum = checksum.slice(0, 4);
		var privWif = Buffer.concat([privKey, checksum]);
		return bs58.encode(privWif);
	};
	
	Auth.wifIsValid = function (privWif, pubWif) {
		return this.wifToPublic(privWif) == pubWif;
	};
	
	Auth.wifToPublic = function (privWif) {
		var pubWif = KeyPrivate.fromWif(privWif);
		pubWif = pubWif.toPublic().toString();
		return pubWif;
	};
	
	Auth.isPubkey = function (pubkey, address_prefix) {
		return PublicKey.fromString(pubkey, address_prefix) != null;
	};
	
	Auth.signTransaction = function (trx, keys) {
		var signatures = [];
		if (trx.signatures) {
			signatures = [].concat(trx.signatures);
		}
	
		var cid = new Buffer(config.get('chain_id'), 'hex');
		var buf = transaction.toBuffer(trx);
	
		for (var key in keys) {
			var sig = Signature.signBuffer(Buffer.concat([cid, buf]), keys[key]);
			signatures.push(sig.toBuffer());
		}
	
		return signed_transaction.toObject(Object.assign(trx, { signatures: signatures }));
	};
	
	module.exports = Auth;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.decode = decode;
	exports.encode = encode;
	exports.getPubKeys = getPubKeys;
	
	var _bytebuffer = __webpack_require__(154);
	
	var _bytebuffer2 = _interopRequireDefault(_bytebuffer);
	
	var _assert = __webpack_require__(105);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _bs = __webpack_require__(149);
	
	var _bs2 = _interopRequireDefault(_bs);
	
	var _ecc = __webpack_require__(103);
	
	var _serializer = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encMemo = _serializer.ops.encrypted_memo;
	
	/**
	    Some fields are only required if the memo is marked for decryption (starts with a hash).
	    @arg {string|PrivateKey} private_key - WIF or PrivateKey object
	    @arg {string} memo - plain text is returned, hash prefix base58 is decrypted
	    @return {string} - utf8 decoded string (hash prefix)
	*/
	function decode(private_key, memo) {
	    (0, _assert2.default)(memo, 'memo is required');
	    _assert2.default.equal(typeof memo === 'undefined' ? 'undefined' : _typeof(memo), 'string', 'memo');
	    if (!/^#/.test(memo)) return memo;
	    memo = memo.substring(1);
	
	    (0, _assert2.default)(private_key, 'private_key is required');
	    checkEncryption();
	
	    private_key = toPrivateObj(private_key);
	
	    memo = _bs2.default.decode(memo);
	    memo = encMemo.fromBuffer(new Buffer(memo, 'binary'));
	
	    var _memo = memo,
	        from = _memo.from,
	        to = _memo.to,
	        nonce = _memo.nonce,
	        check = _memo.check,
	        encrypted = _memo.encrypted;
	
	    var pubkey = private_key.toPublicKey().toString();
	    var otherpub = pubkey === from.toString() ? to.toString() : from.toString();
	    memo = _ecc.Aes.decrypt(private_key, otherpub, nonce, encrypted, check);
	
	    // remove varint length prefix
	    var mbuf = _bytebuffer2.default.fromBinary(memo.toString('binary'), _bytebuffer2.default.DEFAULT_CAPACITY, _bytebuffer2.default.LITTLE_ENDIAN);
	    try {
	        mbuf.mark();
	        return '#' + mbuf.readVString();
	    } catch (e) {
	        mbuf.reset();
	        // Sender did not length-prefix the memo
	        memo = new Buffer(mbuf.toString('binary'), 'binary').toString('utf-8');
	        return '#' + memo;
	    }
	}
	
	/**
	    Some fields are only required if the memo is marked for encryption (starts with a hash).
	    @arg {string|PrivateKey} private_key - WIF or PrivateKey object
	    @arg {string|PublicKey} public_key - Recipient
	    @arg {string} memo - plain text is returned, hash prefix text is encrypted
	    @arg {string} [testNonce = undefined] - just for testing
	    @return {string} - base64 decoded string (or plain text)
	*/
	function encode(private_key, public_key, memo, testNonce) {
	    (0, _assert2.default)(memo, 'memo is required');
	    _assert2.default.equal(typeof memo === 'undefined' ? 'undefined' : _typeof(memo), 'string', 'memo');
	    if (!/^#/.test(memo)) return memo;
	    memo = memo.substring(1);
	
	    (0, _assert2.default)(private_key, 'private_key is required');
	    (0, _assert2.default)(public_key, 'public_key is required');
	    checkEncryption();
	
	    private_key = toPrivateObj(private_key);
	    public_key = toPublicObj(public_key);
	
	    var mbuf = new _bytebuffer2.default(_bytebuffer2.default.DEFAULT_CAPACITY, _bytebuffer2.default.LITTLE_ENDIAN);
	    mbuf.writeVString(memo);
	    memo = new Buffer(mbuf.copy(0, mbuf.offset).toBinary(), 'binary');
	
	    var _Aes$encrypt = _ecc.Aes.encrypt(private_key, public_key, memo, testNonce),
	        nonce = _Aes$encrypt.nonce,
	        message = _Aes$encrypt.message,
	        checksum = _Aes$encrypt.checksum;
	
	    memo = encMemo.fromObject({
	        from: private_key.toPublicKey(),
	        to: public_key,
	        nonce: nonce,
	        check: checksum,
	        encrypted: message
	    });
	    // serialize
	    memo = encMemo.toBuffer(memo);
	    return '#' + _bs2.default.encode(new Buffer(memo, 'binary'));
	}
	
	/** Get public keys of both sender and receiver */
	function getPubKeys(memo) {
	    (0, _assert2.default)(memo, 'memo is required');
	    _assert2.default.equal(typeof memo === 'undefined' ? 'undefined' : _typeof(memo), 'string', 'memo');
	    if (!/^#/.test(memo)) return [];
	    memo = memo.substring(1);
	
	    checkEncryption();
	
	    memo = _bs2.default.decode(memo);
	    memo = encMemo.fromBuffer(new Buffer(memo, 'binary'));
	
	    var _memo2 = memo,
	        from = _memo2.from,
	        to = _memo2.to;
	
	
	    return [from.toString(), to.toString()];
	}
	
	var encodeTest = undefined;
	
	/**
	  Memo encryption has failed in the browser before.  An Error will be thrown
	  if a memo can't be encrypted and decrypted.
	*/
	function checkEncryption() {
	    if (encodeTest === undefined) {
	        var plaintext = void 0;
	        encodeTest = true; // prevent infinate looping
	        try {
	            var wif = '5JdeC9P7Pbd1uGdFVEsJ41EkEnADbbHGq6p1BwFxm6txNBsQnsw';
	            var pubkey = 'STM8m5UgaFAAYQRuaNejYdS8FVLVp9Ss3K1qAVk5de6F8s3HnVbvA';
	            var cyphertext = encode(wif, pubkey, '#memo爱');
	            plaintext = decode(wif, cyphertext);
	        } catch (e) {
	            console.error(e);
	        } finally {
	            encodeTest = plaintext === '#memo爱';
	        }
	    }
	    if (encodeTest === false) throw new Error('This environment does not support encryption.');
	}
	
	var toPrivateObj = function toPrivateObj(o) {
	    return o ? o.d ? o : _ecc.PrivateKey.fromWif(o) : o /*null or undefined*/;
	};
	var toPublicObj = function toPublicObj(o) {
	    return o ? o.Q ? o : _ecc.PublicKey.fromString(o) : o /*null or undefined*/;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _bluebird = __webpack_require__(3);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _debug = __webpack_require__(87);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _helpers = __webpack_require__(241);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _formatter = __webpack_require__(242);
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _auth = __webpack_require__(238);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _utils = __webpack_require__(97);
	
	var _operations = __webpack_require__(203);
	
	var _ecc = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var operations = __webpack_require__(285);
	var config = __webpack_require__(42);
	
	var debug = (0, _debug2.default)('hive:broadcast');
	var noop = function noop() {};
	var formatter = (0, _formatter2.default)(_api2.default);
	
	function getTransactionStatus(trxId, expiration) {
	  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
	
	  return new _bluebird2.default(function (resolve, reject) {
	    setTimeout(function () {
	      _api2.default.findTransactionAsync(trxId, expiration).then(function (res) {
	        resolve(res);
	      });
	    }, time);
	  });
	}
	
	var hiveBroadcast = {};
	
	// Base transaction logic -----------------------------------------------------
	
	/**
	 * Sign and broadcast transactions on the hive network
	 */
	
	hiveBroadcast.send = function hiveBroadcast$send(tx, privKeys, callback) {
	  var trxId = void 0;
	  var resultP = hiveBroadcast._prepareTransaction(tx).then(function (transaction) {
	    if (config.get("address_prefix") === "TST") {
	      transaction.operations = JSON.parse(JSON.stringify(transaction.operations).replace(/ HIVE/g, ' TESTS'));
	      transaction.operations = JSON.parse(JSON.stringify(transaction.operations).replace(/ HBD/g, ' TBD'));
	    }
	    debug('Signing transaction (transaction, transaction.operations)', transaction, transaction.operations);
	    var buf = _operations.transaction.toBuffer(transaction);
	    trxId = _ecc.hash.sha256(buf).toString('hex').slice(0, 40);
	    return _bluebird2.default.join(transaction, _auth2.default.signTransaction(transaction, privKeys));
	  }).spread(function (transaction, signedTransaction) {
	    debug('Broadcasting transaction (transaction, transaction.operations)', transaction, transaction.operations);
	    return _api2.default.broadcastTransactionAsync(signedTransaction).then(function (result) {
	      return Object.assign({ id: trxId }, result, signedTransaction);
	    });
	  });
	
	  resultP.nodeify(callback || noop);
	};
	
	hiveBroadcast._prepareTransaction = function hiveBroadcast$_prepareTransaction(tx) {
	  var propertiesP = _api2.default.getDynamicGlobalPropertiesAsync();
	  return propertiesP.then(function (properties) {
	    // Set defaults on the transaction
	    var chainDate = new Date(properties.time + 'Z');
	    var refBlockNum = properties.last_irreversible_block_num - 1 & 0xFFFF;
	    return _api2.default.getBlockHeaderAsync(properties.last_irreversible_block_num).then(function (block) {
	      var headBlockId = block ? block.previous : '0000000000000000000000000000000000000000';
	      return Object.assign({
	        ref_block_num: refBlockNum,
	        ref_block_prefix: new Buffer(headBlockId, 'hex').readUInt32LE(4),
	        expiration: new Date(chainDate.getTime() + 600 * 1000)
	      }, tx);
	    });
	  });
	};
	
	// Generated wrapper ----------------------------------------------------------
	operations.forEach(function (operation) {
	  var operationName = (0, _utils.camelCase)(operation.operation);
	  var operationParams = operation.params || [];
	
	  var useCommentPermlink = operationParams.indexOf('parent_author') !== -1 && operationParams.indexOf('parent_permlink') !== -1;
	
	  hiveBroadcast[operationName + 'With'] = function hiveBroadcast$specializedSendWith(wif, options, callback) {
	    debug('Sending operation "' + operationName + '" with', { options: options, callback: callback });
	    var keys = {};
	    if (operation.roles && operation.roles.length) {
	      keys[operation.roles[0]] = wif; // TODO - Automatically pick a role? Send all?
	    }
	
	    return hiveBroadcast.send({
	      extensions: [],
	      operations: [[operation.operation, Object.assign({}, options, options.json_metadata != null ? {
	        json_metadata: toString(options.json_metadata)
	      } : {}, useCommentPermlink && options.permlink == null ? {
	        permlink: formatter.commentPermlink(options.parent_author, options.parent_permlink)
	      } : {})]]
	    }, keys, callback);
	  };
	
	  hiveBroadcast[operationName] = function hiveBroadcast$specializedSend(wif) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    debug('Parsing operation "' + operationName + '" with', { args: args });
	    var options = operationParams.reduce(function (memo, param, i) {
	      memo[param] = args[i]; // eslint-disable-line no-param-reassign
	      return memo;
	    }, {});
	    var callback = args[operationParams.length];
	    return hiveBroadcast[operationName + 'With'](wif, options, callback);
	  };
	});
	
	hiveBroadcast.updateOperations = function () {
	  console.log('Warning: call to updateOperations() is deprecated and can safely be removed');
	};
	
	var toString = function toString(obj) {
	  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' ? JSON.stringify(obj) : obj;
	};
	(0, _helpers2.default)(hiveBroadcast);
	
	_bluebird2.default.promisifyAll(hiveBroadcast);
	
	exports = module.exports = hiveBroadcast;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).Buffer))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports = module.exports = function (hiveBroadcast) {
	  hiveBroadcast.addAccountAuth = function (_ref, cb) {
	    var signingKey = _ref.signingKey,
	        username = _ref.username,
	        authorizedUsername = _ref.authorizedUsername,
	        _ref$role = _ref.role,
	        role = _ref$role === undefined ? 'posting' : _ref$role,
	        weight = _ref.weight;
	
	    _api2.default.getAccounts([username], function (err, _ref2) {
	      var _ref3 = _slicedToArray(_ref2, 1),
	          userAccount = _ref3[0];
	
	      if (err) {
	        return cb(new Error(err), null);
	      }
	      if (!userAccount) {
	        return cb(new Error('Invalid account name'), null);
	      }
	
	      var updatedAuthority = userAccount[role];
	
	      /** Release callback if the account already exist in the account_auths array */
	      var authorizedAccounts = updatedAuthority.account_auths.map(function (auth) {
	        return auth[0];
	      });
	      var hasAuthority = authorizedAccounts.indexOf(authorizedUsername) !== -1;
	      if (hasAuthority) {
	        return cb(null, null);
	      }
	
	      /** Use weight_thresold as default weight */
	      weight = weight || userAccount[role].weight_threshold;
	      updatedAuthority.account_auths.push([authorizedUsername, weight]);
	      var owner = role === 'owner' ? updatedAuthority : undefined;
	      var active = role === 'active' ? updatedAuthority : undefined;
	      var posting = role === 'posting' ? updatedAuthority : undefined;
	
	      /** Add authority on user account */
	      hiveBroadcast.accountUpdate(signingKey, userAccount.name, owner, active, posting, userAccount.memo_key, userAccount.json_metadata, cb);
	    });
	  };
	
	  hiveBroadcast.removeAccountAuth = function (_ref4, cb) {
	    var signingKey = _ref4.signingKey,
	        username = _ref4.username,
	        authorizedUsername = _ref4.authorizedUsername,
	        _ref4$role = _ref4.role,
	        role = _ref4$role === undefined ? 'posting' : _ref4$role;
	
	    _api2.default.getAccounts([username], function (err, _ref5) {
	      var _ref6 = _slicedToArray(_ref5, 1),
	          userAccount = _ref6[0];
	
	      if (err) {
	        return cb(new Error(err), null);
	      }
	      if (!userAccount) {
	        return cb(new Error('Invalid account name'), null);
	      }
	
	      var updatedAuthority = userAccount[role];
	      var totalAuthorizedUser = updatedAuthority.account_auths.length;
	      for (var i = 0; i < totalAuthorizedUser; i++) {
	        var user = updatedAuthority.account_auths[i];
	        if (user[0] === authorizedUsername) {
	          updatedAuthority.account_auths.splice(i, 1);
	          break;
	        }
	      }
	
	      /** Release callback if the account does not exist in the account_auths array */
	      if (totalAuthorizedUser === updatedAuthority.account_auths.length) {
	        return cb(null, null);
	      }
	
	      var owner = role === 'owner' ? updatedAuthority : undefined;
	      var active = role === 'active' ? updatedAuthority : undefined;
	      var posting = role === 'posting' ? updatedAuthority : undefined;
	
	      hiveBroadcast.accountUpdate(signingKey, userAccount.name, owner, active, posting, userAccount.memo_key, userAccount.json_metadata, cb);
	    });
	  };
	
	  hiveBroadcast.addKeyAuth = function (_ref7, cb) {
	    var signingKey = _ref7.signingKey,
	        username = _ref7.username,
	        authorizedKey = _ref7.authorizedKey,
	        _ref7$role = _ref7.role,
	        role = _ref7$role === undefined ? 'posting' : _ref7$role,
	        weight = _ref7.weight;
	
	    _api2.default.getAccounts([username], function (err, _ref8) {
	      var _ref9 = _slicedToArray(_ref8, 1),
	          userAccount = _ref9[0];
	
	      if (err) {
	        return cb(new Error(err), null);
	      }
	      if (!userAccount) {
	        return cb(new Error('Invalid account name'), null);
	      }
	
	      var updatedAuthority = userAccount[role];
	
	      /** Release callback if the key already exist in the key_auths array */
	      var authorizedKeys = updatedAuthority.key_auths.map(function (auth) {
	        return auth[0];
	      });
	      var hasAuthority = authorizedKeys.indexOf(authorizedKey) !== -1;
	      if (hasAuthority) {
	        return cb(null, null);
	      }
	
	      /** Use weight_thresold as default weight */
	      weight = weight || userAccount[role].weight_threshold;
	      updatedAuthority.key_auths.push([authorizedKey, weight]);
	      var owner = role === 'owner' ? updatedAuthority : undefined;
	      var active = role === 'active' ? updatedAuthority : undefined;
	      var posting = role === 'posting' ? updatedAuthority : undefined;
	
	      /** Add authority on user account */
	      hiveBroadcast.accountUpdate(signingKey, userAccount.name, owner, active, posting, userAccount.memo_key, userAccount.json_metadata, cb);
	    });
	  };
	
	  hiveBroadcast.removeKeyAuth = function (_ref10, cb) {
	    var signingKey = _ref10.signingKey,
	        username = _ref10.username,
	        authorizedKey = _ref10.authorizedKey,
	        _ref10$role = _ref10.role,
	        role = _ref10$role === undefined ? 'posting' : _ref10$role;
	
	    _api2.default.getAccounts([username], function (err, _ref11) {
	      var _ref12 = _slicedToArray(_ref11, 1),
	          userAccount = _ref12[0];
	
	      if (err) {
	        return cb(new Error(err), null);
	      }
	      if (!userAccount) {
	        return cb(new Error('Invalid account name'), null);
	      }
	
	      var updatedAuthority = userAccount[role];
	      var totalAuthorizedKey = updatedAuthority.key_auths.length;
	      for (var i = 0; i < totalAuthorizedKey; i++) {
	        var user = updatedAuthority.key_auths[i];
	        if (user[0] === authorizedKey) {
	          updatedAuthority.key_auths.splice(i, 1);
	          break;
	        }
	      }
	
	      /** Release callback if the key does not exist in the key_auths array */
	      if (totalAuthorizedKey === updatedAuthority.key_auths.length) {
	        return cb(null, null);
	      }
	
	      var owner = role === 'owner' ? updatedAuthority : undefined;
	      var active = role === 'active' ? updatedAuthority : undefined;
	      var posting = role === 'posting' ? updatedAuthority : undefined;
	
	      hiveBroadcast.accountUpdate(signingKey, userAccount.name, owner, active, posting, userAccount.memo_key, userAccount.json_metadata, cb);
	    });
	  };
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = __webpack_require__(243);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _ecc = __webpack_require__(103);
	
	var _config = __webpack_require__(42);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (hiveAPI) {
	  function numberWithCommas(x) {
	    return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	  }
	
	  // Deprecating - Replacement: vestingHive
	  function vestingSteem(account, gprops) {
	    var vests = parseFloat(account.vesting_shares.split(" ")[0]);
	    var total_vests = parseFloat(gprops.total_vesting_shares.split(" ")[0]);
	    var total_vest_hive = parseFloat(gprops['total_vesting_fund_hive'].split(" ")[0]);
	    var vesting_hivef = total_vest_hive * (vests / total_vests);
	    return vesting_hivef;
	  }
	  var vestingHive = vestingSteem;
	
	  function processOrders(open_orders, assetPrecision) {
	    var hbdOrders = !open_orders ? 0 : open_orders.reduce(function (o, order) {
	      if (order.sell_price.base.indexOf("HBD") !== -1) {
	        o += order.for_sale;
	      }
	      return o;
	    }, 0) / assetPrecision;
	
	    var hiveOrders = !open_orders ? 0 : open_orders.reduce(function (o, order) {
	      if (order.sell_price.base.indexOf("HIVE") !== -1) {
	        o += order.for_sale;
	      }
	      return o;
	    }, 0) / assetPrecision;
	
	    return { hiveOrders: hiveOrders, hbdOrders: hbdOrders };
	  }
	
	  function calculateSaving(savings_withdraws) {
	    var savings_pending = 0;
	    var savings_hbd_pending = 0;
	    savings_withdraws.forEach(function (withdraw) {
	      var _withdraw$amount$spli = withdraw.amount.split(" "),
	          _withdraw$amount$spli2 = _slicedToArray(_withdraw$amount$spli, 2),
	          amount = _withdraw$amount$spli2[0],
	          asset = _withdraw$amount$spli2[1];
	
	      if (asset === "HIVE") savings_pending += parseFloat(amount);else {
	        if (asset === "HBD") savings_hbd_pending += parseFloat(amount);
	      }
	    });
	    return { savings_pending: savings_pending, savings_hbd_pending: savings_hbd_pending };
	  }
	
	  // Deprecating - Replacement: pricePerHive
	  function pricePerSteem(feed_price) {
	    var price_per_hive = undefined;
	    var base = feed_price.base,
	        quote = feed_price.quote;
	
	    if (/ HBD$/.test(base) && / HIVE$/.test(quote)) {
	      price_per_hive = parseFloat(base.split(" ")[0]) / parseFloat(quote.split(" ")[0]);
	    }
	    return price_per_hive;
	  }
	  var pricePerHive = pricePerSteem;
	
	  // TODO: remove vesting_steem
	  function estimateAccountValue(account) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        gprops = _ref.gprops,
	        feed_price = _ref.feed_price,
	        open_orders = _ref.open_orders,
	        savings_withdraws = _ref.savings_withdraws,
	        vesting_steem = _ref.vesting_steem,
	        vesting_hive = _ref.vesting_hive;
	
	    var promises = [];
	    var username = account.name;
	    var assetPrecision = 1000;
	    var orders = void 0,
	        savings = void 0;
	
	    // TODO: remove vesting_steem
	    // this is necessary to work with unbranded apis
	    if (vesting_steem) {
	      vesting_hive = vesting_steem;
	    }
	    if (!vesting_hive || !feed_price) {
	      if (!gprops || !feed_price) {
	        promises.push(hiveAPI.getStateAsync("/@" + username).then(function (data) {
	          gprops = data.props;
	          feed_price = data.feed_price;
	          vesting_hive = vestingHive(account, gprops);
	        }));
	      } else {
	        vesting_hive = vestingHive(account, gprops);
	      }
	    }
	
	    if (!open_orders) {
	      promises.push(hiveAPI.getOpenOrdersAsync(username).then(function (open_orders) {
	        orders = processOrders(open_orders, assetPrecision);
	      }));
	    } else {
	      orders = processOrders(open_orders, assetPrecision);
	    }
	
	    if (!savings_withdraws) {
	      promises.push(hiveAPI.getSavingsWithdrawFromAsync(username).then(function (savings_withdraws) {
	        savings = calculateSaving(savings_withdraws);
	      }));
	    } else {
	      savings = calculateSaving(savings_withdraws);
	    }
	
	    return Promise.all(promises).then(function () {
	      var price_per_hive = pricePerHive(feed_price);
	
	      var savings_balance = account.savings_balance;
	      var savings_hbd_balance = account["savings_hbd_balance"];
	      var balance_hive = parseFloat(account.balance.split(" ")[0]);
	      var saving_balance_hive = parseFloat(savings_balance.split(" ")[0]);
	      var hbd_balance = parseFloat(account["hbd_balance"]);
	      var hbd_balance_savings = parseFloat(savings_hbd_balance.split(" ")[0]);
	
	      var conversionValue = 0;
	      var currentTime = new Date().getTime();
	      (account.other_history || []).reduce(function (out, item) {
	        if ((0, _get2.default)(item, [1, "op", 0], "") !== "convert") return out;
	
	        var timestamp = new Date((0, _get2.default)(item, [1, "timestamp"])).getTime();
	        var finishTime = timestamp + 86400000 * 3.5; // add 3.5day conversion delay
	        if (finishTime < currentTime) return out;
	
	        var amount = parseFloat((0, _get2.default)(item, [1, "op", 1, "amount"]).replace(" HBD", ""));
	        conversionValue += amount;
	      }, []);
	
	      var total_hbd = hbd_balance + hbd_balance_savings + savings.savings_hbd_pending + orders.hbdOrders + conversionValue;
	
	      var total_hive = vesting_hive + balance_hive + saving_balance_hive + savings.savings_pending + orders.hiveOrders;
	
	      return (total_hive * price_per_hive + total_hbd).toFixed(2);
	    });
	  }
	
	  function createSuggestedPassword() {
	    var PASSWORD_LENGTH = 32;
	    var privateKey = _ecc.key_utils.get_random_key();
	    return privateKey.toWif().substring(3, 3 + PASSWORD_LENGTH);
	  }
	
	  return {
	    reputation: function reputation(_reputation) {
	      if (_reputation == null) return _reputation;
	      var neg = _reputation < 0;
	      var rep = String(_reputation);
	      rep = neg ? rep.substring(1) : rep;
	      var v = Math.log10((rep > 0 ? rep : -rep) - 10) - 9;
	      v = neg ? -v : v;
	      return parseInt(v * 9 + 25);
	    },
	
	    // Deprecated - Remove on future releases
	    vestToSteem: function vestToSteem(vestingShares, totalVestingShares, totalVestingFundSteem) {
	      console.warn('vestToSteem() is deprecated and will be removed in the future releases. Use vestToHive() instead.');
	      return parseFloat(totalVestingFundSteem) * (parseFloat(vestingShares) / parseFloat(totalVestingShares));
	    },
	
	    // Same as vestToSteem
	    vestToHive: function vestToHive(vestingShares, totalVestingShares, totalVestingFundHive) {
	      return parseFloat(totalVestingFundHive) * (parseFloat(vestingShares) / parseFloat(totalVestingShares));
	    },
	
	    commentPermlink: function commentPermlink(parentAuthor, parentPermlink) {
	      var timeStr = new Date().toISOString().replace(/[^a-zA-Z0-9]+/g, "").toLowerCase();
	      parentPermlink = parentPermlink.replace(/(-\d{8}t\d{9}z)/g, "");
	      return ("re-" + parentAuthor + "-" + parentPermlink + "-" + timeStr).replace(".", "");
	    },
	
	    amount: function amount(_amount, asset) {
	      return _amount.toFixed(3) + " " + asset;
	    },
	    numberWithCommas: numberWithCommas,
	    vestingSteem: vestingSteem,
	    vestingHive: vestingHive,
	    estimateAccountValue: estimateAccountValue,
	    createSuggestedPassword: createSuggestedPassword,
	    pricePerSteem: pricePerSteem,
	    pricePerHive: pricePerHive
	  };
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseGet = __webpack_require__(244);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var castPath = __webpack_require__(245),
	    toKey = __webpack_require__(284);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return index && index == length ? object : undefined;
	}
	
	module.exports = baseGet;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(62),
	    isKey = __webpack_require__(246),
	    stringToPath = __webpack_require__(248),
	    toString = __webpack_require__(281);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isArray = __webpack_require__(62),
	    isSymbol = __webpack_require__(247);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
	}
	
	module.exports = isKey;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var baseGetTag = __webpack_require__(55),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
	}
	
	module.exports = isSymbol;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var memoizeCapped = __webpack_require__(249);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function (string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function (match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
	  });
	  return result;
	});
	
	module.exports = stringToPath;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var memoize = __webpack_require__(250);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function (key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MapCache = __webpack_require__(251);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function memoized() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache)();
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var mapCacheClear = __webpack_require__(252),
	    mapCacheDelete = __webpack_require__(275),
	    mapCacheGet = __webpack_require__(278),
	    mapCacheHas = __webpack_require__(279),
	    mapCacheSet = __webpack_require__(280);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	    var index = -1,
	        length = entries == null ? 0 : entries.length;
	
	    this.clear();
	    while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	    }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Hash = __webpack_require__(253),
	    ListCache = __webpack_require__(266),
	    Map = __webpack_require__(274);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash(),
	    'map': new (Map || ListCache)(),
	    'string': new Hash()
	  };
	}
	
	module.exports = mapCacheClear;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hashClear = __webpack_require__(254),
	    hashDelete = __webpack_require__(262),
	    hashGet = __webpack_require__(263),
	    hashHas = __webpack_require__(264),
	    hashSet = __webpack_require__(265);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	    var index = -1,
	        length = entries == null ? 0 : entries.length;
	
	    this.clear();
	    while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	    }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nativeCreate = __webpack_require__(255);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getNative = __webpack_require__(256);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseIsNative = __webpack_require__(257),
	    getValue = __webpack_require__(261);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isFunction = __webpack_require__(77),
	    isMasked = __webpack_require__(258),
	    isObject = __webpack_require__(78),
	    toSource = __webpack_require__(260);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var coreJsData = __webpack_require__(259);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = function () {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? 'Symbol(src)_1.' + uid : '';
	}();
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && maskSrcKey in func;
	}
	
	module.exports = isMasked;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var root = __webpack_require__(57);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return func + '';
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nativeCreate = __webpack_require__(255);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nativeCreate = __webpack_require__(255);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nativeCreate = __webpack_require__(255);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var listCacheClear = __webpack_require__(267),
	    listCacheDelete = __webpack_require__(268),
	    listCacheGet = __webpack_require__(271),
	    listCacheHas = __webpack_require__(272),
	    listCacheSet = __webpack_require__(273);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	    var index = -1,
	        length = entries == null ? 0 : entries.length;
	
	    this.clear();
	    while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	    }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assocIndexOf = __webpack_require__(269);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var eq = __webpack_require__(270);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || value !== value && other !== other;
	}
	
	module.exports = eq;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assocIndexOf = __webpack_require__(269);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getNative = __webpack_require__(256),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getMapData = __webpack_require__(276);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isKeyable = __webpack_require__(277);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
	}
	
	module.exports = getMapData;

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
	}
	
	module.exports = isKeyable;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getMapData = __webpack_require__(276);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getMapData = __webpack_require__(276);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getMapData = __webpack_require__(276);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var baseToString = __webpack_require__(282);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Symbol = __webpack_require__(56),
	    arrayMap = __webpack_require__(283),
	    isArray = __webpack_require__(62),
	    isSymbol = __webpack_require__(247);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = _Symbol ? _Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = value + '';
	  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
	}
	
	module.exports = baseToString;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isSymbol = __webpack_require__(247);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = value + '';
	  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
	}
	
	module.exports = toKey;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(42);
	
	module.exports = [{
	  "roles": ["posting", "active", "owner"],
	  "operation": "vote",
	  "params": ["voter", "author", "permlink", "weight"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "comment",
	  "params": ["parent_author", "parent_permlink", "author", "permlink", "title", "body", "json_metadata"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "transfer",
	  "params": ["from", "to", "amount", "memo"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "transfer_to_vesting",
	  "params": ["from", "to", "amount"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "withdraw_vesting",
	  "params": ["account", "vesting_shares"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "limit_order_create",
	  "params": ["owner", "orderid", "amount_to_sell", "min_to_receive", "fill_or_kill", "expiration"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "limit_order_cancel",
	  "params": ["owner", "orderid"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "price",
	  "params": ["base", "quote"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "feed_publish",
	  "params": ["publisher", "exchange_rate"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "convert",
	  "params": ["owner", "requestid", "amount"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "collateralized_convert",
	  "params": ["owner", "requestid", "amount"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "account_create",
	  "params": ["fee", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "account_update",
	  "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "witness_update",
	  "params": ["owner", "url", "block_signing_key", "props", "fee"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "account_witness_vote",
	  "params": ["account", "witness", "approve"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "account_witness_proxy",
	  "params": ["account", "proxy"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "pow",
	  "params": ["worker", "input", "signature", "work"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "custom",
	  "params": ["required_auths", "id", "data"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "delete_comment",
	  "params": ["author", "permlink"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "custom_json",
	  "params": ["required_auths", "required_posting_auths", "id", "json"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "comment_options",
	  "params": ["author", "permlink", "max_accepted_payout", "percent_hbd", "allow_votes", "allow_curation_rewards", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "set_withdraw_vesting_route",
	  "params": ["from_account", "to_account", "percent", "auto_vest"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "limit_order_create2",
	  "params": ["owner", "orderid", "amount_to_sell", "exchange_rate", "fill_or_kill", "expiration"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "claim_account",
	  "params": ["creator", "fee", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "create_claimed_account",
	  "params": ["creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "request_account_recovery",
	  "params": ["recovery_account", "account_to_recover", "new_owner_authority", "extensions"]
	}, {
	  "roles": ["owner"],
	  "operation": "recover_account",
	  "params": ["account_to_recover", "new_owner_authority", "recent_owner_authority", "extensions"]
	}, {
	  "roles": ["owner"],
	  "operation": "change_recovery_account",
	  "params": ["account_to_recover", "new_recovery_account", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "escrow_transfer",
	  "params": ["from", "to", "agent", "escrow_id", "hbd_amount", "hive_amount", "fee", "ratification_deadline", "escrow_expiration", "json_meta"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "escrow_dispute",
	  "params": ["from", "to", "agent", "who", "escrow_id"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "escrow_release",
	  "params": ["from", "to", "agent", "who", "receiver", "escrow_id", "hbd_amount", "hive_amount"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "pow2",
	  "params": ["input", "pow_summary"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "escrow_approve",
	  "params": ["from", "to", "agent", "who", "escrow_id", "approve"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "transfer_to_savings",
	  "params": ["from", "to", "amount", "memo"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "transfer_from_savings",
	  "params": ["from", "request_id", "to", "amount", "memo"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "cancel_transfer_from_savings",
	  "params": ["from", "request_id"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "custom_binary",
	  "params": ["id", "data"]
	}, {
	  "roles": ["owner"],
	  "operation": "decline_voting_rights",
	  "params": ["account", "decline"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "reset_account",
	  "params": ["reset_account", "account_to_reset", "new_owner_authority"]
	}, {
	  "roles": ["owner", "posting"],
	  "operation": "set_reset_account",
	  "params": ["account", "current_reset_account", "reset_account"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "claim_reward_balance",
	  "params": ["account", "reward_hive", "reward_hbd", "reward_vests"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "delegate_vesting_shares",
	  "params": ["delegator", "delegatee", "vesting_shares"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "account_create_with_delegation",
	  "params": ["fee", "delegation", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "witness_set_properties",
	  "params": ["owner", "props", "extensions"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "account_update2",
	  "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata", "posting_json_metadata", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "create_proposal",
	  "params": ["creator", "receiver", "start_date", "end_date", "daily_pay", "subject", "permlink", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "update_proposal_votes",
	  "params": ["voter", "proposal_ids", "approve", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "remove_proposal",
	  "params": ["proposal_owner", "proposal_ids", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "update_proposal",
	  "params": ["proposal_id", "creator", "daily_pay", "subject", "permlink", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "recurrent_transfer",
	  "params": ["from", "to", "amount", "memo", "recurrence", "executions", "extensions"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "claim_reward_balance2",
	  "params": ["account", "reward_tokens", "extensions"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "vote2",
	  "params": ["voter", "author", "permlink", "rshares", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_create",
	  "params": ["control_account", "symbol", "smt_creation_fee", "precision", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_setup",
	  "params": ["control_account", "symbol", "max_supply", "contribution_begin_time", "contribution_end_time", "launch_time", "hive_units_min", "min_unit_ratio", "max_unit_ratio", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_setup_emissions",
	  "params": ["control_account", "symbol", "schedule_time", "emissions_unit", "interval_seconds", "interval_coount", "lep_time", "rep_time", "lep_abs_amount", "rep_abs_amount", "lep_rel_amount_numerator", "rep_rel_amount_numerator", "rel_amount_denom_bits", "remove", "floor_emissions", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_setup_ico_tier",
	  "params": ["control_account", "symbol", "hive_units_cap", "generation_policy", "remove", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_set_setup_parameters",
	  "params": ["control_account", "symbol", "setup_parameters", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_set_runtime_parameters",
	  "params": ["control_account", "symbol", "runtime_parameters", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "smt_contribute",
	  "params": ["contributor", "symbol", "contribution_id", "contribution", "extensions"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "fill_convert_request",
	  "params": ["owner", "requestid", "amount_in", "amount_out"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "comment_reward",
	  "params": ["author", "permlink", "payout"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "liquidity_reward",
	  "params": ["owner", "payout"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "interest",
	  "params": ["owner", "interest"]
	}, {
	  "roles": ["active", "owner"],
	  "operation": "fill_vesting_withdraw",
	  "params": ["from_account", "to_account", "withdrawn", "deposited"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "fill_order",
	  "params": ["current_owner", "current_orderid", "current_pays", "open_owner", "open_orderid", "open_pays"]
	}, {
	  "roles": ["posting", "active", "owner"],
	  "operation": "fill_transfer_from_savings",
	  "params": ["from", "to", "amount", "request_id", "memo"]
	}];

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// hive.min.js